import * as i1$4 from '@angular/cdk/clipboard';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import * as i11 from '@angular/cdk/scrolling';
import { CdkVirtualScrollViewport, CdkScrollableModule, ScrollingModule } from '@angular/cdk/scrolling';
import * as i1$1 from '@angular/common';
import { formatDate, APP_BASE_HREF, CommonModule, DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Component, Inject, Input, ViewChild, EventEmitter, Output, Optional, ChangeDetectionStrategy, Pipe, Directive, NgModule } from '@angular/core';
import * as i6 from '@angular/forms';
import { Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i13$2 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i3$2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i8$1 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i7 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i12 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i2 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i3$1 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i13$1 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i4$1 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i18 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i13 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i1$3 from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA, MatSnackBarConfig, MatSnackBarModule } from '@angular/material/snack-bar';
import * as i4 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i8$2 from '@ebootis/ui';
import { UiLibModule } from '@ebootis/ui';
import { Subject, timer, Observable, BehaviorSubject, of, iif, concat, fromEvent, interval } from 'rxjs';
import * as i9 from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i8 from '@angular/material/core';
import { map, take, switchMap, tap, takeUntil, startWith, debounceTime, distinctUntilChanged, filter, first, concatMap } from 'rxjs/operators';
import * as i1$2 from '@angular/cdk/platform';
import { getSupportedInputTypes } from '@angular/cdk/platform';
import { HttpParams, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { SFX_SERVICE_INVOKER } from '@ebootis/common';
import * as i14 from '@angular/material/divider';
import * as i17 from '@angular/material/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import * as i2$1 from '@angular/cdk/observers';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import * as i1$5 from '@angular/service-worker';
import * as i3$3 from '@angular/platform-browser';
import { MatCardModule } from '@angular/material/card';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

const USER_SETTINGS_DB_SERVICE = new InjectionToken('USER_SETTINGS_DB_SERVICE');

class TableIntl {
    constructor() {
        this.changes = new Subject();
        this.distributeColumnsEvenly = 'Spalten gleichmäßig verteilen';
        this.reorganizeColumns = 'Spalten verwalten';
        this.close = 'Schließen';
        this.cancel = 'Abbrechen';
        this.hidden = 'Nicht anzeigen';
        this.visible = 'Anzeigen';
        this.save = 'Speichern';
        this.atLeastOneColumnMustBeVisible = 'Mindestens eine Spalte muss sichtbar sein';
        this.setColumnWidthToMinContent = 'Spaltenbreiten an Inhalt anpassen';
        this.leftHandSide = 'Linksseitig';
        this.rightHandSide = 'Rechtsseitig';
        this.name = 'Name';
        this.makeVisible = 'einblenden';
        this.hide = 'ausblenden';
        this.toggleColumnVisibility = 'Spalten ein-/ausblenden';
        this.freezeColumns = 'Spalten einfrieren';
    }
    static { this.ɵfac = function TableIntl_Factory(t) { return new (t || TableIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TableIntl, factory: TableIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

function ReorganizeColumnsDlgComponent_mat_header_cell_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.m_tableIntl.name);
} }
function ReorganizeColumnsDlgComponent_mat_cell_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r6 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(column_r6.translation);
} }
function ReorganizeColumnsDlgComponent_mat_header_cell_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.m_tableIntl.visible);
} }
const _c0$a = function (a0) { return { "column-hidden": a0 }; };
function ReorganizeColumnsDlgComponent_mat_cell_29_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-cell")(1, "button", 23);
    i0.ɵɵlistener("click", function ReorganizeColumnsDlgComponent_mat_cell_29_Template_button_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const column_r7 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.toggleVisibility_Click(column_r7)); });
    i0.ɵɵelementStart(2, "mat-icon", 24);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const column_r7 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("matTooltip", column_r7.hidden ? ctx_r3.m_tableIntl.makeVisible : ctx_r3.m_tableIntl.hide);
    i0.ɵɵattribute("aria-label", column_r7.hidden ? ctx_r3.m_tableIntl.makeVisible : ctx_r3.m_tableIntl.hide);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$a, column_r7.hidden));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", column_r7.hidden ? "visibility_off" : "visibility", " ");
} }
function ReorganizeColumnsDlgComponent_mat_header_row_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-row");
} }
function ReorganizeColumnsDlgComponent_mat_row_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-row");
} }
class ReorganizeColumnsDlgComponent {
    constructor(m_data, m_dialogRef) {
        this.m_data = m_data;
        this.m_dialogRef = m_dialogRef;
        this.m_displayedColumns = ['name', 'isVisible'];
        this.IS_VISIBLE = 'isVisible';
        this.COLUMNSETTINGS = 'columnSettings';
        this.m_tableIntl = new TableIntl();
        this.m_tableSettings = this.m_data.tableSettings;
    }
    ngOnInit() {
    }
    toggleVisibility_Click(p_columSettings) {
        p_columSettings.hidden = !p_columSettings.hidden;
    }
    save_Click() {
        this.m_dialogRef.close(this.m_tableSettings.columnSettings);
    }
    close_Click() {
        this.m_dialogRef.close();
    }
    get hasVisibleColumns() {
        return this.m_tableSettings.columnSettings.some(col => !col.hidden);
    }
    get countFreezableColumns() {
        let visibleColumns = this.m_tableSettings?.columnSettings?.filter((col) => !col.hidden)?.length;
        return visibleColumns - (this.m_tableSettings.columnsFrozenLeft + this.m_tableSettings.columnsFrozenRight);
    }
    static { this.ɵfac = function ReorganizeColumnsDlgComponent_Factory(t) { return new (t || ReorganizeColumnsDlgComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1.MatDialogRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReorganizeColumnsDlgComponent, selectors: [["ebootis-reorganize-columns-dlg"]], decls: 44, vars: 20, consts: [["mat-dialog-title", "", 1, "ebo-dialog-header"], [1, "ebo-dialog-title"], ["mat-icon-button", "", "type", "button", "mat-dialog-close", "", 3, "aria-label"], [1, "d-flex", "flex-fill", "flex-column"], [1, "mb-2"], [1, "row"], [1, "col-12", "col-md-6", "d-flex"], ["appearance", "fill", 1, "flex-fill", "d-flex", "flex-column"], ["matInput", "", "type", "number", "min", "0", 1, "text-end", 3, "ngModel", "max", "ngModelChange"], [1, "d-flex", "flex-fill", "flex-column", 3, "dataSource"], ["matColumnDef", "name"], [4, "matHeaderCellDef"], [4, "matCellDef"], ["matColumnDef", "isVisible"], [4, "matHeaderRowDef"], [4, "matRowDef", "matRowDefColumns"], [1, "pt-1", 3, "hidden"], [1, "d-flex", "align-content-center"], [1, "me-1"], [1, "ebo-dialog-actions"], ["type", "button", "mat-button", "", 3, "click"], ["mat-raised-button", "", "color", "primary", "type", "button", 1, "ms-3", 3, "matTooltip", "disabled", "click"], [1, "pe-1"], ["mat-button", "", "type", "button", "color", "primary", 3, "matTooltip", "click"], [3, "ngClass"]], template: function ReorganizeColumnsDlgComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0)(1, "span", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "button", 2)(4, "mat-icon");
            i0.ɵɵtext(5, "close");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(6, "mat-dialog-content", 3)(7, "span", 4);
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 5)(10, "div", 6)(11, "mat-form-field", 7)(12, "mat-label");
            i0.ɵɵtext(13);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "input", 8);
            i0.ɵɵlistener("ngModelChange", function ReorganizeColumnsDlgComponent_Template_input_ngModelChange_14_listener($event) { return ctx.m_tableSettings.columnsFrozenLeft = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(15, "div", 6)(16, "mat-form-field", 7)(17, "mat-label");
            i0.ɵɵtext(18);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(19, "input", 8);
            i0.ɵɵlistener("ngModelChange", function ReorganizeColumnsDlgComponent_Template_input_ngModelChange_19_listener($event) { return ctx.m_tableSettings.columnsFrozenRight = $event; });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(20, "span", 4);
            i0.ɵɵtext(21);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "div", 3)(23, "mat-table", 9);
            i0.ɵɵelementContainerStart(24, 10);
            i0.ɵɵtemplate(25, ReorganizeColumnsDlgComponent_mat_header_cell_25_Template, 2, 1, "mat-header-cell", 11);
            i0.ɵɵtemplate(26, ReorganizeColumnsDlgComponent_mat_cell_26_Template, 2, 1, "mat-cell", 12);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(27, 13);
            i0.ɵɵtemplate(28, ReorganizeColumnsDlgComponent_mat_header_cell_28_Template, 2, 1, "mat-header-cell", 11);
            i0.ɵɵtemplate(29, ReorganizeColumnsDlgComponent_mat_cell_29_Template, 4, 6, "mat-cell", 12);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵtemplate(30, ReorganizeColumnsDlgComponent_mat_header_row_30_Template, 1, 0, "mat-header-row", 14);
            i0.ɵɵtemplate(31, ReorganizeColumnsDlgComponent_mat_row_31_Template, 1, 0, "mat-row", 15);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(32, "div", 16)(33, "mat-error", 17)(34, "mat-icon", 18);
            i0.ɵɵtext(35, "error");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(36);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(37, "mat-dialog-actions", 19)(38, "button", 20);
            i0.ɵɵlistener("click", function ReorganizeColumnsDlgComponent_Template_button_click_38_listener() { return ctx.close_Click(); });
            i0.ɵɵtext(39);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(40, "button", 21);
            i0.ɵɵlistener("click", function ReorganizeColumnsDlgComponent_Template_button_click_40_listener() { return ctx.save_Click(); });
            i0.ɵɵelementStart(41, "mat-icon", 22);
            i0.ɵɵtext(42, "save");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(43);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.m_tableIntl.reorganizeColumns, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("aria-label", ctx.m_tableIntl.close);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.m_tableIntl.freezeColumns);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.m_tableIntl.leftHandSide);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngModel", ctx.m_tableSettings.columnsFrozenLeft)("max", ctx.countFreezableColumns);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.m_tableIntl.rightHandSide);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngModel", ctx.m_tableSettings.columnsFrozenRight)("max", ctx.countFreezableColumns);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.m_tableIntl.toggleColumnVisibility);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("dataSource", ctx.m_tableSettings == null ? null : ctx.m_tableSettings.columnSettings);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("matHeaderRowDef", ctx.m_displayedColumns);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("matRowDefColumns", ctx.m_displayedColumns);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hidden", ctx.hasVisibleColumns);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1("", ctx.m_tableIntl.atLeastOneColumnMustBeVisible, ".");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.m_tableIntl.cancel);
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("matTooltip", ctx.m_tableIntl.save);
            i0.ɵɵproperty("disabled", !ctx.hasVisibleColumns);
            i0.ɵɵattribute("aria-label", ctx.m_tableIntl.save);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", ctx.m_tableIntl.save, " ");
        } }, dependencies: [i1$1.NgClass, i3.MatIcon, i4.MatTooltip, i2.MatFormField, i2.MatLabel, i2.MatError, i3$1.MatInput, i6.DefaultValueAccessor, i6.NumberValueAccessor, i6.NgControlStatus, i6.MinValidator, i6.MaxValidator, i6.NgModel, i3$2.MatButton, i3$2.MatIconButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, i9.MatTable, i9.MatHeaderCellDef, i9.MatHeaderRowDef, i9.MatColumnDef, i9.MatCellDef, i9.MatRowDef, i9.MatHeaderCell, i9.MatCell, i9.MatHeaderRow, i9.MatRow], styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column}.column-hidden[_ngcontent-%COMP%]{color:#bbb}.error[_ngcontent-%COMP%]{color:red}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReorganizeColumnsDlgComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-reorganize-columns-dlg', template: "<h1 mat-dialog-title class=\"ebo-dialog-header\">\n  <span class=\"ebo-dialog-title\">\n    {{m_tableIntl.reorganizeColumns}}\n  </span>\n  <button mat-icon-button type=\"button\" aria-label=\"{{m_tableIntl.close}}\" mat-dialog-close>\n    <mat-icon>close</mat-icon>\n  </button>\n</h1>\n<mat-dialog-content class=\"d-flex flex-fill flex-column\">\n  <span class=\"mb-2\">{{m_tableIntl.freezeColumns}}</span>\n  <div class=\"row\">\n    <div class=\"col-12 col-md-6 d-flex\">\n      <mat-form-field appearance=\"fill\" class=\"flex-fill d-flex flex-column\">\n        <mat-label>{{m_tableIntl.leftHandSide}}</mat-label>\n        <input matInput type=\"number\" [(ngModel)]=\"m_tableSettings.columnsFrozenLeft\" min=\"0\"\n               [max]=\"countFreezableColumns\" class=\"text-end\">\n      </mat-form-field>\n    </div>\n    <div class=\"col-12 col-md-6 d-flex\">\n      <mat-form-field appearance=\"fill\" class=\"flex-fill d-flex flex-column\">\n        <mat-label>{{m_tableIntl.rightHandSide}}</mat-label>\n        <input matInput type=\"number\" [(ngModel)]=\"m_tableSettings.columnsFrozenRight\" min=\"0\"\n               [max]=\"countFreezableColumns\" class=\"text-end\">\n      </mat-form-field>\n    </div>\n  </div>\n  <span class=\"mb-2\">{{m_tableIntl.toggleColumnVisibility}}</span>\n  <div class=\"d-flex flex-fill flex-column\">\n    <mat-table [dataSource]=\"m_tableSettings?.columnSettings\" class=\"d-flex flex-fill flex-column\">\n      <ng-container matColumnDef=\"name\">\n        <mat-header-cell *matHeaderCellDef>{{m_tableIntl.name}}</mat-header-cell>\n        <mat-cell *matCellDef=\"let column\">{{column.translation}}</mat-cell>\n      </ng-container>\n\n      <ng-container matColumnDef=\"isVisible\">\n        <mat-header-cell *matHeaderCellDef>{{m_tableIntl.visible}}</mat-header-cell>\n        <mat-cell *matCellDef=\"let column\">\n          <button mat-button type=\"button\" color=\"primary\"\n                  attr.aria-label=\"{{column.hidden ? m_tableIntl.makeVisible : m_tableIntl.hide}}\"\n                  matTooltip=\"{{column.hidden ? m_tableIntl.makeVisible : m_tableIntl.hide}}\"\n                  (click)=\"toggleVisibility_Click(column)\">\n            <mat-icon [ngClass]=\"{'column-hidden': column.hidden}\">\n              {{(column.hidden) ? 'visibility_off' : 'visibility'}}\n            </mat-icon>\n          </button>\n        </mat-cell>\n      </ng-container>\n\n      <mat-header-row *matHeaderRowDef=\"m_displayedColumns\"></mat-header-row>\n      <mat-row *matRowDef=\"let row; columns: m_displayedColumns;\"></mat-row>\n    </mat-table>\n  </div>\n  <div class=\"pt-1\" [hidden]=\"hasVisibleColumns\">\n    <mat-error class=\"d-flex align-content-center\"><mat-icon class=\"me-1\">error</mat-icon>{{m_tableIntl.atLeastOneColumnMustBeVisible}}.</mat-error>\n  </div>\n</mat-dialog-content>\n<mat-dialog-actions class=\"ebo-dialog-actions\">\n  <button type=\"button\" mat-button (click)=\"close_Click()\">{{m_tableIntl.cancel}}</button>\n  <button class=\"ms-3\" mat-raised-button color=\"primary\" type=\"button\" attr.aria-label=\"{{m_tableIntl.save}}\"\n          matTooltip=\"{{m_tableIntl.save}}\" (click)=\"save_Click()\" [disabled]=\"!hasVisibleColumns\">\n    <mat-icon class=\"pe-1\">save</mat-icon>{{m_tableIntl.save}}\n  </button>\n</mat-dialog-actions>", styles: [":host{display:flex;flex-direction:column}.column-hidden{color:#bbb}.error{color:red}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i1.MatDialogRef }]; }, null); })();

const _c0$9 = ["alert"];
function AlertComponent_strong_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "strong");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.m_title);
} }
function AlertComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function AlertComponent_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.close_Click()); });
    i0.ɵɵtext(1, "\u00D7");
    i0.ɵɵelementEnd();
} }
class AlertComponent {
    constructor() {
        /** error, warning, success, info */
        this.m_role = 'error';
        /** X-Button zum Schließen anzeigen: Default = true */
        this.m_showCloseButton = true;
        /** nach 3 Sekunden ausblenden: Default = false */
        this.m_timed = false;
        this.m_currentState = 'initial';
        this.m_fadeOutTime = 1000;
    }
    ngOnInit() {
        if (this.m_timed) {
            const alertDuration = 3000;
            const showAlertCountdown = timer(alertDuration);
            showAlertCountdown.subscribe({
                next: () => {
                    this.m_currentState = 'final';
                    const fadeOutCountdown = timer(this.m_fadeOutTime);
                    fadeOutCountdown.subscribe(() => this.m_alert.nativeElement.remove());
                }
            });
        }
    }
    close_Click() {
        this.m_currentState = 'final';
        const countdown = timer(this.m_fadeOutTime);
        countdown.subscribe(() => { this.m_alert.nativeElement.remove(); });
    }
    static { this.ɵfac = function AlertComponent_Factory(t) { return new (t || AlertComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AlertComponent, selectors: [["ebootis-alert"]], viewQuery: function AlertComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$9, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.m_alert = _t.first);
        } }, inputs: { m_role: ["role", "m_role"], m_title: ["title", "m_title"], m_message: ["message", "m_message"], m_showCloseButton: ["showCloseButton", "m_showCloseButton"], m_timed: ["timed", "m_timed"] }, decls: 5, vars: 6, consts: [[1, "p-3", "alert"], ["alert", ""], [4, "ngIf"], ["type", "button", "mat-button", "", "class", "close", 3, "click", 4, "ngIf"], ["type", "button", "mat-button", "", 1, "close", 3, "click"]], template: function AlertComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0, 1);
            i0.ɵɵtemplate(2, AlertComponent_strong_2_Template, 2, 1, "strong", 2);
            i0.ɵɵtext(3);
            i0.ɵɵtemplate(4, AlertComponent_button_4_Template, 2, 0, "button", 3);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵclassMap("alert-" + ctx.m_role);
            i0.ɵɵproperty("@fadeout", ctx.m_currentState);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.m_title);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.m_message, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.m_showCloseButton);
        } }, dependencies: [i1$1.NgIf, i3$2.MatButton], styles: [".alert[_ngcontent-%COMP%]{border-radius:4px;color:#fff}.alert-error[_ngcontent-%COMP%]{background-color:#b60e08c0}.alert-warning[_ngcontent-%COMP%]{background-color:orange}.alert-success[_ngcontent-%COMP%]{background-color:#8cc152}.alert-info[_ngcontent-%COMP%]{background-color:#274b80}"], data: { animation: [
                trigger('fadeout', [
                    state('initial', style({
                        opacity: '100%'
                    })),
                    state('final', style({
                        opacity: '0%'
                    })),
                    transition('initial=>final', animate('1000ms')),
                ]),
            ] } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AlertComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-alert', animations: [
                    trigger('fadeout', [
                        state('initial', style({
                            opacity: '100%'
                        })),
                        state('final', style({
                            opacity: '0%'
                        })),
                        transition('initial=>final', animate('1000ms')),
                    ]),
                ], template: "<div class=\"p-3 alert\" [@fadeout]=\"m_currentState\" #alert  [class]=\"'alert-'+m_role\">\n    <strong *ngIf=\"m_title\">{{m_title}}</strong>\n    {{m_message}}\n    <button type=\"button\" mat-button class=\"close\" *ngIf=\"m_showCloseButton\" (click)=\"close_Click()\">&times;</button>\n</div>", styles: [".alert{border-radius:4px;color:#fff}.alert-error{background-color:#b60e08c0}.alert-warning{background-color:orange}.alert-success{background-color:#8cc152}.alert-info{background-color:#274b80}\n"] }]
    }], function () { return []; }, { m_role: [{
            type: Input,
            args: ["role"]
        }], m_title: [{
            type: Input,
            args: ["title"]
        }], m_message: [{
            type: Input,
            args: ["message"]
        }], m_showCloseButton: [{
            type: Input,
            args: ["showCloseButton"]
        }], m_timed: [{
            type: Input,
            args: ["timed"]
        }], m_alert: [{
            type: ViewChild,
            args: ['alert', { static: false }]
        }] }); })();

var ClsAttrType;
(function (ClsAttrType) {
    ClsAttrType["STRING"] = "STRING";
    ClsAttrType["NUMBER"] = "NUMBER";
    ClsAttrType["BOOLEAN"] = "BOOLEAN";
    ClsAttrType["DATE"] = "DATE";
})(ClsAttrType || (ClsAttrType = {}));

const ATTRIBUTE_FIELD_TRANSLATE = new InjectionToken('ATTRIBUTE_FIELD_TRANSLATE');

function AttributeFieldComponent_ng_container_1_mat_option_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const enum_r6 = ctx.$implicit;
    i0.ɵɵproperty("value", enum_r6.oid);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", enum_r6.value, " ");
} }
function AttributeFieldComponent_ng_container_1_mat_error_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.m_strings.requiredText, " ");
} }
function AttributeFieldComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 3)(2, "mat-label");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-select", 4, 5);
    i0.ɵɵlistener("selectionChange", function AttributeFieldComponent_ng_container_1_Template_mat_select_selectionChange_4_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.attributeCtrl_Change()); });
    i0.ɵɵtemplate(6, AttributeFieldComponent_ng_container_1_mat_option_6_Template, 2, 2, "mat-option", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, AttributeFieldComponent_ng_container_1_mat_error_7_Template, 2, 1, "mat-error", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.m_attribute.name, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControlName", ctx_r0.m_valueCtrlName)("required", ctx_r0.m_attribute.isMandatory);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.m_enumValues);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.m_valueControl.hasError("required"));
} }
function AttributeFieldComponent_ng_template_2_mat_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 12);
    i0.ɵɵlistener("change", function AttributeFieldComponent_ng_template_2_mat_checkbox_1_Template_mat_checkbox_change_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.attributeCtrl_Change()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formControlName", ctx_r9.m_valueCtrlName)("required", ctx_r9.m_attribute.isMandatory);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.m_attribute.name, " ");
} }
function AttributeFieldComponent_ng_template_2_mat_form_field_2_mat_error_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.m_strings.requiredText, " ");
} }
function AttributeFieldComponent_ng_template_2_mat_form_field_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 3)(1, "mat-label", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 14, 15);
    i0.ɵɵlistener("dateChange", function AttributeFieldComponent_ng_template_2_mat_form_field_2_Template_input_dateChange_3_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r18.attributeCtrl_Change()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "mat-datepicker-toggle", 16)(6, "mat-datepicker", null, 17);
    i0.ɵɵtemplate(8, AttributeFieldComponent_ng_template_2_mat_form_field_2_mat_error_8_Template, 2, 1, "mat-error", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r16 = i0.ɵɵreference(7);
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.m_attribute.name, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matDatepicker", _r16)("formControlName", ctx_r10.m_valueCtrlName)("required", ctx_r10.m_attribute.isMandatory);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r16);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r10.m_valueControl.hasError("required"));
} }
function AttributeFieldComponent_ng_template_2_mat_form_field_3_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r21.unit);
} }
function AttributeFieldComponent_ng_template_2_mat_form_field_3_mat_error_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r22.m_strings.requiredText, " ");
} }
function AttributeFieldComponent_ng_template_2_mat_form_field_3_mat_error_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r23.m_strings.numberMinError, " ");
} }
function AttributeFieldComponent_ng_template_2_mat_form_field_3_mat_error_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r24.m_strings.numberMaxError, " ");
} }
function AttributeFieldComponent_ng_template_2_mat_form_field_3_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 3)(1, "mat-label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 18, 19);
    i0.ɵɵlistener("change", function AttributeFieldComponent_ng_template_2_mat_form_field_3_Template_input_change_3_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r25.attributeCtrl_Change()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, AttributeFieldComponent_ng_template_2_mat_form_field_3_span_5_Template, 2, 1, "span", 20);
    i0.ɵɵtemplate(6, AttributeFieldComponent_ng_template_2_mat_form_field_3_mat_error_6_Template, 2, 1, "mat-error", 7);
    i0.ɵɵtemplate(7, AttributeFieldComponent_ng_template_2_mat_form_field_3_mat_error_7_Template, 2, 1, "mat-error", 7);
    i0.ɵɵtemplate(8, AttributeFieldComponent_ng_template_2_mat_form_field_3_mat_error_8_Template, 2, 1, "mat-error", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r11.m_attribute.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControlName", ctx_r11.m_valueCtrlName)("step", ctx_r11.m_attribute.step)("min", ctx_r11.m_attribute.numberRange && ctx_r11.m_attribute.numberRange[0] ? ctx_r11.m_attribute.numberRange[0] : null)("max", ctx_r11.m_attribute.numberRange && ctx_r11.m_attribute.numberRange[1] ? ctx_r11.m_attribute.numberRange[1] : null)("required", ctx_r11.m_attribute.isMandatory);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r11.unit);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.m_valueControl.hasError("required"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.m_valueControl.hasError("min"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.m_valueControl.hasError("max"));
} }
function AttributeFieldComponent_ng_template_2_mat_form_field_4_mat_error_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r28.m_strings.requiredText, " ");
} }
function AttributeFieldComponent_ng_template_2_mat_form_field_4_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 3)(1, "mat-label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 22, 23);
    i0.ɵɵlistener("change", function AttributeFieldComponent_ng_template_2_mat_form_field_4_Template_input_change_3_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r29.attributeCtrl_Change()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, AttributeFieldComponent_ng_template_2_mat_form_field_4_mat_error_5_Template, 2, 1, "mat-error", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r12.m_attribute.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControlName", ctx_r12.m_valueCtrlName)("required", ctx_r12.m_attribute.isMandatory);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r12.m_valueControl.hasError("required"));
} }
function AttributeFieldComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 9);
    i0.ɵɵtemplate(1, AttributeFieldComponent_ng_template_2_mat_checkbox_1_Template, 2, 3, "mat-checkbox", 10);
    i0.ɵɵtemplate(2, AttributeFieldComponent_ng_template_2_mat_form_field_2_Template, 9, 6, "mat-form-field", 11);
    i0.ɵɵtemplate(3, AttributeFieldComponent_ng_template_2_mat_form_field_3_Template, 9, 10, "mat-form-field", 11);
    i0.ɵɵtemplate(4, AttributeFieldComponent_ng_template_2_mat_form_field_4_Template, 6, 4, "mat-form-field", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", ctx_r2.m_attribute.attrType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.ATTR_TYPES.BOOLEAN);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.ATTR_TYPES.DATE);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.ATTR_TYPES.NUMBER);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.ATTR_TYPES.STRING);
} }
class AttributeFieldComponent {
    set Params(p_params) {
        this.m_formGroup = p_params.formGroup;
        this.m_attribute = p_params.attribute;
        this.m_divClass = p_params.cssClass;
        this.m_useSymbolAsUnit = p_params.useSymbolAsUnit;
        if (this.m_formGroup?.controls) {
            this.m_valueCtrlName = Object.keys(this.m_formGroup.controls).find(key => key != this.CLS_ATTRIBUTE_OID);
            if (this.m_valueCtrlName)
                this.m_valueControl = this.m_formGroup.get(this.m_valueCtrlName);
        }
        if (this.m_attribute.isEnum && !this.m_initialValueSet) {
            this.m_deprecatedSelectedEnumValueOid = this.m_valueControl.value;
            this.m_enumValues = this.m_attribute.enumValues.filter(ev => !ev.isDepracated || ev.oid == this.m_deprecatedSelectedEnumValueOid);
            let myEnumValue = this.m_enumValues.find(ev => ev.oid == this.m_deprecatedSelectedEnumValueOid);
            if (!myEnumValue?.isDepracated)
                this.m_deprecatedSelectedEnumValueOid = null;
            this.m_initialValueSet = true;
        }
    }
    constructor(m_attributeFieldTranslate) {
        this.m_attributeFieldTranslate = m_attributeFieldTranslate;
        this.fieldChange = new EventEmitter();
        // Dient dazu, dass der initiale Wert nicht mit jedem setParams neue gesetzt wird.
        // Da setParams bei jeder neuen Auswahl der Werte neu aufgerufen wird!
        this.m_initialValueSet = false;
        this.CLS_ATTRIBUTE_OID = 'clsAttributeOid';
        this.ATTR_TYPES = ClsAttrType;
        this.m_strings = {
            requiredText: 'Pflichtfeld',
            numberMinError: 'Minimaler Wert unterschritten',
            numberMaxError: 'Maximaler Wert überschritten',
        };
    }
    ngOnInit() {
        let numMin = 0, numMax = 0;
        if (this.m_attribute.numberRange) {
            numMin = this.m_attribute.numberRange[0] || 0;
            numMax = this.m_attribute.numberRange[1] || 0;
        }
        this.m_attributeFieldTranslate.getRequiredText().subscribe(res => this.m_strings.requiredText = res);
        this.m_attributeFieldTranslate.getNumberMinError(numMin).subscribe(res => this.m_strings.numberMinError = res);
        this.m_attributeFieldTranslate.getNumberMaxError(numMax).subscribe(res => this.m_strings.numberMaxError = res);
    }
    attributeCtrl_Change() {
        this.fieldChange.emit();
        // Damit veraltete Werte nicht gespeichert werden, wenn diese nicht verändert wurden. Ansonsten gäbe es eine Fehlermeldung vom Server.
        if (this.m_attribute.isEnum && this.m_deprecatedSelectedEnumValueOid && this.m_valueControl.value == this.m_deprecatedSelectedEnumValueOid)
            this.m_valueControl.markAsPristine();
    }
    get unit() {
        let unit = this.m_attribute.unitName || this.m_attribute.unitSymbol;
        if (this.m_attribute.unitName && this.m_attribute.unitSymbol && this.m_useSymbolAsUnit)
            unit = this.m_attribute.unitSymbol;
        return unit;
    }
    static { this.ɵfac = function AttributeFieldComponent_Factory(t) { return new (t || AttributeFieldComponent)(i0.ɵɵdirectiveInject(ATTRIBUTE_FIELD_TRANSLATE)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AttributeFieldComponent, selectors: [["ebootis-attribute-field"]], inputs: { Params: "Params" }, outputs: { fieldChange: "fieldChange" }, decls: 4, vars: 4, consts: [[3, "ngClass", "formGroup"], [4, "ngIf", "ngIfElse"], ["notAnEnum", ""], ["appearance", "fill", 1, "w-100"], [3, "formControlName", "required", "selectionChange"], ["enum", ""], [3, "value", 4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "value"], [3, "ngSwitch"], ["class", "me-md-3", "color", "primary", "class", "w-100 formfield-height", 3, "formControlName", "required", "change", 4, "ngSwitchCase"], ["appearance", "fill", "class", "w-100", 4, "ngSwitchCase"], ["color", "primary", 1, "w-100", "formfield-height", 3, "formControlName", "required", "change"], [1, "fw-bold"], ["matInput", "", 3, "matDatepicker", "formControlName", "required", "dateChange"], ["datePickerField", ""], ["matSuffix", "", 3, "for"], ["datePicker", ""], ["matInput", "", "type", "number", 1, "text-end", 3, "formControlName", "step", "min", "max", "required", "change"], ["number", ""], ["matSuffix", "", 4, "ngIf"], ["matSuffix", ""], ["matInput", "", "type", "text", "autocomplete", "off", 3, "formControlName", "required", "change"], ["string", ""]], template: function AttributeFieldComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, AttributeFieldComponent_ng_container_1_Template, 8, 5, "ng-container", 1);
            i0.ɵɵtemplate(2, AttributeFieldComponent_ng_template_2_Template, 5, 5, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(3);
            i0.ɵɵproperty("ngClass", ctx.m_divClass)("formGroup", ctx.m_formGroup);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.m_attribute.isEnum)("ngIfElse", _r1);
        } }, dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, i1$1.NgSwitch, i1$1.NgSwitchCase, i2.MatFormField, i2.MatLabel, i2.MatError, i2.MatSuffix, i3$1.MatInput, i13.MatSelect, i8.MatOption, i6.DefaultValueAccessor, i6.NumberValueAccessor, i6.NgControlStatus, i6.NgControlStatusGroup, i6.RequiredValidator, i6.MinValidator, i6.MaxValidator, i6.FormGroupDirective, i6.FormControlName, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i8$1.MatCheckbox, i8$1.MatCheckboxRequiredValidator], styles: [".reduced-min-width[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{min-width:80px!important}mat-checkbox[_ngcontent-%COMP%]   .mdc-label[_ngcontent-%COMP%]{margin:auto}.formfield-height[_ngcontent-%COMP%]   .mdc-form-field[_ngcontent-%COMP%]{height:100%}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AttributeFieldComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-attribute-field', template: "<div [ngClass]=\"m_divClass\" [formGroup]=\"m_formGroup\">\n\t<ng-container *ngIf=\"m_attribute.isEnum; else notAnEnum\">\n\t\t<mat-form-field appearance=\"fill\" class=\"w-100\">\n\t\t\t<mat-label>\n\t\t\t\t{{m_attribute.name}}\n\t\t\t</mat-label>\n\t\t\t<mat-select [formControlName]=\"m_valueCtrlName\" [required]=\"m_attribute.isMandatory\"\n\t\t\t\t(selectionChange)=\"attributeCtrl_Change()\" #enum>\n\t\t\t\t<mat-option *ngFor='let enum of m_enumValues' [value]=\"enum.oid\">\n\t\t\t\t\t{{enum.value}}\n\t\t\t\t</mat-option>\n\t\t\t</mat-select>\n\t\t\t<mat-error *ngIf=\"m_valueControl.hasError('required')\">\n\t\t\t\t{{ m_strings.requiredText }}\n\t\t\t</mat-error>\n\t\t</mat-form-field>\n\t</ng-container>\n\t<ng-template #notAnEnum>\n\t\t<ng-container [ngSwitch]=\"m_attribute.attrType\">\n\t\t\t<mat-checkbox *ngSwitchCase=\"ATTR_TYPES.BOOLEAN\" class=\"me-md-3\" color=\"primary\" class=\"w-100 formfield-height\"\n\t\t\t\t[formControlName]=\"m_valueCtrlName\" [required]=\"m_attribute.isMandatory\"\n\t\t\t\t(change)=\"attributeCtrl_Change()\">\n\t\t\t\t{{m_attribute.name}}\n\t\t\t</mat-checkbox>\n\t\t\t<mat-form-field *ngSwitchCase=\"ATTR_TYPES.DATE\" appearance=\"fill\" class=\"w-100\">\n\t\t\t\t<mat-label class=\"fw-bold\"> {{m_attribute.name}}</mat-label>\n\t\t\t\t<input matInput [matDatepicker]=\"datePicker\" [formControlName]=\"m_valueCtrlName\"\n\t\t\t\t\t[required]=\"m_attribute.isMandatory\" #datePickerField (dateChange)=\"attributeCtrl_Change()\">\n\t\t\t\t<mat-datepicker-toggle matSuffix [for]=\"datePicker\"></mat-datepicker-toggle>\n\t\t\t\t<mat-datepicker #datePicker></mat-datepicker>\n\t\t\t\t<mat-error *ngIf=\"m_valueControl.hasError('required')\">\n\t\t\t\t\t{{ m_strings.requiredText }}\n\t\t\t\t</mat-error>\n\t\t\t</mat-form-field>\n\t\t\t<mat-form-field *ngSwitchCase=\"ATTR_TYPES.NUMBER\" appearance=\"fill\" class=\"w-100\">\n\t\t\t\t<mat-label>{{m_attribute.name}}</mat-label>\n\t\t\t\t<input matInput type=\"number\" [formControlName]=\"m_valueCtrlName\" [step]=\"m_attribute.step\"\n\t\t\t\t\t[min]=\"m_attribute.numberRange && m_attribute.numberRange[0]?m_attribute.numberRange[0]:null\"\n\t\t\t\t\t[max]=\"m_attribute.numberRange && m_attribute.numberRange[1]?m_attribute.numberRange[1]:null\"\n\t\t\t\t\t[required]=\"m_attribute.isMandatory\" #number class=\"text-end\" (change)=\"attributeCtrl_Change()\">\n\t\t\t\t<span matSuffix *ngIf=\"unit\">{{unit}}</span>\n\t\t\t\t<mat-error *ngIf=\"m_valueControl.hasError('required')\">\n\t\t\t\t\t{{ m_strings.requiredText}}\n\t\t\t\t</mat-error>\n\t\t\t\t<mat-error *ngIf=\"m_valueControl.hasError('min')\">\n\t\t\t\t\t{{ m_strings.numberMinError }}\n\t\t\t\t</mat-error>\n\t\t\t\t<mat-error *ngIf=\"m_valueControl.hasError('max')\">\n\t\t\t\t\t{{ m_strings.numberMaxError }}\n\t\t\t\t</mat-error>\n\t\t\t</mat-form-field>\n\t\t\t<mat-form-field *ngSwitchCase=\"ATTR_TYPES.STRING\" appearance=\"fill\" class=\"w-100\">\n\t\t\t\t<mat-label>{{m_attribute.name}}</mat-label>\n\t\t\t\t<input matInput type=\"text\" autocomplete=\"off\" [formControlName]=\"m_valueCtrlName\"\n\t\t\t\t\t[required]=\"m_attribute.isMandatory\" #string (change)=\"attributeCtrl_Change()\">\n\t\t\t\t<mat-error *ngIf=\"m_valueControl.hasError('required')\">\n\t\t\t\t\t{{ m_strings.requiredText }}\n\t\t\t\t</mat-error>\n\t\t\t</mat-form-field>\n\t\t</ng-container>\n\t</ng-template>\n</div>", styles: [".reduced-min-width mat-form-field{min-width:80px!important}mat-checkbox .mdc-label{margin:auto}.formfield-height .mdc-form-field{height:100%}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ATTRIBUTE_FIELD_TRANSLATE]
            }] }]; }, { Params: [{
            type: Input
        }], fieldChange: [{
            type: Output
        }] }); })();

var ClsOwnerAssignType;
(function (ClsOwnerAssignType) {
    ClsOwnerAssignType["NONE"] = "NONE";
    ClsOwnerAssignType["NEW"] = "NEW";
    ClsOwnerAssignType["EDIT"] = "EDIT";
    ClsOwnerAssignType["REMOVE"] = "REMOVE";
})(ClsOwnerAssignType || (ClsOwnerAssignType = {}));

class ClassificationUtility {
    static { this.CLASSIFICATION_FORM = 'classificationForm'; }
    static { this.OWNER_OID = 'ownerOid'; }
    static { this.CLASSIFICATION = 'classification'; }
    static { this.CLASSIFICATION_OID = 'classificationOid'; }
    static { this.CLS_ATTRIBUTES = 'clsAttributes'; }
    static { this.CLS_ATTRIBUTE_OID = 'clsAttributeOid'; }
    static { this.CLS_ENUM_VALUE_OID = 'clsEnumValueOid'; }
    static { this.STR_VALUE = 'strValue'; }
    static { this.NUM_VALUE = 'numValue'; }
    static { this.BOOL_VALUE = 'boolValue'; }
    static { this.DATE_VALUE = 'dateValue'; }
    static getClassificationsChangedValues(p_formGroup, p_clsClassOwner) {
        if (!p_formGroup || !p_clsClassOwner || p_clsClassOwner.length <= 0)
            return null;
        let changedFormValues = p_clsClassOwner.filter(cco => cco.assignType == ClsOwnerAssignType.REMOVE || cco.assignType == ClsOwnerAssignType.NEW) ?? [];
        const clsFormArray = p_formGroup.get(this.CLASSIFICATION);
        const ownerOid = p_formGroup.get(this.OWNER_OID)?.value;
        if (clsFormArray?.controls?.length > 0) {
            clsFormArray.controls
                .filter(clsForm => clsForm.dirty)
                .forEach(clsForm => {
                const clsClassOwner = p_clsClassOwner.find(ccO => {
                    return (ccO.ownerOid === ownerOid || !ownerOid)
                        && ccO.clsClass.oid === clsForm.get(this.CLASSIFICATION_OID).value;
                });
                if (clsClassOwner) {
                    const attrFormArray = clsForm.get(this.CLS_ATTRIBUTES);
                    const changedAttributeValues = attrFormArray.controls
                        .filter(attrForm => attrForm.dirty)
                        .map(attrForm => attrForm.value);
                    let newCco = {
                        ownerOid: ownerOid,
                        clsClassSystem: null,
                        clsClass: clsClassOwner.clsClass,
                        ordnum: clsClassOwner.ordnum,
                        assignType: clsClassOwner.assignType,
                        attributeValues: changedAttributeValues
                    };
                    let insertIndex = -1;
                    if (clsClassOwner.assignType == ClsOwnerAssignType.NEW)
                        insertIndex = changedFormValues.findIndex(cco => this.areClsClassOwnerEqual(clsClassOwner, cco));
                    if (insertIndex >= 0)
                        changedFormValues.splice(insertIndex, 1, newCco);
                    else
                        changedFormValues.push(newCco);
                }
            });
        }
        return changedFormValues;
    }
    static findClsClass(p_clsClassList, p_clsClassOid) {
        if (!p_clsClassList?.length || !p_clsClassOid)
            return null;
        let foundClsClass = null;
        p_clsClassList.some((clsClass) => {
            if (clsClass.oid == p_clsClassOid)
                foundClsClass = clsClass;
            else
                foundClsClass = this.findClsClass(clsClass.subClasses, p_clsClassOid);
            return foundClsClass != null;
        });
        return foundClsClass;
    }
    static areClsClassOwnerEqual(p_cco1, p_cco2) {
        if (!p_cco1 || !p_cco2)
            return false;
        if (p_cco1.ownerOid != p_cco2.ownerOid)
            return false;
        if (p_cco1.clsClass && p_cco2.clsClass)
            return p_cco1.clsClass.oid == p_cco2.clsClass.oid;
        else
            return p_cco1.clsClassSystem.clsProxyOid == p_cco2.clsClassSystem.clsProxyOid;
    }
}

class ClassificationAssignNewIntl {
    constructor() {
        this.changes = new Subject();
        this.classification = 'Klassifikationssystem';
        this.assignClassification = 'Klassifikation zuordnen';
        this.assignClassificationButton = 'zuordnen';
        this.required = 'Pflichtfeld';
    }
    static { this.ɵfac = function ClassificationAssignNewIntl_Factory(t) { return new (t || ClassificationAssignNewIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ClassificationAssignNewIntl, factory: ClassificationAssignNewIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClassificationAssignNewIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

function ClassificationAssignNewComponent_mat_optgroup_15_mat_option_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const cls_r3 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", cls_r3.oid)("ngStyle", ctx_r2.getOptionsStyle(cls_r3));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", cls_r3.name, " ");
} }
function ClassificationAssignNewComponent_mat_optgroup_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-optgroup", 11);
    i0.ɵɵtemplate(1, ClassificationAssignNewComponent_mat_optgroup_15_mat_option_1_Template, 2, 3, "mat-option", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const classif_r1 = ctx.$implicit;
    i0.ɵɵproperty("label", classif_r1.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", classif_r1.classes);
} }
class ClassificationAssignNewComponent {
    constructor(m_fb, dialogRef, classificationAssignNewIntl, m_data) {
        this.m_fb = m_fb;
        this.dialogRef = dialogRef;
        this.classificationAssignNewIntl = classificationAssignNewIntl;
        this.m_data = m_data;
        this.ATTRIBUTE_PG = 'ATTRIBUTE_PG';
        // Entspricht dem Padding von Material Select Option
        this.INDENT_PADDING_OFFSET_PX = 32;
        this.INDENT_PADDING_PX = 16;
        if (this.classificationAssignNewIntl) {
            this.m_classificationAssignNewIntl = this.classificationAssignNewIntl;
        }
        else {
            this.m_classificationAssignNewIntl = new ClassificationAssignNewIntl();
        }
        this.clsClasses = m_data.clsClasses;
        this.classifications = [];
        this.clsClasses.forEach(clsClass => {
            let newClassif = {
                oid: clsClass.oid,
                name: clsClass.proxyName,
                classes: [],
            };
            newClassif.classes.push({
                oid: clsClass.oid,
                name: this.getClsClassName(clsClass),
                indent: 0,
            });
            clsClass.subClasses?.forEach(subClass => this.pushSubclasses(newClassif, subClass, 1));
            this.classifications.push(newClassif);
        });
        this.classificationAssignForm = this.m_fb.group({
            [this.ATTRIBUTE_PG]: this.m_fb.control(null, { validators: [Validators.required] })
        });
        this.m_attributeControl = this.classificationAssignForm.get(this.ATTRIBUTE_PG);
    }
    ngOnInit() { }
    assignClassification_Click() {
        let choosenClsClass = ClassificationUtility.findClsClass(this.clsClasses, this.m_attributeControl.value);
        if (choosenClsClass)
            this.dialogRef.close(choosenClsClass);
    }
    getOptionsStyle(p_cls) {
        return {
            'padding-left': (this.INDENT_PADDING_OFFSET_PX + p_cls.indent * this.INDENT_PADDING_PX) + 'px'
        };
    }
    pushSubclasses(classification, clsClass, p_indent) {
        classification.classes.push({
            oid: clsClass.oid,
            name: clsClass.name,
            indent: p_indent,
        });
        clsClass.subClasses?.forEach(subClass => this.pushSubclasses(classification, subClass, p_indent + 1));
    }
    ;
    getClsClassName(p_clsClass) {
        let name = p_clsClass.proxyName || '';
        if (!p_clsClass.isRoot) {
            if (name)
                name += ' - ';
            name += p_clsClass.name;
        }
        return name;
    }
    static { this.ɵfac = function ClassificationAssignNewComponent_Factory(t) { return new (t || ClassificationAssignNewComponent)(i0.ɵɵdirectiveInject(i6.FormBuilder), i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(ClassificationAssignNewIntl, 8), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ClassificationAssignNewComponent, selectors: [["ebootis-classification-assign-new"]], decls: 21, vars: 9, consts: [["mat-dialog-title", "", 1, "ebo-dialog-header"], [1, "ebo-dialog-title"], ["mat-icon-button", "", "type", "button", "mat-dialog-close", "", 1, "close"], [3, "formGroup"], [1, "row"], ["appearance", "fill", 1, "col-12"], [3, "formControl"], [3, "label", 4, "ngFor", "ngForOf"], [3, "hidden"], [1, "ebo-dialog-actions"], ["type", "submit", "mat-raised-button", "", "color", "primary", 3, "disabled", "click"], [3, "label"], [3, "value", "ngStyle", 4, "ngFor", "ngForOf"], [3, "value", "ngStyle"]], template: function ClassificationAssignNewComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0)(1, "span", 1)(2, "mat-icon");
            i0.ɵɵtext(3, "assignment");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "button", 2)(6, "mat-icon");
            i0.ɵɵtext(7, "close");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(8, "form", 3)(9, "mat-dialog-content")(10, "div", 4)(11, "mat-form-field", 5)(12, "mat-label");
            i0.ɵɵtext(13);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "mat-select", 6);
            i0.ɵɵtemplate(15, ClassificationAssignNewComponent_mat_optgroup_15_Template, 2, 2, "mat-optgroup", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "mat-error", 8);
            i0.ɵɵtext(17);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(18, "mat-dialog-actions", 9)(19, "button", 10);
            i0.ɵɵlistener("click", function ClassificationAssignNewComponent_Template_button_click_19_listener() { return ctx.assignClassification_Click(); });
            i0.ɵɵtext(20);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", ctx.m_classificationAssignNewIntl.assignClassification, " ");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("formGroup", ctx.classificationAssignForm);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.m_classificationAssignNewIntl.classification);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControl", ctx.m_attributeControl);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.classifications);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hidden", ctx.m_attributeControl.untouched || !ctx.m_attributeControl.hasError("required"));
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.m_classificationAssignNewIntl.required, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.classificationAssignForm.invalid);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.m_classificationAssignNewIntl.assignClassificationButton, " ");
        } }, dependencies: [i1$1.NgForOf, i1$1.NgStyle, i3.MatIcon, i2.MatFormField, i2.MatLabel, i2.MatError, i13.MatSelect, i8.MatOption, i8.MatOptgroup, i6.ɵNgNoValidate, i6.NgControlStatus, i6.NgControlStatusGroup, i6.FormControlDirective, i6.FormGroupDirective, i3$2.MatButton, i3$2.MatIconButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions], styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;flex:1 1 auto}form[_ngcontent-%COMP%]{width:100%}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClassificationAssignNewComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-classification-assign-new', template: "<h1 mat-dialog-title class=\"ebo-dialog-header\">\n    <span class=\"ebo-dialog-title\">\n        <mat-icon>assignment</mat-icon>\n        {{m_classificationAssignNewIntl.assignClassification}}\n    </span>\n    <button mat-icon-button type=\"button\" class=\"close\" mat-dialog-close>\n        <mat-icon>close</mat-icon>\n    </button>\n</h1>\n<form [formGroup]=\"classificationAssignForm\">\n    <mat-dialog-content>\n        <div class=\"row\">\n            <mat-form-field appearance=\"fill\" class=\"col-12\">\n                <mat-label>{{m_classificationAssignNewIntl.classification}}</mat-label>\n                <mat-select [formControl]=\"m_attributeControl\">\n                    <mat-optgroup *ngFor=\"let classif of classifications\"\n                                  [label]=\"classif.name\">\n                        <mat-option *ngFor=\"let cls of classif.classes\"\n                                    [value]=\"cls.oid\"\n                                    [ngStyle]=\"getOptionsStyle(cls)\">\n                            {{cls.name}}\n                        </mat-option>\n                    </mat-optgroup>\n                </mat-select>\n                <mat-error [hidden]=\"m_attributeControl.untouched || !m_attributeControl.hasError('required')\">\n                    {{m_classificationAssignNewIntl.required}}\n                </mat-error>\n            </mat-form-field>\n        </div>\n    </mat-dialog-content>\n    <mat-dialog-actions class=\"ebo-dialog-actions\">\n        <button type=\"submit\"\n                mat-raised-button\n                color=\"primary\"\n                (click)=\"assignClassification_Click()\"\n                [disabled]=\"classificationAssignForm.invalid\">\n            {{m_classificationAssignNewIntl.assignClassificationButton}}\n        </button>\n    </mat-dialog-actions>\n</form>", styles: [":host{display:flex;flex-direction:column;flex:1 1 auto}form{width:100%}\n"] }]
    }], function () { return [{ type: i6.FormBuilder }, { type: i1.MatDialogRef }, { type: ClassificationAssignNewIntl, decorators: [{
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

/**
 * Utility Klasse welche verschiedene Date Hilfs-Funktionen bereitstellt
 *
 * @TODO wenn TypeScript irgendwann ein final/sealed Modifier implementiert, diesen dieser Klasse hinzufügen :)
 */
class DateUtility {
    // nicht instanziierbar
    constructor() { }
    static localDateStringToUTCDate(dateString) {
        let parsedDate;
        if (dateString != null) {
            let year = Number.parseInt(dateString.substr(0, 4));
            let month = Number.parseInt(dateString.substr(5, 2)) - 1;
            let day = Number.parseInt(dateString.substr(8, 2));
            if (dateString.length > 10) {
                let hours = Number.parseInt(dateString.substr(11, 2));
                let minutes = Number.parseInt(dateString.substr(14, 2));
                parsedDate = new Date(year, month, day, hours, minutes);
            }
            else {
                parsedDate = new Date(year, month, day);
            }
        }
        return parsedDate;
    }
    /**
   * Compares two Date objects and returns e number value that represents
   * the result:
   * 0 if the two dates are equal.
   * 1 if the first date is greater than second.
   * -1 if the first date is less than second.
   * @param date1 First date object to compare.
   * @param date2 Second date object to compare.
   */
    static compareDate(date1, date2) {
        // With Date object we can compare dates them using the >, <, <= or >=.
        // The ==, !=, ===, and !== operators require to use date.getTime(),
        // so we need to create a new instance of Date with 'new Date()'
        let d1 = new Date(date1);
        let d2 = new Date(date2);
        // Check if the dates are equal
        let same = d1.getTime() === d2.getTime();
        if (same)
            return 0;
        // Check if the first is greater than second
        if (d1 > d2)
            return 1;
        // Check if the first is less than second
        if (d1 < d2)
            return -1;
    }
    static localDateToUTC_ISO_DateString(localDate) {
        let myDate = localDate.toISOString();
        return myDate.slice(0, myDate.length - 1);
    }
    /** Da Safari und Firefox nicht mit datetime-local umgehen können,
     * wird geprüft, ob es sich beim verwendeten Browser um einen von diesen
     * handelt.
     *
     * 19.07.2023 Firefox auch als Safari haben den Support für datetime-local seit einiger Zeit nachgeliefert. (https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/datetime-local#browser_compatibility)
     * Angular bietet zudem eine zuverlässige Hilfsmethode welche angibt welche Inputtypen des verwendeten Browser untersützt werden.
     *
     * @deprecated see @method supportsInputType
     */
    static get canBrowserHandleDateTimeLocal() {
        let userAgent = window.navigator.userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        let currentBrowserName = userAgent.toString().toLowerCase();
        let canBrowserHandleDateTimeLocal = currentBrowserName.includes('safari') === false && currentBrowserName.includes('firefox') === false;
        return canBrowserHandleDateTimeLocal;
    }
    static supportsInputType(p_type) {
        // see (https://material.angular.io/cdk/platform/api#cdk-platform-functions)
        return getSupportedInputTypes().has(p_type);
    }
    static addMonth(p_date, p_month) {
        let year = p_date.getFullYear();
        let month = p_date.getMonth() + p_month;
        let day = p_date.getDate();
        if (month >= 12) {
            month -= 12;
            year++;
        }
        if (day > 28 && month == 1)
            day = 28;
        if (day == 31 && [3, 5, 8, 10].includes(month))
            day = 30;
        return new Date(year, month, day);
    }
}

class ClassificationIntl {
    constructor() {
        this.changes = new Subject();
        this.buttonSave = 'Speichern';
        this.buttonSaveTooltip = 'Speichern';
        this.buttonUndo = 'Verwerfen';
        this.buttonUndoTooltip = 'Änderungen rückgängig machen';
        this.buttonAssignNew = 'Klassifikation hinzufügen';
        this.buttonAssignNewTooltip = 'Neue Klassifikation zuordnen';
        this.buttonAssignmentRemove = 'Zuordnung entfernen';
        this.boolYes = 'Ja';
        this.boolNo = 'Nein';
        this.noClassification = 'Keine Merkmale vorhanden';
    }
    static { this.ɵfac = function ClassificationIntl_Factory(t) { return new (t || ClassificationIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ClassificationIntl, factory: ClassificationIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClassificationIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

class StringUtility {
    /**
     * Vergleicht einen String gegen einen Filter-String. Der Filterstring kann am Anfang und/oder Ende einen * für beliebige Zeichen enthalten.
     * Ohne * werden die Strings auf Gleichheit geprüft.
     *
     * Spezialfälle:
     * * Wenn p_filterStr **nicht** definiert oder gleich '*' ist, wird true zurückgegeben (da nichts zu filtern ist).
     * * Wenn p_filterStr definiert (und ungleich '*') ist, aber p_stringToCheck **nicht**, wird false zurückgegeben
     * @param p_stringToCheck Zu überprüfender String
     * @param p_filterStr Filter-String
     * @returns true, wenn der zu überprüfende String zum Filter-String passt, sonst false.
     */
    static compareStringAgainstFilter(p_stringToCheck, p_filterStr) {
        let checkResult = !p_filterStr || p_filterStr === '*';
        if (p_stringToCheck && !checkResult) {
            const stringToCheck = p_stringToCheck.toLowerCase();
            let filterStr = p_filterStr.toLowerCase();
            let checkStart = false, checkEnd = false;
            if (filterStr.startsWith('*')) {
                filterStr = filterStr.substring(1);
                checkEnd = true;
            }
            if (filterStr.endsWith('*')) {
                filterStr = filterStr.substring(0, filterStr.length - 1);
                checkStart = true;
            }
            if (checkStart && checkEnd)
                checkResult = stringToCheck.includes(filterStr);
            else if (checkStart)
                checkResult = stringToCheck.startsWith(filterStr);
            else if (checkEnd)
                checkResult = stringToCheck.endsWith(filterStr);
            else
                checkResult = stringToCheck === filterStr;
        }
        return checkResult;
    }
}

class ObjectUtility {
    /** sinn? */
    // public static readonly TODAY = new Date();
    // nicht instanziierbar
    constructor() { }
    static areObjectsEqual(p_obj1, p_obj2) {
        if (!p_obj1 || !p_obj2)
            return !p_obj1 && !p_obj2;
        if (typeof p_obj1 != typeof p_obj2)
            return false;
        if (['string', 'number', 'boolean'].includes(typeof p_obj1))
            return p_obj1 == p_obj2;
        if (typeof p_obj1 == 'function')
            return p_obj1.name == p_obj2.name;
        const keys1 = Object.keys(p_obj1).sort();
        const keys2 = Object.keys(p_obj2).sort();
        if (keys1.length != keys2.length || keys1.some((key, idx) => key != keys2[idx]))
            return false;
        return !keys1.some(key => !ObjectUtility.areObjectsEqual(p_obj1[key], p_obj2[key]));
    }
}

/* Wird sowohl für LogContextFilter, als auch für LogContext verwendet! */
const STRING_FIELDS = ['fileName', 'className', 'functionName'];
;
class LogContextBuilder {
    constructor(p_fileName, p_className) {
        this.ctx = {
            fileName: p_fileName,
            className: p_className,
            additionalInfo: [],
            parameters: []
        };
    }
    static getInstance(p_fileName, p_className, p_functionName, p_category) {
        let logCtxBuilder = new LogContextBuilder(p_fileName, p_className);
        if (p_functionName)
            logCtxBuilder = logCtxBuilder.setFunction(p_functionName);
        if (p_category)
            logCtxBuilder = logCtxBuilder.setCategory(p_category);
        return logCtxBuilder;
    }
    setCategory(p_category) {
        this.ctx.category = p_category;
        return this;
    }
    setFunction(p_functionName) {
        this.ctx.functionName = p_functionName;
        return this;
    }
    addParameter(...p_param) {
        p_param?.forEach(p => {
            if (p.value?.hasOwnProperty('serviceParms') && p.value['serviceParms'].hasOwnProperty['tlob']) {
                // structuredClone ist erst ab node-version 17.0.29 verfügbar
                //let clone = structuredClone(p.value);
                let clone = JSON.parse(JSON.stringify(p.value));
                clone.serviceParms.tlob.data = `${clone.serviceParms.tlob.data.slice(0, 15)}...`;
                this.ctx.parameters.push({ name: p.name, value: clone });
            }
            else
                this.ctx.parameters.push(p);
        });
        return this;
    }
    get(...p_additionalInfo) {
        let tempCtx = { ...this.ctx, additionalInfo: p_additionalInfo };
        return tempCtx;
    }
}
class LogContextHelper {
    /**
     * Prüft einen LogContext gegen einen Filter. Ist der Kontext oder der Filter ohne Werte, wird true zurück geliefert.
     * @param p_ctx LogContext der geprüft werden soll
     * @param p_filterContext LogFilter der zur überprüfung verwendet wird
     * @returns true, wenn der Kontext in allen definierten Feldern zudenen des Filters passt, sonst false.
     */
    static checkAgainstFilterContext(p_ctx, p_filterContext) {
        if (!LogContextHelper.hasValues(p_filterContext))
            return true; // Nichts zu filtern
        if (!LogContextHelper.hasValues(p_ctx))
            return true;
        /* Achtung: doppelte Verneinung!! .some(..) liefert nur true, wenn einer der compareStringAgainstFilter false ergibt.
                    ctxResult ist true, wenn .some(..) false liefert.
                    => ctxResult ist true, wenn alle compareStringAgainstFilter true ergeben!
        */
        let ctxResult = !STRING_FIELDS.some(key => !StringUtility.compareStringAgainstFilter(p_ctx[key], p_filterContext[key]));
        ctxResult = ctxResult && LogContextHelper.checkCategoryAgainstFilterCategory(p_ctx.category, p_filterContext.category);
        return ctxResult;
    }
    static hasValues(p_context) {
        return !!p_context.category || STRING_FIELDS.some(key => p_context[key] && p_context[key] != '*');
    }
    static containsSearchString(p_context, p_searchString) {
        let containsString = Object.keys(p_context).some(key => {
            if (typeof p_context[key] == 'string')
                return p_context[key].includes(p_searchString);
            else
                return false;
        });
        if (!containsString)
            containsString = p_context.category?.name?.includes(p_searchString);
        if (!containsString)
            containsString = p_context.additionalInfo?.some(ai => ai.includes(p_searchString));
        if (!containsString)
            containsString = p_context.parameters?.some(param => param.name.includes(p_searchString));
        return containsString;
    }
    static contextToString(p_ctx, p_complete) {
        let formatString = '';
        if (p_ctx.category) {
            formatString += p_ctx.category.translation;
            if (p_ctx.className || p_ctx.functionName || p_ctx.fileName)
                formatString += ' - ';
        }
        if (p_ctx.className || p_ctx.functionName) {
            if (p_ctx.className)
                formatString += p_ctx.className;
            if (p_ctx.className && p_ctx.functionName)
                formatString += '.';
            if (p_ctx.functionName)
                formatString += p_ctx.functionName;
            if (LogContextHelper.isLogContext(p_ctx)) {
                if (p_ctx.additionalInfo?.length > 0)
                    formatString += ' [' + p_ctx.additionalInfo.join('>') + ']';
                if (p_complete && p_ctx.parameters?.length > 0)
                    formatString += ' [' + p_ctx.parameters.map(LogContextHelper.parameterToString).join(';') + ']';
            }
        }
        if (p_ctx.fileName) {
            if (p_ctx.className || p_ctx.functionName)
                formatString += ' (' + p_ctx.fileName + ')';
            else
                formatString += p_ctx.fileName;
        }
        return formatString;
    }
    static areEquals(p_ctx1, p_ctx2) {
        if (!p_ctx1 || !p_ctx2)
            return !p_ctx1 && !p_ctx2;
        let notEquals = STRING_FIELDS.some(key => {
            if (!p_ctx1[key] || !p_ctx2[key]) // Mind. einer hat keinen Wert
                return !!p_ctx1[key] || !!p_ctx2[key]; // => Werte sind ungleich, wenn einer einen Wert hat
            else
                return p_ctx1[key] != p_ctx2[key];
        });
        if (!notEquals)
            notEquals = p_ctx1.category?.name != p_ctx2.category?.name;
        if (LogContextHelper.isLogContext(p_ctx1) && LogContextHelper.isLogContext(p_ctx2)) {
            if (!notEquals) {
                let addInfo1 = p_ctx1.additionalInfo?.sort() ?? [];
                let addInfo2 = p_ctx2.additionalInfo?.sort() ?? [];
                if (addInfo1.length > 0 || addInfo2.length > 0) {
                    notEquals = addInfo1.length != addInfo2.length;
                    if (!notEquals)
                        notEquals = addInfo1.some((ai, idx) => ai != addInfo2[idx]);
                }
            }
            if (!notEquals) {
                let parms1 = p_ctx1.parameters?.sort(LogContextHelper.sortParameters) ?? [];
                let parms2 = p_ctx2.parameters?.sort(LogContextHelper.sortParameters) ?? [];
                if (parms1.length > 0 || parms2.length > 0) {
                    notEquals = parms1.length != parms2.length;
                    if (!notEquals)
                        notEquals = parms1.some((param, idx) => !LogContextHelper.areParametersEqual(param, parms2[idx]));
                }
            }
        }
        return !notEquals;
    }
    static compareContextFilter(p_filter1, p_filter2) {
        let compareResult = LogContextHelper.compareStrings(p_filter1?.category?.translation, p_filter2?.category?.translation);
        if (compareResult == 0)
            compareResult = LogContextHelper.compareStrings(p_filter1?.fileName, p_filter2?.fileName);
        if (compareResult == 0)
            compareResult = LogContextHelper.compareStrings(p_filter1?.className, p_filter2?.className);
        if (compareResult == 0)
            compareResult = LogContextHelper.compareStrings(p_filter1?.functionName, p_filter2?.functionName);
        return compareResult;
    }
    /* #region private static functions */
    static parameterToString(p_param) {
        let paramString = '';
        if (p_param)
            paramString = p_param.name + ': ' + JSON.stringify(p_param.value);
        return paramString;
    }
    static sortParameters(a, b) {
        if (a.name < b.name)
            return -1;
        if (a.name > b.name)
            return 1;
        return 0;
    }
    static areParametersEqual(p_param1, p_param2) {
        if (p_param1.name != p_param2.name)
            return false;
        return ObjectUtility.areObjectsEqual(p_param1.value, p_param2.value);
    }
    /**
       * Liefert true, wenn die beiden Kategorien den gelichen Namen haben oder p_category eine Vorgängerkomponente (parentCategory)
       * mit dem Namen der p_filterCategory hat.
       * Wenn eine der beiden Kategorien falsy ist, wird true gelifert.
       * @param p_category
       * @param p_filterCategory
       * @returns
       */
    static checkCategoryAgainstFilterCategory(p_category, p_filterCategory) {
        if (!p_filterCategory || !p_category || p_category.name == p_filterCategory.name)
            return true;
        if (!p_category.parentCategory)
            return false;
        return LogContextHelper.checkCategoryAgainstFilterCategory(p_category.parentCategory, p_filterCategory);
    }
    static isLogContext(p_ctx) {
        if (!p_ctx)
            return false;
        return ['additionalInfo', 'parameters'].some(key => p_ctx.hasOwnProperty(key));
    }
    static compareStrings(p_str1, p_str2) {
        if (p_str1 || p_str2) {
            if (!p_str1)
                return -1;
            else if (!p_str2)
                return 1;
            else if (p_str1.toLowerCase() === p_str2.toLowerCase())
                return 0;
            else if (p_str1.toLowerCase() < p_str2.toLowerCase())
                return -1;
            else
                return 1;
        }
        else
            return 0;
    }
}
;

// GENERATED FILE. DO NOT EDIT!
// GENERATOR       de.ebootis.sfx.sfxGen.TypescriptGen
class IMobileClassificationMtn {
    constructor(sfxService) {
        this.sfxService = sfxService;
        this.REMOTE_NAME = 'mobileclassificationmtn';
    }
    getClsAttributeValuesForOwner(ownerOid, clsProxyOid) {
        let params = new HttpParams();
        if (ownerOid != null) {
            params = params.set('ownerOid', ownerOid);
        }
        if (clsProxyOid != null) {
            params = params.set('clsProxyOid', clsProxyOid);
        }
        return this.sfxService.get(this.REMOTE_NAME, "getClsAttributeValuesForOwner", params);
    }
    getClsClass(oid) {
        let params = new HttpParams();
        if (oid != null) {
            params = params.set('oid', oid);
        }
        return this.sfxService.get(this.REMOTE_NAME, "getClsClass", params);
    }
    getClsClassListByOwner(ownerOid, classOid) {
        let params = new HttpParams();
        if (ownerOid != null) {
            params = params.set('ownerOid', ownerOid);
        }
        if (classOid != null) {
            params = params.set('classOid', classOid);
        }
        return this.sfxService.get(this.REMOTE_NAME, "getClsClassListByOwner", params);
    }
    getClsClassOwnerListBySearchParams(searchParams) {
        let params = {};
        if (searchParams != null) {
            params.searchParams = searchParams;
        }
        return this.sfxService.post(this.REMOTE_NAME, "getClsClassOwnerListBySearchParams", params);
    }
    saveItemAttributes(param) {
        let params = {};
        if (param != null) {
            params.param = param;
        }
        return this.sfxService.post(this.REMOTE_NAME, "saveItemAttributes", params);
    }
    static { this.ɵfac = function IMobileClassificationMtn_Factory(t) { return new (t || IMobileClassificationMtn)(i0.ɵɵinject(SFX_SERVICE_INVOKER)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IMobileClassificationMtn, factory: IMobileClassificationMtn.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IMobileClassificationMtn, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [SFX_SERVICE_INVOKER]
            }] }]; }, null); })();
(function (IMobileClassificationMtn) {
    //TypeDesc("de.ebootis.fet.webapps.shared.common.IMobileClassificationMtn$ClassificationSearchParams")
    class ClassificationSearchParams {
    }
    IMobileClassificationMtn.ClassificationSearchParams = ClassificationSearchParams;
    //TypeDesc("de.ebootis.fet.webapps.shared.common.IMobileClassificationMtn$ClsAttribute")
    class ClsAttribute {
    }
    IMobileClassificationMtn.ClsAttribute = ClsAttribute;
    //TypeDesc("de.ebootis.fet.webapps.shared.common.IMobileClassificationMtn$ClsAttributeValue")
    class ClsAttributeValue {
    }
    IMobileClassificationMtn.ClsAttributeValue = ClsAttributeValue;
    //TypeDesc("de.ebootis.fet.webapps.shared.common.IMobileClassificationMtn$ClsClass")
    class ClsClass {
    }
    IMobileClassificationMtn.ClsClass = ClsClass;
    //TypeDesc("de.ebootis.fet.webapps.shared.common.IMobileClassificationMtn$ClsClassOwner")
    class ClsClassOwner {
    }
    IMobileClassificationMtn.ClsClassOwner = ClsClassOwner;
    //TypeDesc("de.ebootis.fet.webapps.shared.common.IMobileClassificationMtn$ClsClassSystem")
    class ClsClassSystem {
    }
    IMobileClassificationMtn.ClsClassSystem = ClsClassSystem;
    //TypeDesc("de.ebootis.fet.webapps.shared.common.IMobileClassificationMtn$ClsEnumValue")
    class ClsEnumValue {
    }
    IMobileClassificationMtn.ClsEnumValue = ClsEnumValue;
    //TypeDesc("de.ebootis.fet.webapps.shared.common.IMobileClassificationMtn$ClsLayout")
    class ClsLayout {
    }
    IMobileClassificationMtn.ClsLayout = ClsLayout;
    //TypeDesc("de.ebootis.fet.webapps.shared.common.IMobileClassificationMtn$ClsLayoutAttribute")
    class ClsLayoutAttribute {
    }
    IMobileClassificationMtn.ClsLayoutAttribute = ClsLayoutAttribute;
    //TypeDesc("de.ebootis.fet.webapps.shared.common.IMobileClassificationMtn$ClsLayoutElement")
    class ClsLayoutElement {
    }
    IMobileClassificationMtn.ClsLayoutElement = ClsLayoutElement;
    //TypeDesc("de.ebootis.fet.webapps.shared.common.IMobileClassificationMtn$ClsLayoutGroup")
    class ClsLayoutGroup {
    }
    IMobileClassificationMtn.ClsLayoutGroup = ClsLayoutGroup;
    //TypeDesc("de.ebootis.fet.webapps.shared.common.IMobileClassificationMtn$SaveItemAttributesParam")
    class SaveItemAttributesParam {
    }
    IMobileClassificationMtn.SaveItemAttributesParam = SaveItemAttributesParam;
    //TypeDesc("de.ebootis.fet.webapps.shared.common.IMobileClassificationMtn$SaveItemAttributesResult")
    class SaveItemAttributesResult {
    }
    IMobileClassificationMtn.SaveItemAttributesResult = SaveItemAttributesResult;
})(IMobileClassificationMtn || (IMobileClassificationMtn = {}));

/**
 * InjectionToken
 */
const LOGGER_FORMAT_SERVICE = new InjectionToken('LOGGER_FORMAT_SERVICE');

/**
 * InjectionToken
 */
const LOGGER_WRITER_SERVICE = new InjectionToken('LOGGER_WRITER_SERVICE');

class UserSettingsService {
    constructor(m_offlineService) {
        this.m_offlineService = m_offlineService;
        this.STANDARD_PAGE_SIZE_OPTIONS = [5, 10, 25, 50, 100];
        this.STANDARD_SEARCH_LIMIT = 50;
        this.STANDARD_SEARCH_LIMITS = [50, 100, 500];
    }
    /** Holt einen UserSettings-Wert anhand des Contexts
     * @param p_id: Die Komponente
     */
    getUserSettings(p_id) {
        let id = this.removeComponentSubstrings(p_id);
        return this.m_offlineService.get(id).pipe(map((x) => {
            if (!x) {
                return {
                    id: p_id,
                    formSettings: [],
                    tableSettings: []
                };
            }
            return x;
        }));
    }
    /**
     * Entfernt den SubString "Component" aus dem Context,
     * um die Lesbarkeit zu erhöhen
     */
    removeComponentSubstrings(p_id) {
        let componentParts = p_id?.split('Component');
        let res = '';
        componentParts?.forEach(part => {
            res = res + part;
        });
        if (res == '')
            res = p_id;
        return res;
    }
    /** Speichert die UserSettings in die IndexedDB.*/
    saveUserSettings(p_settings) {
        return new Observable((os) => {
            if (p_settings.tableSettings) {
                p_settings.tableSettings.forEach(setting => {
                    if (!setting.tableName || setting.tableName === 'undefined') {
                        os.error(new Error("Couldn't save UserSettings: TableName was undefined"));
                    }
                });
            }
            if (p_settings.formSettings) {
                p_settings.formSettings.forEach(setting => {
                    if (!setting.formName || setting.formName === 'undefined') {
                        os.error(new Error("Couldn't save UserSettings: FormName was undefined"));
                    }
                });
            }
            p_settings.id = this.removeComponentSubstrings(p_settings.id);
            return this.m_offlineService.post(p_settings)
                .subscribe({
                next: (v) => {
                    os.next(p_settings);
                    os.complete();
                },
                error: (e) => {
                    os.error(e);
                },
                complete: () => {
                    os.complete();
                }
            });
        });
    }
    /** Gibt die Tabelleneinstellungen für eine bestimmte Tabelle zurück,
     *  entweder aus den Settings oder die Standards.
     */
    getTableSettings(p_userSettings, p_tableName) {
        if (!p_userSettings) {
            return null;
        }
        if (!p_tableName) {
            throw new Error('tableName required');
        }
        if (!p_userSettings.tableSettings) {
            p_userSettings.tableSettings = new Array();
        }
        let tableSettings = p_userSettings.tableSettings.find(settings => settings.tableName === p_tableName);
        if (!tableSettings) {
            tableSettings = {
                tableName: p_tableName,
                pageSizeOptions: this.STANDARD_PAGE_SIZE_OPTIONS,
                pageSize: this.STANDARD_PAGE_SIZE_OPTIONS[0],
                columnSettings: []
            };
            p_userSettings.tableSettings.push(tableSettings);
        }
        return tableSettings;
    }
    getDisplayedColumns(p_userSettings, p_tableName, p_availableColumns) {
        if (!p_userSettings || !p_tableName)
            return p_availableColumns || [];
        let tableSettings = this.getTableSettings(p_userSettings, p_tableName);
        return this.getDisplayedColumnsByTableSettings(tableSettings, p_availableColumns, []);
    }
    getDisplayedColumnsByTableSettings(p_tableSettings, p_availableColumns, p_translations) {
        let displayedColumns = [];
        let colSettings = p_tableSettings?.columnSettings;
        if (colSettings?.length > 0) {
            colSettings.sort(this.compareColSettings);
            displayedColumns = colSettings.reduce((arr, col) => !col.hidden ? [...arr, col.colName] : arr, []);
        }
        if (p_availableColumns?.length > 0) {
            if (displayedColumns.length == 0) {
                displayedColumns = p_availableColumns;
            }
            else {
                p_availableColumns.forEach(colName => {
                    let setting = colSettings?.find(cs => cs.colName == colName);
                    if (!setting?.hidden && !displayedColumns.find(displayedCol => displayedCol == colName)) {
                        // displayedColumns.push(colName);
                        colSettings.push({
                            colName: colName,
                            hidden: true,
                            translation: p_translations?.find(translation => translation.colName === colName)?.translation,
                        });
                    }
                });
            }
        }
        return displayedColumns;
    }
    /**
     * Gibt die FormSettings für ein Formular zurück. Legt diese mit Standardwerten an,
     * sofern sie nicht in den UserSettings existieren.
     */
    getFormSettings(p_userSettings, p_formName) {
        if (!p_userSettings) {
            return null;
        }
        if (!p_formName) {
            throw new Error('formName required!');
        }
        if (!p_userSettings.formSettings) {
            p_userSettings.formSettings = new Array();
        }
        let formSettings = p_userSettings.formSettings.find(settings => settings.formName === p_formName);
        if (!formSettings) {
            formSettings = {
                formName: p_formName,
                searchLimit: this.STANDARD_SEARCH_LIMIT
            };
            p_userSettings.formSettings.push(formSettings);
        }
        return formSettings;
    }
    compareColSettings(colSettingA, colSettingB) {
        if (colSettingA != null && colSettingB != null) {
            if (colSettingA.order != null && colSettingB.order != null)
                return colSettingA.order - colSettingB.order;
            else if (colSettingA.order != null)
                return 1;
            else if (colSettingB.order != null)
                return -1;
            else
                return 0;
        }
        else if (colSettingA != null)
            return 1;
        else if (colSettingB != null)
            return -1;
        else
            return 0;
    }
    static { this.ɵfac = function UserSettingsService_Factory(t) { return new (t || UserSettingsService)(i0.ɵɵinject(USER_SETTINGS_DB_SERVICE)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UserSettingsService, factory: UserSettingsService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserSettingsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [USER_SETTINGS_DB_SERVICE]
            }] }]; }, null); })();

/* #endregion Type-Definitions */
/* #region Prüf-Funktionen zu den Typen */
function isValidObject(p_objectToCheck) {
    if (!p_objectToCheck)
        return false;
    else if (!p_objectToCheck.className && !p_objectToCheck.functionName)
        return false;
    else
        return true;
}
function isValidClassFunctionFilter(p_filter) {
    if (!p_filter)
        return false;
    else if (!p_filter.className && (p_filter.functions?.length ?? 0) == 0)
        return false;
    else
        return true;
}
/* #region Prüf-Funktionen zu den Typen */
class StackTraceService {
    constructor(platform) {
        this.platform = platform;
        if (platform.IOS || platform.FIREFOX || platform.SAFARI || platform.WEBKIT)
            this.browserStackTrace = new StackTraceWithFunctionOnly();
        else
            this.browserStackTrace = new StackTraceWithClassAndFunction();
    }
    /**
     * Liefert einen gefilterten Stacktrace von dem Objekt (sofern vorhanden)
     * oder erstellt einen Dummy Error, dessen Stacktrace gefiltert zurückgegeben wird.
     * Gefiltert werden Methoden der Frameworks und Libraries, die den Stacktrace unnötig aufblähen.
     * (z.B.: alles Observable-, Zone-Methoden o.Ä.)
     * @param p_msg Objekt mit Stacktrace (optional)
     * @returns Stacktrace als String-Array
     */
    getFilteredStackTrace(p_msg) {
        try {
            let stackTrace;
            if (p_msg?.stack && typeof p_msg.stack === 'string')
                stackTrace = p_msg.stack.split('\n');
            else {
                stackTrace = new Error().stack?.split('\n');
            }
            return stackTrace.filter(line => this.browserStackTrace.filterLine(line))
                .map(line => line.trim());
        }
        catch (err) {
            return null;
        }
    }
    filterStackTrace(p_stackTrace) {
        if ((p_stackTrace?.length ?? 0) == 0)
            return null;
        try {
            return p_stackTrace.split('\n')
                .filter(line => this.browserStackTrace.filterLine(line))
                .map(line => line.trim());
        }
        catch (err) {
            return null;
        }
    }
    /**
     * Erzeugt einen Dummy-Error und liefert aus dessen Stacktrace die erste Zeile zurück, die nicht zum
     * StackTraceService oder LoggerService gehört zurück, sofern diese nicht in die allgemeinen Filter-
     * Kriterien erfüllt (d.h. keine rxJs-, Zone-Methode o.Ä. ist)
     * Damit enthält das zurückgegeben Objekt vermutlich eine eigenen implementierte Methode.
     * @returns
     */
    getCallingFunction() {
        try {
            let stackTrace = new Error().stack?.split('\n');
            stackTrace = stackTrace?.filter(line => this.browserStackTrace.filterLine(line, true))
                .map(line => line.trim());
            let callingFunctionLine;
            if (stackTrace?.length > 0 && this.browserStackTrace.filterLine(stackTrace[0]))
                callingFunctionLine = stackTrace[0];
            return this.browserStackTrace.parseLine(callingFunctionLine);
        }
        catch (err) {
            return null;
        }
    }
    static { this.ɵfac = function StackTraceService_Factory(t) { return new (t || StackTraceService)(i0.ɵɵinject(i1$2.Platform)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: StackTraceService, factory: StackTraceService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StackTraceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$2.Platform }]; }, null); })();
/* Chromium-spezifische Implementierungen */
class StackTraceWithClassAndFunction {
    constructor() {
        this.STACK_TRACE_FILTER = [
            { className: 'LoggerService' }, { className: 'StackTraceService' },
            { className: 'IDBRequest' }, { className: 'XMLHttpRequest' },
            { className: 'Object' }, { className: '*Subject' },
            { className: 'Observable' }, { className: '_Observable*' },
            { className: '*Subscriber' }, { className: '*Operator' },
            { className: 'ZipBufferIterator' },
            { className: 'Zone*' }, { className: '_ZoneDelegate' },
            { functions: ['innerSubscribe', 'invokeTask', 'globalCallback', 'drainMicroTaskQueue'] }
        ];
        this.STACK_TRACE_FILTER_LOGGER = [
            { className: 'LoggerService' }, { className: 'StackTraceService' }
        ];
        Error['stackTraceLimit'] = Infinity;
    }
    filterLine(p_stackTraceLine, p_onlyLogger) {
        const stackObject = this.parseLine(p_stackTraceLine);
        if (isValidObject(stackObject) == false)
            return false;
        else if (p_onlyLogger)
            return !this.STACK_TRACE_FILTER_LOGGER.some(f => this.checkObjectAgainstClassFilter(stackObject, f));
        else
            return !this.STACK_TRACE_FILTER.some(f => this.checkObjectAgainstClassFilter(stackObject, f));
    }
    parseLine(p_stackTraceLine) {
        if (!p_stackTraceLine)
            return null;
        let startIndex = p_stackTraceLine.indexOf('at ');
        if (startIndex < 0)
            return null;
        startIndex += 3;
        let endIndex = p_stackTraceLine.indexOf(' (', startIndex);
        let asIndex = p_stackTraceLine.indexOf(' [as', startIndex);
        if (asIndex >= startIndex && (asIndex < endIndex || (asIndex > 0 && endIndex < 0)))
            endIndex = asIndex;
        if (endIndex < 0)
            endIndex = p_stackTraceLine.indexOf('http://', startIndex);
        if (endIndex < 0)
            endIndex = p_stackTraceLine.length;
        if (startIndex < endIndex) {
            const arr = p_stackTraceLine.substring(startIndex, endIndex).split('.');
            return {
                functionName: arr.pop(),
                className: arr.join('.')
            };
        }
        else
            return null;
    }
    checkObjectAgainstClassFilter(p_objectToCheck, p_filter) {
        if (isValidObject(p_objectToCheck) == false)
            return true; // leere Objekte werden pauschal gefiltert
        if (isValidClassFunctionFilter(p_filter) == false)
            return false; // leere Filter sind niemals erfüllt
        let checkResult = StringUtility.compareStringAgainstFilter(p_objectToCheck.className, p_filter.className);
        // Wenn das Objekt passt, weiter die Funktion prüfen
        if (checkResult && p_filter.functions?.length > 0)
            checkResult = p_filter.functions.some(func => StringUtility.compareStringAgainstFilter(p_objectToCheck.functionName, func));
        return checkResult;
    }
}
/* Firefox/Safari-spezifische Implementierungen */
class StackTraceWithFunctionOnly {
    constructor() {
        this.STACK_TRACE_FILTER = [
            { functionName: 'AppModule*' }, { functionName: '*ModuleInjector' }, { functionName: 'NgModuleRef' },
            { functionName: '_resolveInjectorDefTypes' }, { functionName: '*RootComponent' },
            { functionName: '*bootstrap*' },
            { functionName: 'call' }, { functionName: 'create' }, { functionName: 'get' },
            { functionName: 'defer' }, { functionName: 'iif' }, { functionName: 'onLoad' },
            { functionName: 'hydrate' }, { functionName: 'run' }, { functionName: 'then' },
            { functionName: '_complete' }, { functionName: 'complete' },
            { functionName: 'getOrCreateInjectable' },
            { functionName: '*error' },
            { functionName: 'globalCallback' }, { functionName: 'globalZoneAwareCallback' },
            { functionName: 'handle' }, { functionName: '*handleEvent*customScheduleGlobal' },
            { functionName: '*inject' }, { functionName: 'injectInjectorOnly' }, { functionName: 'getNodeInjectable' },
            { functionName: '*invoke' },
            { functionName: '_log' }, { functionName: 'log*' },
            { functionName: 'makeAddListener' },
            { functionName: '_next' }, { functionName: 'next' }, { functionName: 'notifyNext' }, { functionName: '_tryNext' },
            { functionName: 'nextInfiniteTimeWindow' }, { functionName: 'notifyComplete' },
            { functionName: 'patchTimer*' }, { functionName: 'patchMethod*' },
            { functionName: 'shareReplayOperation' },
            { functionName: 'scheduleResolveOrReject' }, { functionName: 'scheduleMacroTask*' }, { functionName: '*ScheduleMicroTask' },
            { functionName: '_subscribe' }, { functionName: 'subscribe*' }, { functionName: '__tryOrUnsub' },
            { functionName: '_trySubscribe' }, { functionName: '_innerSub' }, { functionName: 'innerSubscribe' },
            { functionName: '*scheduleTask*' }, { functionName: 'scheduleEventTask' }, { functionName: '*invokeTask' },
            { functionName: 'drainMicroTaskQueue' }, { functionName: 'runTask' }, { functionName: 'zoneTask' },
            { functionName: '__webpack*' }, { functionName: 'webpack*' },
            { functionName: 'wrapFn' }
        ];
        this.stackTraceFilterLogger = [];
        const objMethods = this.getObjectMethodsAsFunctionFilters(StackTraceService, LoggerService);
        this.stackTraceFilterLogger = [...objMethods];
        this.stackTraceFilter = [...this.STACK_TRACE_FILTER, ...objMethods];
    }
    filterLine(p_stackTraceLine, p_onlyLogger) {
        const stackObject = this.parseLine(p_stackTraceLine);
        if (isValidObject(stackObject) == false)
            return false;
        else if (p_onlyLogger)
            return !this.stackTraceFilterLogger.some(f => this.checkObjectAgainstFunctionFilter(stackObject, f));
        else
            return !this.stackTraceFilter.some(f => this.checkObjectAgainstFunctionFilter(stackObject, f));
    }
    parseLine(p_stackTraceLine) {
        let startIndex = 0;
        let endIndex = p_stackTraceLine?.indexOf('@', startIndex) ?? -1;
        if (endIndex > 0)
            return { functionName: p_stackTraceLine.substring(startIndex, endIndex).replace(/\/\</g, '') };
        else
            return null;
    }
    checkObjectAgainstFunctionFilter(p_objectToCheck, p_filter) {
        if (!p_filter || !p_filter.functionName)
            return false;
        return StringUtility.compareStringAgainstFilter(p_objectToCheck.functionName, p_filter.functionName);
    }
    getObjectMethodsAsFunctionFilters(...p_objects) {
        return p_objects.map(obj => Object.getOwnPropertyNames(obj?.prototype ?? {})
            .filter(prop => typeof obj.prototype[prop] === 'function')
            .map(method => { return { functionName: method }; }))
            .flat();
    }
}

var LogLevel;
(function (LogLevel) {
    /** Allgemeine Logs "Method called" */
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["WARNING"] = "WARNING";
    /** Zusatzinfo wie "Method complete" */
    LogLevel["SUCCESS"] = "SUCCESS";
    /**Zusatzinformationen wie "Revision" */
    LogLevel["INFO"] = "INFO";
})(LogLevel || (LogLevel = {}));
const LOG_LEVEL_ARRAY = [LogLevel.DEBUG, LogLevel.INFO, LogLevel.SUCCESS, LogLevel.WARNING, LogLevel.ERROR];
const LOG_SETTINGS_DEFAULT = {
    id: 'LogSettings',
    activeLogLevels: [LogLevel.DEBUG, LogLevel.ERROR],
    displayedLogLevels: [LogLevel.DEBUG, LogLevel.ERROR],
    activeLogContexts: [],
    shouldLog: true,
    logUntil: null,
};
class LogSettingsHelper {
    /**
     * Gibt an, ob zu den gegebenen Einstellungen ein Log erstellt wird.
     * D.h. das Flag 'Soll geloggt werden?' ist gesetzt, das 'Logging bis'-Datum ist nicht überschritten (falls angegeben)
     * und es gibt allgemeine LogLevel und/oder spezielle Logging-Kontexte, die geloggt werden sollen
     * @param p_settings Logger Einstellungen
     * @returns
     */
    static getIsLogSettingsActive(p_settings) {
        let logActive = p_settings?.shouldLog
            && (p_settings.activeLogLevels?.length > 0
                || p_settings.activeLogContexts?.length > 0);
        if (logActive && (p_settings.activeLogLevels?.length ?? 0) == 0 && p_settings.activeLogContexts?.length > 0) {
            // Spezialfall prüfen, wenn keine allgemeinen LogLevel, aber Kontexte, angegeben wurden.
            // Dann muss geprüft werden, dass bei mindestens einem Kontext auch ein LogLevel hinterlegt ist, 
            // sonst wird ebenfalls nichts geloggt
            logActive = p_settings.activeLogContexts.some(lc => lc.logLevels?.length > 0);
        }
        if (logActive && p_settings.logUntil) {
            // Prüfen, ob die zeitliche Begrenzung nicht überschritten wurde
            const now = new Date();
            logActive = now.getTime() < p_settings.logUntil.getTime();
        }
        return logActive;
    }
    /**
     * Gibt alle LogLevel aus, die in den gegebenene Einstellungen verwendet werden.
     * D.h. die allgemeinen LogLevel zusammen mit den LogLeveln aus den verschiedenen Kontexten
     * @param p_settings Logger Einstellungen
     * @returns
     */
    static getComulativeActiveLogLevels(p_settings) {
        let comulativeLogLevels = new Set(p_settings.activeLogLevels);
        p_settings.activeLogContexts?.forEach(logCtx => logCtx.logLevels.forEach(ll => comulativeLogLevels.add(ll)));
        return comulativeLogLevels;
    }
}
class LoggerService {
    get userLogSettings() {
        return this._userLogSettings;
    }
    set userLogSettings(p_logSettings) {
        this._userLogSettings = p_logSettings;
        this.userLogSettingsSubject.next(p_logSettings);
        this.shouldLogAccordingToSettings = LogSettingsHelper.getIsLogSettingsActive(p_logSettings);
        if (this.initializationLogs.length > 0) {
            // Gespeicherte Logs ausführen und den Speicher leeren
            this.initializationLogs.forEach(({ logLevel, param }) => this._log(logLevel, param));
            this.initializationLogs = [];
        }
    }
    constructor(m_userSettingsService, m_formatService, m_writerService, m_stackTraceService) {
        this.m_userSettingsService = m_userSettingsService;
        this.m_formatService = m_formatService;
        this.m_writerService = m_writerService;
        this.m_stackTraceService = m_stackTraceService;
        /**
         * Subject das die Logs hält
         */
        this.logsSubject = new BehaviorSubject([]);
        /**
         * Observable für die Logs
         */
        this.logs$ = this.logsSubject.asObservable();
        this.LOG_SETTINGS = 'LogSettings';
        this.MAX_LOGLEVEL_ENTRIES = 500;
        this.logs = new Array();
        this.userLogSettingsSubject = new BehaviorSubject(null);
        this.logSettings$ = this.userLogSettingsSubject.asObservable();
        this.logsSubject.next([]);
        this.m_index = 0;
        this.initializationLogs = [];
        this.m_userSettingsService.getUserSettings(this.LOG_SETTINGS)
            .pipe(take(1))
            .subscribe({
            next: (settings) => {
                this.userLogSettings = this.setDefaultsWhenNotDefined(settings);
            },
            error: (err) => {
                this.userLogSettings = this.setDefaultsWhenNotDefined();
                this.logError({
                    entry: err, context: {
                        fileName: 'logger.service.ts', className: 'LoggerService',
                        functionName: 'constructor', additionalInfo: ['getLogSettings']
                    }
                });
            }
        });
    }
    /* #region: LogSettings */
    setDefaultsWhenNotDefined(p_userSettings) {
        if (p_userSettings?.id != this.LOG_SETTINGS)
            return { ...LOG_SETTINGS_DEFAULT };
        else // Die Vorangestellten Werte werden von denen aus p_userSettings überschrieben, falls vorhanden
            return { ...LOG_SETTINGS_DEFAULT, ...p_userSettings };
    }
    saveLogSettings(p_logSettings) {
        return this.m_userSettingsService.saveUserSettings(p_logSettings)
            .pipe(switchMap((userSettings) => of(userSettings)))
            .pipe(tap((ls) => this.userLogSettings = ls));
    }
    /* #endregion: LogSettings */
    /* #region public logger-methods */
    logError(p_param) {
        this._log(LogLevel.ERROR, p_param);
    }
    logWarning(p_param) {
        this._log(LogLevel.WARNING, p_param);
    }
    logInfo(p_param) {
        this._log(LogLevel.INFO, p_param);
    }
    logSuccess(p_param) {
        this._log(LogLevel.SUCCESS, p_param);
    }
    logDebug(p_param) {
        this._log(LogLevel.DEBUG, p_param);
    }
    /* #endregion public logger-methods */
    /* #region private logger-methods */
    _log(p_logLevel, p_param) {
        if (!p_param.context)
            p_param.context = this.getLogContext();
        else if (!p_param.context.functionName)
            p_param.context = this.extendLogContext(p_param.context);
        // Wenn die LogSettings noch nicht geladen sind, werden die Einträge zwischengespeichert und später geschrieben
        if (!this.userLogSettings)
            this.initializationLogs.push({ logLevel: p_logLevel, param: p_param });
        else if (this.shouldLog(p_logLevel, p_param)) {
            let logEntry = this.createLogEntry(p_logLevel, p_param);
            this.displayEntryInConsole(logEntry);
            // wenn WriterService vorhanden weiteren Schreibvorgang aufrufen
            if (this.m_writerService) {
                this.m_writerService.writeMessage(logEntry);
            }
            this.saveLogEntry(logEntry);
        }
    }
    createLogEntry(p_logLevel, p_param) {
        const extParam = this.expandLogParam(p_param);
        return {
            date: new Date(),
            title: this.m_formatService.formatTitle(extParam.title),
            context: extParam.context,
            entry: extParam.message,
            level: p_logLevel,
            parameters: this.m_formatService.formatParameters(extParam.parameters),
            stack: this.getStackTrace(p_logLevel, extParam),
        };
    }
    expandLogParam(p_param) {
        if (p_param.entry instanceof HttpErrorResponse) {
            const httpError = p_param.entry;
            return this.expandLogParamForHttpError(p_param, httpError);
        }
        else if (p_param.entry instanceof Error) {
            const err = p_param.entry;
            return this.expandLogParamForJsError(p_param, err);
        }
        else {
            let extParam = { ...p_param };
            extParam.message = this.m_formatService.formatMessage(p_param.entry);
            return extParam;
        }
    }
    expandLogParamForHttpError(p_param, p_httpError) {
        let extParam = { ...p_param };
        if (!p_param.title)
            extParam.title = p_httpError.name + ' (' + p_httpError.status + ' - ' + p_httpError.statusText + ')';
        else
            extParam.title = p_param.title + ' [' + p_httpError.name + ']';
        extParam.message = p_httpError.message + '\n' + p_httpError.error;
        if ((extParam.parameters?.length ?? 0) == 0) {
            extParam.parameters = p_httpError.headers.keys().map(key => {
                const values = p_httpError.headers.getAll(key);
                return {
                    title: key,
                    // values kann null sein, dann liefert p_httpError.headers.get(key) ebenfalls null values[0] würde einen Fehler liefern
                    entry: values?.length > 1 ? values : p_httpError.headers.get(key)
                };
            });
        }
        return extParam;
    }
    expandLogParamForJsError(p_param, p_error) {
        let extParam = { ...p_param, entry: null };
        extParam.message = p_error.message;
        extParam.stackTrace = p_error.stack;
        return extParam;
    }
    getStackTrace(p_logLevel, p_param) {
        if (p_param.stackTrace?.length > 0)
            return this.m_stackTraceService.filterStackTrace(p_param.stackTrace);
        if (this.shouldCreateStack(p_logLevel))
            return this.m_stackTraceService.getFilteredStackTrace(p_param.entry);
        else
            return null;
    }
    shouldLog(p_logLevel, p_param) {
        if (this.shouldLogAccordingToSettings == false)
            return false;
        if (!this.hasLogEntryValues(p_param))
            return false;
        const validContexts = this.userLogSettings?.activeLogContexts?.filter((contextFilter) => LogContextHelper.checkAgainstFilterContext(p_param.context, contextFilter));
        let shouldLog;
        if (validContexts?.length > 0)
            shouldLog = validContexts.some((contextFilter) => contextFilter.logLevels?.includes(p_logLevel) ?? false);
        else
            shouldLog = this.userLogSettings?.activeLogLevels?.includes(p_logLevel) ?? false;
        return shouldLog;
    }
    hasLogEntryValues(p_param) {
        if (!p_param)
            return false;
        return !!p_param.title || !!p_param.entry || (!!p_param.context && LogContextHelper.hasValues(p_param.context));
    }
    shouldCreateStack(p_logLevel) {
        return p_logLevel == LogLevel.ERROR;
    }
    getLogContext(p_category, p_fileName, p_class) {
        const callingFunction = this.m_stackTraceService.getCallingFunction();
        let ctx = {
            fileName: p_fileName,
            category: p_category,
            className: callingFunction?.className,
            functionName: callingFunction?.functionName
        };
        if (p_class) {
            if (typeof p_class === 'string')
                ctx.className = p_class;
            else
                ctx.className = p_class.name;
        }
        return ctx;
    }
    extendLogContext(p_logContext, p_category) {
        const callingFunction = this.m_stackTraceService.getCallingFunction();
        return {
            fileName: p_logContext.fileName,
            category: p_category ?? p_logContext.category,
            className: callingFunction?.className ?? p_logContext.className,
            functionName: callingFunction?.functionName ?? p_logContext.functionName
        };
    }
    saveLogEntry(p_logEntry) {
        this.logs[this.m_index] = p_logEntry;
        if (this.m_index == this.MAX_LOGLEVEL_ENTRIES) {
            this.m_index = 0;
        }
        else {
            this.m_index++;
        }
        this.logsSubject.next(this.logs);
    }
    /** Leert das Log */
    clear() {
        this.logs = [];
        this.m_index = 0;
        this.logsSubject.next(this.logs);
    }
    displayEntryInConsole(p_logEntry) {
        const consoleFunction = this.getConsoleFunction(p_logEntry.level);
        consoleFunction(this.m_formatService.formatLogEntry(p_logEntry));
        // p_logEntry.parameters?.forEach(parameter => consoleFunction(JSON.stringify(parameter)));
    }
    getConsoleFunction(p_logLevel) {
        switch (p_logLevel) {
            case LogLevel.ERROR:
                return console.error;
            case LogLevel.WARNING:
                return console.warn;
            case LogLevel.INFO:
                return console.info;
            case LogLevel.SUCCESS:
            case LogLevel.DEBUG:
                return console.debug;
            default:
                return console.log;
        }
    }
    /* #region private logger-methods */
    /* #region: deprecated Log-Methods */
    /** @deprecated Loggen eines Fehlers */
    error(p_msg, p_title, p_parameters, p_category) {
        this.log(p_msg, LogLevel.ERROR, p_title, p_parameters, p_category);
    }
    /** @deprecated Loggen einer Info, wie zB. der Revision */
    info(p_msg, p_title, p_parameters, p_category) {
        this.log(p_msg, LogLevel.INFO, p_title, p_parameters, p_category);
    }
    /** @deprecated Loggen zwecks Debugging ("message called") */
    debug(p_msg, p_title, p_parameters, p_category) {
        this.log(p_msg, LogLevel.DEBUG, p_title, p_parameters, p_category);
    }
    /**
     * @deprecated
     * Loggen eines Erfolgs ("processMessage() successful").
     * Für die Console wird console.debug() aufgerufen. In der Logger-Komponente werden
     * Erfolge gesondert dargestellt, um sie schnell zu finden. */
    success(p_msg, p_title, p_parameters, p_category) {
        this.log(p_msg, LogLevel.SUCCESS, p_title, p_parameters, p_category);
    }
    /** @deprecated Stringified die Msg, gibt sie in der Konsole aus und speichert sie in den Logs.*/
    log(p_msg, p_logLevel, p_title, p_parameters, p_category) {
        let param;
        // Beim debug, info und success wird häufig nur ein String als Parameter angegeben
        if (!p_title && typeof p_msg === 'string')
            param = {
                title: p_msg,
                parameters: p_parameters,
            };
        else {
            let paramEntry = p_msg;
            if (!paramEntry // paramEntry falsy
                || Array.isArray(paramEntry) && paramEntry.length == 0 // paramEntry == []
                || Object.keys(paramEntry).length === 0 && paramEntry.constructor === Object) // paramEntry == {}
                paramEntry = null;
            param = {
                title: p_title,
                entry: paramEntry,
                parameters: p_parameters,
            };
        }
        if (p_category)
            param.context = this.getLogContext(p_category);
        this._log(p_logLevel, param);
    }
    static { this.ɵfac = function LoggerService_Factory(t) { return new (t || LoggerService)(i0.ɵɵinject(UserSettingsService), i0.ɵɵinject(LOGGER_FORMAT_SERVICE), i0.ɵɵinject(LOGGER_WRITER_SERVICE, 8), i0.ɵɵinject(StackTraceService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoggerService, factory: LoggerService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoggerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: UserSettingsService }, { type: undefined, decorators: [{
                type: Inject,
                args: [LOGGER_FORMAT_SERVICE]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [LOGGER_WRITER_SERVICE]
            }] }, { type: StackTraceService }]; }, null); })();

function ClassificationComponent_ng_container_0_ng_container_1_form_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ClassificationComponent_ng_container_0_ng_container_1_form_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c0$8 = function (a0) { return { showUndoBtn: a0, showSaveBtn: true }; };
function ClassificationComponent_ng_container_0_ng_container_1_form_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 9);
    i0.ɵɵlistener("ngSubmit", function ClassificationComponent_ng_container_0_ng_container_1_form_1_Template_form_ngSubmit_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r19.attributeValueForm_Submit()); });
    i0.ɵɵtemplate(1, ClassificationComponent_ng_container_0_ng_container_1_form_1_ng_container_1_Template, 1, 0, "ng-container", 10);
    i0.ɵɵtemplate(2, ClassificationComponent_ng_container_0_ng_container_1_form_1_ng_container_2_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    const _r3 = i0.ɵɵreference(4);
    const _r9 = i0.ɵɵreference(10);
    i0.ɵɵproperty("formGroup", ctx_r14.m_attributeValueForm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r9)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c0$8, ctx_r14.m_showUndoButton || ctx_r14.m_attributeValueForm.dirty));
} }
function ClassificationComponent_ng_container_0_ng_container_1_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ClassificationComponent_ng_container_0_ng_container_1_ng_template_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ClassificationComponent_ng_container_0_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ClassificationComponent_ng_container_0_ng_container_1_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 10);
    i0.ɵɵtemplate(1, ClassificationComponent_ng_container_0_ng_container_1_ng_template_2_ng_container_1_Template, 1, 0, "ng-container", 10);
} if (rf & 2) {
    i0.ɵɵnextContext(3);
    const _r3 = i0.ɵɵreference(4);
    const _r9 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r9);
} }
function ClassificationComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ClassificationComponent_ng_container_0_ng_container_1_form_1_Template, 3, 6, "form", 7);
    i0.ɵɵtemplate(2, ClassificationComponent_ng_container_0_ng_container_1_ng_template_2_Template, 2, 2, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r15 = i0.ɵɵreference(3);
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r11.m_parentForm)("ngIfElse", _r15);
} }
function ClassificationComponent_ng_container_0_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ClassificationComponent_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ClassificationComponent_ng_container_0_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 10);
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ClassificationComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ClassificationComponent_ng_container_0_ng_container_1_Template, 4, 2, "ng-container", 0);
    i0.ɵɵtemplate(2, ClassificationComponent_ng_container_0_ng_template_2_Template, 1, 1, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r12 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.m_isEditable)("ngIfElse", _r12);
} }
function ClassificationComponent_ng_template_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ClassificationComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ui-placeholder", 12);
    i0.ɵɵtemplate(1, ClassificationComponent_ng_template_1_ng_container_1_Template, 1, 0, "ng-container", 10);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const _r9 = i0.ɵɵreference(10);
    i0.ɵɵproperty("innerText", ctx_r2.noClassificationPlaceholder);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r9);
} }
function ClassificationComponent_ng_template_3_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ClassificationComponent_ng_template_3_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c1$2 = function (a0) { return { clsOwner: a0 }; };
const _c2 = function (a0) { return { clsClassOwner: a0, cssClass: "mb-2" }; };
function ClassificationComponent_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵtemplate(2, ClassificationComponent_ng_template_3_ng_container_0_ng_container_2_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 16);
    i0.ɵɵtemplate(4, ClassificationComponent_ng_template_3_ng_container_0_ng_container_4_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(6);
    const _r7 = i0.ɵɵreference(8);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c1$2, ctx_r25.m_clsClassificationListToRender[0]));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r7)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c2, ctx_r25.m_clsClassificationListToRender[0]));
} }
function ClassificationComponent_ng_template_3_ng_template_1_mat_expansion_panel_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ClassificationComponent_ng_template_3_ng_template_1_mat_expansion_panel_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c3 = function (a0) { return { clsClassOwner: a0 }; };
function ClassificationComponent_ng_template_3_ng_template_1_mat_expansion_panel_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-expansion-panel", 19)(1, "mat-expansion-panel-header", 20)(2, "mat-panel-title");
    i0.ɵɵtemplate(3, ClassificationComponent_ng_template_3_ng_template_1_mat_expansion_panel_1_ng_container_3_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, ClassificationComponent_ng_template_3_ng_template_1_mat_expansion_panel_1_ng_container_4_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const clsOwner_r32 = ctx.$implicit;
    i0.ɵɵnextContext(3);
    const _r5 = i0.ɵɵreference(6);
    const _r7 = i0.ɵɵreference(8);
    i0.ɵɵproperty("expanded", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c1$2, clsOwner_r32));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r7)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c3, clsOwner_r32));
} }
function ClassificationComponent_ng_template_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-accordion", 17);
    i0.ɵɵtemplate(1, ClassificationComponent_ng_template_3_ng_template_1_mat_expansion_panel_1_Template, 5, 9, "mat-expansion-panel", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r27.m_clsClassificationListToRender);
} }
function ClassificationComponent_ng_template_3_mat_error_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r28.m_error);
} }
function ClassificationComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ClassificationComponent_ng_template_3_ng_container_0_Template, 5, 8, "ng-container", 0);
    i0.ɵɵtemplate(1, ClassificationComponent_ng_template_3_ng_template_1_Template, 2, 1, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(3, ClassificationComponent_ng_template_3_mat_error_3_Template, 2, 1, "mat-error", 14);
} if (rf & 2) {
    const _r26 = i0.ɵɵreference(2);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", (ctx_r4.m_clsClassificationListToRender == null ? null : ctx_r4.m_clsClassificationListToRender.length) == 1)("ngIfElse", _r26);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.m_error);
} }
function ClassificationComponent_ng_template_5_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "button", 25);
    i0.ɵɵlistener("click", function ClassificationComponent_ng_template_5_div_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r39); const clsOwner_r35 = i0.ɵɵnextContext().clsOwner; const ctx_r37 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r37.removeAssignment_Click(clsOwner_r35)); });
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", ctx_r36.m_classificationIntl.buttonAssignmentRemove, " ");
} }
function ClassificationComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21)(1, "div", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ClassificationComponent_ng_template_5_div_3_Template, 5, 1, "div", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const clsOwner_r35 = ctx.clsOwner;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.getHeaderText(clsOwner_r35));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.m_canEditClassificationAssignment);
} }
function ClassificationComponent_ng_template_7_ng_container_0_tr_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const attribute_r51 = i0.ɵɵnextContext().$implicit;
    const clsClassOwner_r40 = i0.ɵɵnextContext(2).clsClassOwner;
    const ctx_r52 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, ctx_r52.getAttributeDateValue(clsClassOwner_r40, attribute_r51), "dd.MM.yyyy"), " ");
} }
function ClassificationComponent_ng_template_7_ng_container_0_tr_2_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const attribute_r51 = i0.ɵɵnextContext().$implicit;
    const clsClassOwner_r40 = i0.ɵɵnextContext(2).clsClassOwner;
    const ctx_r54 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r54.getAttributeStrValue(clsClassOwner_r40, attribute_r51));
} }
function ClassificationComponent_ng_template_7_ng_container_0_tr_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "mat-label", 32);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, ClassificationComponent_ng_template_7_ng_container_0_tr_2_ng_container_4_Template, 4, 4, "ng-container", 0);
    i0.ɵɵtemplate(5, ClassificationComponent_ng_template_7_ng_container_0_tr_2_ng_template_5_Template, 2, 1, "ng-template", null, 33, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const attribute_r51 = ctx.$implicit;
    const _r53 = i0.ɵɵreference(6);
    const ctx_r50 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", attribute_r51.name, ":");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r50.isAttributeOfTypeDate(attribute_r51))("ngIfElse", _r53);
} }
function ClassificationComponent_ng_template_7_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "table", 30);
    i0.ɵɵtemplate(2, ClassificationComponent_ng_template_7_ng_container_0_tr_2_Template, 7, 3, "tr", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const clsClassOwner_r40 = i0.ɵɵnextContext().clsClassOwner;
    const ctx_r41 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r41.elementCssClass);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", clsClassOwner_r40 == null ? null : clsClassOwner_r40.clsClass == null ? null : clsClassOwner_r40.clsClass.attributes);
} }
function ClassificationComponent_ng_template_7_ng_template_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ClassificationComponent_ng_template_7_ng_template_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ClassificationComponent_ng_template_7_ng_template_1_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const clsClassOwner_r40 = i0.ɵɵnextContext(2).clsClassOwner;
    const _r46 = i0.ɵɵreference(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r46)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c3, clsClassOwner_r40));
} }
function ClassificationComponent_ng_template_7_ng_template_1_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ClassificationComponent_ng_template_7_ng_template_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 37);
    i0.ɵɵtemplate(2, ClassificationComponent_ng_template_7_ng_template_1_ng_container_2_ng_container_2_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r44 = i0.ɵɵreference(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r44);
} }
function ClassificationComponent_ng_template_7_ng_template_1_div_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ClassificationComponent_ng_template_7_ng_template_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37)(1, "div", 38);
    i0.ɵɵtemplate(2, ClassificationComponent_ng_template_7_ng_template_1_div_3_ng_container_2_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r44 = i0.ɵɵreference(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r44);
} }
function ClassificationComponent_ng_template_7_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 34);
    i0.ɵɵtemplate(1, ClassificationComponent_ng_template_7_ng_template_1_ng_container_1_Template, 2, 4, "ng-container", 35);
    i0.ɵɵtemplate(2, ClassificationComponent_ng_template_7_ng_template_1_ng_container_2_Template, 3, 1, "ng-container", 35);
    i0.ɵɵtemplate(3, ClassificationComponent_ng_template_7_ng_template_1_div_3_Template, 3, 1, "div", 36);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const clsClassOwner_r40 = i0.ɵɵnextContext().clsClassOwner;
    const ctx_r43 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", ctx_r43.getDisplayType(clsClassOwner_r40));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "layout");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "compact");
} }
function ClassificationComponent_ng_template_7_ng_template_3_ebootis_attribute_field_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ebootis-attribute-field", 40);
} if (rf & 2) {
    const attribute_r69 = ctx.$implicit;
    const clsClassOwner_r40 = i0.ɵɵnextContext(2).clsClassOwner;
    const ctx_r68 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r68.elementCssClass)("Params", ctx_r68.getAttributeFieldParam(clsClassOwner_r40, attribute_r69));
} }
function ClassificationComponent_ng_template_7_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ClassificationComponent_ng_template_7_ng_template_3_ebootis_attribute_field_0_Template, 1, 2, "ebootis-attribute-field", 39);
} if (rf & 2) {
    const clsClassOwner_r40 = i0.ɵɵnextContext().clsClassOwner;
    i0.ɵɵproperty("ngForOf", clsClassOwner_r40 == null ? null : clsClassOwner_r40.clsClass == null ? null : clsClassOwner_r40.clsClass.attributes);
} }
function ClassificationComponent_ng_template_7_ng_template_5_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const clsLayout_r73 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", clsLayout_r73.title, " ");
} }
function ClassificationComponent_ng_template_7_ng_template_5_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c4 = function (a0) { return { elements: a0, width: 1, isGroup: true }; };
const _c5 = function (a0) { return { $implicit: a0 }; };
function ClassificationComponent_ng_template_7_ng_template_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtemplate(1, ClassificationComponent_ng_template_7_ng_template_5_div_1_div_1_Template, 2, 1, "div", 44);
    i0.ɵɵelementStart(2, "div", 45);
    i0.ɵɵtemplate(3, ClassificationComponent_ng_template_7_ng_template_5_div_1_ng_container_3_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const clsLayout_r73 = ctx.$implicit;
    i0.ɵɵnextContext(2);
    const _r48 = i0.ɵɵreference(8);
    const ctx_r72 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", clsLayout_r73.title);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", ctx_r72.getGridStyleForContainer(clsLayout_r73));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r48)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c5, i0.ɵɵpureFunction1(4, _c4, clsLayout_r73.groups)));
} }
function ClassificationComponent_ng_template_7_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵtemplate(1, ClassificationComponent_ng_template_7_ng_template_5_div_1_Template, 4, 8, "div", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const clsClassOwner_r40 = i0.ɵɵnextContext().clsClassOwner;
    const ctx_r47 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r47.getLayoutStructureForClsClass(clsClassOwner_r40 == null ? null : clsClassOwner_r40.clsClass == null ? null : clsClassOwner_r40.clsClass.oid));
} }
function ClassificationComponent_ng_template_7_ng_template_7_ng_container_0_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const clsLayoutElement_r80 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", clsLayoutElement_r80.title, " ");
} }
function ClassificationComponent_ng_template_7_ng_template_7_ng_container_0_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c6 = function (a0) { return { elements: a0, isGroup: false }; };
function ClassificationComponent_ng_template_7_ng_template_7_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 49);
    i0.ɵɵtemplate(1, ClassificationComponent_ng_template_7_ng_template_7_ng_container_0_div_1_div_1_Template, 2, 1, "div", 44);
    i0.ɵɵelementStart(2, "div", 50);
    i0.ɵɵtemplate(3, ClassificationComponent_ng_template_7_ng_template_7_ng_container_0_div_1_ng_container_3_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const clsLayoutElement_r80 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext(2);
    const _r48 = i0.ɵɵreference(8);
    const ctx_r81 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", ctx_r81.getItemStyleForElement(clsLayoutElement_r80));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", clsLayoutElement_r80.title);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", ctx_r81.getGridStyleForContainer(clsLayoutElement_r80));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r48)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c5, i0.ɵɵpureFunction1(5, _c6, clsLayoutElement_r80.attributes)));
} }
function ClassificationComponent_ng_template_7_ng_template_7_ng_container_0_ng_template_2_ebootis_attribute_field_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ebootis-attribute-field", 54);
} if (rf & 2) {
    const clsLayoutElement_r80 = i0.ɵɵnextContext(2).$implicit;
    const clsClassOwner_r40 = i0.ɵɵnextContext(2).clsClassOwner;
    const ctx_r88 = i0.ɵɵnextContext();
    i0.ɵɵproperty("Params", ctx_r88.getAttributeFieldParamForLayout(clsClassOwner_r40, clsLayoutElement_r80));
} }
function ClassificationComponent_ng_template_7_ng_template_7_ng_container_0_ng_template_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 55);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const clsLayoutElement_r80 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", clsLayoutElement_r80.title, " ");
} }
function ClassificationComponent_ng_template_7_ng_template_7_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵtemplate(1, ClassificationComponent_ng_template_7_ng_template_7_ng_container_0_ng_template_2_ebootis_attribute_field_1_Template, 1, 1, "ebootis-attribute-field", 52);
    i0.ɵɵtemplate(2, ClassificationComponent_ng_template_7_ng_template_7_ng_container_0_ng_template_2_ng_template_2_Template, 2, 1, "ng-template", null, 53, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r89 = i0.ɵɵreference(3);
    const clsLayoutElement_r80 = i0.ɵɵnextContext().$implicit;
    const ctx_r83 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngStyle", ctx_r83.getItemStyleForElement(clsLayoutElement_r80));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", clsLayoutElement_r80.attributeOid)("ngIfElse", _r89);
} }
function ClassificationComponent_ng_template_7_ng_template_7_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ClassificationComponent_ng_template_7_ng_template_7_ng_container_0_div_1_Template, 4, 9, "div", 47);
    i0.ɵɵtemplate(2, ClassificationComponent_ng_template_7_ng_template_7_ng_container_0_ng_template_2_Template, 4, 3, "ng-template", null, 48, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r82 = i0.ɵɵreference(3);
    const layoutElements_r78 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", layoutElements_r78.isGroup)("ngIfElse", _r82);
} }
function ClassificationComponent_ng_template_7_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ClassificationComponent_ng_template_7_ng_template_7_ng_container_0_Template, 4, 2, "ng-container", 31);
} if (rf & 2) {
    const layoutElements_r78 = ctx.$implicit;
    i0.ɵɵproperty("ngForOf", layoutElements_r78.elements);
} }
function ClassificationComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ClassificationComponent_ng_template_7_ng_container_0_Template, 3, 2, "ng-container", 0);
    i0.ɵɵtemplate(1, ClassificationComponent_ng_template_7_ng_template_1_Template, 4, 3, "ng-template", null, 26, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(3, ClassificationComponent_ng_template_7_ng_template_3_Template, 1, 1, "ng-template", null, 27, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(5, ClassificationComponent_ng_template_7_ng_template_5_Template, 2, 1, "ng-template", null, 28, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(7, ClassificationComponent_ng_template_7_ng_template_7_Template, 1, 1, "ng-template", null, 29, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r42 = i0.ɵɵreference(2);
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r8.m_isEditable)("ngIfElse", _r42);
} }
function ClassificationComponent_ng_template_9_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r101 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 58)(1, "button", 59);
    i0.ɵɵlistener("click", function ClassificationComponent_ng_template_9_div_0_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r101); const ctx_r100 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r100.assignNewClassification_Click()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r98 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r98.m_classificationIntl.buttonAssignNewTooltip);
    i0.ɵɵproperty("hidden", !ctx_r98.hasNotAssignedClassifications);
    i0.ɵɵattribute("aria-label", ctx_r98.m_classificationIntl.buttonAssignNewTooltip);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r98.m_classificationIntl.buttonAssignNew, " ");
} }
function ClassificationComponent_ng_template_9_div_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r105 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 63);
    i0.ɵɵlistener("click", function ClassificationComponent_ng_template_9_div_1_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r105); const ctx_r104 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r104.undoSaveItemAttributes_Click()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r102 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r102.m_classificationIntl.buttonUndoTooltip);
    i0.ɵɵattribute("aria-label", ctx_r102.m_classificationIntl.buttonUndoTooltip);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r102.m_classificationIntl.buttonUndo, " ");
} }
function ClassificationComponent_ng_template_9_div_1_button_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 64);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r103 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r103.m_classificationIntl.buttonSave);
    i0.ɵɵproperty("disabled", ctx_r103.m_attributeValueForm.pristine || ctx_r103.m_attributeValueForm.invalid);
    i0.ɵɵattribute("aria-label", ctx_r103.m_classificationIntl.buttonSave);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r103.m_classificationIntl.buttonSave, " ");
} }
function ClassificationComponent_ng_template_9_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵtemplate(1, ClassificationComponent_ng_template_9_div_1_button_1_Template, 2, 3, "button", 61);
    i0.ɵɵtemplate(2, ClassificationComponent_ng_template_9_div_1_button_2_Template, 2, 4, "button", 62);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const showSaveBtn_r97 = i0.ɵɵnextContext().showSaveBtn;
    const ctx_r99 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r99.m_showUndoButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", showSaveBtn_r97);
} }
function ClassificationComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ClassificationComponent_ng_template_9_div_0_Template, 3, 4, "div", 56);
    i0.ɵɵtemplate(1, ClassificationComponent_ng_template_9_div_1_Template, 3, 2, "div", 57);
} if (rf & 2) {
    const showSaveBtn_r97 = ctx.showSaveBtn;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r10.m_canEditClassificationAssignment);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.m_showUndoButton || showSaveBtn_r97);
} }
class ClassificationComponent {
    set Params(p_params) {
        this.m_parentForm = p_params.parentForm;
        this.m_ownerOid = p_params.ownerOid;
        this.m_clsClassOid = p_params.clsClassOid;
        this.m_searchParams = {
            ownerOid: p_params.ownerOid,
            ownerType: p_params.ownerType,
            companyOid: p_params.companyOid,
            clsClassOid: p_params.clsClassOid,
            classificationProxyOid: null,
            txDefProxyOid: p_params.txDefProxyOid,
            masterDataTypeProxyOid: p_params.masterDataTypeProxyOid
        };
        this.m_isEditable = p_params.isEditable;
        this.m_error = p_params.errorMsg;
        this.m_showUndoButton = p_params.showUndoButton;
        this.m_canEditClassificationAssignment = this.m_isEditable && p_params.canEditClassificationAssignment;
        this.m_numberOfDisplayColumns = [2, 3, 4, 6].includes(p_params.numberOfColumns) ? p_params.numberOfColumns : 1;
        if (p_params.classificationSrc) {
            this.m_initializedWithParams = true;
            this.initializeClassifications(p_params.classificationSrc);
        }
    }
    constructor(classificationIntl, fb, m_mobileClassificationMtn, loggerService, m_dialog) {
        this.classificationIntl = classificationIntl;
        this.fb = fb;
        this.m_mobileClassificationMtn = m_mobileClassificationMtn;
        this.loggerService = loggerService;
        this.m_dialog = m_dialog;
        this.undoChanges = new EventEmitter();
        this.saveClassification = new EventEmitter();
        // Liefert die Klassifikation zurück, die neu zugeordnet oder gelöscht wird (assignNewClassification_Click)
        this.afterClassificationAssignmentChange = new EventEmitter();
        // Liefert die initial gerenderten Werte zurück (ngOnInit)
        this.afterClassificationInitialization = new EventEmitter();
        this.OWNER_OID = 'ownerOid';
        this.CLASSIFICATION = 'classification';
        this.CLASSIFICATION_OID = 'classificationOid';
        this.CLS_ATTRIBUTES = 'clsAttributes';
        this.CLS_ATTRIBUTE_OID = 'clsAttributeOid';
        this.CLS_ENUM_VALUE_OID = 'clsEnumValueOid';
        this.STR_VALUE = 'strValue';
        this.NUM_VALUE = 'numValue';
        this.BOOL_VALUE = 'boolValue';
        this.DATE_VALUE = 'dateValue';
        this.ATTR_TYPES = ClsAttrType;
        this.hasNotAssignedClassifications = false;
        this.m_subscriptionSubject = new Subject();
        this.m_clsClassOid = null;
        this.m_isEditable = false;
        this.m_showUndoButton = false;
        this.m_canEditClassificationAssignment = false;
        this.m_numberOfDisplayColumns = 1;
        if (this.classificationIntl) {
            this.m_classificationIntl = this.classificationIntl;
        }
        else {
            this.m_classificationIntl = new ClassificationIntl();
        }
        this.m_attributeValueForm = this.fb.group({
            [this.OWNER_OID]: this.fb.control(null),
            [this.CLASSIFICATION]: this.fb.array([]),
        });
    }
    /* #region livecycle */
    ngOnInit() {
        // Falls eine classificationSrc per @Input definiert ist, wird diese genommen.
        // Als Fallback gibt es den Online-Service
        if (!this.m_initializedWithParams) {
            this.m_mobileClassificationMtn.getClsClassOwnerListBySearchParams(this.m_searchParams)
                .pipe(takeUntil(this.m_subscriptionSubject))
                .subscribe({
                next: (clsOwnerList) => {
                    this.initializeClassifications(clsOwnerList);
                    this.afterClassificationInitialization.emit(this.m_clsClassificationListToRender);
                },
                error: (error) => {
                    this.loggerService.logError({
                        title: 'Error encountered while loading classifications after component initiliazation',
                        entry: error,
                        context: this.getLogContextBuilder('ngOnInit').get()
                    });
                    this.m_error = error.message;
                }
            });
        }
    }
    ngOnDestroy() {
        this.m_subscriptionSubject.next();
        this.m_subscriptionSubject.complete();
    }
    initializeClassifications(p_clsOwnerList) {
        this.m_layoutDefinitions = new Map();
        this.m_clsClassificationList = p_clsOwnerList;
        this.updateInternalVariables();
        // Hier werden die Attribute sortiert
        this.m_clsClassificationListToRender = this.m_clsClassificationList?.filter(cco => this.isClsClassOwnerAssigned(cco))
            .map(elem => {
            let clsOwnerClass = elem;
            if (clsOwnerClass.clsClass) {
                if (clsOwnerClass.clsClass.layouts)
                    this.createLayoutStructure(clsOwnerClass.clsClass);
                clsOwnerClass.clsClass.attributes = clsOwnerClass.clsClass.attributes?.sort((a, b) => a.ordinal - b.ordinal) ?? [];
            }
            return clsOwnerClass;
        });
        this.renderForm();
    }
    /* #endregion livecycle */
    /* #region Attribute handling */
    getAttributeFormGroup(p_clsOid, p_attrOid) {
        const clsControl = this.m_attributeValueForm.get(this.CLASSIFICATION)?.controls?.find(ctrl => ctrl.get(this.CLASSIFICATION_OID)?.value == p_clsOid);
        if (clsControl) {
            return clsControl.get(this.CLS_ATTRIBUTES)?.controls?.find(ctrl => ctrl.get(this.CLS_ATTRIBUTE_OID)?.value === p_attrOid);
        }
    }
    getAttributeStrValue(p_clsOwnerClass, p_attribute) {
        let attrValue = p_clsOwnerClass?.attributeValues?.find(av => av.clsAttributeOid == p_attribute?.oid);
        let retStr = '';
        if (p_attribute && attrValue) {
            if (p_attribute.isEnum) {
                const enumObj = p_attribute.enumValues.find(ev => ev.oid === attrValue.clsEnumValueOid);
                if (enumObj)
                    retStr = enumObj.value;
            }
            else if (p_attribute.attrType == ClsAttrType.BOOLEAN)
                retStr = attrValue.boolValue ? this.m_classificationIntl.boolYes : this.m_classificationIntl.boolNo;
            else if (p_attribute.attrType == ClsAttrType.DATE) { // Dieser Fall sollte nicht vorkommen
                retStr = DateUtility.localDateToUTC_ISO_DateString(attrValue.dateValue);
                this.loggerService.logWarning({
                    title: 'getAttributeStrValue should not handle a date value',
                    parameters: [{ title: 'attribute', entry: p_attribute }],
                    context: this.getLogContextBuilder('getAttributeStrValue')
                        .addParameter({ name: 'ClsOwnerClass', value: p_clsOwnerClass }, { name: 'Attribute', value: p_attribute }).get()
                });
            }
            else if (p_attribute.attrType == ClsAttrType.NUMBER && attrValue.numValue)
                retStr = '' + attrValue.numValue;
            else if (p_attribute.attrType == ClsAttrType.STRING && attrValue.strValue)
                retStr = attrValue.strValue;
        }
        return retStr;
    }
    getAttributeDateValue(p_clsOwnerClass, p_attribute) {
        let attrValue = p_clsOwnerClass?.attributeValues?.find(av => av.clsAttributeOid === p_attribute?.oid);
        if (attrValue && !p_attribute.isEnum && p_attribute.attrType == ClsAttrType.DATE) {
            return attrValue.dateValue;
        }
    }
    isAttributeOfTypeDate(p_attribute) {
        return p_attribute.attrType === ClsAttrType.DATE;
    }
    getAttributeFieldParam(p_clsClassOwner, p_attribute) {
        return {
            formGroup: this.getAttributeFormGroup(p_clsClassOwner.clsClass.oid, p_attribute.oid),
            attribute: p_attribute,
        };
    }
    getAttributeFieldParamForLayout(p_clsClassOwner, p_layoutAttribute) {
        return {
            formGroup: this.getAttributeFormGroup(p_clsClassOwner.clsClass.oid, p_layoutAttribute.attributeOid),
            attribute: this.getAttributeByOid(p_clsClassOwner, p_layoutAttribute.attributeOid),
            cssClass: 'reduced-min-width',
            useSymbolAsUnit: p_layoutAttribute.width < 0.5,
        };
    }
    getAttributeByOid(p_clsClassOwner, p_attributeOid) {
        return p_clsClassOwner?.clsClass?.attributes?.find(attr => attr.oid == p_attributeOid);
    }
    /* #endregion Attribute handling */
    /* #region display in template */
    get noClassificationPlaceholder() {
        return this.m_classificationIntl.noClassification;
    }
    get elementCssClass() {
        let cssClass = 'd-flex flex-fill flex-column';
        if (this.m_numberOfDisplayColumns > 1)
            cssClass = `col-12 col-md-${Math.round(12 / this.m_numberOfDisplayColumns)}`;
        return cssClass;
    }
    getHeaderText(p_clsOwner) {
        let headerText = p_clsOwner.clsClass.proxyName || '';
        if (!p_clsOwner.clsClass.isRoot) {
            if (headerText)
                headerText += ' - ';
            headerText += p_clsOwner.clsClass.name;
        }
        return headerText;
    }
    getDisplayType(p_clsClassOwner) {
        let displayType = 'default';
        if (this.m_isEditable && p_clsClassOwner.clsClass.layouts?.length)
            displayType = 'layout';
        else if (this.m_isEditable && this.m_numberOfDisplayColumns > 1)
            displayType = 'compact';
        return displayType;
    }
    getLayoutStructureForClsClass(p_clsClassOid) {
        return this.m_layoutDefinitions.get(p_clsClassOid);
    }
    getGridStyleForContainer(p_container) {
        return p_container?.columnWidths?.length > 0 ? {
            'grid-template-columns': `${p_container.columnWidths.map(cw => cw + 'fr').join(' ')}`
        } : null;
    }
    getItemStyleForElement(p_elem) {
        return p_elem ? {
            'grid-row': `${p_elem.rowIndex + 1} / span ${p_elem.rowSpan}`,
            'grid-column': `${p_elem.colIndex + 1} / span ${p_elem.colSpan}`
        } : null;
    }
    /* #endregion display in template */
    /* #region events */
    undoSaveItemAttributes_Click() {
        this.revertChanges();
        if (this.undoChanges.observers.length > 0) {
            this.undoChanges.emit();
        }
    }
    attributeValueForm_Submit() {
        this.m_error = '';
        const changedValues = ClassificationUtility.getClassificationsChangedValues(this.m_attributeValueForm, this.m_clsClassificationList); //this.getChangedFormValues();
        if (this.saveClassification.observers.length > 0) {
            this.saveClassification.emit(changedValues);
        }
        else {
            const attributeParms = {
                clsClassOwnerList: changedValues,
                clsClassOid: this.m_clsClassOid
            };
            this.m_mobileClassificationMtn.saveItemAttributes(attributeParms)
                .pipe(takeUntil(this.m_subscriptionSubject))
                .subscribe({
                next: (res) => { },
                error: (error) => {
                    this.loggerService.logError({
                        title: 'Error encountered while saving classifications',
                        entry: error,
                        context: this.getLogContextBuilder('attributeValueForm_Submit').get()
                    });
                    this.m_error = error.error.message;
                }
            });
        }
    }
    assignNewClassification_Click() {
        let classificationsToAssign = this.m_clsClassificationList.reduce((arr, clsClassOwner) => {
            if (!this.m_clsClassificationListToRender.some(clsClassRender => ClassificationUtility.areClsClassOwnerEqual(clsClassRender, clsClassOwner)))
                return [...arr, clsClassOwner.clsClassSystem];
            else
                return arr;
        }, []);
        const dialogRef = this.m_dialog.open(ClassificationAssignNewComponent, {
            data: { clsClasses: classificationsToAssign },
            disableClose: false,
            panelClass: 'dialog-sm'
        });
        dialogRef.afterClosed().subscribe({
            next: (classificationToAssign) => {
                if (classificationToAssign) {
                    let clsClassOwner = this.m_clsClassificationList.find(cco => {
                        return classificationToAssign.clsProxyOid == cco.clsClassSystem?.clsProxyOid ?? cco.clsClass?.clsProxyOid;
                    });
                    if (clsClassOwner.clsClass?.oid != classificationToAssign.oid)
                        clsClassOwner.clsClass = ClassificationUtility.findClsClass([clsClassOwner.clsClassSystem], classificationToAssign.oid);
                    if (clsClassOwner.assignType != ClsOwnerAssignType.EDIT)
                        clsClassOwner.assignType = ClsOwnerAssignType.NEW;
                    clsClassOwner.attributeValues = classificationToAssign.attributes?.map(attr => {
                        return {
                            clsAttributeOid: attr.oid,
                            clsEnumValueOid: null,
                            strValue: null,
                            numValue: null,
                            boolValue: null,
                            dateValue: null,
                        };
                    });
                    const clsFormArray = this.m_attributeValueForm.get(this.CLASSIFICATION);
                    const clsFormGroup = this.renderClsClassOwner(clsClassOwner);
                    clsFormArray.push(clsFormGroup);
                    let assignIndex = this.m_clsClassificationListToRender.findIndex(cco => cco.ordnum > clsClassOwner.ordnum);
                    if (assignIndex < 0)
                        assignIndex = this.m_clsClassificationListToRender.length;
                    this.m_clsClassificationListToRender.splice(assignIndex, 0, clsClassOwner);
                    this.createLayoutStructure(clsClassOwner.clsClass);
                    this.updateInternalVariables();
                    this.afterClassificationAssignmentChange.emit(clsClassOwner);
                }
            },
            error: (error) => {
                this.loggerService.logError({
                    title: 'Error encountered while assigning new classification to the owner',
                    entry: error,
                    context: this.getLogContextBuilder('assignNewClassification_Click').get()
                });
                this.m_error = error.message;
            }
        });
    }
    removeAssignment_Click(p_clsOwner) {
        const clsClassOwner = this.m_clsClassificationList.find(cco => {
            return ClassificationUtility.areClsClassOwnerEqual(cco, p_clsOwner);
        });
        this.m_layoutDefinitions.delete(p_clsOwner.clsClass.oid);
        if (clsClassOwner) {
            if (clsClassOwner.assignType == ClsOwnerAssignType.EDIT)
                clsClassOwner.assignType = ClsOwnerAssignType.REMOVE;
            else
                clsClassOwner.assignType = ClsOwnerAssignType.NONE;
        }
        let indexToRemove = this.m_clsClassificationListToRender.findIndex(cco => {
            return ClassificationUtility.areClsClassOwnerEqual(cco, p_clsOwner);
        });
        if (indexToRemove >= 0) {
            this.m_clsClassificationListToRender.splice(indexToRemove, 1);
        }
        const clsFormArray = this.m_attributeValueForm.get(this.CLASSIFICATION);
        indexToRemove = clsFormArray.value.findIndex(fg => {
            return fg[this.CLASSIFICATION_OID] == p_clsOwner.clsClass?.oid ?? p_clsOwner.clsClassSystem?.oid;
        });
        if (indexToRemove >= 0)
            clsFormArray.removeAt(indexToRemove);
        this.updateInternalVariables();
        this.afterClassificationAssignmentChange.emit(clsClassOwner);
    }
    /* #endregion events */
    /* #region form creation (private) */
    renderForm() {
        this.m_attributeValueForm.reset();
        this.m_attributeValueForm.get(this.OWNER_OID).setValue(this.m_ownerOid);
        if (this.m_isEditable) {
            const clsFormArray = this.m_attributeValueForm.get(this.CLASSIFICATION);
            clsFormArray.clear();
            this.m_clsClassificationListToRender?.forEach(clsOwner => {
                const clsFormGroup = this.renderClsClassOwner(clsOwner);
                clsFormArray.push(clsFormGroup);
            });
        }
        if (this.m_parentForm) {
            this.m_parentForm.addControl(ClassificationUtility.CLASSIFICATION_FORM, this.m_attributeValueForm);
        }
    }
    renderClsClassOwner(p_clsClassOwner) {
        const attrFormArray = p_clsClassOwner.clsClass.attributes?.map(attr => {
            const attrValue = p_clsClassOwner.attributeValues?.find(av => av.clsAttributeOid === attr.oid);
            return this.createAttributeValueFormGroup(attr, attrValue);
        }) ?? [];
        return this.fb.group({
            [this.CLASSIFICATION_OID]: this.fb.control(p_clsClassOwner.clsClass.oid),
            [this.CLS_ATTRIBUTES]: this.fb.array(attrFormArray),
        });
    }
    createAttributeValueFormGroup(p_attribute, p_attrValue) {
        const logCtxBuilder = this.getLogContextBuilder('createAttributeValueFormGroup')
            .addParameter({ name: 'Attribute', value: p_attribute }, { name: 'AttributeValue', value: p_attrValue });
        const nameValue = this.getAttributeNameAndValue(p_attribute, p_attrValue);
        let formGroup = this.fb.group({
            [this.CLS_ATTRIBUTE_OID]: this.fb.control(p_attribute.oid),
        });
        if (nameValue) {
            let ctrl2 = this.fb.control(nameValue.value, { validators: this.getAttributeValidators(p_attribute) });
            formGroup.addControl(nameValue.name, ctrl2);
        }
        else
            this.loggerService.logError({ title: 'Could not get an value for attribute', context: logCtxBuilder.get() });
        return formGroup;
    }
    getAttributeValidators(p_attribute) {
        let validators = [];
        if (p_attribute.isMandatory) {
            validators.push(Validators.required);
        }
        if (!p_attribute.isEnum && p_attribute.attrType === this.ATTR_TYPES.NUMBER) {
            if (p_attribute.isRange) {
                if (p_attribute.numberRange[0])
                    validators.push(Validators.min(p_attribute.numberRange[0]));
                if (p_attribute.numberRange[1])
                    validators.push(Validators.max(p_attribute.numberRange[1]));
            }
        }
        return validators;
    }
    /* #endregion form creation (private)*/
    /* #region changed value handling (private) */
    revertChanges() {
        const clsFormArray = this.m_attributeValueForm.get(this.CLASSIFICATION);
        if (clsFormArray?.controls?.length > 0) {
            clsFormArray.controls
                .filter(clsForm => clsForm.dirty)
                .forEach(clsForm => {
                const clsClassOwner = this.m_clsClassificationListToRender.find(ccO => {
                    return ccO.ownerOid === this.m_ownerOid
                        && ccO.clsClass.oid === clsForm.get(this.CLASSIFICATION_OID).value;
                });
                const attrFormArray = clsForm.get(this.CLS_ATTRIBUTES);
                if (attrFormArray?.controls?.length > 0) {
                    attrFormArray.controls
                        .filter(attrCtrl => attrCtrl.dirty)
                        .forEach(attrCtrl => {
                        const attribute = clsClassOwner.clsClass.attributes.find(a => a.oid === attrCtrl.get(this.CLS_ATTRIBUTE_OID).value);
                        const attrValue = clsClassOwner.attributeValues.find(av => av.clsAttributeOid === attribute.oid);
                        const nameValue = this.getAttributeNameAndValue(attribute, attrValue);
                        if (nameValue) {
                            attrCtrl.get(nameValue.name).setValue(nameValue.value);
                            attrCtrl.markAsUntouched();
                            attrCtrl.markAsPristine();
                        }
                    });
                }
            });
        }
    }
    updateInternalVariables() {
        this.hasNotAssignedClassifications = this.m_clsClassificationList?.some(cco => !this.isClsClassOwnerAssigned(cco));
    }
    /* #endregion changed value handling (private) */
    /* #region: Layoutconstruction as grid (private) */
    createLayoutStructure(p_clsClass) {
        if (p_clsClass?.layouts?.length > 0) {
            let layouts = p_clsClass.layouts.map(clsLayout => {
                return {
                    oid: clsLayout.oid,
                    ordnum: clsLayout.ordnum,
                    title: clsLayout.title,
                    groups: this.getListOfLayoutElements(clsLayout.groups, this.getLayoutData(clsLayout)),
                    columnWidths: clsLayout.columnWidths,
                };
            });
            this.m_layoutDefinitions.set(p_clsClass.oid, layouts);
        }
    }
    getListOfLayoutElements(p_clsElements, p_layoutData) {
        return p_clsElements?.map(clsElement => {
            let zeroBasedIndex = clsElement.cellIndex - 1;
            let colIndex = zeroBasedIndex % p_layoutData.numberOfColumns;
            let rowIndex = (zeroBasedIndex - colIndex) / p_layoutData.numberOfColumns;
            return this.getLayoutElement(clsElement, rowIndex, colIndex, p_layoutData);
        });
    }
    getLayoutElement(p_element, p_rowIndex, p_colIndex, p_layoutData) {
        let elem = {
            title: p_element?.title,
            rowIndex: p_rowIndex,
            colIndex: p_colIndex,
            rowSpan: p_element?.rowSpan,
            colSpan: p_element?.colSpan,
        };
        if (p_layoutData.isGroup) {
            let grp = p_element;
            return {
                ...elem,
                attributes: this.getListOfLayoutElements(grp?.attributes, this.getLayoutData(grp, p_colIndex, grp?.colSpan, p_layoutData)),
                columnWidths: grp?.columnWidths,
            };
        }
        else {
            return {
                ...elem,
                attributeOid: p_element?.attributeOid,
                width: p_layoutData.parentWidth * ((p_layoutData.columnWidth[p_colIndex] ?? 100) / 100),
            };
        }
    }
    getLayoutData(p_container, p_colIndex, p_colSpan, p_layoutData) {
        let layoutData = {
            columnWidth: p_container.columnWidths ?? [],
            numberOfColumns: p_container.columnWidths?.length ?? 0,
            parentWidth: 1,
            isGroup: true,
        };
        if (p_layoutData && p_colIndex >= 0 && p_colSpan >= 1 && p_colIndex + p_colSpan <= p_layoutData.columnWidth?.length) {
            let colWidth = p_layoutData.columnWidth
                .slice(p_colIndex, p_colIndex + p_colSpan)
                .reduce((sum, width) => sum + width, 0);
            layoutData.parentWidth = p_layoutData.parentWidth * ((colWidth ?? 100) / 100);
            layoutData.isGroup = false;
        }
        return layoutData;
    }
    /* #endregion: Layoutconstruction as grid (private) */
    /* #region: Convenience (private) */
    getAttributeNameAndValue(p_attribute, p_attrValue) {
        let nameValue;
        if (p_attribute.isEnum) {
            nameValue = { name: this.CLS_ENUM_VALUE_OID, value: p_attrValue?.clsEnumValueOid };
        }
        else {
            switch (p_attribute.attrType) {
                case this.ATTR_TYPES.BOOLEAN:
                    nameValue = { name: this.BOOL_VALUE, value: p_attrValue?.boolValue };
                    break;
                case this.ATTR_TYPES.NUMBER:
                    nameValue = { name: this.NUM_VALUE, value: p_attrValue?.numValue };
                    break;
                case this.ATTR_TYPES.DATE:
                    let dateValue = null;
                    if (p_attrValue?.dateValue)
                        dateValue = formatDate(p_attrValue?.dateValue, 'yyyy-MM-dd', 'en');
                    nameValue = { name: this.DATE_VALUE, value: dateValue };
                    break;
                case this.ATTR_TYPES.STRING:
                    nameValue = { name: this.STR_VALUE, value: p_attrValue?.strValue };
                    break;
            }
        }
        return nameValue;
    }
    isClsClassOwnerAssigned(p_clsClassOwner) {
        return p_clsClassOwner.assignType == ClsOwnerAssignType.NEW
            || p_clsClassOwner.assignType == ClsOwnerAssignType.EDIT;
    }
    getLogContextBuilder(p_functionName) {
        return LogContextBuilder.getInstance('classification.component.ts', 'ClassificationComponent', p_functionName);
    }
    static { this.ɵfac = function ClassificationComponent_Factory(t) { return new (t || ClassificationComponent)(i0.ɵɵdirectiveInject(ClassificationIntl, 8), i0.ɵɵdirectiveInject(i6.FormBuilder), i0.ɵɵdirectiveInject(IMobileClassificationMtn), i0.ɵɵdirectiveInject(LoggerService), i0.ɵɵdirectiveInject(i1.MatDialog)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ClassificationComponent, selectors: [["ebootis-classification"]], inputs: { Params: "Params" }, outputs: { undoChanges: "undoChanges", saveClassification: "saveClassification", afterClassificationAssignmentChange: "afterClassificationAssignmentChange", afterClassificationInitialization: "afterClassificationInitialization" }, decls: 11, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["placeholder", ""], ["tmplClassification", ""], ["tmplClsHeader", ""], ["tmplDisplayType", ""], ["tmplButtons", ""], ["tmplReadOnly", ""], [3, "formGroup", "ngSubmit", 4, "ngIf", "ngIfElse"], ["tmplWithoutForm", ""], [3, "formGroup", "ngSubmit"], [4, "ngTemplateOutlet"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "innerText"], ["multiClassView", ""], [4, "ngIf"], [1, "cls-single-wrapper", "cls-single-header", "mb-2"], [1, "cls-single-wrapper", "cls-single-content"], ["multi", ""], ["class", "mb-0", 3, "expanded", 4, "ngFor", "ngForOf"], [1, "mb-0", 3, "expanded"], [1, "mb-2"], [1, "cls-header-line", "d-flex", "flex-fill"], [1, "cls-header"], ["class", "d-flex flex-fill justify-content-end", 4, "ngIf"], [1, "d-flex", "flex-fill", "justify-content-end"], ["mat-button", "", "type", "button", "color", "warn", 3, "click"], ["tmplEditableFields", ""], ["tmplFormFields", ""], ["tmplClsLayout", ""], ["tmplGridElems", ""], [3, "ngClass"], [4, "ngFor", "ngForOf"], [1, "fw-bold"], ["nonDateField", ""], [3, "ngSwitch"], [4, "ngSwitchCase"], ["class", "row", 4, "ngSwitchDefault"], [1, "row"], [1, "col-12", "col-md-4"], [3, "ngClass", "Params", 4, "ngFor", "ngForOf"], [3, "ngClass", "Params"], [1, "cls-layout-view", "d-flex", "flex-fill", "flex-column"], ["class", "cls-layout", 4, "ngFor", "ngForOf"], [1, "cls-layout"], ["class", "cls-layout-header mb-2", 4, "ngIf"], [1, "cls-layout-grid", 3, "ngStyle"], [1, "cls-layout-header", "mb-2"], ["class", "cls-layout-group", 3, "ngStyle", 4, "ngIf", "ngIfElse"], ["templLayoutAttribute", ""], [1, "cls-layout-group", 3, "ngStyle"], [1, "cls-layout-group-grid", 3, "ngStyle"], [1, "cls-grid-item", 3, "ngStyle"], [3, "Params", 4, "ngIf", "ngIfElse"], ["attrLabel", ""], [3, "Params"], [1, "cls-attr-label"], ["class", "cls-button-line d-flex flex-fill justify-content-start mt-2", 4, "ngIf"], ["class", "cls-button-line d-flex flex-fill justify-content-end mt-2", 4, "ngIf"], [1, "cls-button-line", "d-flex", "flex-fill", "justify-content-start", "mt-2"], ["mat-button", "", "type", "button", "color", "primary", 3, "hidden", "matTooltip", "click"], [1, "cls-button-line", "d-flex", "flex-fill", "justify-content-end", "mt-2"], ["mat-button", "", "type", "button", "color", "warn", 3, "matTooltip", "click", 4, "ngIf"], ["mat-raised-button", "", "type", "submit", "color", "primary", 3, "matTooltip", "disabled", 4, "ngIf"], ["mat-button", "", "type", "button", "color", "warn", 3, "matTooltip", "click"], ["mat-raised-button", "", "type", "submit", "color", "primary", 3, "matTooltip", "disabled"]], template: function ClassificationComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ClassificationComponent_ng_container_0_Template, 4, 2, "ng-container", 0);
            i0.ɵɵtemplate(1, ClassificationComponent_ng_template_1_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(3, ClassificationComponent_ng_template_3_Template, 4, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(5, ClassificationComponent_ng_template_5_Template, 4, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(7, ClassificationComponent_ng_template_7_Template, 9, 2, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(9, ClassificationComponent_ng_template_9_Template, 2, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", (ctx.m_clsClassificationListToRender == null ? null : ctx.m_clsClassificationListToRender.length) > 0)("ngIfElse", _r1);
        } }, dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, i1$1.NgTemplateOutlet, i1$1.NgStyle, i1$1.NgSwitch, i1$1.NgSwitchCase, i1$1.NgSwitchDefault, i8$2.PlaceholderComponent, i3.MatIcon, i4.MatTooltip, i2.MatLabel, i2.MatError, i6.ɵNgNoValidate, i6.NgControlStatusGroup, i6.FormGroupDirective, i3$2.MatButton, i12.MatAccordion, i12.MatExpansionPanel, i12.MatExpansionPanelHeader, i12.MatExpansionPanelTitle, AttributeFieldComponent, i1$1.DatePipe], styles: ["@charset \"UTF-8\";mat-expansion-panel.mat-expansion-panel[_ngcontent-%COMP%]{box-shadow:none}mat-expansion-panel.mat-expansion-panel[_ngcontent-%COMP%]   mat-expansion-panel-header.mat-expansion-panel-header[_ngcontent-%COMP%]{height:-moz-fit-content;height:fit-content}.cls-single-wrapper[_ngcontent-%COMP%]{padding:0 24px;font-size:14px}.cls-single-wrapper.cls-single-header[_ngcontent-%COMP%]{font-size:15px;line-height:22.5px}.cls-single-wrapper.cls-single-content[_ngcontent-%COMP%]{line-height:20px}.cls-header[_ngcontent-%COMP%]{font-size:1.2em;font-weight:600;align-self:center}.cls-layout-view[_ngcontent-%COMP%]   .cls-layout-header[_ngcontent-%COMP%]{font-size:1.1em;font-weight:500}.cls-layout-view[_ngcontent-%COMP%]   .cls-layout-group[_ngcontent-%COMP%] > .cls-layout-header[_ngcontent-%COMP%]{border-bottom:1px solid rgba(0,0,0,.12)}.cls-layout-grid[_ngcontent-%COMP%], .cls-layout-group-grid[_ngcontent-%COMP%]{display:grid;grid-column-gap:.5em;grid-row-gap:.5em}.cls-button-line[_ngcontent-%COMP%]{padding:0 24px}@media (max-width: 992px){.cls-layout-grid[_ngcontent-%COMP%]{display:block}}@media (max-width: 768px){.cls-layout-group-grid[_ngcontent-%COMP%]{display:block}}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClassificationComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-classification', template: "<ng-container *ngIf=\"m_clsClassificationListToRender?.length > 0;else placeholder\">\n  <!-- Falls editierbar wird eine Form erstellt -->\n  <ng-container *ngIf=\"m_isEditable; else tmplReadOnly\">\n    <form *ngIf=\"!m_parentForm; else tmplWithoutForm\"\n          [formGroup]=\"m_attributeValueForm\"\n          (ngSubmit)=\"attributeValueForm_Submit()\">\n      <ng-container *ngTemplateOutlet=\"tmplClassification\"></ng-container>\n      <ng-container *ngTemplateOutlet=\"tmplButtons; \n        context: {showUndoBtn: m_showUndoButton || m_attributeValueForm.dirty, showSaveBtn: true}\">\n      </ng-container>\n    </form>\n\n    <ng-template #tmplWithoutForm>\n      <ng-container *ngTemplateOutlet=\"tmplClassification\"></ng-container>\n      <ng-container *ngTemplateOutlet=\"tmplButtons\"></ng-container>\n    </ng-template>\n  </ng-container>\n  <!-- Falls nicht editierbar wird nur eine Tabelle mit den Werten angezeigt (s. unten #tmplReadOnlyFields) -->\n  <ng-template #tmplReadOnly>\n    <ng-container *ngTemplateOutlet=\"tmplClassification\"></ng-container>\n  </ng-template>\n</ng-container>\n\n<!-- Placeholder, falls keine Daten verf\u00FCgbar sind -->\n<ng-template #placeholder>\n  <ui-placeholder [innerText]=\"noClassificationPlaceholder\"></ui-placeholder>\n  <ng-container *ngTemplateOutlet=\"tmplButtons\"></ng-container>\n</ng-template>\n\n<ng-template #tmplClassification>\n  <!-- Falls nur eine Klassifikation vorhanden ist, wird diese ohne Accordion angezeigt -->\n  <ng-container *ngIf=\"m_clsClassificationListToRender?.length == 1; else multiClassView\">\n    <div class=\"cls-single-wrapper cls-single-header mb-2\">\n      <ng-container *ngTemplateOutlet=\"tmplClsHeader; context: {clsOwner: m_clsClassificationListToRender[0]}\"></ng-container>\n    </div>\n    <div class=\"cls-single-wrapper cls-single-content\">\n      <ng-container *ngTemplateOutlet=\"tmplDisplayType;\n          context: { clsClassOwner: m_clsClassificationListToRender[0], cssClass: 'mb-2' }\">\n      </ng-container>\n    </div>\n  </ng-container>\n\n  <!-- Falls mehrere Klassifikationen angezeigt werden sollen, werden diese als Accordion adargestellt -->\n  <ng-template #multiClassView>\n    <mat-accordion multi>\n      <mat-expansion-panel *ngFor=\"let clsOwner of m_clsClassificationListToRender\"\n                           class=\"mb-0\" [expanded]=\"true\">\n        <mat-expansion-panel-header class=\"mb-2\">\n          <mat-panel-title>\n            <ng-container *ngTemplateOutlet=\"tmplClsHeader; \n              context: {clsOwner: clsOwner}\">\n            </ng-container>\n          </mat-panel-title>\n        </mat-expansion-panel-header>\n        <ng-container *ngTemplateOutlet=\"tmplDisplayType; \n          context: { clsClassOwner: clsOwner }\">\n        </ng-container>\n      </mat-expansion-panel>\n    </mat-accordion>\n  </ng-template>\n\n  <mat-error *ngIf=\"m_error\">{{ m_error }}</mat-error>\n</ng-template>\n\n<!-- \u00DCberschrift des Klassifikationssystems -->\n<ng-template #tmplClsHeader let-clsOwner=\"clsOwner\">\n  <div class=\"cls-header-line d-flex flex-fill\">\n    <div class=\"cls-header\">{{ getHeaderText(clsOwner) }}</div>\n    <div *ngIf=\"m_canEditClassificationAssignment\"\n         class=\"d-flex flex-fill justify-content-end\">\n      <button mat-button type=\"button\" color=\"warn\"\n              (click)=\"removeAssignment_Click(clsOwner)\">\n        <mat-icon>delete</mat-icon>{{ m_classificationIntl.buttonAssignmentRemove }}\n      </button>\n    </div>\n  </div>\n</ng-template>\n\n<!-- Bestimmung der Anzeige (Ansicht oder Editierbar) -->\n<ng-template #tmplDisplayType let-clsClassOwner=\"clsClassOwner\">\n  <!-- Reine Anzeige der Klassifikation in Tabellenform -->\n  <ng-container *ngIf=\"!m_isEditable; else tmplEditableFields\">\n    <table [ngClass]=\"elementCssClass\">\n      <tr *ngFor=\"let attribute of clsClassOwner?.clsClass?.attributes\">\n        <td>\n          <mat-label class=\"fw-bold\">{{ attribute.name }}:</mat-label>\n        </td>\n        <ng-container *ngIf=\"isAttributeOfTypeDate(attribute); else nonDateField\">\n          <td>\n            {{ getAttributeDateValue(clsClassOwner, attribute) | date: 'dd.MM.yyyy' }}\n          </td>\n        </ng-container>\n        <ng-template #nonDateField>\n          <td>{{ getAttributeStrValue(clsClassOwner, attribute) }}</td>\n        </ng-template>\n      </tr>\n    </table>\n  </ng-container>\n\n  <!-- Anzeige mit editierbaren FormFields -->\n  <ng-template #tmplEditableFields>\n    <ng-container [ngSwitch]=\"getDisplayType(clsClassOwner)\">\n      <!-- Anzeige gem\u00E4\u00DF der Layout-Definition aus dem ERPII-Client -->\n      <ng-container *ngSwitchCase=\"'layout'\">\n        <ng-container *ngTemplateOutlet=\"tmplClsLayout; context: { clsClassOwner: clsClassOwner }\">\n        </ng-container>\n      </ng-container>\n      <!-- Anzeige als mehr-spaltiges Layout (wenn gr\u00F6\u00DFer md, sonst eine Spalte in Containter-Breite) -->\n      <ng-container *ngSwitchCase=\"'compact'\">\n        <div class=\"row\">\n          <ng-container *ngTemplateOutlet=\"tmplFormFields\"></ng-container>\n        </div>\n      </ng-container>\n      <!-- Anzeige als eine Spalte mit drittel Container-Breite (wenn gr\u00F6\u00DFer md, sonst ganze Containter-Breite) -->\n      <div *ngSwitchDefault class=\"row\">\n        <div class=\"col-12 col-md-4\">\n          <ng-container *ngTemplateOutlet=\"tmplFormFields\"></ng-container>\n        </div>\n      </div>\n    </ng-container>\n  </ng-template>\n\n  <!-- Schleife \u00FCber die Attribute der geg. Klassifikation -->\n  <ng-template #tmplFormFields>\n    <ebootis-attribute-field *ngFor=\"let attribute of clsClassOwner?.clsClass?.attributes\"\n                    [ngClass]=\"elementCssClass\"\n                    [Params]=\"getAttributeFieldParam(clsClassOwner, attribute)\">\n    </ebootis-attribute-field>\n  </ng-template>\n\n  <ng-template #tmplClsLayout>\n    <div class=\"cls-layout-view d-flex flex-fill flex-column\">\n      <div *ngFor=\"let clsLayout of getLayoutStructureForClsClass(clsClassOwner?.clsClass?.oid)\"\n           class=\"cls-layout\">\n        <div *ngIf=\"clsLayout.title\" class=\"cls-layout-header mb-2\">\n          {{ clsLayout.title }}\n        </div>\n        <div class=\"cls-layout-grid\" [ngStyle]=\"getGridStyleForContainer(clsLayout)\">\n          <ng-container *ngTemplateOutlet=\"tmplGridElems;\n                              context: {$implicit: {\n                                elements: clsLayout.groups, \n                                width: 1,\n                                isGroup: true\n                              }}\">\n          </ng-container>\n        </div>\n      </div>\n    </div>\n  </ng-template>\n\n  <ng-template #tmplGridElems\n               let-layoutElements>\n    <ng-container *ngFor=\"let clsLayoutElement of layoutElements.elements\">\n      <!-- Element ist eine LayoutGroup -->\n      <div *ngIf=\"layoutElements.isGroup else templLayoutAttribute\"\n            class=\"cls-layout-group\"\n            [ngStyle]=\"getItemStyleForElement(clsLayoutElement)\">\n        <div *ngIf=\"clsLayoutElement.title\"\n              class=\"cls-layout-header mb-2\">\n          {{ clsLayoutElement.title }}\n        </div>\n        <div class=\"cls-layout-group-grid\"\n              [ngStyle]=\"getGridStyleForContainer(clsLayoutElement)\">\n          <ng-container *ngTemplateOutlet=\"tmplGridElems; \n                                      context: {$implicit: {\n                                        elements: clsLayoutElement.attributes,\n                                        isGroup: false\n                                      }}\">\n          </ng-container>\n        </div>\n      </div>\n      <!-- Element ist ein LayoutAttribute -->\n      <ng-template #templLayoutAttribute>\n        <div class=\"cls-grid-item\"\n              [ngStyle]=\"getItemStyleForElement(clsLayoutElement)\">\n          <ebootis-attribute-field *ngIf=\"clsLayoutElement.attributeOid; else attrLabel\"\n                                    [Params]=\"getAttributeFieldParamForLayout(clsClassOwner, clsLayoutElement)\">\n          </ebootis-attribute-field>\n          <ng-template #attrLabel>\n            <div class=\"cls-attr-label\">\n              {{ clsLayoutElement.title }}\n            </div>\n          </ng-template>\n        </div>\n      </ng-template>\n    </ng-container>\n  </ng-template>\n</ng-template>\n\n<ng-template #tmplButtons\n             let-showUndoButton=\"showUndoBtn\"\n             let-showSaveBtn=\"showSaveBtn\">\n  <div *ngIf=\"m_canEditClassificationAssignment\" \n       class=\"cls-button-line d-flex flex-fill justify-content-start mt-2\">\n    <button [hidden]=\"!hasNotAssignedClassifications\"\n            mat-button type=\"button\" color=\"primary\"\n            attr.aria-label=\"{{ m_classificationIntl.buttonAssignNewTooltip }}\"\n            matTooltip=\"{{ m_classificationIntl.buttonAssignNewTooltip }}\"\n            (click)=\"assignNewClassification_Click()\">\n      {{ m_classificationIntl.buttonAssignNew }}\n    </button>\n  </div>\n  <div *ngIf=\"m_showUndoButton || showSaveBtn\"\n       class=\"cls-button-line d-flex flex-fill justify-content-end mt-2\">\n    <button *ngIf=\"m_showUndoButton\"\n            mat-button type=\"button\" color=\"warn\"\n            attr.aria-label=\"{{ m_classificationIntl.buttonUndoTooltip }}\"\n            matTooltip=\"{{ m_classificationIntl.buttonUndoTooltip }}\"\n            (click)=\"undoSaveItemAttributes_Click()\">\n      {{ m_classificationIntl.buttonUndo }}\n    </button>\n    <button *ngIf=\"showSaveBtn\"\n            mat-raised-button type=\"submit\" color=\"primary\"\n            attr.aria-label=\"{{ m_classificationIntl.buttonSave }}\"\n            matTooltip=\"{{ m_classificationIntl.buttonSave }}\"\n            [disabled]=\"m_attributeValueForm.pristine || m_attributeValueForm.invalid\">\n      {{ m_classificationIntl.buttonSave }}\n    </button>\n  </div>\n</ng-template>", styles: ["@charset \"UTF-8\";mat-expansion-panel.mat-expansion-panel{box-shadow:none}mat-expansion-panel.mat-expansion-panel mat-expansion-panel-header.mat-expansion-panel-header{height:-moz-fit-content;height:fit-content}.cls-single-wrapper{padding:0 24px;font-size:14px}.cls-single-wrapper.cls-single-header{font-size:15px;line-height:22.5px}.cls-single-wrapper.cls-single-content{line-height:20px}.cls-header{font-size:1.2em;font-weight:600;align-self:center}.cls-layout-view .cls-layout-header{font-size:1.1em;font-weight:500}.cls-layout-view .cls-layout-group>.cls-layout-header{border-bottom:1px solid rgba(0,0,0,.12)}.cls-layout-grid,.cls-layout-group-grid{display:grid;grid-column-gap:.5em;grid-row-gap:.5em}.cls-button-line{padding:0 24px}@media (max-width: 992px){.cls-layout-grid{display:block}}@media (max-width: 768px){.cls-layout-group-grid{display:block}}\n"] }]
    }], function () { return [{ type: ClassificationIntl, decorators: [{
                type: Optional
            }] }, { type: i6.FormBuilder }, { type: IMobileClassificationMtn }, { type: LoggerService }, { type: i1.MatDialog }]; }, { Params: [{
            type: Input
        }], undoChanges: [{
            type: Output
        }], saveClassification: [{
            type: Output
        }], afterClassificationAssignmentChange: [{
            type: Output
        }], afterClassificationInitialization: [{
            type: Output
        }] }); })();

function DbviewerDialog_mat_list_option_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-list-option");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const name_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", name_r2, " ");
} }
function DbviewerDialog_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "button", 6);
    i0.ɵɵtext(2, " Zip ");
    i0.ɵɵelementEnd()();
} }
class DbviewerDialog {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.m_selectedStoresControl = new FormControl();
    }
    static { this.ɵfac = function DbviewerDialog_Factory(t) { return new (t || DbviewerDialog)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DbviewerDialog, selectors: [["ng-component"]], decls: 7, vars: 2, consts: [[1, "row", "flex-fill", "d-flex"], [1, "flex-fill", "d-flex"], [1, "selectList"], [4, "cdkVirtualFor", "cdkVirtualForOf"], ["class", "row justify-content-center", 4, "ngIf"], [1, "row", "justify-content-center"], ["mat-raised-button", ""]], template: function DbviewerDialog_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "form")(4, "mat-selection-list");
            i0.ɵɵtemplate(5, DbviewerDialog_mat_list_option_5_Template, 2, 1, "mat-list-option", 3);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(6, DbviewerDialog_div_6_Template, 3, 0, "div", 4);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("cdkVirtualForOf", ctx.data.objectStoreNameList);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.data.isDelete);
        } }, dependencies: [i1$1.NgIf, i6.ɵNgNoValidate, i6.NgControlStatusGroup, i6.NgForm, i11.CdkVirtualForOf, i3$2.MatButton, i13$1.MatSelectionList, i13$1.MatListOption], styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;flex:1 1 auto}.container[_ngcontent-%COMP%]{display:flex}"], changeDetection: 0 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DbviewerDialog, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row flex-fill d-flex\">\r\n    <div class=\"flex-fill d-flex\">\r\n        <div class=\"flex-fill d-flex flex-column\" class=\"selectList\">\r\n            <form>\r\n                <mat-selection-list>\r\n                    <mat-list-option *cdkVirtualFor=\"let name of data.objectStoreNameList\">\r\n                        {{name}}\r\n                    </mat-list-option>\r\n                </mat-selection-list>\r\n            </form>\r\n        </div>\r\n        <div class=\"row justify-content-center\" *ngIf=\"!data.isDelete\">\r\n            <button mat-raised-button>\r\n                Zip\r\n            </button>\r\n        </div>\r\n    </div>", styles: [":host{display:flex;flex-direction:column;flex:1 1 auto}.container{display:flex}\n"] }]
    }], function () { return [{ type: i1.MatDialogRef }, { type: params, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();
class params {
}

class DBViewerIntl {
    constructor() {
        this.changes = new Subject();
        this.databaseVersion = 'Datenbank-Version';
        this.databaseKeypath = 'Schlüssel';
        this.databaseObjectStore = 'Objektspeicher';
        this.searchTerm = 'Suchbegriff';
        this.value = 'Wert';
        this.clear = 'Leeren';
        this.password = 'Passwort';
        this.noData = 'Zurzeit sind keine Daten verhanden';
        this.wouldYouReallyLikeToPermanentlyClearDatabase = 'Möchten Sie wirklich die Datenbank leeren?';
        this.clearDatabase = 'Datenbank leeren';
        this.wouldYouReallyLikeToPermanentlyDeleteObject = 'Möchten Sie wirklich das Objekt löschen?';
        this.deleteObject = 'Objekt löschen';
        this.wouldYouReallyLikeToPermanentlyClearObjectStore = 'Möchten Sie wirklich den ObjectStore leeren?';
        this.clearObjectStore = 'ObjectStore leeren';
        this.failedClearedObjectStores = 'Folgende ObjectStore konnten nicht gelöscht werden';
        this.clearEntireDatabase = 'Gesamte Datenbank leeren';
        this.deleteSelectedObject = 'Ausgewähltes Objekt löschen';
        this.number = 'Nr.';
        this.deleteDatabase = 'Datenbank löschen';
        this.wouldYouReallyLikeToDeleteTheDatabase = 'Möchten Sie wirklich die gesamte Datenbank löschen?';
        this.allOfflineDataWillBeLost = 'Alle Offlinedaten gehen dabei verloren';
    }
    static { this.ɵfac = function DBViewerIntl_Factory(t) { return new (t || DBViewerIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DBViewerIntl, factory: DBViewerIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DBViewerIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

const DB_VIEWER_DB_SERVICE = new InjectionToken('DB_VIEWER_DB_SERVICE');

function SnackbarComponent_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.iconName);
} }
function SnackbarComponent_ng_container_4_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function SnackbarComponent_ng_container_4_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r5.snackBarRef.dismiss()); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "close");
    i0.ɵɵelementEnd()();
} }
function SnackbarComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SnackbarComponent_ng_container_4_button_1_Template, 3, 0, "button", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.data.actionLabel == "x")("ngIfElse", _r2);
} }
function SnackbarComponent_ng_template_5_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function SnackbarComponent_ng_template_5_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.snackBarRef.dismiss()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.data.actionLabel, " ");
} }
function SnackbarComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SnackbarComponent_ng_template_5_button_0_Template, 2, 1, "button", 8);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r3.m_isDismissable);
} }
class SnackbarComponent {
    constructor(snackBarRef, data) {
        this.snackBarRef = snackBarRef;
        this.data = data;
        this.m_isDismissable = false;
        this.m_isDismissable = this.data.isDismissable;
    }
    ngOnInit() {
    }
    get iconName() {
        switch (this.data.messageType) {
            case MessageType.success:
                return 'check_circle_outline';
            case MessageType.info:
                return 'info_outline';
            case MessageType.warning:
                return 'warning_amber';
            case MessageType.error:
                return 'error_outline';
            default:
                return null;
        }
    }
    get class() {
        return this.data.messageType.toString() + '-snackbar';
    }
    static { this.ɵfac = function SnackbarComponent_Factory(t) { return new (t || SnackbarComponent)(i0.ɵɵdirectiveInject(i1$3.MatSnackBarRef), i0.ɵɵdirectiveInject(MAT_SNACK_BAR_DATA)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SnackbarComponent, selectors: [["app-snackbar"]], decls: 7, vars: 5, consts: [[1, "d-flex", "align-items-center", "rounded"], ["class", "m-3", 4, "ngIf"], [1, "flex-fill"], [4, "ngIf"], ["actionTemplate", ""], [1, "m-3"], ["mat-icon-button", "", 3, "click", 4, "ngIf", "ngIfElse"], ["mat-icon-button", "", 3, "click"], ["mat-button", "", "class", "mt-1 font-weight-bold", 3, "click", 4, "ngIf"], ["mat-button", "", 1, "mt-1", "font-weight-bold", 3, "click"]], template: function SnackbarComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, SnackbarComponent_mat_icon_1_Template, 2, 1, "mat-icon", 1);
            i0.ɵɵelementStart(2, "span", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, SnackbarComponent_ng_container_4_Template, 2, 2, "ng-container", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, SnackbarComponent_ng_template_5_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵclassMap(ctx.class);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.iconName);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("", ctx.data.text, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.m_isDismissable);
        } }, dependencies: [i1$1.NgIf, i3.MatIcon, i3$2.MatButton, i3$2.MatIconButton], styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;flex:1 1 auto;height:100%;border-radius:5px}[_nghost-%COMP%]   mat-icon[_ngcontent-%COMP%]{overflow:visible}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SnackbarComponent, [{
        type: Component,
        args: [{ selector: 'app-snackbar', template: "<div [class]=\"class\" class=\"d-flex align-items-center rounded\">\n    <mat-icon *ngIf=\"iconName\" class=\"m-3\">{{ iconName }}</mat-icon>\n    <span class=\"flex-fill\">{{ data.text }} </span>\n    <ng-container *ngIf=\"m_isDismissable\">\n        <button *ngIf=\"data.actionLabel=='x'; else actionTemplate\" mat-icon-button \n                (click)=\"snackBarRef.dismiss()\">\n            <mat-icon>close</mat-icon>\n        </button>\n    </ng-container>\n</div>\n\n<ng-template #actionTemplate>\n    <button *ngIf=\"m_isDismissable\" mat-button (click)=\"snackBarRef.dismiss()\" class=\"mt-1 font-weight-bold\">\n        {{data.actionLabel}}\n    </button>\n</ng-template>", styles: [":host{display:flex;flex-direction:column;flex:1 1 auto;height:100%;border-radius:5px}:host mat-icon{overflow:visible}\n"] }]
    }], function () { return [{ type: i1$3.MatSnackBarRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_SNACK_BAR_DATA]
            }] }]; }, null); })();

/**
 * Service um den Benutzer Nachrichten via. Snackbar anzuzeigen
 */
class MessageService {
    constructor(m_snackbar) {
        this.m_snackbar = m_snackbar;
        // 3 Sekunden für Type: Info und Success
        this.DFLT_ERROR_DURATION = 3000;
    }
    /**
     * Methode um eine Snackbar anzuzeigen
     * @param p_message Message
     * @param p_action Label für die Snackbar-Action
     * @param p_config Zusätzliche Konfiguration für die Snackbar
     */
    _showMessage(p_message, p_action, p_type, p_config) {
        let panelClass = ['snackbar'];
        if (p_config?.panelClass) {
            if (typeof p_config?.panelClass === 'string')
                panelClass.push(p_config?.panelClass);
            else
                panelClass.push(...p_config?.panelClass);
        }
        this.m_snackbar.openFromComponent(SnackbarComponent, {
            data: {
                isDismissable: true,
                text: p_message,
                messageType: p_type,
                actionLabel: p_action
            },
            panelClass: panelClass,
            duration: p_config?.duration
        });
    }
    /**
     * Methode um eine eine Snackbar Message anzuzeigen.
     *
     * Unsere Vorgaben geben an das Snackbars welche NICHT @param p_type gleich warning und error
     * sind, eine Anzeige dauer von 3 Sekunden besitzen. Sollte @param p_type = null sein,
     * wird die Snackbar so lange angezeigt bis der User diese wegklickt.
     *
     * Für Nachrichten mit einem @param p_type und @param p_config = null fügen wir automatisch einen
     * Style hinzu, nach folgenden Schema: 'MessageType-snackbar', um z.B. die Hintergrundfarbe zu ändern.
     *
     * Die Snackbar Action @param p_action wenn nicht angegeben ist Default 'x'.
     *
     * Hinweis: Die Angabe einer @param p_config MatSnackbarConfig überschreibt unsere Defaulteinstellungen zur Anzeigedauer und Styles.
     * i.d.R wird eine eigene Konfiguration nicht nötigt, für diverse Sonderfälle aber vorhanden.
     *
     * @param p_message Message
     * @param p_type (nullable) MessageType
     * @param p_action (nullable) Label für die Snackbar-Action (default 'x')
     * @param p_config (nullable) zusätzliche Konfiguration, überschreibt unsere Default Konfiguration
     */
    showMessage(p_message, p_type, p_action, p_config) {
        const action = p_action ?? 'x';
        let config = new MatSnackBarConfig();
        if (p_type) {
            if (p_type !== MessageType.error && p_type !== MessageType.warning) {
                config.duration = this.DFLT_ERROR_DURATION;
            }
        }
        if (p_config)
            config = p_config;
        this._showMessage(p_message, action, p_type, config);
    }
    /**
     * Erzeugt und versendet eine Snackbar mit einer benutzerdefinierten Komponente
     * für den Inhalt und entfernt alle derzeit geöffneten Snackbars
     * @param p_component Komponente welche instanziiert wird
     * @param p_config zusätzliche Konfiguration
     * @returns
     */
    showMessagFromComponent(p_component, p_config) {
        return this.m_snackbar.openFromComponent(p_component, p_config);
    }
    /**
     * Erstellt und versendet eine Snackbar mit einer benutzerdefinierten Vorlage
     * für den Inhalt und entfernt alle derzeit geöffneten Snackbars
     * @param p_template Template welches instanziiert wird
     * @param p_config zusätzliche Konfiguration
     * @returns
     */
    showMessageFromTemplate(p_template, p_config) {
        return this.m_snackbar.openFromTemplate(p_template, p_config);
    }
    /**
     * Zeigt eine Snackbar vom `MessageType.info` an
     * @param p_message die anzuzeigende Nachricht
     */
    info(p_message) {
        this.showMessage(p_message, MessageType.info);
    }
    /**
     * Zeigt eine Snackbar vom `MessageType.error` an
     * @param p_message die anzuzeigende Nachricht
     */
    error(p_message) {
        this.showMessage(p_message, MessageType.error);
    }
    /**
     * Zeigt eine Snackbar vom `MessageType.success` an
     * @param p_message die anzuzeigende Nachricht
     */
    success(p_message) {
        this.showMessage(p_message, MessageType.success);
    }
    /**
     * Zeigt eine Snackbar vom `MessageType.warning` an
     * @param p_message die anzuzeigende Nachricht
     */
    warning(p_message) {
        this.showMessage(p_message, MessageType.warning);
    }
    static { this.ɵfac = function MessageService_Factory(t) { return new (t || MessageService)(i0.ɵɵinject(i1$3.MatSnackBar)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MessageService, factory: MessageService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i1$3.MatSnackBar }]; }, null); })();
var MessageType;
(function (MessageType) {
    MessageType["info"] = "info";
    MessageType["success"] = "success";
    MessageType["warning"] = "warning";
    MessageType["error"] = "error";
})(MessageType || (MessageType = {}));

class ConfirmationDlgIntl {
    constructor() {
        this.changes = new Subject();
        this.yes = 'Ja';
        this.no = 'Nein';
        this.close = 'Schließen';
    }
    static { this.ɵfac = function ConfirmationDlgIntl_Factory(t) { return new (t || ConfirmationDlgIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConfirmationDlgIntl, factory: ConfirmationDlgIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationDlgIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

function ConfirmationDialogComponent_button_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("mat-dialog-close", false);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.m_btnNoText, " ");
} }
function ConfirmationDialogComponent_button_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.m_btnCancelText, " ");
} }
class ConfirmationDialogComponent {
    constructor(m_data, confirmationDlgIntl) {
        this.m_data = m_data;
        this.confirmationDlgIntl = confirmationDlgIntl;
        this.m_mainButtonColor = 'primary';
        if (this.confirmationDlgIntl) {
            this.m_confirmationDlgIntl = this.confirmationDlgIntl;
        }
        else {
            this.m_confirmationDlgIntl = new ConfirmationDlgIntl();
        }
        this.m_title = this.m_data.title;
        this.m_message = this.m_data.message;
        this.m_mainButtonColor = this.m_data.isWarning ? 'warn' : 'primary';
        this.initTexts();
    }
    initTexts() {
        this.m_btnYesText = this.m_data.btnYesText ? this.m_data.btnYesText : this.m_confirmationDlgIntl.yes;
        this.m_btnNoText = this.m_data.btnNoText ? this.m_data.btnNoText : this.m_confirmationDlgIntl.no;
        this.m_hideNoBtn = this.m_data.hideNoBtn;
        // Wenn für den Cancel-Button kein Text mitgegeben wurde, wird er nicht angezeigt
        this.m_btnCancelText = this.m_data.btnCancelText;
    }
    ngOnInit() {
    }
    static { this.ɵfac = function ConfirmationDialogComponent_Factory(t) { return new (t || ConfirmationDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(ConfirmationDlgIntl, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ConfirmationDialogComponent, selectors: [["app-confirmation-dialog"]], decls: 14, vars: 9, consts: [["mat-dialog-title", "", 1, "ebo-dialog-header"], [1, "ebo-dialog-title"], ["mat-icon-button", "", "type", "button", "mat-dialog-close", "", 3, "aria-label", "matTooltip"], [1, "default-font"], [1, "ebo-dialog-actions"], ["type", "button", "mat-button", "", "cdkFocusInitial", "", 3, "mat-dialog-close", 4, "ngIf"], ["type", "button", "mat-button", "", "mat-dialog-close", "", "cdkFocusInitial", "", 4, "ngIf"], ["type", "button", "mat-raised-button", "", "color", "primary", 3, "mat-dialog-close", "color"], ["type", "button", "mat-button", "", "cdkFocusInitial", "", 3, "mat-dialog-close"], ["type", "button", "mat-button", "", "mat-dialog-close", "", "cdkFocusInitial", ""]], template: function ConfirmationDialogComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0)(1, "span", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "button", 2)(4, "mat-icon");
            i0.ɵɵtext(5, "close");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(6, "mat-dialog-content")(7, "pre", 3);
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "mat-dialog-actions", 4);
            i0.ɵɵtemplate(10, ConfirmationDialogComponent_button_10_Template, 2, 2, "button", 5);
            i0.ɵɵtemplate(11, ConfirmationDialogComponent_button_11_Template, 2, 1, "button", 6);
            i0.ɵɵelementStart(12, "button", 7);
            i0.ɵɵtext(13);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.m_title, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("aria-label", ctx.m_confirmationDlgIntl.close)("matTooltip", ctx.m_confirmationDlgIntl.close);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.m_message);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.m_hideNoBtn);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.m_btnCancelText);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("mat-dialog-close", true)("color", ctx.m_mainButtonColor);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.m_btnYesText, " ");
        } }, dependencies: [i1$1.NgIf, i3.MatIcon, i4.MatTooltip, i3$2.MatButton, i3$2.MatIconButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationDialogComponent, [{
        type: Component,
        args: [{ selector: 'app-confirmation-dialog', template: "<h1 mat-dialog-title class=\"ebo-dialog-header\">\n  <span class=\"ebo-dialog-title\">\n    {{ m_title }}\n  </span>\n  <button mat-icon-button type=\"button\" [aria-label]=\"m_confirmationDlgIntl.close\"\n          [matTooltip]=\"m_confirmationDlgIntl.close\" mat-dialog-close>\n    <mat-icon>close</mat-icon>\n  </button>\n</h1>\n<mat-dialog-content>\n  <pre class=\"default-font\">{{ m_message }}</pre>\n</mat-dialog-content>\n<mat-dialog-actions class=\"ebo-dialog-actions\">\n  <button *ngIf=\"!m_hideNoBtn\" type=\"button\" mat-button [mat-dialog-close]=\"false\" cdkFocusInitial>\n    {{ m_btnNoText }}\n  </button>\n  <button *ngIf=\"m_btnCancelText\" type=\"button\" mat-button mat-dialog-close cdkFocusInitial>\n    {{ m_btnCancelText }}\n  </button>\n  <button type=\"button\" mat-raised-button color=\"primary\" [mat-dialog-close]=\"true\" [color]=\"m_mainButtonColor\">\n    {{m_btnYesText}}\n  </button>\n</mat-dialog-actions>" }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: ConfirmationDlgIntl, decorators: [{
                type: Optional
            }] }]; }, null); })();

class ConfirmationIntl {
    constructor() {
        this.changes = new Subject();
        this.askYouHaveUnsavedChangesDiscardThem = 'Sie haben ungespeicherte Änderungen. Sollen diese verworfen werden?';
        this.askDiscardUnsavedChanges = 'Ungespeicherte Änderungen verwerfen?';
    }
    static { this.ɵfac = function ConfirmationIntl_Factory(t) { return new (t || ConfirmationIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConfirmationIntl, factory: ConfirmationIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

class ConfirmationService {
    constructor(m_dialog, confirmationIntl) {
        this.m_dialog = m_dialog;
        this.confirmationIntl = confirmationIntl;
        this.m_confirmationIntl = this.confirmationIntl ?? new ConfirmationIntl();
        /* if (this.confirmationIntl) {
          this.m_confirmationIntl = this.confirmationIntl;
        } else {
          this.m_confirmationIntl = new ConfirmationIntl();
        } */
    }
    /**
     *  Öffnet den Bestätigungsdialog mit den mitgegebenen Texten.
     *  Beinhaltet afterClosed und eine Take-1 Pipe.
     *  Bestätigen-Button returned true,
     *  Negieren-Button returned false,
     *  Cancel-Button returned null
     *
    */
    openConfirmationDialog(p_confirmationDialogData) {
        return this.m_dialog.open(ConfirmationDialogComponent, {
            data: p_confirmationDialogData,
            autoFocus: true,
        }).afterClosed()
            .pipe(take(1));
    }
    openUnsavedChangesDialog() {
        return this.m_dialog.open(ConfirmationDialogComponent, {
            data: {
                title: this.m_confirmationIntl.askDiscardUnsavedChanges,
                message: this.m_confirmationIntl.askYouHaveUnsavedChangesDiscardThem,
                isWarning: true,
            },
            autoFocus: true,
        }).afterClosed()
            .pipe(take(1));
    }
    static { this.ɵfac = function ConfirmationService_Factory(t) { return new (t || ConfirmationService)(i0.ɵɵinject(i1.MatDialog), i0.ɵɵinject(ConfirmationIntl, 8)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConfirmationService, factory: ConfirmationService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.MatDialog }, { type: ConfirmationIntl, decorators: [{
                type: Optional
            }] }]; }, null); })();

function PasswordFieldContentComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵprojection(1);
    i0.ɵɵelementContainerEnd();
} }
function PasswordFieldContentComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 2)(1, "mat-form-field", 3)(2, "mat-label");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 4);
    i0.ɵɵlistener("ngModelChange", function PasswordFieldContentComponent_ng_template_1_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.passwordValue = $event); })("change", function PasswordFieldContentComponent_ng_template_1_Template_input_change_4_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onInputChanged()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.fieldLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r2.passwordValue);
} }
const _c0$7 = ["*"];
class PasswordFieldContentComponent {
    get value() {
        return this.passwordValue;
    }
    set value(p_value) {
        this.passwordValue = p_value;
        this.checkPassword();
    }
    constructor() {
        this.valueChanged = new EventEmitter();
    }
    checkPassword() {
        this.isPasswordCorrect = this.passwordValue == this.password;
    }
    onInputChanged() {
        this.checkPassword();
        this.valueChanged.emit(this.passwordValue);
    }
    static { this.ɵfac = function PasswordFieldContentComponent_Factory(t) { return new (t || PasswordFieldContentComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PasswordFieldContentComponent, selectors: [["ebootis-password-field-content"]], inputs: { password: "password", fieldLabel: "fieldLabel", value: "value" }, outputs: { valueChanged: "valueChanged" }, ngContentSelectors: _c0$7, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["passwordForm", ""], [1, "w-100"], ["appearance", "fill", 1, "w-100"], ["matInput", "", "type", "password", "name", "password", "autocomplete", "off", 3, "ngModel", "ngModelChange", "change"]], template: function PasswordFieldContentComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, PasswordFieldContentComponent_ng_container_0_Template, 2, 0, "ng-container", 0);
            i0.ɵɵtemplate(1, PasswordFieldContentComponent_ng_template_1_Template, 5, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.isPasswordCorrect)("ngIfElse", _r1);
        } }, dependencies: [i1$1.NgIf, i2.MatFormField, i2.MatLabel, i3$1.MatInput, i6.ɵNgNoValidate, i6.DefaultValueAccessor, i6.NgControlStatus, i6.NgControlStatusGroup, i6.NgModel, i6.NgForm] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PasswordFieldContentComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-password-field-content', template: "<ng-container *ngIf=\"isPasswordCorrect; else passwordForm\">\n  <ng-content></ng-content>\n</ng-container>\n\n<ng-template #passwordForm>\n  <form class=\"w-100\">\n    <mat-form-field class=\"w-100\" appearance=\"fill\">\n      <mat-label>{{fieldLabel}}</mat-label>\n      <input matInput type=\"password\" name=\"password\" [(ngModel)]=\"passwordValue\"\n             autocomplete=\"off\" (change)=\"onInputChanged()\">\n    </mat-form-field>\n  </form>\n</ng-template>" }]
    }], function () { return []; }, { password: [{
            type: Input
        }], fieldLabel: [{
            type: Input
        }], value: [{
            type: Input
        }], valueChanged: [{
            type: Output
        }] }); })();

function DBViewerComponent_mat_option_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const name_r15 = ctx.$implicit;
    i0.ɵɵproperty("value", name_r15);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", name_r15, " ");
} }
function DBViewerComponent_mat_icon_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 22);
} }
function DBViewerComponent_ng_template_21_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 23);
    i0.ɵɵlistener("click", function DBViewerComponent_ng_template_21_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.clearObjectStoreField_Click()); });
    i0.ɵɵtext(1, "close");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", ctx_r5.m_strings.clear)("hidden", !ctx_r5.m_objectStoreCtrl.value || ctx_r5.m_objectStoreCtrl.value == "");
    i0.ɵɵattribute("aria-label", ctx_r5.m_strings.clear);
} }
function DBViewerComponent_mat_icon_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 22);
} }
function DBViewerComponent_ng_template_28_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 23);
    i0.ɵɵlistener("click", function DBViewerComponent_ng_template_28_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.clearSearchTextField_Click()); });
    i0.ɵɵtext(1, "close");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", ctx_r8.m_strings.clear)("hidden", !ctx_r8.m_searchTextCtrl.value || ctx_r8.m_searchTextCtrl.value == "");
    i0.ɵɵattribute("aria-label", ctx_r8.m_strings.clear);
} }
function DBViewerComponent_div_44_div_9_i_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 46);
    i0.ɵɵtext(1, "arrow_right");
    i0.ɵɵelementEnd();
} }
function DBViewerComponent_div_44_div_9_i_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 46);
    i0.ɵɵtext(1, "arrow_drop_down");
    i0.ɵɵelementEnd();
} }
function DBViewerComponent_div_44_div_9_span_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 47);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r21 = i0.ɵɵnextContext().$implicit;
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r25.getShortenedJson(item_r21.value)));
} }
const _c0$6 = function (a0, a1) { return { "selected": a0, "odd": a1 }; };
function DBViewerComponent_div_44_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵlistener("click", function DBViewerComponent_div_44_div_9_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r28); const i_r22 = restoredCtx.index; const ctx_r27 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r27.m_selectedRowId = i_r22); });
    i0.ɵɵelementStart(1, "div", 32)(2, "div", 33)(3, "span", 34);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 35)(7, "span", 34);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 36);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 37)(12, "div", 38);
    i0.ɵɵlistener("click", function DBViewerComponent_div_44_div_9_Template_div_click_12_listener() { const restoredCtx = i0.ɵɵrestoreView(_r28); const item_r21 = restoredCtx.$implicit; const ctx_r29 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r29.m_expandedElement = ctx_r29.m_expandedElement === item_r21 ? null : item_r21); });
    i0.ɵɵelementStart(13, "div", 39)(14, "span", 34);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 40);
    i0.ɵɵtemplate(17, DBViewerComponent_div_44_div_9_i_17_Template, 2, 0, "i", 41);
    i0.ɵɵtemplate(18, DBViewerComponent_div_44_div_9_i_18_Template, 2, 0, "i", 41);
    i0.ɵɵtemplate(19, DBViewerComponent_div_44_div_9_span_19_Template, 3, 3, "span", 42);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(20, "div", 43)(21, "div", 44)(22, "pre", 45);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "json");
    i0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    const item_r21 = ctx.$implicit;
    const i_r22 = ctx.index;
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(16, _c0$6, i_r22 === ctx_r20.m_selectedRowId, i_r22 % 2 == 0));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r20.m_strings.number);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i_r22 + 1, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", ctx_r20.m_strings.databaseKeypath, ":\"", ctx_r20.m_objectStoreKeyPath, "\"");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r20.m_data[i_r22].key);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r20.m_strings.value);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r21 !== ctx_r20.m_expandedElement);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r21 == ctx_r20.m_expandedElement);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r21 !== ctx_r20.m_expandedElement);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("expanded-row", ctx_r20.m_expandedElement === item_r21);
    i0.ɵɵproperty("@detailExpand", item_r21 === ctx_r20.m_expandedElement ? "expanded" : "collapsed");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(24, 14, ctx_r20.getShortenedJson(item_r21.value)));
} }
function DBViewerComponent_div_44_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24)(1, "div", 25)(2, "div", 26);
    i0.ɵɵtext(3, "#");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 27);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 28);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "cdk-virtual-scroll-viewport", 29);
    i0.ɵɵtemplate(9, DBViewerComponent_div_44_div_9_Template, 25, 19, "div", 30);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate2("", ctx_r12.m_strings.databaseKeypath, ":\"", ctx_r12.m_objectStoreKeyPath, "\"");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r12.m_strings.value);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cdkVirtualForOf", ctx_r12.m_data)("cdkVirtualForTemplateCacheSize", 0);
} }
function DBViewerComponent_ng_template_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r14.m_strings.noData);
} }
class ObjectStoreValue {
}
class DBViewerComponent {
    constructor(m_messageService, m_confirmationService, dbService, dbViewerIntl) {
        this.m_messageService = m_messageService;
        this.m_confirmationService = m_confirmationService;
        this.dbService = dbService;
        this.dbViewerIntl = dbViewerIntl;
        this.passwordInputChanged = new EventEmitter();
        this.deleteDatabaseClicked = new EventEmitter();
        this.m_selectedRowId = -1;
        this.m_data = [];
        this.m_objectStoreCtrl = new FormControl('', { initialValueIsDefault: true });
        this.m_searchTextCtrl = new FormControl('', { initialValueIsDefault: true });
        this.m_objectStoreNames = [];
        this.READONLY = 'readonly';
        this.READ_WRITE = 'readwrite';
        this.m_subscriptionSubject = new Subject();
        if (this.m_strings)
            this.m_strings = this.dbViewerIntl;
        else
            this.m_strings = new DBViewerIntl();
    }
    ngOnInit() {
        this.m_searchTextCtrl.disable();
        this.dbService.getDB().pipe(takeUntil(this.m_subscriptionSubject)).subscribe(db => {
            this.m_database = db;
            if (this.m_database !== undefined) {
                this.m_version = this.m_database.version;
                this.getObjectStores();
            }
        });
        this.m_autocompleteObjectStoreNames = this.m_objectStoreCtrl.valueChanges.pipe(takeUntil(this.m_subscriptionSubject), startWith(''), map(name => this.filterNames(name)));
        this.m_searchTextCtrl.valueChanges.pipe(takeUntil(this.m_subscriptionSubject), debounceTime(1000), distinctUntilChanged(), map(searchValue => this.filterValues(searchValue))).subscribe();
    }
    ngOnDestroy() {
        this.m_subscriptionSubject.next();
        this.m_subscriptionSubject.complete();
    }
    /**
     * Holt die Namen der ObjectStores
     * lädt die Werte des ersten bekannten ObjectStores und versucht diese Informationen zuladen und anzuzeigen
     */
    getObjectStores() {
        this.m_objectStoreNames = Array.from(this.m_database?.objectStoreNames);
        let selected = this.m_objectStoreNames[0];
        this.m_objectStoreCtrl.setValue(selected);
        this.getObjectStoreByName(selected);
    }
    /**
     * Löscht das ausgewählte Objekt des ausgewählten ObjectStores
     */
    deleteSelected_Click() {
        if (this.m_selectedRowId < 0 && !this.m_objectStoreCtrl.value) //damit Dialog garnicht erst geöffnet wird wenn kein Element ausgewählt
            return;
        this.openConfirmationDialog({
            message: this.m_strings.wouldYouReallyLikeToPermanentlyDeleteObject,
            title: this.m_strings.deleteObject,
        }).pipe(switchMap((answer) => {
            let key = this.m_data?.length > 0 ? this.m_data[this.m_selectedRowId]?.key : null;
            return iif(() => answer == true && key != null, this.removeByKey(this.m_objectStoreCtrl.value, key), of(false));
        }))
            .subscribe({
            next: (answer) => {
                const selectedRow = this.m_data[this.m_selectedRowId];
                const index = this.m_data.indexOf(selectedRow, 0);
                if (answer != false && index > -1) {
                    this.m_data.splice(index, 1);
                    this.m_data = [...this.m_data];
                    this.m_cdkVirtualScrollViewport?.checkViewportSize();
                }
            },
            error: (err) => {
                this.m_messageService.error(err?.error?.message);
            }
        });
    }
    openConfirmationDialog(p_cfg) {
        p_cfg.isWarning = true;
        return this.m_confirmationService.openConfirmationDialog(p_cfg);
    }
    /**
     * TODO: Dialog zum auswählen der ObjectStores die man Zippen/löschen möchte
     * @deprecated / not implemented
     */
    _openDialog(p_ZipOrDelete) {
        // this.m_dialog.open(DbviewerDialog, {
        //   data: {
        //     objectStoreNameList: Array.from(this.m_storeNamesDOMList),
        //     isDelete: p_ZipOrDelete == "zip" ? false : true
        //   },
        //   height: "80vh",
        //   width: "400px"
        // }).afterClosed().subscribe((selectedStoresToZip) => {
        // });
    }
    /**
     * Leert ein ObjectStore
     */
    clearObjectStore_Click() {
        if (!this.m_objectStoreCtrl.value)
            return;
        this.openConfirmationDialog({
            message: this.m_strings.wouldYouReallyLikeToPermanentlyClearObjectStore,
            title: this.m_strings.clearObjectStore,
        }).pipe(switchMap((answer) => {
            return iif(() => answer == true, this.clearObjectStore(this.m_objectStoreCtrl.value), of(false));
        }))
            .subscribe({
            next: (answer) => {
                if (answer != false) {
                    this.m_data = [];
                    this.m_cdkVirtualScrollViewport?.checkViewportSize();
                }
            },
            error: (err) => {
                this.m_messageService.error(err?.error?.message);
            }
        });
    }
    /**
     * Leert alle Einträge aus jedem ObjectStore der bekannten IndexedDB Datenbank
     */
    clearDatabase_Click() {
        if (this.m_objectStoreNames) {
            this.openConfirmationDialog({
                message: this.m_strings.wouldYouReallyLikeToPermanentlyClearDatabase,
                title: this.m_strings.clearDatabase,
            }).pipe(switchMap((answer) => {
                let removeAllObservableList = concat(//concat funktiert vielleicht nicht
                this.m_objectStoreNames.map(storeName => {
                    return this.clearObjectStore(storeName);
                }));
                return iif(() => answer === true, removeAllObservableList, of(false));
            }))
                .subscribe({
                error: err => {
                    this.m_messageService.error(err?.error?.message);
                }
            });
        }
    }
    /**
      * liefert angegebenen Objektstore zurück
      * @param p_objectStoreName der Objectstore, aus dem alle Einträge zurückgeliefert werden sollen
      */
    getValuesFromObjectStore(p_objectStoreName) {
        return new Observable((os) => {
            return this.getTransaction(p_objectStoreName, this.READONLY)
                .subscribe({
                next: (tx) => {
                    const objectStore = tx.objectStore(p_objectStoreName);
                    const cursorReq = objectStore.openCursor();
                    const values = [];
                    this.m_objectStoreKeyPath = objectStore.keyPath;
                    cursorReq.onsuccess = () => {
                        const cursor = cursorReq.result;
                        if (cursor) {
                            values.push({
                                key: cursor.primaryKey.toString(),
                                value: cursor.value,
                            });
                            cursor.continue();
                        }
                        else {
                            os.next(values);
                            os.complete();
                        }
                    };
                    cursorReq.onerror = () => {
                        os.error(cursorReq.error);
                    };
                }
            });
        });
    }
    /**
     * Löscht den Eintrag, der unter dem angegebenen Schlüssel gefunden wurde
     * @param p_objectStoreName Objectstore aus dem ein Eintrag gelöscht werden soll
     * @param p_key Primärschlüssel des Eintrags
     */
    removeByKey(p_objectStoreName, p_key) {
        return new Observable((os) => {
            return this.getTransaction(p_objectStoreName, this.READ_WRITE)
                .subscribe({
                next: (tx) => {
                    const req = tx.objectStore(p_objectStoreName).delete(p_key);
                    req.onerror = (ev) => {
                        os.error(ev);
                        os.error(req.error);
                    };
                    req.onsuccess = () => {
                        os.next(true);
                        os.complete();
                    };
                }
            });
        });
    }
    /**
     * Löscht alle inhalte eines ObjectStores
     * @param p_objectStoreName ObjectStoreName
     * @returns
     */
    clearObjectStore(p_objectStoreName) {
        return new Observable((os) => {
            return this.getTransaction(p_objectStoreName, this.READ_WRITE)
                .subscribe({
                next: (tx) => {
                    const req = tx.objectStore(p_objectStoreName).clear();
                    req.onsuccess = () => {
                        os.next(true);
                        os.complete();
                    };
                    req.onerror = () => {
                        os.error(req.error);
                    };
                }
            });
        });
    }
    deleteDatabase_Click() {
        this.openConfirmationDialog({
            message: `${this.m_strings.wouldYouReallyLikeToDeleteTheDatabase}\n${this.m_strings.allOfflineDataWillBeLost}`,
            title: this.m_strings.deleteDatabase,
        }).subscribe({
            next: (confirmed) => {
                if (confirmed) {
                    this.deleteDatabaseClicked.emit(true);
                }
            },
            error: err => {
                this.m_messageService.error(err?.error?.message);
            }
        });
    }
    /**
     * Erstellt eine Transaction mit einem ObjectStore
     * @param p_storeNames ObjectStoreName
     * @param p_mode readwrite/readonly
     * @returns
     */
    getTransaction(p_storeNames, p_mode) {
        return of(this.m_database.transaction(p_storeNames, p_mode));
    }
    /**
     * Holt alle Daten eines ObjectStores
     * @param p_name Name des ObjectStores
     */
    getObjectStoreByName(p_name) {
        this.m_searchTextCtrl.enable();
        this.getValuesFromObjectStore(p_name).subscribe(res => {
            this.m_data = res;
            this.m_cdkVirtualScrollViewport?.checkViewportSize();
        });
    }
    /**
     * Schneidet inhalte eines JSON auf 38 Zeichen
     * @param p_json Json zum schneiden
     * @returns
     */
    // hier könnte ne shared pipe doch ganz nett sein (möglicher weise auch für andere Projekte), mit Number als Parameter wann abgeschnitten werden soll (default 38 z.B)
    getShortenedJson(p_json) {
        if (p_json) {
            Object.keys(p_json).forEach((k) => {
                if (typeof p_json[k] === 'object') {
                    p_json[k] = this.getShortenedJson(p_json[k]);
                }
                else if (p_json[k]?.length > 38) {
                    p_json[k] = p_json[k].slice(0, 38) + "...";
                }
            });
        }
        return p_json;
    }
    /** Methode zum Filtern der ObjectStores */
    filterNames(name) {
        const filterValue = name.trim().toLowerCase();
        return this.m_objectStoreNames.filter(option => option.toLowerCase().includes(filterValue));
    }
    /**
     * Methode zum Filter der Werte eines ObjectStores
     * @param p_search Sucheingabe
     */
    filterValues(p_search) {
        const search = p_search.trim().toLowerCase();
        if (!search || search?.length === 0 || search === '') {
            this.getObjectStoreByName(this.m_objectStoreCtrl.value);
            return;
        }
        this.m_data = this.m_data.filter(data => this.objectContains(data.value, search));
    }
    objectContains(p_object, p_searchTerm) {
        for (let key in p_object) {
            if (typeof (p_object[key]) === 'object') {
                if (this.objectContains(p_object[key], p_searchTerm))
                    return true;
            }
            else if (typeof (p_object[key]) === 'boolean' || typeof (p_object[key]) === 'number') {
                if (StringUtility.compareStringAgainstFilter(`${p_object[key]}`, p_searchTerm))
                    return true;
            }
            else {
                if (StringUtility.compareStringAgainstFilter(p_object[key], p_searchTerm))
                    return true;
            }
        }
        return false;
    }
    /** Leert das ObjectStore Ctrl */
    clearObjectStoreField_Click() {
        this.m_objectStoreCtrl.reset();
        this.m_data = [];
        this.m_selectedRowId = -1;
        this.m_expandedElement = null;
        this.m_searchTextCtrl.disable();
        this.m_cdkVirtualScrollViewport?.checkViewportSize();
    }
    /**
     * Leert das Suchfeld
     */
    clearSearchTextField_Click() {
        this.m_searchTextCtrl.reset();
        this.getObjectStoreByName(this.m_objectStoreCtrl.value);
    }
    onPasswordValue_Change(p_newValue) {
        this.m_passwordInput = p_newValue;
        this.passwordInputChanged.emit(this.m_passwordInput);
    }
    static { this.ɵfac = function DBViewerComponent_Factory(t) { return new (t || DBViewerComponent)(i0.ɵɵdirectiveInject(MessageService), i0.ɵɵdirectiveInject(ConfirmationService), i0.ɵɵdirectiveInject(DB_VIEWER_DB_SERVICE), i0.ɵɵdirectiveInject(DBViewerIntl, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DBViewerComponent, selectors: [["ebootis-db-viewer"]], viewQuery: function DBViewerComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(CdkVirtualScrollViewport, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.m_cdkVirtualScrollViewport = _t.first);
        } }, inputs: { m_password: ["password", "m_password"], m_passwordInput: ["passwordInput", "m_passwordInput"] }, outputs: { passwordInputChanged: "passwordInputChanged", deleteDatabaseClicked: "deleteDatabaseClicked" }, decls: 47, vars: 25, consts: [[1, "container-fluid", "h-100", "d-flex", "flex-column"], [1, "row"], [1, "col", "ebo-tab-header"], [1, "headerSpan"], ["mat-icon-button", "", 3, "matTooltip", "click"], ["tooltip", "matTooltip"], [1, "col-12", "col-sm-6", "col-md-4", "col-lg-3"], ["appearance", "fill", 1, "w-100"], ["type", "text", "matInput", "", 3, "formControl", "matAutocomplete"], ["multiple", "", 3, "optionSelected"], ["auto", "matAutocomplete"], [3, "value", 4, "ngFor", "ngForOf"], ["matSuffix", "", 4, "ngIf", "ngIfElse"], ["clearSuffix", ""], ["type", "text", "matInput", "", 3, "formControl"], ["clearTextSuffix", ""], [3, "password", "fieldLabel", "value", "valueChanged"], ["mat-icon-button", "", 1, "mx-2", 3, "matTooltip", "click"], ["mat-icon-button", "", 1, "mx-2", 3, "matTooltip", "disabled", "click"], ["class", "flex-fill d-flex flex-column", 4, "ngIf", "ngIfElse"], ["noData", ""], [3, "value"], ["matSuffix", ""], ["tabindex", "-1", "matSuffix", "", 1, "cursor-pointer", 3, "matTooltip", "hidden", "click"], [1, "flex-fill", "d-flex", "flex-column"], [1, "flex-row", "d-flex", "head", "align-items-center", "not-mobile"], [1, "col-1"], [1, "col-md-4"], [1, "col", "flex-fill"], ["itemSize", "26", "minBufferPx", "208", "maxBufferPx", "416", 1, "flex-fill"], [3, "ngClass", "click", 4, "cdkVirtualFor", "cdkVirtualForOf", "cdkVirtualForTemplateCacheSize"], [3, "ngClass", "click"], [1, "flex-row", "align-items-center", "mobile", "d-flex"], [1, "col-md-1", "d-flex"], [1, "mobile-label"], [1, "col-md-4", "d-flex", "flex-column"], [1, "keyPathValue"], [1, "col-md-7", "d-flex", "flex-column", "w-100"], [1, "d-flex", "flex-column", "w-100", 3, "click"], [1, "flex-row"], [1, "flex-row", "d-flex", "align-items-center", "w-100", "valueDiv"], ["class", "material-icons cursor-pointer", 4, "ngIf"], ["class", "json w-100", 4, "ngIf"], [1, "expanded-element"], [1, "d-flex", "ms-3"], [1, "overflow-hidden"], [1, "material-icons", "cursor-pointer"], [1, "json", "w-100"], [1, "d-flex", "justify-content-center"]], template: function DBViewerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h2", 2)(3, "span", 3);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "button", 4, 5);
            i0.ɵɵlistener("click", function DBViewerComponent_Template_button_click_5_listener() { return ctx.deleteDatabase_Click(); });
            i0.ɵɵelementStart(7, "mat-icon");
            i0.ɵɵtext(8, "settings_backup_restore");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(9, "div", 1)(10, "div", 6)(11, "form")(12, "mat-form-field", 7)(13, "mat-label");
            i0.ɵɵtext(14);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(15, "input", 8);
            i0.ɵɵelementStart(16, "mat-autocomplete", 9, 10);
            i0.ɵɵlistener("optionSelected", function DBViewerComponent_Template_mat_autocomplete_optionSelected_16_listener($event) { return ctx.getObjectStoreByName($event.option.value); });
            i0.ɵɵtemplate(18, DBViewerComponent_mat_option_18_Template, 2, 2, "mat-option", 11);
            i0.ɵɵpipe(19, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(20, DBViewerComponent_mat_icon_20_Template, 1, 0, "mat-icon", 12);
            i0.ɵɵtemplate(21, DBViewerComponent_ng_template_21_Template, 2, 3, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "mat-form-field", 7)(24, "mat-label");
            i0.ɵɵtext(25);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(26, "input", 14);
            i0.ɵɵtemplate(27, DBViewerComponent_mat_icon_27_Template, 1, 0, "mat-icon", 12);
            i0.ɵɵtemplate(28, DBViewerComponent_ng_template_28_Template, 2, 3, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(30, "div", 6)(31, "ebootis-password-field-content", 16);
            i0.ɵɵlistener("valueChanged", function DBViewerComponent_Template_ebootis_password_field_content_valueChanged_31_listener($event) { return ctx.onPasswordValue_Change($event); });
            i0.ɵɵelementStart(32, "button", 17, 5);
            i0.ɵɵlistener("click", function DBViewerComponent_Template_button_click_32_listener() { return ctx.clearDatabase_Click(); });
            i0.ɵɵelementStart(34, "mat-icon");
            i0.ɵɵtext(35, "delete");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(36, "button", 18, 5);
            i0.ɵɵlistener("click", function DBViewerComponent_Template_button_click_36_listener() { return ctx.clearObjectStore_Click(); });
            i0.ɵɵelementStart(38, "mat-icon");
            i0.ɵɵtext(39, "do_not_disturb");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(40, "button", 18, 5);
            i0.ɵɵlistener("click", function DBViewerComponent_Template_button_click_40_listener() { return ctx.deleteSelected_Click(); });
            i0.ɵɵelementStart(42, "mat-icon");
            i0.ɵɵtext(43, "close");
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵtemplate(44, DBViewerComponent_div_44_Template, 10, 5, "div", 19);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(45, DBViewerComponent_ng_template_45_Template, 3, 1, "ng-template", null, 20, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(17);
            const _r4 = i0.ɵɵreference(22);
            const _r7 = i0.ɵɵreference(29);
            const _r13 = i0.ɵɵreference(46);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate2("", ctx.m_strings.databaseVersion, ": ", ctx.m_version, "");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("matTooltip", ctx.m_strings.deleteDatabase);
            i0.ɵɵadvance(9);
            i0.ɵɵtextInterpolate(ctx.m_strings.databaseObjectStore);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControl", ctx.m_objectStoreCtrl)("matAutocomplete", _r1);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(19, 23, ctx.m_autocompleteObjectStoreNames));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.m_objectStoreCtrl.value || ctx.m_objectStoreCtrl.value == "")("ngIfElse", _r4);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.m_strings.searchTerm);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControl", ctx.m_searchTextCtrl);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.m_searchTextCtrl.value || ctx.m_searchTextCtrl.value == "")("ngIfElse", _r7);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("password", ctx.m_password)("fieldLabel", ctx.m_strings.password)("value", ctx.m_passwordInput);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("matTooltip", ctx.m_strings.clearEntireDatabase);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("matTooltip", ctx.m_strings.clearObjectStore)("disabled", !ctx.m_objectStoreCtrl.value);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("matTooltip", ctx.m_strings.deleteSelectedObject)("disabled", ctx.m_selectedRowId < 0);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.m_data.length != 0)("ngIfElse", _r13);
        } }, dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, i3.MatIcon, i4.MatTooltip, i2.MatFormField, i2.MatLabel, i2.MatSuffix, i3$1.MatInput, i8.MatOption, i6.ɵNgNoValidate, i6.DefaultValueAccessor, i6.NgControlStatus, i6.NgControlStatusGroup, i6.NgForm, i6.FormControlDirective, i11.CdkFixedSizeVirtualScroll, i11.CdkVirtualForOf, i11.CdkVirtualScrollViewport, i3$2.MatIconButton, i13$2.MatAutocomplete, i13$2.MatAutocompleteTrigger, PasswordFieldContentComponent, i1$1.AsyncPipe, i1$1.JsonPipe], styles: ["pre[_ngcontent-%COMP%]{white-space:pre!important}.expanded-element[_ngcontent-%COMP%]{margin-top:2px!important;margin-left:5px!important;width:100%!important;overflow:auto!important}.form[_ngcontent-%COMP%]{justify-content:space-between;align-items:baseline;display:flex;flex-direction:row;margin-bottom:10px}.json[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.valueDiv[_ngcontent-%COMP%]{margin-left:-8px!important}.keyPathValue[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}@media (max-width: 767px){.form[_ngcontent-%COMP%]{display:flex;flex-direction:column!important;margin-bottom:10px}.mobile[_ngcontent-%COMP%]{display:flex;flex-direction:column!important;align-items:flex-start!important}.not-mobile[_ngcontent-%COMP%]{display:none!important}}.selected[_ngcontent-%COMP%]{background-color:#c8c8c8!important}cdk-virtual-scroll-viewport[_ngcontent-%COMP%]{max-width:100%}cdk-virtual-scroll-viewport[_ngcontent-%COMP%]     div.cdk-virtual-scroll-content-wrapper{max-width:100%!important}.row.head[_ngcontent-%COMP%]{height:56px}.row[_ngcontent-%COMP%]:not(.selected){height:auto}.odd[_ngcontent-%COMP%]{background-color:#eee}h2[_ngcontent-%COMP%] > .headerSpan[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;height:100%}"], data: { animation: [
                trigger('detailExpand', [
                    state('collapsed, void', style({ height: '0px', minHeight: '0', display: 'none' })),
                    state('expanded', style({ height: '*' })),
                    transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                    transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
                ])
            ] } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DBViewerComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-db-viewer', animations: [
                    trigger('detailExpand', [
                        state('collapsed, void', style({ height: '0px', minHeight: '0', display: 'none' })),
                        state('expanded', style({ height: '*' })),
                        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                        transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
                    ])
                ], template: "<div class=\"container-fluid h-100 d-flex flex-column\">\n  <div class=\"row\">\n    <h2 class=\"col ebo-tab-header\">\n      <span class=\"headerSpan\">{{m_strings.databaseVersion}}: {{m_version}}</span>\n      <button mat-icon-button #tooltip=\"matTooltip\" [matTooltip]=\"m_strings.deleteDatabase\"\n              (click)=\"deleteDatabase_Click()\">\n        <mat-icon>settings_backup_restore</mat-icon>\n      </button>\n    </h2>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-12 col-sm-6 col-md-4 col-lg-3\">\n      <form>\n        <mat-form-field appearance=\"fill\" class=\"w-100\">\n          <mat-label>{{m_strings.databaseObjectStore}}</mat-label>\n          <input type=\"text\" matInput [formControl]=\"m_objectStoreCtrl\" [matAutocomplete]=\"auto\">\n          <mat-autocomplete #auto=\"matAutocomplete\"\n                            (optionSelected)=\"getObjectStoreByName($event.option.value)\" multiple>\n            <mat-option *ngFor=\"let name of m_autocompleteObjectStoreNames | async\" [value]=\"name\">\n              {{name}}\n            </mat-option>\n          </mat-autocomplete>\n          <mat-icon matSuffix\n                    *ngIf=\"!m_objectStoreCtrl.value || m_objectStoreCtrl.value==''; else clearSuffix\">\n          </mat-icon>\n          <ng-template #clearSuffix>\n            <mat-icon tabindex=\"-1\" [matTooltip]=\"m_strings.clear\"\n                      [attr.aria-label]=\"m_strings.clear\" matSuffix class=\"cursor-pointer\"\n                      [hidden]=\"!m_objectStoreCtrl.value || m_objectStoreCtrl.value==''\"\n                      (click)=\"clearObjectStoreField_Click()\">close</mat-icon>\n          </ng-template>\n        </mat-form-field>\n\n        <mat-form-field appearance=\"fill\" class=\"w-100\">\n          <mat-label>{{m_strings.searchTerm}}</mat-label>\n          <input type=\"text\" matInput [formControl]=\"m_searchTextCtrl\">\n          <mat-icon matSuffix\n                    *ngIf=\"!m_searchTextCtrl.value || m_searchTextCtrl.value==''; else clearTextSuffix\">\n          </mat-icon>\n          <ng-template #clearTextSuffix>\n            <mat-icon tabindex=\"-1\" [matTooltip]=\"m_strings.clear\"\n                      [attr.aria-label]=\"m_strings.clear\" matSuffix class=\"cursor-pointer\"\n                      [hidden]=\"!m_searchTextCtrl.value || m_searchTextCtrl.value==''\"\n                      (click)=\"clearSearchTextField_Click()\">close</mat-icon>\n          </ng-template>\n        </mat-form-field>\n      </form>\n    </div>\n    <div class=\"col-12 col-sm-6 col-md-4 col-lg-3\"><!-- [ngClass]=\"{'col-md-4 col-lg-3': !passwordCorrect, 'col-md-8 col-lg-9': passwordCorrect}\" -->\n      <ebootis-password-field-content [password]=\"m_password\" [fieldLabel]=\"m_strings.password\" [value]=\"m_passwordInput\"\n                                      (valueChanged)=\"onPasswordValue_Change($event)\">\n        <button mat-icon-button class=\"mx-2\" #tooltip=\"matTooltip\" [matTooltip]=\"m_strings.clearEntireDatabase\"\n                (click)=\"clearDatabase_Click()\">\n          <mat-icon>delete</mat-icon>\n        </button>\n        <button mat-icon-button class=\"mx-2\" #tooltip=\"matTooltip\"\n                [matTooltip]=\"m_strings.clearObjectStore\" [disabled]=\"!m_objectStoreCtrl.value\"\n                (click)=\"clearObjectStore_Click()\">\n          <mat-icon>do_not_disturb</mat-icon>\n        </button>\n        <button mat-icon-button class=\"mx-2\" #tooltip=\"matTooltip\"\n                [matTooltip]=\"m_strings.deleteSelectedObject\" [disabled]=\"m_selectedRowId < 0\"\n                (click)=\"deleteSelected_Click()\">\n          <mat-icon>close</mat-icon>\n        </button>\n      </ebootis-password-field-content>\n    </div>\n  </div>\n  <div class=\"flex-fill d-flex flex-column\" *ngIf=\"m_data.length != 0 ; else noData\">\n    <div class=\"flex-row d-flex head align-items-center not-mobile\">\n      <div class=\"col-1\">#</div>\n      <div class=\"col-md-4\">{{m_strings.databaseKeypath}}:\"{{m_objectStoreKeyPath}}\"</div>\n      <div class=\"col flex-fill\">{{m_strings.value}}</div>\n    </div>\n    <cdk-virtual-scroll-viewport itemSize=\"26\" minBufferPx=\"208\" maxBufferPx=\"416\" class=\"flex-fill\">\n      <div *cdkVirtualFor=\"let item of m_data; let i = index; templateCacheSize:0 \"\n           [ngClass]=\"{ 'selected': i === m_selectedRowId, 'odd':i%2==0}\" (click)=\"m_selectedRowId = i\">\n        <div class=\"flex-row align-items-center mobile d-flex\">\n          <div class=\"col-md-1 d-flex\">\n            <span class=\"mobile-label\">{{m_strings.number}}</span>\n            {{i+1}}\n          </div>\n          <div class=\"col-md-4 d-flex flex-column\">\n            <span\n                  class=\"mobile-label\">{{m_strings.databaseKeypath}}:\"{{m_objectStoreKeyPath}}\"</span>\n            <span class=\"keyPathValue\">{{m_data[i].key}}</span>\n          </div>\n          <div class=\"col-md-7 d-flex flex-column w-100\">\n            <div class=\"d-flex flex-column w-100\"\n                 (click)=\"m_expandedElement = m_expandedElement === item ? null : item\">\n              <div class=\"flex-row\">\n                <span class=\"mobile-label\">{{m_strings.value}}</span>\n              </div>\n              <div class=\"flex-row d-flex align-items-center w-100 valueDiv\">\n                <i class=\"material-icons cursor-pointer\" *ngIf=\"item !== m_expandedElement\">arrow_right</i>\n                <i class=\"material-icons cursor-pointer\" *ngIf=\"item == m_expandedElement\">arrow_drop_down</i>\n                <span class=\"json w-100\" *ngIf=\"item !== m_expandedElement\">{{getShortenedJson(item.value) | json}}</span>\n              </div>\n            </div>\n\n            <div class=\"expanded-element \">\n              <div class=\"d-flex ms-3\" [class.expanded-row]=\"m_expandedElement === item\"\n                   [@detailExpand]=\"item === m_expandedElement ? 'expanded' : 'collapsed'\">\n                <pre class=\"overflow-hidden\">{{getShortenedJson(item.value) | json}}</pre>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </cdk-virtual-scroll-viewport>\n  </div>\n</div>\n<ng-template #noData>\n  <div class=\"d-flex justify-content-center\">\n    <span>{{m_strings.noData}}</span>\n  </div>\n</ng-template>", styles: ["pre{white-space:pre!important}.expanded-element{margin-top:2px!important;margin-left:5px!important;width:100%!important;overflow:auto!important}.form{justify-content:space-between;align-items:baseline;display:flex;flex-direction:row;margin-bottom:10px}.json{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.valueDiv{margin-left:-8px!important}.keyPathValue{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}@media (max-width: 767px){.form{display:flex;flex-direction:column!important;margin-bottom:10px}.mobile{display:flex;flex-direction:column!important;align-items:flex-start!important}.not-mobile{display:none!important}}.selected{background-color:#c8c8c8!important}cdk-virtual-scroll-viewport{max-width:100%}cdk-virtual-scroll-viewport ::ng-deep div.cdk-virtual-scroll-content-wrapper{max-width:100%!important}.row.head{height:56px}.row:not(.selected){height:auto}.odd{background-color:#eee}h2>.headerSpan{display:inline-block;vertical-align:middle;height:100%}\n"] }]
    }], function () { return [{ type: MessageService }, { type: ConfirmationService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DB_VIEWER_DB_SERVICE]
            }] }, { type: DBViewerIntl, decorators: [{
                type: Optional
            }] }]; }, { m_password: [{
            type: Input,
            args: ['password']
        }], m_passwordInput: [{
            type: Input,
            args: ['passwordInput']
        }], passwordInputChanged: [{
            type: Output
        }], deleteDatabaseClicked: [{
            type: Output
        }], m_cdkVirtualScrollViewport: [{
            type: ViewChild,
            args: [CdkVirtualScrollViewport]
        }] }); })();

class FilterByLogLevelPipe {
    transform(p_arrayToFilter, p_logLevels) {
        if (!p_arrayToFilter)
            return null;
        if (!p_logLevels)
            return p_arrayToFilter;
        let res = p_arrayToFilter;
        if (p_logLevels?.length > 0) {
            res = p_arrayToFilter.filter(entry => p_logLevels.includes(entry?.level));
        }
        return res;
    }
    static { this.ɵfac = function FilterByLogLevelPipe_Factory(t) { return new (t || FilterByLogLevelPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "filterByLogLevel", type: FilterByLogLevelPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterByLogLevelPipe, [{
        type: Pipe,
        args: [{
                name: 'filterByLogLevel'
            }]
    }], null, null); })();

class FilterBySearchStringPipe {
    transform(p_arrayToFilter, p_searchString) {
        if (!p_arrayToFilter)
            return null;
        if (!p_searchString)
            return p_arrayToFilter;
        p_searchString = p_searchString.toLowerCase();
        return p_arrayToFilter.filter(function (item) {
            return JSON.stringify(item).toLowerCase().includes(p_searchString);
        });
    }
    static { this.ɵfac = function FilterBySearchStringPipe_Factory(t) { return new (t || FilterBySearchStringPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "filterBySearchString", type: FilterBySearchStringPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterBySearchStringPipe, [{
        type: Pipe,
        args: [{
                name: 'filterBySearchString'
            }]
    }], null, null); })();

const _c0$5 = ["expandable"];
function LogEntryComponent_ng_template_1_mat_icon_0_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 3);
    i0.ɵɵlistener("click", function LogEntryComponent_ng_template_1_mat_icon_0_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.preButton_Click()); });
    i0.ɵɵtext(1, " arrow_drop_down ");
    i0.ɵɵelementEnd();
} }
function LogEntryComponent_ng_template_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 3);
    i0.ɵɵlistener("click", function LogEntryComponent_ng_template_1_ng_template_1_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.preButton_Click()); });
    i0.ɵɵtext(1, "arrow_right");
    i0.ɵɵelementEnd();
} }
function LogEntryComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LogEntryComponent_ng_template_1_mat_icon_0_Template, 2, 0, "mat-icon", 7);
    i0.ɵɵtemplate(1, LogEntryComponent_ng_template_1_ng_template_1_Template, 2, 0, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r8 = i0.ɵɵreference(2);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.isExpanded)("ngIfElse", _r8);
} }
function LogEntryComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "br");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.logEntry.title);
} }
function LogEntryComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.entryContext);
} }
function LogEntryComponent_ng_template_10_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const entryLine_r15 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", entryLine_r15, " ");
} }
function LogEntryComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LogEntryComponent_ng_template_10_div_0_Template, 2, 1, "div", 9);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r3.entryLines);
} }
function LogEntryComponent_div_11_ng_template_2_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c1$1 = function (a0, a1) { return { name: a0, value: a1 }; };
function LogEntryComponent_div_11_ng_template_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, LogEntryComponent_div_11_ng_template_2_div_2_ng_container_1_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const parameter_r25 = ctx.$implicit;
    i0.ɵɵnextContext(3);
    const _r5 = i0.ɵɵreference(13);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c1$1, parameter_r25.name, parameter_r25.value));
} }
function LogEntryComponent_div_11_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, LogEntryComponent_div_11_ng_template_2_div_2_Template, 2, 5, "div", 9);
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r17.m_logsIntl == null ? null : ctx_r17.m_logsIntl.contextParameters);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r17.logEntry.context.parameters);
} }
function LogEntryComponent_div_11_hr_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "hr");
} }
function LogEntryComponent_div_11_pre_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "pre");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("        ", i0.ɵɵpipeBind1(2, 1, ctx_r19.getJson(ctx_r19.logEntry.entry)), "\n      ");
} }
function LogEntryComponent_div_11_hr_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "hr");
} }
function LogEntryComponent_div_11_ng_template_6_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function LogEntryComponent_div_11_ng_template_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, LogEntryComponent_div_11_ng_template_6_div_2_ng_container_1_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const parameter_r28 = ctx.$implicit;
    i0.ɵɵnextContext(3);
    const _r5 = i0.ɵɵreference(13);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c1$1, parameter_r28.title, parameter_r28.entry));
} }
function LogEntryComponent_div_11_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, LogEntryComponent_div_11_ng_template_6_div_2_Template, 2, 5, "div", 9);
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r21.m_logsIntl == null ? null : ctx_r21.m_logsIntl.parameters);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r21.logEntry.parameters);
} }
function LogEntryComponent_div_11_hr_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "hr");
} }
function LogEntryComponent_div_11_ng_template_8_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const entry_r31 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(entry_r31);
} }
function LogEntryComponent_div_11_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, LogEntryComponent_div_11_ng_template_8_div_2_Template, 2, 1, "div", 9);
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r23.m_logsIntl == null ? null : ctx_r23.m_logsIntl.stack);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r23.logEntry.stack);
} }
function LogEntryComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10, 11);
    i0.ɵɵtemplate(2, LogEntryComponent_div_11_ng_template_2_Template, 3, 2, "ng-template", 1);
    i0.ɵɵtemplate(3, LogEntryComponent_div_11_hr_3_Template, 1, 0, "hr", 4);
    i0.ɵɵtemplate(4, LogEntryComponent_div_11_pre_4_Template, 3, 3, "pre", 4);
    i0.ɵɵtemplate(5, LogEntryComponent_div_11_hr_5_Template, 1, 0, "hr", 4);
    i0.ɵɵtemplate(6, LogEntryComponent_div_11_ng_template_6_Template, 3, 2, "ng-template", 1);
    i0.ɵɵtemplate(7, LogEntryComponent_div_11_hr_7_Template, 1, 0, "hr", 4);
    i0.ɵɵtemplate(8, LogEntryComponent_div_11_ng_template_8_Template, 3, 2, "ng-template", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r4.logEntry.context == null ? null : ctx_r4.logEntry.context.parameters == null ? null : ctx_r4.logEntry.context.parameters.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.renderLines[0]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.isEntryObject);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.renderLines[1]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r4.logEntry.parameters == null ? null : ctx_r4.logEntry.parameters.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.renderLines[2]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r4.logEntry.stack == null ? null : ctx_r4.logEntry.stack.length) > 0);
} }
function LogEntryComponent_ng_template_12_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵelementStart(1, "pre");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "json");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext();
    const name_r32 = ctx_r36.name;
    const value_r33 = ctx_r36.value;
    const ctx_r34 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", name_r32, ": ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("      ", i0.ɵɵpipeBind1(3, 2, ctx_r34.getJson(value_r33)), "\n    ");
} }
function LogEntryComponent_ng_template_12_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext();
    const name_r32 = ctx_r37.name;
    const value_r33 = ctx_r37.value;
    i0.ɵɵtextInterpolate2(" ", name_r32, ": ", value_r33, " ");
} }
function LogEntryComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LogEntryComponent_ng_template_12_ng_template_0_Template, 4, 4, "ng-template", 1);
    i0.ɵɵtemplate(1, LogEntryComponent_ng_template_12_ng_template_1_Template, 1, 2, "ng-template", 1);
} if (rf & 2) {
    const value_r33 = ctx.value;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r6.isJson(value_r33));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.isJson(value_r33));
} }
var EntryType;
(function (EntryType) {
    EntryType[EntryType["EMPTY"] = 0] = "EMPTY";
    EntryType[EntryType["OBJECT"] = 1] = "OBJECT";
    EntryType[EntryType["STRING"] = 2] = "STRING";
})(EntryType || (EntryType = {}));
class LogEntryComponent {
    set LogEntry(p_logEntry) {
        this.logEntry = p_logEntry;
        let str = p_logEntry?.entry?.trim() ?? '';
        if (str.length == 0)
            this.entryType = EntryType.EMPTY;
        else if (str.length > 2 && str[0] == '{' && str[str.length - 1] == '}')
            this.entryType = EntryType.OBJECT;
        else
            this.entryType = EntryType.STRING;
        this.hasEntryContext = LogContextHelper.hasValues(this.logEntry.context);
        this.entryContext = LogContextHelper.contextToString(this.logEntry.context);
        // Hilfskonstrukt für die Anzeige der Linien
        let lines = [
            this.logEntry.context?.parameters?.length > 0,
            this.entryType == EntryType.OBJECT,
            this.logEntry.parameters?.length > 0,
            this.logEntry.stack?.length > 0
        ];
        this.renderLines = [
            lines[0] && (lines[1] || lines[2] || lines[3]),
            lines[1] && (lines[2] || lines[3]),
            lines[2] && lines[3]
        ];
        this.isEntryExpandable = lines.some(l => l);
        this.cssClasses = [];
        if (this.logEntry?.level)
            this.cssClasses.push(this.logEntry?.level?.toLowerCase());
        if (!this.isEntryExpandable)
            this.cssClasses.push('ps-4');
    }
    ;
    constructor() { }
    get expandableHtmlDiv() {
        return this.expandableElem.nativeElement;
    }
    get isEntryString() {
        return this.entryType == EntryType.STRING;
    }
    get isEntryObject() {
        return this.entryType == EntryType.OBJECT;
    }
    get entryLines() {
        return this.logEntry?.entry?.split('\n') ?? [];
    }
    preButton_Click() {
        if (this.isEntryExpandable) {
            if (this.isExpanded) {
                this.expandableHtmlDiv.classList.add('collapsed');
                this.expandableHtmlDiv.classList.remove('expanded');
            }
            else {
                this.expandableHtmlDiv.classList.add('expanded');
                this.expandableHtmlDiv.classList.remove('collapsed');
            }
            this.isExpanded = !this.isExpanded;
        }
    }
    isJson(p_obj) {
        if (p_obj === null || p_obj === undefined
            || ['boolean', 'number', 'bigint', 'sysmbol', 'function'].some(x => typeof p_obj == x))
            return false;
        else if (Array.isArray(p_obj))
            return p_obj.length > 1;
        else if (typeof p_obj === 'string') {
            let str = p_obj.trim();
            return str.length > 2 && str[0] == '{' && str[str.length - 1] == '}';
        }
        return true;
    }
    getJson(p_str) {
        if (typeof p_str != 'string')
            return p_str;
        let json;
        try {
            json = JSON.parse(p_str);
        }
        catch (e) {
            return null;
        }
        return json;
    }
    static { this.ɵfac = function LogEntryComponent_Factory(t) { return new (t || LogEntryComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LogEntryComponent, selectors: [["ebootis-log-entry"]], viewQuery: function LogEntryComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$5, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expandableElem = _t.first);
        } }, inputs: { m_logsIntl: ["logsIntl", "m_logsIntl"], LogEntry: ["logEntry", "LogEntry"], index: "index" }, decls: 14, vars: 11, consts: [[1, "log-entry", "d-flex", "flex-fill", 3, "ngClass"], [3, "ngIf"], [1, "d-flex", "flex-fill", "flex-column"], [3, "click"], [4, "ngIf"], ["class", "expandable collapsed ms-4", 4, "ngIf"], ["paramEntry", ""], [3, "click", 4, "ngIf", "ngIfElse"], ["expand", ""], [4, "ngFor", "ngForOf"], [1, "expandable", "collapsed", "ms-4"], ["expandable", ""], [1, "fw-bold"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function LogEntryComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, LogEntryComponent_ng_template_1_Template, 3, 2, "ng-template", 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "div", 3);
            i0.ɵɵlistener("click", function LogEntryComponent_Template_div_click_3_listener() { return ctx.isEntryExpandable ? ctx.preButton_Click() : false; });
            i0.ɵɵelementStart(4, "div")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "date");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, LogEntryComponent_ng_template_8_Template, 3, 1, "ng-template", 1);
            i0.ɵɵtemplate(9, LogEntryComponent_span_9_Template, 2, 1, "span", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(10, LogEntryComponent_ng_template_10_Template, 1, 1, "ng-template", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(11, LogEntryComponent_div_11_Template, 9, 7, "div", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(12, LogEntryComponent_ng_template_12_Template, 2, 2, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.cssClasses);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isEntryExpandable);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate2("(", ctx.index, ") ", i0.ɵɵpipeBind2(7, 8, ctx.logEntry.date, "dd.MM.yyyy - HH:mm"), ":");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.logEntry.title);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.hasEntryContext);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isEntryString);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isEntryExpandable);
        } }, dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, i1$1.NgTemplateOutlet, i3.MatIcon, i1$1.JsonPipe, i1$1.DatePipe], styles: [".log-entry[_ngcontent-%COMP%]{word-break:break-all}.error[_ngcontent-%COMP%]{color:red;background-color:#ffe6e6;border-top:1px solid #f7c6c6}.success[_ngcontent-%COMP%]{color:green}.info[_ngcontent-%COMP%]{color:#2161ff}pre[_ngcontent-%COMP%]{margin:0;white-space:pre-line;overflow:hidden;text-overflow:ellipsis}div.expandable[_ngcontent-%COMP%]{color:#789}div.expandable.expanded[_ngcontent-%COMP%]{display:block;overflow:auto;max-height:-moz-fit-content;max-height:fit-content;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word}div.expandable.collapsed[_ngcontent-%COMP%]{display:none}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogEntryComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-log-entry', template: "<div class=\"log-entry d-flex flex-fill\" [ngClass]=\"cssClasses\">\n  <ng-template [ngIf]=\"isEntryExpandable\">\n    <mat-icon *ngIf=\"isExpanded; else expand\" (click)=\"preButton_Click()\">\n      arrow_drop_down\n    </mat-icon>\n    <ng-template #expand>\n      <mat-icon (click)=\"preButton_Click()\">arrow_right</mat-icon>\n    </ng-template>\n  </ng-template>\n  <div class=\"d-flex flex-fill flex-column\">\n    <div (click)=\"isEntryExpandable ? preButton_Click() : false;\">\n      <div>\n        <span>({{index}}) {{logEntry.date| date: 'dd.MM.yyyy - HH:mm'}}:</span>\n        <ng-template [ngIf]=\"logEntry.title\">\n          <span>{{logEntry.title}}</span>\n          <br/>\n        </ng-template>\n        <span *ngIf=\"hasEntryContext\">{{entryContext}}</span>\n      </div>\n      <ng-template [ngIf]=\"isEntryString\">\n        <div *ngFor=\"let entryLine of entryLines\">\n          {{entryLine}}\n        </div>\n      </ng-template>\n    </div>\n    <div *ngIf=\"isEntryExpandable\" class=\"expandable collapsed ms-4\" #expandable>\n      <!-- Context-Paramter -->\n      <ng-template [ngIf]=\"logEntry.context?.parameters?.length>0\">\n        <div class=\"fw-bold\">{{m_logsIntl?.contextParameters}}</div>\n        <div *ngFor=\"let parameter of logEntry.context.parameters\">\n          <ng-container *ngTemplateOutlet=\"paramEntry; context: {name: parameter.name, value: parameter.value}\">\n          </ng-container>\n        </div>\n      </ng-template>\n      <hr *ngIf=\"renderLines[0]\">\n      <!-- Entry (falls es ein Objekt ist) -->\n      <pre *ngIf=\"isEntryObject\">\n        {{getJson(logEntry.entry) | json}}\n      </pre>\n      <hr *ngIf=\"renderLines[1]\">\n      <!-- Parameter -->\n      <ng-template [ngIf]=\"logEntry.parameters?.length>0\">\n        <div class=\"fw-bold\">{{m_logsIntl?.parameters}}</div>\n        <div *ngFor=\"let parameter of logEntry.parameters\">\n          <ng-container *ngTemplateOutlet=\"paramEntry; context: {name: parameter.title, value: parameter.entry}\">\n          </ng-container>\n        </div>\n      </ng-template>\n      <hr *ngIf=\"renderLines[2]\">\n      <!-- Stacktrace -->\n      <ng-template [ngIf]=\"logEntry.stack?.length>0\">\n        <div class=\"fw-bold\">{{m_logsIntl?.stack}}</div>\n        <div *ngFor=\"let entry of logEntry.stack\">{{entry}}</div>\n      </ng-template>\n    </div>\n  </div>\n</div>\n\n<ng-template #paramEntry let-name=\"name\" let-value=\"value\">\n  <ng-template [ngIf]=\"isJson(value)\">\n    {{name}}:\n    <pre>\n      {{getJson(value) | json}}\n    </pre>\n  </ng-template>\n  <ng-template [ngIf]=\"!isJson(value)\">\n    {{name}}: {{value}}\n  </ng-template>\n</ng-template>", styles: [".log-entry{word-break:break-all}.error{color:red;background-color:#ffe6e6;border-top:1px solid #f7c6c6}.success{color:green}.info{color:#2161ff}pre{margin:0;white-space:pre-line;overflow:hidden;text-overflow:ellipsis}div.expandable{color:#789}div.expandable.expanded{display:block;overflow:auto;max-height:-moz-fit-content;max-height:fit-content;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word}div.expandable.collapsed{display:none}\n"] }]
    }], function () { return []; }, { m_logsIntl: [{
            type: Input,
            args: ['logsIntl']
        }], LogEntry: [{
            type: Input,
            args: ['logEntry']
        }], index: [{
            type: Input,
            args: ['index']
        }], expandableElem: [{
            type: ViewChild,
            args: ['expandable']
        }] }); })();

const _c0$4 = ["logScrollViewer"];
function LogScrollerComponent_div_0_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelement(1, "ebootis-log-entry", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const logEntry_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("logsIntl", ctx_r4.m_logsIntl)("logEntry", logEntry_r5)("index", i_r6 + 1);
} }
function LogScrollerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "button", 4);
    i0.ɵɵlistener("click", function LogScrollerComponent_div_0_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.copyLogsToClipboard()); });
    i0.ɵɵelementStart(3, "mat-icon", 5);
    i0.ɵɵtext(4, "content_copy");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 6)(7, "button", 7);
    i0.ɵɵlistener("click", function LogScrollerComponent_div_0_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.scrollLogs_Click(true)); });
    i0.ɵɵelementStart(8, "mat-icon", 5);
    i0.ɵɵtext(9, "expand_less");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(11, "cdk-virtual-scroll-viewport", 8, 9);
    i0.ɵɵlistener("renderedRangeStream", function LogScrollerComponent_div_0_Template_cdk_virtual_scroll_viewport_renderedRangeStream_11_listener() { i0.ɵɵrestoreView(_r8); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.onScrolled()); });
    i0.ɵɵtemplate(13, LogScrollerComponent_div_0_div_13_Template, 2, 3, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 11)(15, "button", 12);
    i0.ɵɵlistener("click", function LogScrollerComponent_div_0_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r8); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.scrollLogs_Click(false)); });
    i0.ɵɵelementStart(16, "mat-icon", 5);
    i0.ɵɵtext(17, "expand_more");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", ctx_r0.m_logsIntl == null ? null : ctx_r0.m_logsIntl.copyToClipboard);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.m_logsIntl == null ? null : ctx_r0.m_logsIntl.copyToClipboard, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r0.m_disableScrollToTopButton);
    i0.ɵɵattribute("aria-label", ctx_r0.m_logsIntl == null ? null : ctx_r0.m_logsIntl.scrollToTop);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.m_logsIntl == null ? null : ctx_r0.m_logsIntl.scrollToTop, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("maxBufferPx", 1200)("minBufferPx", 1200);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cdkVirtualForOf", ctx_r0.m_logs)("cdkVirtualForTemplateCacheSize", 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r0.m_disableScrollToBottomButton);
    i0.ɵɵattribute("aria-label", ctx_r0.m_logsIntl == null ? null : ctx_r0.m_logsIntl.scrollToBottom);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.m_logsIntl == null ? null : ctx_r0.m_logsIntl.scrollToBottom, " ");
} }
function LogScrollerComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ui-placeholder", 15);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerText", ctx_r2.m_logsIntl == null ? null : ctx_r2.m_logsIntl.noLogsForSelectedCriteria);
} }
class LogScrollerComponent {
    set logs(p_logs) {
        this.m_logs = p_logs;
        this.m_disableScrollToTopButton = this.disableScrollButton(true);
        this.m_disableScrollToBottomButton = this.disableScrollButton(false);
        this.m_changeDetectorRef.detectChanges();
    }
    ;
    constructor(m_clipboard, m_changeDetectorRef) {
        this.m_clipboard = m_clipboard;
        this.m_changeDetectorRef = m_changeDetectorRef;
        this.m_disableScrollToTopButton = false;
        this.m_disableScrollToBottomButton = false;
    }
    ngOnInit() {
    }
    copyLogsToClipboard() {
        this.copyToClipboard(JSON.stringify(this.m_logs));
    }
    copyToClipboard(p_value) {
        const pending = this.m_clipboard.beginCopy(p_value);
        let remainingAttempts = 3;
        const attempt = () => {
            const result = pending.copy();
            if (!result && --remainingAttempts) {
                setTimeout(attempt);
            }
            else {
                pending.destroy();
            }
        };
        attempt();
    }
    scrollLogs_Click(p_scrollToTop) {
        let scrollIndex = p_scrollToTop ? 0 : this.m_logs?.length;
        this.m_logVirtualScroller.scrollToIndex(scrollIndex);
    }
    disableScrollButton(p_isScrollToTopButton) {
        let disable = this.m_logs?.length > 0 ? false : true;
        if (this.m_logVirtualScroller) {
            if (p_isScrollToTopButton) {
                disable = this.m_logVirtualScroller.measureScrollOffset('top') == 0;
            }
            else {
                disable = this.m_logVirtualScroller.measureScrollOffset('bottom') == 0;
            }
        }
        return disable;
    }
    onScrolled() {
        this.m_changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = function LogScrollerComponent_Factory(t) { return new (t || LogScrollerComponent)(i0.ɵɵdirectiveInject(i1$4.Clipboard), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LogScrollerComponent, selectors: [["ebootis-log-scroller"]], viewQuery: function LogScrollerComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$4, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.m_logVirtualScroller = _t.first);
        } }, inputs: { logs: "logs", m_logsIntl: ["logsIntl", "m_logsIntl"] }, decls: 3, vars: 2, consts: [["class", "d-flex flex-fill flex-column", 4, "ngIf", "ngIfElse"], ["placeholder", ""], [1, "d-flex", "flex-fill", "flex-column"], [1, "d-flex", "justify-content-between", "flex-wrap"], ["mat-button", "", "type", "button", 1, "mb-1", 3, "click"], [1, "pe-1"], [1, "d-flex", "flex-fill", "justify-content-end"], ["mat-button", "", "type", "button", 1, "me-3", 3, "disabled", "click"], ["itemSize", "35", 1, "flex-fill", 3, "maxBufferPx", "minBufferPx", "renderedRangeStream"], ["logScrollViewer", ""], ["class", "mb-1", 4, "cdkVirtualFor", "cdkVirtualForOf", "cdkVirtualForTemplateCacheSize"], [1, "d-flex", "justify-content-end"], ["mat-button", "", "type", "button", 3, "disabled", "click"], [1, "mb-1"], [3, "logsIntl", "logEntry", "index"], [3, "innerText"]], template: function LogScrollerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, LogScrollerComponent_div_0_Template, 19, 12, "div", 0);
            i0.ɵɵtemplate(1, LogScrollerComponent_ng_template_1_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", (ctx.m_logs == null ? null : ctx.m_logs.length) > 0)("ngIfElse", _r1);
        } }, dependencies: [i1$1.NgIf, i8$2.PlaceholderComponent, i3.MatIcon, i11.CdkFixedSizeVirtualScroll, i11.CdkVirtualForOf, i11.CdkVirtualScrollViewport, i3$2.MatButton, LogEntryComponent], styles: ["cdk-virtual-scroll-viewport[_ngcontent-%COMP%]{font-size:14px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogScrollerComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-log-scroller', template: "<div *ngIf=\"m_logs?.length>0; else placeholder\" class=\"d-flex flex-fill flex-column\">\n  <div class=\"d-flex justify-content-between flex-wrap\">\n    <button mat-button type=\"button\" (click)=\"copyLogsToClipboard()\"\n            [attr.aria-label]=\"m_logsIntl?.copyToClipboard\" class=\"mb-1\">\n      <mat-icon class=\"pe-1\">content_copy</mat-icon> {{m_logsIntl?.copyToClipboard}}\n    </button>\n    <div class=\"d-flex flex-fill justify-content-end\">\n      <button mat-button type=\"button\" (click)=\"scrollLogs_Click(true)\" [disabled]=\"m_disableScrollToTopButton\"\n              class=\"me-3\" [attr.aria-label]=\"m_logsIntl?.scrollToTop\">\n        <mat-icon class=\"pe-1\">expand_less</mat-icon>\n        {{m_logsIntl?.scrollToTop}}\n      </button>\n    </div>\n  </div>\n  <!--03.2022 Todo: einbauen, sobald verf\u00FCgbar: An autosize strategy that works on elements of differing sizes(!) \n    is currently being developed in @angular/cdk-experimental, but it is not ready for production use yet.-->\n  <cdk-virtual-scroll-viewport class=\"flex-fill\" itemSize=\"35\" #logScrollViewer [maxBufferPx]=\"1200\"\n                               [minBufferPx]=\"1200\" (renderedRangeStream)=\"onScrolled()\">\n    <div *cdkVirtualFor=\"let logEntry of m_logs; let i = index; templateCacheSize:0\" class=\"mb-1\">\n      <ebootis-log-entry [logsIntl]=\"m_logsIntl\" [logEntry]=\"logEntry\" [index]=\"i+1\">\n      </ebootis-log-entry>\n    </div>\n  </cdk-virtual-scroll-viewport>\n  <div class=\"d-flex justify-content-end\">\n    <button mat-button type=\"button\" (click)=\"scrollLogs_Click(false)\" [disabled]=\"m_disableScrollToBottomButton\"\n            [attr.aria-label]=\"m_logsIntl?.scrollToBottom\">\n      <mat-icon class=\"pe-1\">expand_more</mat-icon>\n      {{m_logsIntl?.scrollToBottom}}\n    </button>\n  </div>\n</div>\n\n<ng-template #placeholder>\n  <ui-placeholder [innerText]=\"m_logsIntl?.noLogsForSelectedCriteria\"></ui-placeholder>\n</ng-template>", styles: ["cdk-virtual-scroll-viewport{font-size:14px}\n"] }]
    }], function () { return [{ type: i1$4.Clipboard }, { type: i0.ChangeDetectorRef }]; }, { logs: [{
            type: Input,
            args: ['logs']
        }], m_logsIntl: [{
            type: Input,
            args: ['logsIntl']
        }], m_logVirtualScroller: [{
            type: ViewChild,
            args: ['logScrollViewer']
        }] }); })();

const LOGGER_CATEGORY_PROVIDER = new InjectionToken('LOGGER_CATEGORY_PROVIDER');

class LoggerCategoryService {
    constructor(categoryProvider) {
        this.categoryProvider = categoryProvider;
        if (categoryProvider)
            this.categoryArray = categoryProvider.getLogCategories() ?? [];
        else
            this.categoryArray = [];
    }
    getLogCategories() {
        return this.categoryArray;
    }
    getSortedLogCategories() {
        return this.categoryArray.sort((a, b) => {
            const at = a.translation.toLowerCase();
            const bt = b.translation.toLowerCase();
            if (at < bt)
                return -1;
            else if (at > bt)
                return 1;
            else
                return 0;
        });
    }
    getCategoryByName(p_categoryName) {
        return this.categoryArray.find(cat => cat.name == p_categoryName);
    }
    static { this.ɵfac = function LoggerCategoryService_Factory(t) { return new (t || LoggerCategoryService)(i0.ɵɵinject(LOGGER_CATEGORY_PROVIDER, 8)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoggerCategoryService, factory: LoggerCategoryService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoggerCategoryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [LOGGER_CATEGORY_PROVIDER]
            }] }]; }, null); })();

function LogSettingsComponent_mat_option_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const logLevel_r10 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", logLevel_r10);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.m_logsIntl.getLogLevelTranslation(logLevel_r10), " ");
} }
function LogSettingsComponent_ng_container_36_mat_option_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const logCategory_r12 = ctx.$implicit;
    i0.ɵɵproperty("value", logCategory_r12);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", logCategory_r12.translation, " ");
} }
function LogSettingsComponent_ng_container_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9)(2, "mat-form-field", 10)(3, "mat-label");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-select", 31);
    i0.ɵɵelement(6, "mat-option");
    i0.ɵɵtemplate(7, LogSettingsComponent_ng_container_36_mat_option_7_Template, 2, 2, "mat-option", 12);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r2.m_logsIntl.logCategoryFilter);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControl", ctx_r2.getContextControl(ctx_r2.CONTEXT_CATEGORY))("compareWith", ctx_r2.compareCategories);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.m_logCategories);
} }
function LogSettingsComponent_mat_option_59_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const logLevel_r13 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", logLevel_r13);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.m_logsIntl.getLogLevelTranslation(logLevel_r13), " ");
} }
function LogSettingsComponent_button_61_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 32);
    i0.ɵɵlistener("click", function LogSettingsComponent_button_61_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.addContext_Click()); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "save");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r4.isContextFormValid);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.m_logsIntl.settingsSaveContext, " ");
} }
function LogSettingsComponent_ng_template_62_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 32);
    i0.ɵɵlistener("click", function LogSettingsComponent_ng_template_62_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.addContext_Click()); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "add");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r6.isContextFormValid);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.m_logsIntl.settingsAddContext, " ");
} }
function LogSettingsComponent_mat_list_64_ng_container_1_ng_container_1_mat_list_item_3_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-list-item")(1, "div", 35)(2, "div", 36);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 37);
    i0.ɵɵlistener("click", function LogSettingsComponent_mat_list_64_ng_container_1_ng_container_1_mat_list_item_3_Template_button_click_4_listener() { const restoredCtx = i0.ɵɵrestoreView(_r28); const entryIndex_r25 = restoredCtx.index; const subListIdx_r20 = i0.ɵɵnextContext(2).index; const ctx_r26 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r26.editContext_Click(subListIdx_r20, entryIndex_r25)); });
    i0.ɵɵelementStart(5, "mat-icon");
    i0.ɵɵtext(6, "edit");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "button", 38);
    i0.ɵɵlistener("click", function LogSettingsComponent_mat_list_64_ng_container_1_ng_container_1_mat_list_item_3_Template_button_click_7_listener() { const restoredCtx = i0.ɵɵrestoreView(_r28); const entryIndex_r25 = restoredCtx.index; const subListIdx_r20 = i0.ɵɵnextContext(2).index; const ctx_r29 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r29.deleteContext_Click(subListIdx_r20, entryIndex_r25)); });
    i0.ɵɵelementStart(8, "mat-icon");
    i0.ɵɵtext(9, "delete");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r24 = ctx.$implicit;
    const ctx_r22 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r22.getLogContextString(ctx_r24), " ");
} }
function LogSettingsComponent_mat_list_64_ng_container_1_ng_container_1_mat_divider_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-divider");
} }
function LogSettingsComponent_mat_list_64_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 34);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, LogSettingsComponent_mat_list_64_ng_container_1_ng_container_1_mat_list_item_3_Template, 10, 1, "mat-list-item", 26);
    i0.ɵɵtemplate(4, LogSettingsComponent_mat_list_64_ng_container_1_ng_container_1_mat_divider_4_Template, 1, 0, "mat-divider", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext();
    const subList_r19 = ctx_r31.$implicit;
    const subListIdx_r20 = ctx_r31.index;
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(subList_r19.subheader);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", subList_r19.logContextFiltersForDisplay);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.needToInsertSeparator(subListIdx_r20));
} }
function LogSettingsComponent_mat_list_64_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LogSettingsComponent_mat_list_64_ng_container_1_ng_container_1_Template, 5, 3, "ng-container", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const subListIdx_r20 = ctx.index;
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.hasFilterEntriesToDisplay(subListIdx_r20));
} }
function LogSettingsComponent_mat_list_64_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-list", 33);
    i0.ɵɵtemplate(1, LogSettingsComponent_mat_list_64_ng_container_1_Template, 2, 1, "ng-container", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r7.m_logContextFilterDisplayList);
} }
function LogSettingsComponent_div_69_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const expl_r32 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", expl_r32, " ");
} }
function LogSettingsComponent_div_73_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const expl_r33 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", expl_r33, " ");
} }
const _c0$3 = function (a0, a1) { return { "col-12 col-sm-6": a0, "col-12": a1 }; };
class LogSettingsComponent {
    constructor(m_dialogRef, m_loggerService, m_changeDetectorRef, m_fb, m_data, m_loggerCategoryService) {
        this.m_dialogRef = m_dialogRef;
        this.m_loggerService = m_loggerService;
        this.m_changeDetectorRef = m_changeDetectorRef;
        this.m_fb = m_fb;
        this.m_data = m_data;
        this.m_loggerCategoryService = m_loggerCategoryService;
        this.m_logLevels = LOG_LEVEL_ARRAY;
        this.m_isSaving = false;
        this.m_subscriptionsSubject = new Subject();
        this.SETTINGS_LOG_LEVEL = "activeLogLevels";
        this.SETTINGS_SHOULD_LOG = "shouldLog";
        this.SETTINGS_LOG_UNTIL = "logUntil";
        this.CONTEXT_LOG_LEVELS = "logLevels";
        this.CONTEXT_FILE = "fileName";
        this.CONTEXT_CLASS = "className";
        this.CONTEXT_FUNCTION = "functionName";
        this.CONTEXT_CATEGORY = "category";
        this.DISPLAY_CAT_INDEX = 0;
        this.DISPLAY_FILE_INDEX = 1;
        this.DISPLAY_CLASS_INDEX = 2;
        this.DISPLAY_FUNC_INDEX = 3;
        this.m_logsIntl = this.m_data.intl;
        this.minLogDate = new Date();
        // 6 Monate später
        this.maxLogDate = DateUtility.addMonth(this.minLogDate, 6);
        this.m_logContextFilters = [];
        this.m_contextEditIndicies = null;
        this.m_logContextFilterDisplayList = [];
        this.m_logContextFilterDisplayList[this.DISPLAY_CAT_INDEX] = { subheader: this.m_logsIntl.contextSubHeaderCategory, logContextFiltersForDisplay: [] };
        this.m_logContextFilterDisplayList[this.DISPLAY_FILE_INDEX] = { subheader: this.m_logsIntl.contextSubHeaderFile, logContextFiltersForDisplay: [] };
        this.m_logContextFilterDisplayList[this.DISPLAY_CLASS_INDEX] = { subheader: this.m_logsIntl.contextSubHeaderClass, logContextFiltersForDisplay: [] };
        this.m_logContextFilterDisplayList[this.DISPLAY_FUNC_INDEX] = { subheader: this.m_logsIntl.contextSubHeaderFunction, logContextFiltersForDisplay: [] };
    }
    ngOnInit() {
        this.m_logSettingsGroup = this.m_fb.group({
            [this.SETTINGS_LOG_LEVEL]: [null],
            [this.SETTINGS_SHOULD_LOG]: [null],
            [this.SETTINGS_LOG_UNTIL]: [null],
        });
        this.m_logContextGroup = this.m_fb.group({
            [this.CONTEXT_LOG_LEVELS]: [null],
            [this.CONTEXT_FILE]: [null],
            [this.CONTEXT_CLASS]: [null],
            [this.CONTEXT_FUNCTION]: [null],
            [this.CONTEXT_CATEGORY]: [null]
        });
        this.m_logCategories = this.m_loggerCategoryService.getSortedLogCategories();
        this.m_loggerService.logSettings$
            .pipe(filter(settings => !!settings))
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe({
            next: (logSettings) => {
                this.m_logContextFilters = logSettings.activeLogContexts.map(alc => {
                    const lcFilter = {
                        category: alc.category,
                        fileName: alc.fileName,
                        className: alc.className,
                        functionName: alc.functionName,
                        logLevels: [...alc.logLevels],
                    };
                    return lcFilter;
                });
                this.fillDisplayList();
                this.m_displayedLogLevels = [...logSettings.displayedLogLevels];
                this.m_logSettingsGroup.patchValue(logSettings);
                this.m_logContextGroup.patchValue({ [this.CONTEXT_LOG_LEVELS]: [...this.m_logSettingsGroup.get(this.SETTINGS_LOG_LEVEL).value] });
                this.m_changeDetectorRef.detectChanges();
            },
            error: (err) => {
                this.m_loggerService.logError({ title: 'getUserSettings failed', entry: err, context: this.getLogContextBuilder('ngOnInit').get() });
            }
        });
    }
    ngOnDestroy() {
        this.m_subscriptionsSubject.next();
        this.m_subscriptionsSubject.complete();
    }
    get isCtxEdit() {
        //return this.m_contextEditIndex >= 0;
        return !!this.m_contextEditIndicies;
    }
    get isContextFormValid() {
        const formValue = this.m_logContextGroup.value;
        return formValue[this.CONTEXT_CATEGORY] || formValue[this.CONTEXT_FILE]
            || formValue[this.CONTEXT_CLASS] || formValue[this.CONTEXT_FUNCTION];
    }
    get generalExplanations() {
        return this.m_logsIntl.generalExplanation.split('\n');
    }
    get contextExplanations() {
        return this.m_logsIntl.contextExplanation.split('\n');
    }
    getLogContextString(p_ctxDisplayEntry) {
        return LogContextHelper.contextToString(p_ctxDisplayEntry.logContextFilter);
    }
    /* public getLogContextString(p_ctx: LogContextFilter): string {
      return LogContextHelper.contextToString(p_ctx);
    } */
    getGeneralControl(p_name) {
        return this.m_logSettingsGroup.get(p_name);
    }
    getContextControl(p_name) {
        return this.m_logContextGroup?.get(p_name);
    }
    compareCategories(p_cat1, p_cat2) {
        if (p_cat1 && p_cat2)
            return p_cat1.name === p_cat2.name;
        else
            return p_cat1 == p_cat2;
    }
    hasFilterEntriesToDisplay(p_index) {
        if (p_index === undefined || p_index === null || p_index < 0 || p_index >= this.m_logContextFilterDisplayList.length) {
            return this.m_logContextFilterDisplayList.some((subList) => {
                return subList.logContextFiltersForDisplay.length > 0;
            });
        }
        else {
            return this.m_logContextFilterDisplayList[p_index].logContextFiltersForDisplay.length > 0;
        }
    }
    needToInsertSeparator(p_subListIndex) {
        // Eine Trennlinie muss nur eingefügt werden, wenn es nachfolgend Unterlisten mit Einträgen gibt.
        return this.m_logContextFilterDisplayList.some((subList, idx) => {
            if (idx <= p_subListIndex)
                return false;
            else
                return subList.logContextFiltersForDisplay.length > 0;
        });
    }
    fillDisplayList() {
        this.m_logContextFilters.forEach((lcFilter, idx) => {
            this.addLogContextFilterToDisplayList({ listIndex: idx, logContextFilter: lcFilter });
        });
        /* this.m_logContextFilterDisplayList.forEach(elem => {
          elem.logContextFiltersForDisplay.sort((a,b) => {
            return LogContextHelper.compareContextFilter(a.logContextFilter, b.logContextFilter);
          });
        }); */
    }
    addLogContextFilterToDisplayList(p_logContextFilterEntry) {
        if (p_logContextFilterEntry.listIndex < 0 || !p_logContextFilterEntry.logContextFilter)
            return;
        let logCtxFilterList;
        if (p_logContextFilterEntry.logContextFilter.functionName)
            logCtxFilterList = this.m_logContextFilterDisplayList[this.DISPLAY_FUNC_INDEX];
        // this.m_logContextFilterDisplayList[this.DISPLAY_FUNC_INDEX].logContextFiltersForDisplay.push(p_logContextFilterEntry); 
        else if (p_logContextFilterEntry.logContextFilter.className)
            logCtxFilterList = this.m_logContextFilterDisplayList[this.DISPLAY_CLASS_INDEX];
        // this.m_logContextFilterDisplayList[this.DISPLAY_CLASS_INDEX].logContextFiltersForDisplay.push(p_logContextFilterEntry); 
        else if (p_logContextFilterEntry.logContextFilter.fileName)
            logCtxFilterList = this.m_logContextFilterDisplayList[this.DISPLAY_FILE_INDEX];
        // this.m_logContextFilterDisplayList[this.DISPLAY_FILE_INDEX].logContextFiltersForDisplay.push(p_logContextFilterEntry); 
        else if (p_logContextFilterEntry.logContextFilter.category)
            logCtxFilterList = this.m_logContextFilterDisplayList[this.DISPLAY_CAT_INDEX];
        // this.m_logContextFilterDisplayList[this.DISPLAY_CAT_INDEX].logContextFiltersForDisplay.push(p_logContextFilterEntry);
        const sortIndex = logCtxFilterList.logContextFiltersForDisplay.findIndex((entry) => {
            return LogContextHelper.compareContextFilter(entry.logContextFilter, p_logContextFilterEntry.logContextFilter) > 0;
        });
        if (sortIndex < 0)
            logCtxFilterList.logContextFiltersForDisplay.push(p_logContextFilterEntry);
        else
            logCtxFilterList.logContextFiltersForDisplay.splice(sortIndex, 0, p_logContextFilterEntry);
    }
    /* #region: Event-Handler */
    logUntil_Input(p_event) {
        this.m_logSettingsGroup.get(this.SETTINGS_SHOULD_LOG).setValue(true);
    }
    shouldLog_Change(p_event) {
        if (p_event.checked == false)
            this.m_logSettingsGroup.get(this.SETTINGS_LOG_UNTIL).setValue(null);
    }
    saveSettings_Click() {
        this.m_isSaving = true;
        let newLogSettings = {
            ...this.m_logSettingsGroup.value,
            id: 'LogSettings',
            activeLogContexts: [...this.m_logContextFilters],
        };
        // DateInput ist ein Moment und kein Date...daher die Prüfung auf _d
        const untilDateCtrlValue = this.getGeneralControl(this.SETTINGS_LOG_UNTIL).value;
        if (untilDateCtrlValue && '_d' in untilDateCtrlValue) {
            newLogSettings.logUntil = untilDateCtrlValue._d;
        }
        const allUsedLogLevels = LogSettingsHelper.getComulativeActiveLogLevels(newLogSettings);
        newLogSettings.displayedLogLevels = this.m_displayedLogLevels.filter(ll => allUsedLogLevels.has(ll));
        this.m_loggerService.saveLogSettings(newLogSettings)
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe({
            next: () => {
                this.m_isSaving = false;
                this.m_dialogRef.close();
            },
            error: (err) => {
                this.m_isSaving = false;
                this.m_loggerService.logError({ title: 'saveUserSettings failed', entry: err, context: this.getLogContextBuilder('saveSettings_Click').get() });
            }
        });
    }
    addContext_Click() {
        /* if (this.m_contextEditIndex == -1)
          this.m_logContextFilters.push(this.getLogContextFilter());
        else {
          this.m_logContextFilters.splice(this.m_contextEditIndex, 1, this.getLogContextFilter());
          this.m_contextEditIndex = -1;
        } */
        const logContextFilter = this.getLogContextFilter();
        if (!this.m_contextEditIndicies) {
            const newIndex = this.m_logContextFilters.push(logContextFilter) - 1;
            this.addLogContextFilterToDisplayList({ listIndex: newIndex, logContextFilter: logContextFilter });
        }
        else {
            const ctxEditIndex = this.m_logContextFilterDisplayList[this.m_contextEditIndicies.subListIndex]
                .logContextFiltersForDisplay[this.m_contextEditIndicies.entryIndex].listIndex;
            // Eintrag in der Liste der Kontext-Filter ersetzen
            this.m_logContextFilters.splice(ctxEditIndex, 1, logContextFilter);
            // Eintrag aus der angezeigten Liste entfernen
            this.m_logContextFilterDisplayList[this.m_contextEditIndicies.subListIndex]
                .logContextFiltersForDisplay.splice(this.m_contextEditIndicies.entryIndex, 1);
            // Neuen Eintrag in der angezeigten Liste einfügen
            this.addLogContextFilterToDisplayList({ listIndex: ctxEditIndex, logContextFilter: logContextFilter });
            this.m_contextEditIndicies = null;
        }
        this.resetLogContextForm();
    }
    editContext_Click(p_subListIndex, p_entryIndex) {
        if (p_subListIndex < 0 || p_subListIndex >= this.m_logContextFilterDisplayList.length
            || p_entryIndex < 0 || p_entryIndex >= this.m_logContextFilterDisplayList[p_subListIndex].logContextFiltersForDisplay.length) {
            this.m_contextEditIndicies = null;
            return;
        }
        this.m_contextEditIndicies = { subListIndex: p_subListIndex, entryIndex: p_entryIndex };
        const ctx = { logLevels: [], ...this.m_logContextFilterDisplayList[p_subListIndex].logContextFiltersForDisplay[p_entryIndex].logContextFilter };
        this.m_logContextGroup.patchValue(ctx);
    }
    deleteContext_Click(p_subListIndex, p_entryIndex) {
        if (p_subListIndex >= 0 || p_subListIndex < this.m_logContextFilterDisplayList.length
            || p_entryIndex >= 0 || p_entryIndex < this.m_logContextFilterDisplayList[p_subListIndex].logContextFiltersForDisplay.length) {
            const ctxListIndex = this.m_logContextFilterDisplayList[p_subListIndex]
                .logContextFiltersForDisplay[p_entryIndex].listIndex;
            this.m_logContextFilters.splice(ctxListIndex, 1);
            this.m_logContextFilterDisplayList[p_subListIndex]
                .logContextFiltersForDisplay.splice(p_entryIndex, 1);
            if (this.m_contextEditIndicies && this.m_contextEditIndicies.subListIndex === p_subListIndex) {
                // Falls der gelöschte Eintrag gerade editiert wird, den Edit-Index löschen und die Form resetten
                if (this.m_contextEditIndicies.entryIndex == p_entryIndex) {
                    this.m_contextEditIndicies = null;
                    this.resetLogContextForm();
                }
                else if (this.m_contextEditIndicies.entryIndex > p_entryIndex) {
                    this.m_contextEditIndicies.entryIndex--;
                }
            }
        }
    }
    /* public editContext_Click(p_idx: number): void {
      this.m_contextEditIndex = p_idx;
      if (p_idx >= 0) {
        // logLevels: [] als default, damit das Control geleert wird, wenn nicht definiert
        const ctx: LogContextFilter = { logLevels: [], ...this.m_logContextFilters[p_idx] }
        this.m_logContextGroup.patchValue(ctx);
      }
    }
  
    public deleteContext_Click(p_idx: number): void {
      if (p_idx >= 0) {
        this.m_logContextFilters.splice(p_idx, 1);
        if (p_idx == this.m_contextEditIndex) {
          this.m_contextEditIndex = -1;
          this.resetLogContextForm();
        }
        else if (p_idx < this.m_contextEditIndex)
          this.m_contextEditIndex--;
      }
    } */
    /* #endregion: Event-Handler */
    /* #region: private methods */
    resetLogContextForm() {
        this.m_logContextGroup.reset();
        this.m_logContextGroup.patchValue({ [this.CONTEXT_LOG_LEVELS]: [...this.m_logSettingsGroup.get(this.SETTINGS_LOG_LEVEL).value] });
    }
    getLogContextFilter() {
        let filter = { ...this.m_logContextGroup.value };
        return filter;
    }
    getLogContextBuilder(p_functionName) {
        return LogContextBuilder.getInstance('log-settings.component.ts', 'LogSettingsComponent', p_functionName);
    }
    static { this.ɵfac = function LogSettingsComponent_Factory(t) { return new (t || LogSettingsComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(LoggerService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i6.FormBuilder), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(LoggerCategoryService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LogSettingsComponent, selectors: [["ebootis-log-settings"]], decls: 79, vars: 42, consts: [["mat-dialog-title", "", 1, "ebo-dialog-header"], [1, "ebo-dialog-title"], ["mat-icon-button", "", "type", "button", "mat-dialog-close", "", 3, "aria-label", "matTooltip"], [1, "flex-fill"], [1, "h-100", "ebo-tab-header-margin"], [3, "label"], [1, "container-fluid"], [1, "row"], [1, "col-12"], [1, "col-12", "col-sm-6"], ["appearance", "fill"], ["multiple", "", 3, "formControl"], [3, "value", 4, "ngFor", "ngForOf"], ["matInput", "", "disabled", "", 3, "matDatepicker", "min", "max", "formControl", "dateInput"], ["matSuffix", "", 3, "for"], ["disabled", "false"], ["logUntilPicker", ""], [1, "col-12", "col-sm-6", "offset-sm-6"], ["color", "primary", 3, "formControl", "change"], [4, "ngIf"], [3, "ngClass"], ["matInput", "", 3, "formControl"], ["mat-button", "", "type", "button", "class", "float-end formfield-height", 3, "disabled", "click", 4, "ngIf", "ngIfElse"], ["addButton", ""], ["class", "log-context-list", 4, "ngIf"], [1, "pb-2"], [4, "ngFor", "ngForOf"], [1, "ebo-dialog-actions"], ["type", "button", "mat-button", "", "mat-dialog-close", ""], ["mat-raised-button", "", "color", "primary", "cdkFocusInitial", "", 3, "disabled", "click"], [3, "value"], [3, "formControl", "compareWith"], ["mat-button", "", "type", "button", 1, "float-end", "formfield-height", 3, "disabled", "click"], [1, "log-context-list"], ["mat-subheader", ""], [1, "d-flex"], [1, "flex-fill", "d-flex", "align-items-center"], ["mat-icon-button", "", 1, "ebo-sm-icon-button", 3, "click"], ["mat-icon-button", "", "color", "warn", 1, "ebo-sm-icon-button", "ms-3", 3, "click"]], template: function LogSettingsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0)(1, "span", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "button", 2)(4, "mat-icon");
            i0.ɵɵtext(5, "close");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(6, "mat-dialog-content", 3)(7, "mat-tab-group", 4)(8, "mat-tab", 5)(9, "div", 6)(10, "div", 7)(11, "div", 8);
            i0.ɵɵtext(12);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "div", 7)(14, "div", 9)(15, "mat-form-field", 10)(16, "mat-label");
            i0.ɵɵtext(17);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "mat-select", 11);
            i0.ɵɵtemplate(19, LogSettingsComponent_mat_option_19_Template, 2, 2, "mat-option", 12);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(20, "div", 9)(21, "mat-form-field", 10)(22, "mat-label");
            i0.ɵɵtext(23);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(24, "input", 13);
            i0.ɵɵlistener("dateInput", function LogSettingsComponent_Template_input_dateInput_24_listener($event) { return ctx.logUntil_Input($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(25, "mat-datepicker-toggle", 14)(26, "mat-datepicker", 15, 16);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(28, "div", 7)(29, "div", 17)(30, "mat-checkbox", 18);
            i0.ɵɵlistener("change", function LogSettingsComponent_Template_mat_checkbox_change_30_listener($event) { return ctx.shouldLog_Change($event); });
            i0.ɵɵtext(31);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(32, "div", 7)(33, "div", 8);
            i0.ɵɵtext(34);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(35, "div", 7);
            i0.ɵɵtemplate(36, LogSettingsComponent_ng_container_36_Template, 8, 4, "ng-container", 19);
            i0.ɵɵelementStart(37, "div", 20)(38, "mat-form-field", 10)(39, "mat-label");
            i0.ɵɵtext(40);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(41, "input", 21);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(42, "div", 7)(43, "div", 9)(44, "mat-form-field", 10)(45, "mat-label");
            i0.ɵɵtext(46);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(47, "input", 21);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(48, "div", 9)(49, "mat-form-field", 10)(50, "mat-label");
            i0.ɵɵtext(51);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(52, "input", 21);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(53, "div", 7)(54, "div", 9)(55, "mat-form-field", 10)(56, "mat-label");
            i0.ɵɵtext(57);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(58, "mat-select", 11);
            i0.ɵɵtemplate(59, LogSettingsComponent_mat_option_59_Template, 2, 2, "mat-option", 12);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(60, "div", 9);
            i0.ɵɵtemplate(61, LogSettingsComponent_button_61_Template, 4, 2, "button", 22);
            i0.ɵɵtemplate(62, LogSettingsComponent_ng_template_62_Template, 4, 2, "ng-template", null, 23, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(64, LogSettingsComponent_mat_list_64_Template, 2, 1, "mat-list", 24);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(65, "mat-tab", 5)(66, "h3");
            i0.ɵɵtext(67);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(68, "div", 25);
            i0.ɵɵtemplate(69, LogSettingsComponent_div_69_Template, 2, 1, "div", 26);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(70, "h3");
            i0.ɵɵtext(71);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(72, "div", 25);
            i0.ɵɵtemplate(73, LogSettingsComponent_div_73_Template, 2, 1, "div", 26);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(74, "mat-dialog-actions", 27)(75, "button", 28);
            i0.ɵɵtext(76);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(77, "button", 29);
            i0.ɵɵlistener("click", function LogSettingsComponent_Template_button_click_77_listener() { return ctx.saveSettings_Click(); });
            i0.ɵɵtext(78);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(27);
            const _r5 = i0.ɵɵreference(63);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.m_logsIntl.settings, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("aria-label", ctx.m_logsIntl.close)("matTooltip", ctx.m_logsIntl.close);
            i0.ɵɵadvance(5);
            i0.ɵɵpropertyInterpolate("label", ctx.m_logsIntl.settingsTabTitle);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", ctx.m_logsIntl.settingsGeneral, ": ");
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.m_logsIntl.logLevelFilter);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControl", ctx.getGeneralControl(ctx.SETTINGS_LOG_LEVEL));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.m_logLevels);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.m_logsIntl.settingsTimeToLog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("matDatepicker", _r1)("min", ctx.minLogDate)("max", ctx.maxLogDate)("formControl", ctx.getGeneralControl(ctx.SETTINGS_LOG_UNTIL));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("for", _r1);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("formControl", ctx.getGeneralControl(ctx.SETTINGS_SHOULD_LOG));
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.m_logsIntl.settingsShouldLog, " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.m_logsIntl.contextsToLog, ": ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.m_logCategories.length > 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(39, _c0$3, ctx.m_logCategories.length > 0, ctx.m_logCategories.length == 0));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.m_logsIntl.contextFile);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControl", ctx.getContextControl(ctx.CONTEXT_FILE));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.m_logsIntl.contextClass);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControl", ctx.getContextControl(ctx.CONTEXT_CLASS));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.m_logsIntl.contextFunction);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControl", ctx.getContextControl(ctx.CONTEXT_FUNCTION));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.m_logsIntl.contextLogLevel);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControl", ctx.getContextControl(ctx.CONTEXT_LOG_LEVELS));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.m_logLevels);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.isCtxEdit)("ngIfElse", _r5);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.hasFilterEntriesToDisplay());
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("label", ctx.m_logsIntl.explanationTabTitle);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.m_logsIntl.settingsGeneral, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.generalExplanations);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.m_logsIntl.contextsToLog, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.contextExplanations);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.m_logsIntl.close, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", ctx.m_isSaving);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.m_logsIntl.save, " ");
        } }, dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, i3.MatIcon, i4.MatTooltip, i2.MatFormField, i2.MatLabel, i2.MatSuffix, i3$1.MatInput, i13.MatSelect, i8.MatOption, i6.DefaultValueAccessor, i6.NgControlStatus, i6.FormControlDirective, i3$2.MatButton, i3$2.MatIconButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, i13$1.MatList, i13$1.MatListItem, i13$1.MatListSubheaderCssMatStyler, i14.MatDivider, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i8$1.MatCheckbox, i17.MatTab, i17.MatTabGroup], styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;height:100%}div.row[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > .mat-mdc-form-field[_ngcontent-%COMP%]{width:100%}.log-context-list[_ngcontent-%COMP%]{overflow-y:auto;min-height:200px}@media (max-width: 575px){.log-context-list[_ngcontent-%COMP%]{max-height:200px}.log-context-list[_ngcontent-%COMP%]   .mat-mdc-subheader[_ngcontent-%COMP%]{margin-top:8px;margin-bottom:8px}.log-context-list[_ngcontent-%COMP%]   .mat-mdc-list-item.mdc-list-item--with-one-line[_ngcontent-%COMP%]{height:-moz-fit-content;height:fit-content}}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogSettingsComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-log-settings', template: "<h1 mat-dialog-title class=\"ebo-dialog-header\">\n    <span class=\"ebo-dialog-title\">\n        {{m_logsIntl.settings}}\n    </span>\n    <button mat-icon-button type=\"button\" [aria-label]=\"m_logsIntl.close\"\n            [matTooltip]=\"m_logsIntl.close\" mat-dialog-close>\n        <mat-icon>close</mat-icon>\n    </button>\n</h1>\n<mat-dialog-content class=\"flex-fill\">\n    <mat-tab-group class=\"h-100 ebo-tab-header-margin\">\n        <mat-tab label=\"{{m_logsIntl.settingsTabTitle}}\">\n            <div class=\"container-fluid\">\n                <div class=\"row\">\n                    <div class=\"col-12\">\n                        {{m_logsIntl.settingsGeneral}}:\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-12 col-sm-6\">\n                        <!-- Zu loggende Level allgemein -->\n                        <mat-form-field appearance=\"fill\">\n                            <mat-label>{{m_logsIntl.logLevelFilter}}</mat-label>\n                            <mat-select multiple [formControl]=\"getGeneralControl(SETTINGS_LOG_LEVEL)\">\n                                <mat-option *ngFor=\"let logLevel of m_logLevels\" [value]=\"logLevel\">\n                                    {{m_logsIntl.getLogLevelTranslation(logLevel)}}\n                                </mat-option>\n                            </mat-select>\n                        </mat-form-field>\n                    </div>\n                    <div class=\"col-12 col-sm-6\">\n                        <!-- Logging bis -->\n                        <mat-form-field appearance=\"fill\">\n                            <mat-label>{{m_logsIntl.settingsTimeToLog}}</mat-label>\n                            <input matInput [matDatepicker]=\"logUntilPicker\" [min]=\"minLogDate\" [max]=\"maxLogDate\" disabled\n                                   [formControl]=\"getGeneralControl(SETTINGS_LOG_UNTIL)\" (dateInput)=\"logUntil_Input($event)\">\n                            <mat-datepicker-toggle matSuffix [for]=\"logUntilPicker\"></mat-datepicker-toggle>\n                            <mat-datepicker #logUntilPicker disabled=\"false\"></mat-datepicker>\n                        </mat-form-field>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-12 col-sm-6 offset-sm-6\">\n                        <!-- Soll geloggt werden? -->\n                        <mat-checkbox [formControl]=\"getGeneralControl(SETTINGS_SHOULD_LOG)\" (change)=\"shouldLog_Change($event)\"\n                                      color=\"primary\">\n                            {{m_logsIntl.settingsShouldLog}}\n                        </mat-checkbox>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-12\">\n                        {{m_logsIntl.contextsToLog}}:\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <!-- Bereich -->\n                    <ng-container *ngIf=\"m_logCategories.length > 0\">\n                        <div class=\"col-12 col-sm-6\">\n                            <mat-form-field appearance=\"fill\">\n                                <mat-label>{{m_logsIntl.logCategoryFilter}}</mat-label>\n                                <mat-select [formControl]=\"getContextControl(CONTEXT_CATEGORY)\" [compareWith]=\"compareCategories\">\n                                    <mat-option></mat-option>\n                                    <mat-option *ngFor=\"let logCategory of m_logCategories\" [value]=\"logCategory\">\n                                        {{logCategory.translation}}\n                                    </mat-option>\n                                </mat-select>\n                            </mat-form-field>\n                        </div>\n                    </ng-container>\n                    <div [ngClass]=\"{'col-12 col-sm-6': m_logCategories.length > 0, 'col-12': m_logCategories.length == 0}\">\n                        <!-- Datei -->\n                        <mat-form-field appearance=\"fill\">\n                            <mat-label>{{m_logsIntl.contextFile}}</mat-label>\n                            <input matInput [formControl]=\"getContextControl(CONTEXT_FILE)\">\n                        </mat-form-field>\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"col-12 col-sm-6\">\n                        <!-- Klasse -->\n                        <mat-form-field appearance=\"fill\">\n                            <mat-label>{{m_logsIntl.contextClass}}</mat-label>\n                            <input matInput [formControl]=\"getContextControl(CONTEXT_CLASS)\">\n                        </mat-form-field>\n                    </div>\n                    <div class=\"col-12 col-sm-6\">\n                        <!-- Funktion -->\n                        <mat-form-field appearance=\"fill\">\n                            <mat-label>{{m_logsIntl.contextFunction}}</mat-label>\n                            <input matInput [formControl]=\"getContextControl(CONTEXT_FUNCTION)\">\n                        </mat-form-field>\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"col-12 col-sm-6\">\n                        <!-- LogLevel -->\n                        <mat-form-field appearance=\"fill\">\n                            <mat-label>{{m_logsIntl.contextLogLevel}}</mat-label>\n                            <mat-select multiple [formControl]=\"getContextControl(CONTEXT_LOG_LEVELS)\">\n                                <mat-option *ngFor=\"let logLevel of m_logLevels\" [value]=\"logLevel\">\n                                    {{m_logsIntl.getLogLevelTranslation(logLevel)}}\n                                </mat-option>\n                            </mat-select>\n                        </mat-form-field>\n                    </div>\n                    <!-- Hinzuf\u00FCgen / Speichern -->\n                    <div class=\"col-12 col-sm-6\">\n                        <button *ngIf=\"isCtxEdit; else addButton\" mat-button type=\"button\" class=\"float-end formfield-height\"\n                                [disabled]=\"!isContextFormValid\" (click)=\"addContext_Click()\">\n                            <mat-icon>save</mat-icon>\n                            {{ m_logsIntl.settingsSaveContext }}\n                        </button>\n                        <ng-template #addButton>\n                            <button mat-button type=\"button\" class=\"float-end formfield-height\" [disabled]=\"!isContextFormValid\"\n                                    (click)=\"addContext_Click()\">\n                                <mat-icon>add</mat-icon>\n                                {{ m_logsIntl.settingsAddContext }}\n                            </button>\n                        </ng-template>\n                    </div>\n                </div>\n            </div>\n\n            <mat-list *ngIf=\"hasFilterEntriesToDisplay()\" class=\"log-context-list\">\n                <ng-container *ngFor=\"let subList of m_logContextFilterDisplayList; index as subListIdx\">\n                    <ng-container *ngIf=\"hasFilterEntriesToDisplay(subListIdx)\">\n                        <div mat-subheader>{{subList.subheader}}</div>\n                        <mat-list-item *ngFor=\"let ctx of subList.logContextFiltersForDisplay; index as entryIndex\">\n                            <div class=\"d-flex\">\n                                <div class=\"flex-fill d-flex align-items-center\">\n                                    {{getLogContextString(ctx)}}\n                                </div>\n                                <button mat-icon-button class=\"ebo-sm-icon-button\" (click)=\"editContext_Click(subListIdx, entryIndex)\">\n                                    <mat-icon>edit</mat-icon>\n                                </button>\n                                <button mat-icon-button class=\"ebo-sm-icon-button ms-3\" color=\"warn\"\n                                        (click)=\"deleteContext_Click(subListIdx, entryIndex)\">\n                                    <mat-icon>delete</mat-icon>\n                                </button>\n                            </div>\n                        </mat-list-item>\n                        <mat-divider *ngIf=\"needToInsertSeparator(subListIdx)\"></mat-divider>\n                    </ng-container>\n                </ng-container>\n            </mat-list>\n        </mat-tab>\n        <mat-tab label=\"{{m_logsIntl.explanationTabTitle}}\">\n            <h3>\n                {{m_logsIntl.settingsGeneral}}\n            </h3>\n            <div class=\"pb-2\">\n                <div *ngFor=\"let expl of generalExplanations\">\n                    {{expl}}\n                </div>\n            </div>\n            <h3>\n                {{m_logsIntl.contextsToLog}}\n            </h3>\n            <div class=\"pb-2\">\n                <div *ngFor=\"let expl of contextExplanations\">\n                    {{expl}}\n                </div>\n            </div>\n        </mat-tab>\n    </mat-tab-group>\n</mat-dialog-content>\n<mat-dialog-actions class=\"ebo-dialog-actions\">\n    <button type=\"button\" mat-button mat-dialog-close>\n        {{m_logsIntl.close}}\n    </button>\n    <button mat-raised-button color=\"primary\" [disabled]=\"m_isSaving\" (click)=\"saveSettings_Click()\" cdkFocusInitial>\n        {{m_logsIntl.save}}\n    </button>\n</mat-dialog-actions>", styles: [":host{display:flex;flex-direction:column;height:100%}div.row>div>.mat-mdc-form-field{width:100%}.log-context-list{overflow-y:auto;min-height:200px}@media (max-width: 575px){.log-context-list{max-height:200px}.log-context-list .mat-mdc-subheader{margin-top:8px;margin-bottom:8px}.log-context-list .mat-mdc-list-item.mdc-list-item--with-one-line{height:-moz-fit-content;height:fit-content}}\n"] }]
    }], function () { return [{ type: i1.MatDialogRef }, { type: LoggerService }, { type: i0.ChangeDetectorRef }, { type: i6.FormBuilder }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: LoggerCategoryService }]; }, null); })();

class LogsDialogComponent {
    constructor(m_data) {
        this.m_data = m_data;
        this.m_logs = this.m_data.logs;
        this.m_logsIntl = this.m_data.intl;
    }
    ngOnInit() {
    }
    static { this.ɵfac = function LogsDialogComponent_Factory(t) { return new (t || LogsDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LogsDialogComponent, selectors: [["ebootis-logs-dialog"]], decls: 11, vars: 6, consts: [["mat-dialog-title", "", 1, "ebo-dialog-header"], [1, "ebo-dialog-title"], ["mat-icon-button", "", "type", "button", "mat-dialog-close", "", 3, "matTooltip"], [1, "d-flex", "flex-fill", "flex-column", "mh-100"], [1, "d-flex", "flex-fill", "flex-column", 3, "logs", "logsIntl"], [1, "ebo-dialog-actions"], ["type", "button", "mat-button", "", "mat-dialog-close", "", "cdkFocusInitial", ""]], template: function LogsDialogComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0)(1, "span", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "button", 2)(4, "mat-icon");
            i0.ɵɵtext(5, "close");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(6, "mat-dialog-content", 3);
            i0.ɵɵelement(7, "ebootis-log-scroller", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "mat-dialog-actions", 5)(9, "button", 6);
            i0.ɵɵtext(10);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.m_logsIntl.logs, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("matTooltip", ctx.m_logsIntl.close);
            i0.ɵɵattribute("aria-label", ctx.m_logsIntl.close);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("logs", ctx.m_logs)("logsIntl", ctx.m_logsIntl);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.m_logsIntl.close);
        } }, dependencies: [i3.MatIcon, i4.MatTooltip, i3$2.MatButton, i3$2.MatIconButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, LogScrollerComponent], styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;flex:1}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogsDialogComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-logs-dialog', template: "<h1 mat-dialog-title class=\"ebo-dialog-header\">\n    <span class=\"ebo-dialog-title\">\n        {{m_logsIntl.logs}}\n    </span>\n    <button mat-icon-button type=\"button\" [attr.aria-label]=\"m_logsIntl.close\"\n            [matTooltip]=\"m_logsIntl.close\" mat-dialog-close>\n        <mat-icon>close</mat-icon>\n    </button>\n</h1>\n<mat-dialog-content class=\"d-flex flex-fill flex-column mh-100\">\n    <ebootis-log-scroller [logs]=\"m_logs\" [logsIntl]=\"m_logsIntl\" class=\"d-flex flex-fill flex-column\"></ebootis-log-scroller>\n</mat-dialog-content>\n<mat-dialog-actions class=\"ebo-dialog-actions\">\n    <button type=\"button\" mat-button mat-dialog-close cdkFocusInitial>{{m_logsIntl.close}}</button>\n</mat-dialog-actions>", styles: [":host{display:flex;flex-direction:column;flex:1}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

class LogsIntl {
    constructor() {
        this.changes = new Subject();
        this.logLevelInfo = "Info";
        this.logLevelDebug = "Debug";
        this.logLevelError = 'Error';
        this.logLevelSuccess = 'Erfolg';
        this.logLevelWarning = 'Warnung';
        this.noLogsForSelectedCriteria = 'Keine Logeinträge für die ausgewählten Kriterien';
        this.deleteAllLogEntries = 'Alle Logeinträge löschen';
        this.logs = 'Logs';
        this.entries = 'Einträge';
        this.failed = 'fehlgeschlagen';
        this.copyToClipboard = 'In die Zwischenablage kopieren';
        this.levels = 'Level';
        this.searchString = 'Suchbegriff';
        this.clearLog = 'Log leeren';
        this.scrollToTop = 'nach oben';
        this.scrollToBottom = 'nach unten';
        this.password = 'Passwort';
        this.wouldYouReallyLikeToPermanentlyDeleteAllLogEntries = 'Möchten Sie wirklich alle Logeinträge unwiderruflich löschen?';
        this.yes = 'Ja';
        this.no = 'Nein';
        this.parameters = 'Parameter';
        this.stack = 'Stack';
        this.filters = 'Filter';
        this.close = 'Schließen';
        this.fullscreen = 'Vollbild';
        this.clear = 'Leeren';
        this.settings = 'Einstellungen';
        this.save = 'Speichern';
        this.activateAtLeastOneLogLevelToActivateLogging = `Das Logging ist nicht aktiv. Zum Aktivieren muss in den Einstellungen die Checkbox
                                                            angehakt sein, das 'Logging bis'-Datum in der Zukunft liegen (falls gefüllt) und 
                                                            mindestens ein LogLevel in den allgemeinen Einstellungen ausgewählt sein
                                                            oder ein Kontext mit einer LogLevel-Auswahl angegeben sein.`;
        this.couldNotSaveDisplayedLogs = 'Fehler beim Speichern der sichtbaren Logs';
        this.levelsToLog = "Zu loggende Level";
        this.logLevelFilter = "LogLevel-Filter";
        this.logCategoryFilter = "Bereich-Filter";
        this.logCategory = "Bereich";
        this.contextsToLog = "zu loggende Kontexte";
        this.contextFile = "Datei";
        this.contextCategory = "Bereich";
        this.contextClass = "Klasse";
        this.contextFunction = "Funktion";
        this.contextParameters = "Kontext-Parameter";
        this.contextLogLevel = "LogLevel";
        this.contextSubHeaderCategory = "Bereich";
        this.contextSubHeaderFile = "Datei";
        this.contextSubHeaderClass = "Klasse";
        this.contextSubHeaderFunction = "Function";
        this.settingsSaveContext = "Ändern";
        this.settingsAddContext = "Hinzufügen";
        this.settingsGeneral = "Allgemeine Einstellungen";
        this.settingsTabTitle = "Einstellungen";
        this.explanationTabTitle = "Erläuterung";
        this.settingsShouldLog = "Soll geloggt werden?";
        this.settingsTimeToLog = "Logging bis";
        this.generalExplanation = `Angaben zum allgemeinen Logging. Die angegebenen LogLevel filtern alle Einträge, die von keinem Kontext\
                                   abgedeckt sind. Sind keinerlei LogLevel ausgewählt, werden nur die Einträge geloggt, die zu einem bestimmten Kontext gehören.\n\
                                   Über das Feld 'Logging bis' kann ein zeitlicher Rahmen (bis 6 Monate in die Zukunft) für den Logger festgelegt werden.\
                                   Dieses Datum ist exklusiv. Über das Flag 'Soll geloggt werden?' kann das Logging abgeschaltet werden.\
                                   Falls das Flag deaktiviert ist oder das angegeben Datum überschritten ist, wird kein Eintrag geloggt.\n\
                                   Fehlen sowohl allgemeine LogLevel, als auch Kontexte, wird ebenfalls nicht geloggt.`;
        this.contextExplanation = `Gibt an, welche Kontexte geloggt werden sollen. Ein Kontext definiert sich durch einen Bereich, eine Datei,\
                                   eine Klasse und/oder eine Funktion. Dabei können die Felder beliebig kombiniert werden.\n\
                                   Bei den Feldern Datei, Klasse und Funktion kann am Anfang und/oder am Ende ein '*' verwendet werden,\
                                   um eine Gruppe von Objekten zu definieren. Wird beispielsweise im Feld 'Klasse' der Text '*Service' eingetragen,\
                                   werden alle Klassen wie 'DataService', 'MessageService', usw. geloggt. Wird zu der Klassenangabe '*Service'\
                                   als Funktion 'update*' eingestellt, werden in diesen Klassen nur Funktionen geloggt, die mit 'update' beginnen.\n\
                                   Über die LogLevel-Auswahl werden nur solche Einträge im gewählten Kontext geloggt, die zu einem der selektierten LogLevel passt.\
                                   Wird für einen Kontext kein LogLevel angegeben, wird dieser Kontext nicht geloggt.`;
    }
    getLogLevelTranslation(p_logLevel) {
        switch (p_logLevel) {
            case LogLevel.INFO:
                return this.logLevelInfo;
            case LogLevel.DEBUG:
                return this.logLevelDebug;
            case LogLevel.ERROR:
                return this.logLevelError;
            case LogLevel.SUCCESS:
                return this.logLevelSuccess;
            case LogLevel.WARNING:
                return this.logLevelWarning;
            default:
                throw new Error('unknown logLevel');
        }
    }
    static { this.ɵfac = function LogsIntl_Factory(t) { return new (t || LogsIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LogsIntl, factory: LogsIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogsIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

class FilterLogEntryPipe {
    transform(p_arrayToFilter, p_filter) {
        if (!p_arrayToFilter)
            return null;
        if (!this.hasFilterValues(p_filter))
            return p_arrayToFilter;
        return p_arrayToFilter.filter(logEntry => this.filterEntry(logEntry, p_filter));
    }
    hasFilterValues(p_filter) {
        if (!p_filter)
            return false;
        let isValid = !!p_filter.searchString || !!p_filter.date;
        if (!isValid)
            isValid = (p_filter.logLevels?.length ?? 0) > 0;
        if (!isValid)
            isValid = LogContextHelper.hasValues(p_filter.context);
        return isValid;
    }
    filterEntry(p_logEntry, p_filter) {
        if ((p_filter.logLevels?.length ?? 0) > 0 && !p_filter.logLevels.includes(p_logEntry.level))
            return false;
        if (p_filter.date && p_logEntry.date && p_logEntry.date.getTime() < p_filter.date.getTime())
            return false;
        if (!LogContextHelper.checkAgainstFilterContext(p_logEntry.context, p_filter.context))
            return false;
        if (!this.containsEntrySearchString(p_logEntry, p_filter.searchString))
            return false;
        return true;
    }
    containsEntrySearchString(p_logEntry, p_searchString) {
        if (!p_searchString)
            return true;
        if (p_logEntry.title?.includes(p_searchString))
            return true;
        if (p_logEntry.entry?.includes(p_searchString))
            return true;
        if (p_logEntry.parameters?.some(param => param.title?.includes(p_searchString)))
            return true;
        if (p_logEntry.stack.some(line => line.includes(p_searchString)))
            return true;
        if (LogContextHelper.containsSearchString(p_logEntry.context, p_searchString))
            return true;
        return false;
    }
    static { this.ɵfac = function FilterLogEntryPipe_Factory(t) { return new (t || FilterLogEntryPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "filterLogEntry", type: FilterLogEntryPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterLogEntryPipe, [{
        type: Pipe,
        args: [{
                name: 'filterLogEntry'
            }]
    }], null, null); })();

function LogsComponent_ng_container_4_mat_option_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const logLevel_r15 = ctx.$implicit;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", logLevel_r15)("disabled", !ctx_r7.isActiveLogLevel(logLevel_r15));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.m_logsIntl.getLogLevelTranslation(logLevel_r15), " ");
} }
function LogsComponent_ng_container_4_mat_icon_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 21);
} }
function LogsComponent_ng_container_4_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 22);
    i0.ɵɵlistener("click", function LogsComponent_ng_container_4_ng_template_15_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r16.clearSearchField_Click()); });
    i0.ɵɵtext(1, " close ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("matTooltip", ctx_r11.m_logsIntl.clear)("hidden", !ctx_r11.m_logSearchStringCtrl.value || ctx_r11.m_logSearchStringCtrl.value == "");
    i0.ɵɵattribute("aria-label", ctx_r11.m_logsIntl.clear);
} }
function LogsComponent_ng_container_4_ng_container_18_mat_option_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const logCategory_r19 = ctx.$implicit;
    i0.ɵɵproperty("value", logCategory_r19);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", logCategory_r19.translation, " ");
} }
function LogsComponent_ng_container_4_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field", 8)(2, "mat-label");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-select", 23);
    i0.ɵɵlistener("selectionChange", function LogsComponent_ng_container_4_ng_container_18_Template_mat_select_selectionChange_4_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.onLogCategoryChanged($event.value)); });
    i0.ɵɵelement(5, "mat-option");
    i0.ɵɵtemplate(6, LogsComponent_ng_container_4_ng_container_18_mat_option_6_Template, 2, 2, "mat-option", 24);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r12.m_logsIntl.logCategory);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControl", ctx_r12.m_logCategoryCtrl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r12.m_logCategories);
} }
function LogsComponent_ng_container_4_ng_container_20_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function LogsComponent_ng_container_4_ng_container_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LogsComponent_ng_container_4_ng_container_20_ng_container_1_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(10);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
} }
function LogsComponent_ng_container_4_ng_container_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function LogsComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 7)(3, "mat-form-field", 8)(4, "mat-label");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "mat-select", 9);
    i0.ɵɵlistener("selectionChange", function LogsComponent_ng_container_4_Template_mat_select_selectionChange_6_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23.onDisplayedLogLevelsChanged($event.value)); });
    i0.ɵɵtemplate(7, LogsComponent_ng_container_4_mat_option_7_Template, 2, 3, "mat-option", 10);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "div", 7)(9, "mat-form-field", 8)(10, "mat-label");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "input", 11, 12);
    i0.ɵɵtemplate(14, LogsComponent_ng_container_4_mat_icon_14_Template, 1, 0, "mat-icon", 13);
    i0.ɵɵtemplate(15, LogsComponent_ng_container_4_ng_template_15_Template, 2, 3, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "div", 7);
    i0.ɵɵtemplate(18, LogsComponent_ng_container_4_ng_container_18_Template, 7, 3, "ng-container", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 7);
    i0.ɵɵtemplate(20, LogsComponent_ng_container_4_ng_container_20_Template, 2, 1, "ng-container", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 16)(22, "button", 17);
    i0.ɵɵlistener("click", function LogsComponent_ng_container_4_Template_button_click_22_listener() { i0.ɵɵrestoreView(_r24); const ctx_r25 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r25.openLogDialog_Click()); });
    i0.ɵɵelementStart(23, "mat-icon");
    i0.ɵɵtext(24, "open_in_new");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(26, LogsComponent_ng_container_4_ng_container_26_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(27, "ebootis-log-scroller", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r10 = i0.ɵɵreference(16);
    const ctx_r0 = i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(10);
    const _r3 = i0.ɵɵreference(8);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.m_logsIntl.logLevelFilter);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControl", ctx_r0.m_logLevelFilterCtrl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.m_logLevels);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.m_logsIntl.searchString);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControl", ctx_r0.m_logSearchStringCtrl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.m_logSearchStringCtrl.value || ctx_r0.m_logSearchStringCtrl.value == "")("ngIfElse", _r10);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.m_logCategories.length > 0)("ngIfElse", _r5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.m_logCategories.length > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", ctx_r0.m_logsIntl.fullscreen);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.m_logsIntl.fullscreen, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("logs", ctx_r0.m_filteredLogs)("logsIntl", ctx_r0.m_logsIntl);
} }
function LogsComponent_ng_template_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function LogsComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 26);
    i0.ɵɵtemplate(2, LogsComponent_ng_template_5_ng_container_2_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(3, "ui-placeholder", 27);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(8);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerText", ctx_r2.m_logsIntl.activateAtLeastOneLogLevelToActivateLogging);
} }
function LogsComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function LogsComponent_ng_template_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r27.openLogSettings_Click()); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "settings");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r4.m_logsIntl.settings);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.m_logsIntl.settings, " ");
} }
function LogsComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ebootis-password-field-content", 29);
    i0.ɵɵlistener("valueChanged", function LogsComponent_ng_template_9_Template_ebootis_password_field_content_valueChanged_0_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r29.onPasswordValue_Change($event)); });
    i0.ɵɵelementStart(1, "button", 30);
    i0.ɵɵlistener("click", function LogsComponent_ng_template_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r31.clearLogs_Click()); });
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("password", ctx_r6.m_password)("fieldLabel", ctx_r6.m_logsIntl.password)("value", ctx_r6.passwordValue);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", !ctx_r6.m_logs || ctx_r6.m_logs.length <= 0);
    i0.ɵɵattribute("aria-label", ctx_r6.m_logsIntl.clearLog);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.m_logsIntl.clearLog, " ");
} }
class LogsComponent {
    get passwordInput() {
        return this.passwordValue;
    }
    set passwordInput(p_value) {
        this.passwordValue = p_value;
    }
    set m_logSettings(p_value) {
        this._logSettings = p_value;
        this.m_usedLogLevels = LogSettingsHelper.getComulativeActiveLogLevels(this.m_logSettings);
    }
    get m_logSettings() {
        return this._logSettings;
    }
    constructor(logsIntl, m_filterLogEntryPipe, m_loggerService, m_changeDetectorRef, matDlg, m_loggerCategoryService, m_confirmationService) {
        this.logsIntl = logsIntl;
        this.m_filterLogEntryPipe = m_filterLogEntryPipe;
        this.m_loggerService = m_loggerService;
        this.m_changeDetectorRef = m_changeDetectorRef;
        this.matDlg = matDlg;
        this.m_loggerCategoryService = m_loggerCategoryService;
        this.m_confirmationService = m_confirmationService;
        this.passwordInputChanged = new EventEmitter();
        /** Alle Loglevel */
        this.m_logLevels = LOG_LEVEL_ARRAY;
        this.m_logLevelFilterCtrl = new FormControl();
        this.m_logSearchStringCtrl = new FormControl();
        this.m_logCategoryCtrl = new FormControl();
        this.m_subscriptionsSubject = new Subject();
        if (this.logsIntl) {
            this.m_logsIntl = this.logsIntl;
        }
        else {
            this.m_logsIntl = new LogsIntl();
        }
        this.m_logCategories = this.m_loggerCategoryService?.getSortedLogCategories();
    }
    ngOnInit() {
        // Per Default nur die Errors anzeigen
        this.m_logLevelFilterCtrl.patchValue([LogLevel.ERROR]);
        this.m_loggerService.logSettings$
            .pipe(filter(settings => !!settings))
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe({
            next: (logSettings) => {
                this.m_logSettings = logSettings;
                this.m_logLevelFilterCtrl.patchValue(logSettings.displayedLogLevels);
                this.m_changeDetectorRef.detectChanges();
            },
            error: (err) => { this.m_loggerService.logError({ entry: err, context: this.getLogContextBuilder('ngOnInit').get('getLogSettings') }); }
        });
        this.m_loggerService.logs$
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe({
            next: (logs) => {
                this.m_logs = logs;
                this.filterLogs();
                this.m_changeDetectorRef.detectChanges();
            }
        });
    }
    ngOnDestroy() {
        this.m_subscriptionsSubject.next();
        this.m_subscriptionsSubject.complete();
    }
    get headerTitel() {
        return `${this.m_logsIntl.logs} (${this.m_logs?.length ?? 0} ${this.m_logsIntl.entries}, ${this.countLogErrors()} ${this.m_logsIntl.failed})`;
    }
    get isLoggingActive() {
        if (!this.m_logs)
            return false;
        return this.m_logs && LogSettingsHelper.getIsLogSettingsActive(this.m_logSettings);
    }
    onDisplayedLogLevelsChanged(p_value) {
        this.m_logSettings.displayedLogLevels = p_value;
        this.filterLogs();
        this.m_loggerService.saveLogSettings(this.m_logSettings)
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe({
            next: () => { },
            error: (err) => {
                this.m_loggerService.logError({
                    title: this.m_logsIntl.couldNotSaveDisplayedLogs,
                    entry: err,
                    context: this.getLogContextBuilder('onDisplayedLogLevelsChanged').addParameter({ name: 'LogLevels', value: p_value }).get()
                });
            }
        });
    }
    onLogCategoryChanged(p_value) {
        // Todo: Evtl auch in den Settings speichern?
        this.filterLogs();
    }
    countLogErrors() {
        return this.m_logs?.filter(log => log.level == LogLevel.ERROR)?.length;
    }
    clearLogs_Click() {
        this.m_confirmationService.openConfirmationDialog({
            message: this.m_logsIntl.wouldYouReallyLikeToPermanentlyDeleteAllLogEntries,
            title: this.m_logsIntl.deleteAllLogEntries,
            isWarning: true,
        })
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe({
            next: (answer) => {
                if (answer) {
                    this.m_loggerService.clear();
                }
            }
        });
    }
    /** Die Logs, anhand von Sucheingabe und LogLevel-Filter reduziert */
    filterLogs() {
        let logsFilter = {
            logLevels: this.m_logLevelFilterCtrl?.value ?? [],
            searchString: this.m_logSearchStringCtrl?.value,
            context: { category: this.m_logCategoryCtrl?.value }
        };
        this.m_filteredLogs = this.m_filterLogEntryPipe.transform(this.m_logs, logsFilter);
    }
    /** Öffnet die Log-Liste in einem Vollbild-Dialog */
    openLogDialog_Click() {
        let dlg = this.matDlg.open(LogsDialogComponent, {
            disableClose: true,
            data: {
                logs: this.m_filteredLogs,
                intl: this.m_logsIntl
            },
            panelClass: ['fullscreen-dialog']
        }).afterClosed()
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe();
    }
    /** Leert das Suchfeld via ctrl.reset() */
    clearSearchField_Click() {
        this.m_logSearchStringCtrl.reset();
        this.m_changeDetectorRef.detectChanges();
    }
    /** Öffnet einen Dialog für die Log-Einstellungen */
    openLogSettings_Click() {
        let dlg = this.matDlg.open(LogSettingsComponent, {
            disableClose: true,
            data: {
                intl: this.m_logsIntl,
                displayedLogLevels: this.m_logLevelFilterCtrl.value
            },
            panelClass: ['max-size-dialog']
        }).afterClosed()
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe();
    }
    isActiveLogLevel(p_logLevel) {
        return this.m_usedLogLevels.has(p_logLevel);
    }
    onPasswordValue_Change(p_newValue) {
        this.passwordValue = p_newValue;
        this.passwordInputChanged.emit(this.passwordValue);
    }
    getLogContextBuilder(p_functionName) {
        return LogContextBuilder.getInstance('logs.component.ts', 'LogsComponent', p_functionName);
    }
    static { this.ɵfac = function LogsComponent_Factory(t) { return new (t || LogsComponent)(i0.ɵɵdirectiveInject(LogsIntl, 8), i0.ɵɵdirectiveInject(FilterLogEntryPipe), i0.ɵɵdirectiveInject(LoggerService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(LoggerCategoryService), i0.ɵɵdirectiveInject(ConfirmationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LogsComponent, selectors: [["ebootis-logs"]], inputs: { m_password: ["password", "m_password"], passwordInput: "passwordInput" }, outputs: { passwordInputChanged: "passwordInputChanged" }, features: [i0.ɵɵProvidersFeature([FilterLogEntryPipe])], decls: 11, vars: 3, consts: [[1, "container-fluid", "h-100", "d-flex", "flex-column"], [1, "row"], [1, "col", "ebo-tab-header"], [4, "ngIf", "ngIfElse"], ["loggingNotActive", ""], ["logSettingsButton", ""], ["password", ""], [1, "col-12", "col-sm-6", "col-md-4", "col-lg-3"], ["appearance", "fill", 1, "w-100"], ["multiple", "", 3, "formControl", "selectionChange"], [3, "value", "disabled", 4, "ngFor", "ngForOf"], ["matInput", "", 3, "formControl"], ["logSearchStringCtrl", ""], ["matSuffix", "", 4, "ngIf", "ngIfElse"], ["clearSuffix", ""], [4, "ngIf"], [1, "col", "d-flex", "flex-wrap", "justify-content-end"], ["mat-button", "", "type", "button", 1, "formfield-height", "me-3", 3, "click"], [4, "ngTemplateOutlet"], [1, "d-flex", "flex-fill", "flex-column", 3, "logs", "logsIntl"], [3, "value", "disabled"], ["matSuffix", ""], ["tabindex", "-1", "matSuffix", "", 1, "cursor-pointer", 3, "matTooltip", "hidden", "click"], [3, "formControl", "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], [1, "col"], [3, "innerText"], ["mat-button", "", "type", "button", 1, "formfield-height", 3, "click"], [3, "password", "fieldLabel", "value", "valueChanged"], ["mat-button", "", "type", "button", "color", "warn", 1, "formfield-height", 3, "disabled", "click"]], template: function LogsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h2", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(4, LogsComponent_ng_container_4_Template, 28, 15, "ng-container", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, LogsComponent_ng_template_5_Template, 4, 2, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(7, LogsComponent_ng_template_7_Template, 4, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(9, LogsComponent_ng_template_9_Template, 5, 6, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(6);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.headerTitel, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isLoggingActive)("ngIfElse", _r1);
        } }, dependencies: [i1$1.NgForOf, i1$1.NgIf, i1$1.NgTemplateOutlet, i8$2.PlaceholderComponent, i3.MatIcon, i4.MatTooltip, i2.MatFormField, i2.MatLabel, i2.MatSuffix, i3$1.MatInput, i13.MatSelect, i8.MatOption, i6.DefaultValueAccessor, i6.NgControlStatus, i6.FormControlDirective, i3$2.MatButton, LogScrollerComponent, PasswordFieldContentComponent] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogsComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-logs', providers: [FilterLogEntryPipe], template: "<div class=\"container-fluid h-100 d-flex flex-column\">\n  <div class=\"row\">\n    <h2 class=\"col ebo-tab-header\">\n      {{headerTitel}}\n    </h2>\n  </div>\n  <ng-container *ngIf=\"isLoggingActive; else loggingNotActive\">\n    <div class=\"row\">\n      <div class=\"col-12 col-sm-6 col-md-4 col-lg-3\">\n        <mat-form-field appearance=\"fill\" class=\"w-100\">\n          <mat-label>{{m_logsIntl.logLevelFilter}}</mat-label>\n          <mat-select multiple [formControl]=\"m_logLevelFilterCtrl\"\n                      (selectionChange)=\"onDisplayedLogLevelsChanged($event.value)\">\n            <mat-option *ngFor=\"let logLevel of m_logLevels\" [value]=\"logLevel\"\n                        [disabled]=\"!isActiveLogLevel(logLevel)\">\n              {{m_logsIntl.getLogLevelTranslation(logLevel)}}\n            </mat-option>\n          </mat-select>\n        </mat-form-field>\n      </div>\n      <div class=\"col-12 col-sm-6 col-md-4 col-lg-3\">\n        <mat-form-field appearance=\"fill\" class=\"w-100\">\n          <mat-label>{{m_logsIntl.searchString}}</mat-label>\n          <input matInput #logSearchStringCtrl [formControl]=\"m_logSearchStringCtrl\">\n          <mat-icon matSuffix *ngIf=\"!m_logSearchStringCtrl.value || m_logSearchStringCtrl.value==''; else clearSuffix\">\n          </mat-icon>\n          <ng-template #clearSuffix>\n            <mat-icon tabindex=\"-1\" [matTooltip]=\"m_logsIntl.clear\" [attr.aria-label]=\"m_logsIntl.clear\"\n                      matSuffix class=\"cursor-pointer\"\n                      [hidden]=\"!m_logSearchStringCtrl.value || m_logSearchStringCtrl.value==''\"\n                      (click)=\"clearSearchField_Click()\">\n              close\n            </mat-icon>\n          </ng-template>\n        </mat-form-field>\n      </div>\n      <div class=\"col-12 col-sm-6 col-md-4 col-lg-3\">\n        <ng-container *ngIf=\"m_logCategories.length > 0; else password\">\n          <mat-form-field appearance=\"fill\" class=\"w-100\">\n            <mat-label>{{m_logsIntl.logCategory}}</mat-label>\n            <mat-select [formControl]=\"m_logCategoryCtrl\"\n                        (selectionChange)=\"onLogCategoryChanged($event.value)\">\n              <mat-option></mat-option>\n              <mat-option *ngFor=\"let logCategory of m_logCategories\" [value]=\"logCategory\">\n                {{logCategory.translation}}\n              </mat-option>\n            </mat-select>\n          </mat-form-field>\n        </ng-container>\n      </div>\n      <div class=\"col-12 col-sm-6 col-md-4 col-lg-3\">\n        <ng-container *ngIf=\"m_logCategories.length > 0\">\n          <ng-container *ngTemplateOutlet=\"password\"></ng-container>\n        </ng-container>\n      </div>\n      <div class=\"col d-flex flex-wrap justify-content-end\">\n        <button mat-button type=\"button\" (click)=\"openLogDialog_Click()\"\n                [attr.aria-label]=\"m_logsIntl.fullscreen\"\n                class=\"formfield-height me-3\">\n          <mat-icon>open_in_new</mat-icon>\n          {{m_logsIntl.fullscreen}}\n        </button>\n        <ng-container *ngTemplateOutlet=\"logSettingsButton\"></ng-container>\n      </div>\n    </div>\n    <ebootis-log-scroller [logs]=\"m_filteredLogs\" [logsIntl]=\"m_logsIntl\" \n                          class=\"d-flex flex-fill flex-column\">\n    </ebootis-log-scroller>\n  </ng-container>\n</div>\n\n<ng-template #loggingNotActive>\n  <div class=\"row\">\n    <div class=\"col\">\n      <ng-container *ngTemplateOutlet=\"logSettingsButton\"></ng-container>\n    </div>\n  </div>\n  <ui-placeholder [innerText]=\"m_logsIntl.activateAtLeastOneLogLevelToActivateLogging\"></ui-placeholder>\n</ng-template>\n\n<ng-template #logSettingsButton>\n  <button mat-button type=\"button\" [attr.aria-label]=\"m_logsIntl.settings\" class=\"formfield-height\"\n          (click)=\"openLogSettings_Click()\">\n    <mat-icon>settings</mat-icon> {{m_logsIntl.settings}}\n  </button>\n</ng-template>\n\n<ng-template #password>\n  <ebootis-password-field-content [password]=\"m_password\" [fieldLabel]=\"m_logsIntl.password\" [value]=\"passwordValue\" \n                                  (valueChanged)=\"onPasswordValue_Change($event)\">\n    <button mat-button type=\"button\" color=\"warn\" (click)=\"clearLogs_Click()\"\n            [disabled]=\"!m_logs || m_logs.length<=0\" [attr.aria-label]=\"m_logsIntl.clearLog\"\n            class=\"formfield-height\">\n      <mat-icon>delete</mat-icon>\n      {{m_logsIntl.clearLog}}\n    </button>\n  </ebootis-password-field-content>\n</ng-template>" }]
    }], function () { return [{ type: LogsIntl, decorators: [{
                type: Optional
            }] }, { type: FilterLogEntryPipe }, { type: LoggerService }, { type: i0.ChangeDetectorRef }, { type: i1.MatDialog }, { type: LoggerCategoryService }, { type: ConfirmationService }]; }, { m_password: [{
            type: Input,
            args: ['password']
        }], passwordInput: [{
            type: Input
        }], passwordInputChanged: [{
            type: Output
        }] }); })();

class MessageHandlerIntl {
    constructor() {
        this.changes = new Subject();
        this.displayError500Intl = 'HTTP-Code 500 Serverfehler';
        this.displayError504Intl = 'HTTP-Code 504 Server nicht erreichbar';
        this.displayErrorDefaultIntl = 'Unbekannter Fehler';
        this.displayErrorDefaultIntl = 'Server konnte nicht erreicht werden.';
    }
    static { this.ɵfac = function MessageHandlerIntl_Factory(t) { return new (t || MessageHandlerIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MessageHandlerIntl, factory: MessageHandlerIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessageHandlerIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

function MessageHandlerComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "span", 2);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 3);
    i0.ɵɵlistener("click", function MessageHandlerComponent_ng_container_0_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.dismiss_Click()); });
    i0.ɵɵelementStart(5, "mat-icon");
    i0.ɵɵtext(6, "close");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r0.cssClass);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.m_display, " ");
} }
class MessageHandlerComponent {
    set displayError(p_error) {
        this.m_lastHttpError = p_error;
        this.checkHttpErrorCode(this.m_lastHttpError);
    }
    set displayMessage(p_message) {
        this.m_display = p_message;
    }
    constructor(messageHandlerIntl) {
        this.messageHandlerIntl = messageHandlerIntl;
        this.dismiss = new EventEmitter();
        this.m_subscriptionsSubject = new Subject();
        if (this.messageHandlerIntl) {
            this.m_messageHandlerIntl = this.messageHandlerIntl;
        }
        else {
            this.m_messageHandlerIntl = new MessageHandlerIntl();
        }
    }
    ngOnInit() {
        this.m_messageHandlerIntl.changes.pipe(takeUntil(this.m_subscriptionsSubject)).subscribe({
            next: (v) => {
                if (this.m_lastHttpError) {
                    this.checkHttpErrorCode(this.m_lastHttpError);
                }
            }
        });
    }
    ngOnDestroy() {
        this.m_subscriptionsSubject.next();
        this.m_subscriptionsSubject.complete();
    }
    checkHttpErrorCode(p_error) {
        if (p_error) {
            switch (p_error.status) {
                case 0: {
                    this.m_display = this.m_messageHandlerIntl.displayError0Unkown;
                    break;
                }
                case 401: {
                    //unauthorized
                    break;
                }
                case 403: {
                    //forbidden
                    break;
                }
                case 500: {
                    this.m_display = p_error.error && p_error.error.message ? p_error.error.message.toString() : this.m_messageHandlerIntl.displayError500Intl;
                    break;
                }
                case 504: {
                    this.m_display = this.m_messageHandlerIntl.displayError504Intl;
                    break;
                }
                default: {
                    let err = p_error.status ? `(${p_error.status}) ` : '';
                    this.m_display = err + this.m_messageHandlerIntl.displayErrorDefaultIntl;
                }
            }
        }
        else {
            this.m_display = null;
        }
    }
    dismiss_Click() {
        this.m_display = null; //TODO, wenn der Aufrufer sich kümmern würde, wäre diese Stelle nicht mehr notwendig!
        this.dismiss.emit();
    }
    get cssClass() {
        return `alert-${this.class}`;
    }
    get showCtrl() {
        return this.m_display?.length > 0;
    }
    static { this.ɵfac = function MessageHandlerComponent_Factory(t) { return new (t || MessageHandlerComponent)(i0.ɵɵdirectiveInject(MessageHandlerIntl, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MessageHandlerComponent, selectors: [["ebootis-message-handler"]], inputs: { class: "class", displayError: "displayError", displayMessage: "displayMessage" }, outputs: { dismiss: "dismiss" }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["role", "alert", 1, "alert"], [1, "alert-text"], ["mat-icon-button", "", "type", "button", 1, "ebo-xs-icon-button", 3, "click"]], template: function MessageHandlerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, MessageHandlerComponent_ng_container_0_Template, 7, 3, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.showCtrl);
        } }, dependencies: [i1$1.NgIf, i3.MatIcon, i3$2.MatIconButton], styles: ["[_nghost-%COMP%]{display:block;width:100%}.alert[_ngcontent-%COMP%]{display:flex;width:100%;box-sizing:border-box;padding:1rem;border-radius:4px;color:#fff;align-items:center}.alert[_ngcontent-%COMP%]   .alert-text[_ngcontent-%COMP%]{flex-grow:1}.alert[_ngcontent-%COMP%]   mat-mdc-icon-button[_ngcontent-%COMP%]{color:inherit}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessageHandlerComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-message-handler', template: "<ng-container *ngIf=\"showCtrl\">\n  <div [class]=\"cssClass\" class=\"alert\" role=\"alert\">\n    <span class=\"alert-text\">\n      {{m_display}}\n    </span>\n    <button mat-icon-button type=\"button\" class=\"ebo-xs-icon-button\" (click)=\"dismiss_Click()\">\n      <mat-icon>close</mat-icon>\n    </button>\n  </div>\n</ng-container>", styles: [":host{display:block;width:100%}.alert{display:flex;width:100%;box-sizing:border-box;padding:1rem;border-radius:4px;color:#fff;align-items:center}.alert .alert-text{flex-grow:1}.alert mat-mdc-icon-button{color:inherit}\n"] }]
    }], function () { return [{ type: MessageHandlerIntl, decorators: [{
                type: Optional
            }] }]; }, { class: [{
            type: Input,
            args: [{ required: true }]
        }], displayError: [{
            type: Input
        }], displayMessage: [{
            type: Input
        }], dismiss: [{
            type: Output
        }] }); })();

class NotificationHandlerIntl {
    constructor() {
        this.changes = new Subject();
    }
    static { this.ɵfac = function NotificationHandlerIntl_Factory(t) { return new (t || NotificationHandlerIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NotificationHandlerIntl, factory: NotificationHandlerIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationHandlerIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

function NotificationHandlerComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.m_notificationHandlerIntl.successNotification, " ");
} }
function NotificationHandlerComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.m_notificationHandlerIntl.dangerNotification, " ");
} }
class NotificationHandlerComponent {
    constructor(data, notificationHandlerIntl) {
        this.data = data;
        this.notificationHandlerIntl = notificationHandlerIntl;
        this.m_type = 'danger';
        if (this.notificationHandlerIntl) {
            this.m_notificationHandlerIntl = this.notificationHandlerIntl;
        }
        else {
            this.m_notificationHandlerIntl = new NotificationHandlerIntl();
            this.m_notificationHandlerIntl.successNotification = 'SUCCESS';
            this.m_notificationHandlerIntl.dangerNotification = 'DANGER';
        }
        if (data && data.type) {
            this.m_type = data.type;
        }
    }
    static { this.ɵfac = function NotificationHandlerComponent_Factory(t) { return new (t || NotificationHandlerComponent)(i0.ɵɵdirectiveInject(MAT_SNACK_BAR_DATA), i0.ɵɵdirectiveInject(NotificationHandlerIntl, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotificationHandlerComponent, selectors: [["utilities-notification-handler"]], decls: 5, vars: 5, consts: [[4, "ngIf"]], template: function NotificationHandlerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "span");
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "span");
            i0.ɵɵtemplate(3, NotificationHandlerComponent_span_3_Template, 2, 1, "span", 0);
            i0.ɵɵtemplate(4, NotificationHandlerComponent_span_4_Template, 2, 1, "span", 0);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.data.message, "\n");
            i0.ɵɵadvance(1);
            i0.ɵɵclassMap("right " + ctx.m_type);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.m_type == "success");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.m_type == "danger");
        } }, dependencies: [i1$1.NgIf], styles: [".right[_ngcontent-%COMP%]{float:right}.danger[_ngcontent-%COMP%]{color:red}.success[_ngcontent-%COMP%]{color:#0f0}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationHandlerComponent, [{
        type: Component,
        args: [{ selector: 'utilities-notification-handler', template: "<span>\n  {{data.message}}\n</span>\n<span [class]=\"'right '+m_type\">\n  <span *ngIf=\"m_type=='success'\">\n    {{m_notificationHandlerIntl.successNotification}}\n  </span>\n  <span *ngIf=\"m_type=='danger'\">\n    {{m_notificationHandlerIntl.dangerNotification}}\n  </span>\n</span>\n", styles: [".right{float:right}.danger{color:red}.success{color:#0f0}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_SNACK_BAR_DATA]
            }] }, { type: NotificationHandlerIntl, decorators: [{
                type: Optional
            }] }]; }, null); })();

class IndexedDBService {
    constructor() {
        this.m_indexedDB = indexedDB ? indexedDB : window.indexedDB;
    }
    open(p_name, p_version) {
        const self = this;
        return new Observable((observer) => {
            if (!p_name || p_name == "") {
                const error = new Error("dbname is not set");
                observer.error(error);
            }
            else {
                //wenn die db noch offen ist, muss geprüft werden ob die gleiche db angefragt wurde
                // wenn nicht, muss die aktuelle db Verbindung geschlossen werden
                if (this.m_db && (this.m_db.name != p_name || (p_version && this.m_db.version != p_version))) {
                    self.close();
                }
                if (this.m_db) {
                    observer.next(this.m_db);
                    observer.complete();
                }
                else {
                    // wenn eine Version angegeben ist (wird sie i.d.R. nur zum Upgrade der DB), mit der Versionsangabe öffnen
                    const openDBRequest = p_version
                        ? self.m_indexedDB.open(p_name, p_version)
                        : self.m_indexedDB.open(p_name);
                    openDBRequest.onerror = (error) => {
                        //versionError means, the requested db version is less than the existing
                        //has to reload 
                        observer.error(openDBRequest.error);
                        this.onError(openDBRequest, error);
                    }; // fehler beim öffnen der DB
                    openDBRequest.onsuccess = (event) => {
                        // DB erfolgreich geöffnet
                        this.m_db = openDBRequest.result;
                        this.m_db.onversionchange = (ev) => this.onVersionChanged(this.m_db, ev);
                        observer.next(this.m_db);
                        observer.complete();
                    };
                    openDBRequest.onblocked = (ev) => {
                        observer.error(new Error('db upgrade blocked'));
                        this.onBlocked(openDBRequest, ev);
                    };
                    // "onupgradeneeded" wird ausgelöst, wenn die DB Version sich von der angefragten unterscheidet
                    // nur innerhalb dieses Events können Datenbankänderungen vorgenommen werden
                    openDBRequest.onupgradeneeded = (ev) => this.onUpgradeNeeded(openDBRequest, ev);
                }
            }
        });
    }
    onError(openDBRequest, ev) {
        console.log("OpenDB Error");
    }
    onUpgradeNeeded(openDBRequest, ev) {
        throw Error('not implemented onupgradeneeded');
    }
    ;
    onVersionChanged(p_db, ev) {
        throw Error('not implemented onversionchanged');
    }
    ;
    onBlocked(openDBRequest, ev) {
        throw Error('not implemented onversionchanged');
    }
    ;
    close() {
        if (this.m_db) {
            this.m_db.close();
            this.m_db = null;
        }
    }
    static { this.ɵfac = function IndexedDBService_Factory(t) { return new (t || IndexedDBService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IndexedDBService, factory: IndexedDBService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IndexedDBService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ColumnResizerComponent {
    constructor() {
        this.mouseDown = new EventEmitter;
        this.dblClick = new EventEmitter;
        this.touchStart = new EventEmitter;
    }
    resizer_MouseDown(event) {
        this.mouseDown.emit(event);
    }
    resizer_DblClick(event) {
        this.dblClick.emit(event);
    }
    resizer_TouchStart(event) {
        this.touchStart.emit(event);
    }
    static { this.ɵfac = function ColumnResizerComponent_Factory(t) { return new (t || ColumnResizerComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ColumnResizerComponent, selectors: [["ebootis-column-resizer"]], inputs: { id: "id" }, outputs: { mouseDown: "mouseDown", dblClick: "dblClick", touchStart: "touchStart" }, decls: 1, vars: 1, consts: [[1, "resize-holder", 3, "id", "click", "mousedown", "dblclick", "touchstart"]], template: function ColumnResizerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "span", 0);
            i0.ɵɵlistener("click", function ColumnResizerComponent_Template_span_click_0_listener($event) { return $event.stopPropagation(); })("mousedown", function ColumnResizerComponent_Template_span_mousedown_0_listener($event) { $event.stopPropagation(); return ctx.resizer_MouseDown($event); })("dblclick", function ColumnResizerComponent_Template_span_dblclick_0_listener($event) { $event.stopPropagation(); return ctx.resizer_DblClick($event); })("touchstart", function ColumnResizerComponent_Template_span_touchstart_0_listener($event) { $event.stopPropagation(); return ctx.resizer_TouchStart($event); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("id", ctx.id);
        } }, styles: ["[_nghost-%COMP%]{display:flex;min-height:inherit;height:100%}span.resize-holder[_ngcontent-%COMP%]{cursor:col-resize;background-color:#e9e9e9;width:3px;min-width:1px;max-width:5px;margin-left:5px;margin-right:5px;z-index:2}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ColumnResizerComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-column-resizer', template: `
  <!--$event.stopPropagation() sorgt dafür, dass matSorts o.ä. nicht ausgelöst werden-->
             <span [id]="id" class="resize-holder" 
                (click)="$event.stopPropagation();"
                (mousedown)="$event.stopPropagation();resizer_MouseDown($event)" 
                (dblclick)="$event.stopPropagation();resizer_DblClick($event)"
                (touchstart)="$event.stopPropagation();resizer_TouchStart($event)">
             </span>
             `, styles: [":host{display:flex;min-height:inherit;height:100%}span.resize-holder{cursor:col-resize;background-color:#e9e9e9;width:3px;min-width:1px;max-width:5px;margin-left:5px;margin-right:5px;z-index:2}\n"] }]
    }], null, { id: [{
            type: Input
        }], mouseDown: [{
            type: Output
        }], dblClick: [{
            type: Output
        }], touchStart: [{
            type: Output
        }] }); })();

class ResizeObservable extends Observable {
    constructor(observeElement) {
        super(subscriber => {
            const resizeObserver = new ResizeObserver(entries => {
                subscriber.next(entries);
            });
            resizeObserver.observe(observeElement);
            return function unsubscribe() {
                resizeObserver.unobserve(observeElement);
                resizeObserver.disconnect();
            };
        });
    }
}

class TableMenuComponent {
    constructor(resizeColumnIntl) {
        this.resizeColumnIntl = resizeColumnIntl;
        this.reorganizeColumnsClicked = new EventEmitter();
        this.distributeEvenlyClicked = new EventEmitter();
        this.distributeAccordingToContentClicked = new EventEmitter();
        if (this.resizeColumnIntl) {
            this.m_resizeColumnIntl = this.resizeColumnIntl;
        }
        else {
            this.m_resizeColumnIntl = new TableIntl();
        }
    }
    ngOnInit() {
    }
    distributeAccordingToContent_Click() {
        this.distributeAccordingToContentClicked.emit();
    }
    distributeEvenly_Click() {
        this.distributeEvenlyClicked.emit();
    }
    reorganizeColumns_Click() {
        this.reorganizeColumnsClicked.emit();
    }
    static { this.ɵfac = function TableMenuComponent_Factory(t) { return new (t || TableMenuComponent)(i0.ɵɵdirectiveInject(TableIntl, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TableMenuComponent, selectors: [["ebootis-table-menu"]], outputs: { reorganizeColumnsClicked: "reorganizeColumnsClicked", distributeEvenlyClicked: "distributeEvenlyClicked", distributeAccordingToContentClicked: "distributeAccordingToContentClicked" }, decls: 21, vars: 4, consts: [[1, "mat-menu-three-dots"], ["mat-icon-button", "", "type", "button", 3, "matMenuTriggerFor", "click"], ["menu", ""], ["mat-menu-item", "", "type", "button", 3, "click"], [2, "transform", "rotate(90deg)"]], template: function TableMenuComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
            i0.ɵɵlistener("click", function TableMenuComponent_Template_button_click_1_listener($event) { return $event.stopPropagation(); });
            i0.ɵɵelementStart(2, "mat-icon");
            i0.ɵɵtext(3, "more_vert");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "mat-menu", null, 2)(6, "button", 3);
            i0.ɵɵlistener("click", function TableMenuComponent_Template_button_click_6_listener() { return ctx.distributeEvenly_Click(); });
            i0.ɵɵelementStart(7, "mat-icon", 4);
            i0.ɵɵtext(8, "format_line_spacing");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "span");
            i0.ɵɵtext(10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(11, "button", 3);
            i0.ɵɵlistener("click", function TableMenuComponent_Template_button_click_11_listener() { return ctx.distributeAccordingToContent_Click(); });
            i0.ɵɵelementStart(12, "mat-icon", 4);
            i0.ɵɵtext(13, "expand");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "span");
            i0.ɵɵtext(15);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(16, "button", 3);
            i0.ɵɵlistener("click", function TableMenuComponent_Template_button_click_16_listener() { return ctx.reorganizeColumns_Click(); });
            i0.ɵɵelementStart(17, "mat-icon");
            i0.ɵɵtext(18, "settings");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(19, "span");
            i0.ɵɵtext(20);
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            const _r0 = i0.ɵɵreference(5);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("matMenuTriggerFor", _r0);
            i0.ɵɵadvance(9);
            i0.ɵɵtextInterpolate(ctx.m_resizeColumnIntl.distributeColumnsEvenly);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.m_resizeColumnIntl.setColumnWidthToMinContent);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.m_resizeColumnIntl.reorganizeColumns);
        } }, dependencies: [i3.MatIcon, i3$2.MatIconButton, i4$1.MatMenu, i4$1.MatMenuItem, i4$1.MatMenuTrigger], styles: [".mat-menu-three-dots[_ngcontent-%COMP%]{display:flex;align-items:center;min-height:inherit;width:min-content!important;max-width:20px;min-width:20px;width:20px}.mat-menu-three-dots[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{width:20px;padding:0}.mat-menu-three-dots[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{width:20px;display:flex;align-items:center;font-size:20px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableMenuComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-table-menu', template: `
    <div class="mat-menu-three-dots">
        <!--$event.stopPropagation() sorgt dafür, dass matSorts o.ä. nicht ausgelöst werden-->
        <button mat-icon-button [matMenuTriggerFor]="menu" type="button" (click)="$event.stopPropagation();">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu>
            <button mat-menu-item (click)="distributeEvenly_Click()" type="button">
                <mat-icon style="transform: rotate(90deg)">format_line_spacing</mat-icon>
                <span>{{m_resizeColumnIntl.distributeColumnsEvenly}}</span>
            </button>        
            <button mat-menu-item (click)="distributeAccordingToContent_Click()" type="button">
                <mat-icon style="transform: rotate(90deg)">expand</mat-icon>
                <span>{{m_resizeColumnIntl.setColumnWidthToMinContent}}</span>
            </button>
            <button mat-menu-item (click)="reorganizeColumns_Click()" type="button">
            <mat-icon>settings</mat-icon>
            <span>{{m_resizeColumnIntl.reorganizeColumns}}</span>
            </button>
        </mat-menu>
    </div>
    `, styles: [".mat-menu-three-dots{display:flex;align-items:center;min-height:inherit;width:min-content!important;max-width:20px;min-width:20px;width:20px}.mat-menu-three-dots button{width:20px;padding:0}.mat-menu-three-dots mat-icon{width:20px;display:flex;align-items:center;font-size:20px}\n"] }]
    }], function () { return [{ type: TableIntl, decorators: [{
                type: Optional
            }] }]; }, { reorganizeColumnsClicked: [{
            type: Output
        }], distributeEvenlyClicked: [{
            type: Output
        }], distributeAccordingToContentClicked: [{
            type: Output
        }] }); })();

class ResizeColumnDirective {
    /**
     * @deprecated This array is no longer used, since it is reflected in the column definition.
     */
    set displayedColumns(p_value) {
        this.m_displayedColumns = p_value;
    }
    ;
    set userSettings(p_value) {
        if (p_value && this.tableName) {
            this.m_userSettings = p_value;
            let tableSettings = this.m_userSettingsService.getTableSettings(this.m_userSettings, this.tableName);
            this.m_columnSettings = tableSettings.columnSettings;
            this.changeWidthType(tableSettings.columnWidthType);
        }
        if (!this.m_columnSettings)
            this.m_columnSettings = [];
        if (!this.m_widthType) {
            if (this.m_columnSettings?.length > 0)
                this.changeWidthType('width-px');
            else
                this.changeWidthType('evenly');
        }
    }
    constructor(m_userSettingsService, renderer, viewContainerRef, content, dialog, m_loggerService, el) {
        this.m_userSettingsService = m_userSettingsService;
        this.renderer = renderer;
        this.viewContainerRef = viewContainerRef;
        this.content = content;
        this.dialog = dialog;
        this.m_loggerService = m_loggerService;
        this.el = el;
        this.userSettingsChanged = new EventEmitter();
        this.m_subscriptionsSubject = new Subject();
        this.MAT_HEADER_ROW_CLASS = 'mat-mdc-header-row';
        this.MAT_HEADER_CELL_CLASS = 'mat-mdc-header-cell';
        this.MAT_HEADER_CELL_SORT_CONTAINER_CLASS = 'mat-sort-header-container';
        this.MAT_HEADER_CELL_SORT_CONTENT_CLASS = 'mat-sort-header-content';
        this.MAT_ROW_CLASS = 'mat-mdc-row';
        this.MAT_FOOTER_ROW_CLASS = 'mat-mdc-footer-row';
        this.BOOTSTRAP_WIDTH_100_CLASS = 'w-100';
        this.RESIZABLE_TABLE_CLASS = 'resizable-table';
        this.RESIZING_CLASS = 'resizing';
        this.EBO_HEADER_TEXT = 'ebo-header-text';
        this.EBO_RESIZER_NODE_NAME = 'ebootis-column-resizer';
        this.EBO_MENU_NODE_NAME = 'ebootis-table-menu';
        // Die minimale Breite des Elementes, dass den Textinhalter des Spaltenheaders enthält
        this.MIN_HEADER_CONTENT_WIDTH = 15;
        this.m_columnSettings = [];
        this.changeWidthType('width-px');
    }
    /* #region lifecycles */
    ngOnInit() {
    }
    ngAfterViewInit() {
        this.m_table = this.el.nativeElement;
        this.m_table.id = this.tableName;
        this.m_headerRow = this.m_table.childNodes[0];
        this.m_tableWidthOld = this.m_table.parentElement.offsetWidth - this.tableBorderWidth;
        this.m_tableContainsW100 = this.m_table.classList.contains(this.BOOTSTRAP_WIDTH_100_CLASS);
        if (!this.m_tableContainsW100 && this.m_widthType == 'evenly')
            this.m_table.classList.add(this.BOOTSTRAP_WIDTH_100_CLASS);
        // Auf Änderungen der MatTable achten
        this.content.observe(this.m_table)
            .pipe(switchMap((mutationRecords) => {
            let isRelevant = false;
            mutationRecords.some((mutationRecord) => {
                mutationRecord.addedNodes.forEach((node) => {
                    if (node.nodeName.includes('MAT-ROW') ||
                        node.nodeName.includes('MAT-CELL') ||
                        node.nodeName.includes('MAT-HEADER')) {
                        isRelevant = true;
                    }
                });
                return isRelevant;
            });
            return of(isRelevant);
        }))
            .pipe(filter((relevantChange) => relevantChange == true))
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe({
            next: (tableShouldResize) => {
                if (this.m_table.childNodes[0] != this.m_headerRow) {
                    this.m_headerRow = this.m_table.childNodes[0];
                    this.initTable();
                }
                this.applyColSettings();
            },
            error: (err) => {
                this.m_loggerService.logError({ title: 'Error when table element changed for ' + this.tableName, entry: err, context: this.getLogContextBuilder('ngAfterViewInit').get() });
            }
        });
        this.resizeObserver = new ResizeObservable(this.m_table);
        this.resizeObserver
            .pipe(debounceTime(200))
            .pipe(filter((entries) => {
            return this.m_widthType == 'evenly' && entries?.length > 0
                && entries[0].contentRect.width != this.m_tableWidthOld;
        }))
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe({
            next: (entries) => {
                this.m_tableWidthOld = this.m_table.parentElement.offsetWidth;
                this.distributeColumnsEvenly();
            },
            error: (err) => {
                this.m_loggerService.logError({ title: 'Error when table resized for ' + this.tableName, entry: err, context: this.getLogContextBuilder('ngAfterViewInit').get() });
            }
        });
        this.renderer.addClass(this.m_table, this.RESIZABLE_TABLE_CLASS);
        /**
         * Der setTimeout sorgt hier dafür, dass Angular zuerst die initialen Werte registriert (nach dem ngAfterViewInit).
         * Diese werden dann nachträglich (per timeout) geändert.
         * Darüber bekommt Angular die Änderung mit und kann die View bei Bedarf aktualisieren.
         * Ansonsten kommt der Fehler "NG0100: Expression has changed after it was checked".
         */
        setTimeout(() => {
            this.initTable();
            this.applyColSettings();
        });
    }
    ngOnDestroy() {
        this.m_subscriptionsSubject.next();
        this.m_subscriptionsSubject.complete();
    }
    /* #endregion lifecycles */
    /* #region initialize */
    initTable() {
        this.initMenu();
        this.initResizers();
        if (this.mouseMoveSubscription)
            this.mouseMoveSubscription.unsubscribe();
        this.mouseMoveSubscription = fromEvent(this.m_headerRow, 'mousemove')
            .pipe(takeUntil(this.m_subscriptionsSubject))
            //   .pipe(sampleTime(500))
            .subscribe((e) => this.onMouseMove(e));
        this.m_headerRow.addEventListener("mouseup", (e) => this.onMouseUp(e));
        // this.m_headerRow.addEventListener("touchmove", (e) => this.onTouchMove(e));
        // this.m_headerRow.addEventListener("touchend", (e) => this.onTouchEnd(e));
        // this.m_headerRow.addEventListener("touchcancel", (e) => this.onTouchCancel(e));
    }
    /** Fügt einen Schieber zu jeder Spalte der Tabelle hinzu.
     * Achtung: Kann nicht innerhalb der HeaderCells gemacht werden,
     * da das MatSort Click-Event (noch) nicht unterbunden werden kann (Stand 09/2022)*/
    initResizers() {
        this.headerCells.forEach((headerCell) => {
            if (!this.hasHeaderCellMenuOrResizer(headerCell, 'resizer')) {
                const resizerComp = this.viewContainerRef.createComponent(ColumnResizerComponent).instance;
                this.registerEvent(resizerComp.mouseDown, (event) => this.onMouseDown(event));
                this.registerEvent(resizerComp.dblClick, (event) => this.onDoubleClick(event));
                // this.registerEvent(resizerComp.touchStart, (event: TouchEvent) => this.onTouchStart(event));
                resizerComp.id = `${this.getCellName(headerCell)}-resizer`;
                this.renderer.appendChild(headerCell, this.m_table.nextSibling);
            }
        });
    }
    /** Fügt ein Hamburger-Menü für die Tabellen-Einstellungen hinzu.
     * Es befindet sich zwischen der letzten HeaderCell und ihrem Resizer. */
    initMenu() {
        if (this.headerCells?.length > 0) {
            const hasMenu = this.headerCells.some(headerCell => this.hasHeaderCellMenuOrResizer(headerCell, 'menu'));
            if (!hasMenu) {
                let menuComponent = this.viewContainerRef.createComponent(TableMenuComponent).instance;
                this.registerEvent(menuComponent.distributeEvenlyClicked, () => this.onDistributeEvenlyClicked());
                this.registerEvent(menuComponent.reorganizeColumnsClicked, () => this.onReorganizeColumnsClicked());
                this.registerEvent(menuComponent.distributeAccordingToContentClicked, () => this.onDistributeAccordingToContentClicked());
                this.renderer.appendChild(this.headerCells[this.headerCells.length - 1] /** Letzte MatHeaderCell */, this.m_table.nextSibling);
            }
        }
    }
    registerEvent(p_emitter, p_callback) {
        p_emitter.pipe(takeUntil(this.m_subscriptionsSubject)).subscribe(p_callback);
    }
    /* #endregion initialize */
    /* #region menu click events */
    /**
     * Menüpunkt: Spalten gleichmäßig verteilen
     * Wenn die Spalten manuell zurückgesetzt wurden, muss dies in den UserSettings festgehalten werden
     */
    onDistributeEvenlyClicked() {
        this.changeWidthType('evenly');
        this.distributeColumnsEvenly();
        this.updateUserSettings();
    }
    /* Menüpunkt: Spaltenbreite an Inhalt anpassen */
    onDistributeAccordingToContentClicked() {
        this.changeWidthType('max-content');
        this.distributeAccordingToContent();
        this.updateUserSettings();
    }
    /* Menüpunkt: Spalten verwalten */
    onReorganizeColumnsClicked() {
        // Wenn es noch keine Settings zum Bearbeiten gibt, müssen zunächst die übersetzten HeaderCell-Texte gespeichert werden
        // Denn wenn sie via Dlg ausgeblendet werden, muss der Text trotzdem angezeigt werden
        this.headerCells.forEach((headerCell, colIndex) => {
            let colName = this.getCellName(headerCell);
            let colSetting = this.m_columnSettings.find(setting => setting.colName == colName);
            let displayedText = headerCell.textContent;
            // Iconname des 3 Punkt Menüs
            if (displayedText.includes('more_vert')) {
                displayedText = displayedText.replace('more_vert', '');
            }
            // evtl. Leerzeichen weg
            displayedText = displayedText.trim();
            if (!colSetting) // Neue Spalte
                this.m_columnSettings.push({ colName: colName, hidden: false, order: colIndex, translation: displayedText });
            else if (displayedText && (colSetting.hidden || !colSetting.translation || colSetting.translation != displayedText))
                colSetting.translation = displayedText; // angezeigter String hat sich verändert
        });
        let openDlg = this.dialog.open(ReorganizeColumnsDlgComponent, {
            disableClose: true,
            data: {
                tableSettings: this.m_userSettingsService.getTableSettings(this.m_userSettings, this.tableName)
            },
            panelClass: ['limited-size']
        });
        openDlg
            .afterClosed()
            .subscribe({
            next: (updatedColumnSettings) => {
                if (updatedColumnSettings) {
                    this.m_columnSettings = updatedColumnSettings;
                    this.saveUserSettings();
                }
            },
            error: () => { }
        });
    }
    /* #endregion menu click events */
    /* #region resize logic */
    /** Setzt das Flex aller Zellen auf 'initial'
     * und dann die Breiten entsprechend der Settings */
    applyColSettings() {
        switch (this.m_widthType) {
            case "evenly":
                this.distributeColumnsEvenly();
                break;
            case "max-content":
                this.distributeAccordingToContent();
                break;
            case "width-px":
                this.distributeColumnsBySettingWidth();
                break;
            default:
                const exhaustiveCheck = this.m_widthType;
                this.m_loggerService.logError({
                    title: 'Error no action defined for type',
                    parameters: [{ title: 'TableName', entry: this.tableName }, { title: 'widthType', entry: exhaustiveCheck }],
                    context: this.getLogContextBuilder('applyColSettings').get()
                });
        }
        this.updateUserSettings();
    }
    distributeColumnsBySettingWidth() {
        this.headerCells.forEach((headerCell, cellIndex) => {
            let minWidth = 0;
            let headerIndexWithResizers = this.headerCells.findIndex(hCell => hCell == headerCell);
            let colName = this.getCellName(headerCell);
            let colSettings = this.m_columnSettings.find(setting => setting.colName == colName);
            this.rows.forEach((row) => {
                let columnIndex = cellIndex;
                if (this.isHeaderRow(row))
                    columnIndex = headerIndexWithResizers;
                let cell = this.getCell(row, columnIndex);
                if (colSettings?.width) {
                    let cellWidth = colSettings.width;
                    this.setWidth(cell, cellWidth);
                    if (this.isHeaderRow(row))
                        this.setHeaderContentWidth(cell, cellWidth);
                }
                else {
                    this.setMinContentWidth(cell);
                    let colWidth = cell.offsetWidth;
                    minWidth = minWidth < colWidth ? colWidth : minWidth;
                }
            });
            if (!colSettings?.width) {
                if (colSettings)
                    colSettings.width = minWidth;
                this.rows.forEach((row) => {
                    let columnIndex = cellIndex;
                    let width = minWidth;
                    if (this.isHeaderRow(row)) {
                        columnIndex = headerIndexWithResizers;
                        width = minWidth;
                    }
                    this.getCell(row, columnIndex).style.width = `${width}px`;
                });
            }
        });
    }
    /** Verteilt alle Spalten gleichmäßig */
    distributeColumnsEvenly() {
        const numberOfTableColumns = this.headerCells?.length ?? 0;
        if (numberOfTableColumns > 0) {
            let availableWidth = this.m_table.offsetWidth - this.tableBorderWidth;
            let cellWidth = availableWidth / numberOfTableColumns;
            let cellWidthArray = [];
            this.headerCells.forEach((headerCell) => {
                if (headerCell.className.includes(this.MAT_HEADER_CELL_CLASS)) {
                    const { contentElement, constantWidth } = this.getHeaderTextAndConstantWidth(headerCell);
                    const minContentWidth = constantWidth + this.MIN_HEADER_CONTENT_WIDTH;
                    cellWidthArray.push(Math.max(cellWidth, minContentWidth));
                }
            });
            this.rows.forEach((row) => {
                if (this.isHeaderRow(row)) {
                    let idx = 0;
                    this.getCells(row).forEach((cell) => {
                        // Angular generiert auch mal Comments o.ä., die im Weg sein könnten
                        if (cell.className.includes(this.MAT_HEADER_CELL_CLASS)) {
                            this.setWidth(cell, cellWidthArray[idx]);
                            this.setHeaderContentWidth(cell, cellWidthArray[idx]);
                            idx++;
                        }
                    });
                }
                else {
                    this.getCells(row).forEach((cell, idx) => {
                        this.setWidth(cell, cellWidthArray[idx]);
                    });
                }
            });
        }
    }
    /**
     * Setzt erst alle Zellen auf Content-Breite,
     * um die Breite der Zelle mit dem längsten Inhalt herauszufinden.
     * Passt dann alle Zellen an die Breite der Zelle mit dem längsten Inhalt an
     */
    distributeAccordingToContent() {
        // Für jede Spalte
        this.headerCells.forEach((headerCell) => {
            this.setColumnWidthToMinContentWidth(headerCell);
        });
    }
    setColumnWidthToMinContentWidth(headerCell) {
        const columnIndex = this.headerCells.findIndex(cell => cell == headerCell);
        let minWidth = 0;
        this.rows.forEach((row) => {
            const cell = this.getCell(row, columnIndex);
            if (this.isHeaderRow(row))
                this.setMinContentWidth(this.getHeaderCellContentElement(cell));
            this.setMinContentWidth(cell);
            minWidth = Math.max(minWidth, cell.offsetWidth);
        });
        minWidth += this.tableBorderWidth;
        this.setHeaderContentWidth(headerCell, minWidth);
        this.rows.forEach((row) => {
            this.setWidth(this.getCell(row, columnIndex), minWidth);
        });
    }
    setWidth(cell, width) {
        if (cell && width > 0) {
            cell.style.minWidth = `${width}px`;
            cell.style.flex = 'initial';
            cell.style.width = `${width}px`;
            cell.style.wordBreak = 'initial';
        }
    }
    /**
     * Setzt die Breite des Spalteninhalts.
     * D.h. [Gesamt Breite] - [Breite des Sort-Headers] - [Breite des Resizers] - [Breite Menü (wenn vorhanden)]
     * @param headerCell
     * @param width
     */
    setHeaderContentWidth(headerCell, width) {
        let textElemAndWidth = this.getHeaderTextAndConstantWidth(headerCell);
        if (textElemAndWidth?.contentElement) {
            const remainingWidth = width - textElemAndWidth.constantWidth;
            if (remainingWidth > 0)
                this.setWidth(textElemAndWidth.contentElement, remainingWidth);
        }
    }
    getHeaderTextAndConstantWidth(headerCell) {
        // Das Child-Element, dass den Text enthält
        let contentElement;
        // Die Breite der Elemente, die keinen Text enthalten. z.B. Sortheader, Resizer, Drei-Punkte-Menü
        let nonTextWidth = 0;
        // Padding zählt zur Breite des Elementes -> Padding von der HeaderCell abziehen
        const computedStyles = window.getComputedStyle(headerCell);
        nonTextWidth += parseFloat(computedStyles.getPropertyValue('padding-left')) ?? 0;
        nonTextWidth += parseFloat(computedStyles.getPropertyValue('padding-right')) ?? 0;
        const addElemntWidth = (elem) => {
            const computedStyles = window.getComputedStyle(elem);
            nonTextWidth += parseFloat(computedStyles.getPropertyValue('width')) ?? 0;
            nonTextWidth += parseFloat(computedStyles.getPropertyValue('margin-left')) ?? 0;
            nonTextWidth += parseFloat(computedStyles.getPropertyValue('margin-right')) ?? 0;
        };
        this.getChildrenAsArray(headerCell).forEach(firstLevelChild => {
            if (firstLevelChild.classList.contains(this.MAT_HEADER_CELL_SORT_CONTAINER_CLASS)) {
                this.getChildrenAsArray(firstLevelChild).forEach(secondLevelChild => {
                    if (secondLevelChild.classList.contains(this.MAT_HEADER_CELL_SORT_CONTENT_CLASS))
                        contentElement = secondLevelChild;
                    else
                        addElemntWidth(secondLevelChild);
                });
            }
            else if (firstLevelChild.classList.contains(this.EBO_HEADER_TEXT)) {
                contentElement = firstLevelChild;
            }
            else if (firstLevelChild.nodeName.toLowerCase() == 'ebootis-column-resizer')
                this.getChildrenAsArray(firstLevelChild).forEach(resizerChild => addElemntWidth(resizerChild));
            else
                addElemntWidth(firstLevelChild);
        });
        return { contentElement: contentElement, constantWidth: nonTextWidth };
    }
    getHeaderCellContentElement(headerCell) {
        let contentElement;
        // .some(...) wird hier als Abbruch-Bedingung verwendet, damit nicht alle Element durchsucht werden
        this.getChildrenAsArray(headerCell).some(firstLevelChild => {
            if (firstLevelChild.classList.contains(this.MAT_HEADER_CELL_SORT_CONTAINER_CLASS)) {
                this.getChildrenAsArray(firstLevelChild).some(secondLevelChild => {
                    if (secondLevelChild.classList.contains(this.MAT_HEADER_CELL_SORT_CONTENT_CLASS))
                        contentElement = secondLevelChild;
                    return !!contentElement;
                });
            }
            else if (firstLevelChild.classList.contains(this.EBO_HEADER_TEXT))
                contentElement = firstLevelChild;
            return !!contentElement;
        });
        return contentElement;
    }
    setMinContentWidth(cell) {
        if (cell) {
            cell.style.wordBreak = 'initial';
            cell.style.whiteSpace = 'nowrap';
            cell.style.minWidth = 'min-content';
            cell.style.width = 'min-content';
            cell.style.flex = 'initial';
        }
    }
    ;
    /* #endregion resize logic */
    /* #region mouse & touch events */
    onMouseDown(event) {
        event.preventDefault();
        this.resizeStart(event.pageX, event.target.id);
    }
    ;
    /* private onTouchStart(event: TouchEvent): void {
      event.preventDefault();
      this.resizeStart(event.targetTouches[0].pageX, event.target['id']);
    }; */
    onMouseMove(event) {
        if (this.m_isPressed && event.buttons) {
            this.resizeMove(event.pageX);
        }
    }
    ;
    /* private onTouchMove(event: TouchEvent): void {
      if (this.m_isPressed && event.targetTouches.length > 0) {
        this.resizeMove(event.targetTouches[0].pageX);
      }
    } */
    onMouseUp(event) {
        event.preventDefault();
        this.resizeStop(event.pageX);
    }
    ;
    /* private onTouchEnd(event: TouchEvent): void {
      this.resizeStop(event.changedTouches[0].pageX);
    }
  
    private onTouchCancel(event: TouchEvent): void {
      if (this.m_isPressed)
        this.resetResize();
    } */
    onDoubleClick(event) {
        this.changeWidthType('width-px');
        let resizer = event.target;
        let cellName = resizer.id.split('-resizer')[0];
        const headerCell = this.headerCells.find((cell) => this.checkCell(cell, cellName));
        this.setColumnWidthToMinContentWidth(headerCell);
        this.updateUserSettings();
    }
    ;
    /* #endregion mouse & touch events */
    /* #region resize actions */
    resizeStart(xCoord, resizerElemId) {
        this.changeWidthType('width-px');
        this.m_isPressed = true;
        let cellName = resizerElemId.split('-')[0]; //Name zB amount-resizer
        const headerCell = this.headerCells.find((cell) => this.getCellName(cell) == cellName);
        const textElemAndWidth = this.getHeaderTextAndConstantWidth(headerCell);
        this.m_resizeHeader = {
            element: headerCell,
            startPosition: xCoord,
            width: headerCell.offsetWidth,
            constantWidth: textElemAndWidth.constantWidth,
            contentElement: textElemAndWidth.contentElement,
            rowCells: []
        };
        this.renderer.addClass(headerCell, this.RESIZING_CLASS);
        let columnIndex = this.headerCells.findIndex(headerCell => headerCell == this.m_resizeHeader.element);
        this.rows.forEach((row) => {
            if (this.isNotHeaderRow(row)) {
                const cellInResizeColumn = this.getCell(row, columnIndex);
                this.renderer.addClass(cellInResizeColumn, this.RESIZING_CLASS);
                this.m_resizeHeader.rowCells.push(cellInResizeColumn);
            }
        });
    }
    resizeMove(xCoord) {
        this.doResize(xCoord);
    }
    resizeStop(xCoord) {
        if (this.m_isPressed) {
            this.doResize(xCoord);
            this.resetResize();
            this.updateUserSettings();
        }
    }
    doResize(xCoord) {
        if (this.m_resizeHeader) {
            const manualResizeWidth = this.m_resizeHeader.width + (xCoord - this.m_resizeHeader.startPosition);
            const minContentWidth = this.m_resizeHeader.constantWidth + this.MIN_HEADER_CONTENT_WIDTH;
            const resizeWidth = Math.max(manualResizeWidth, minContentWidth);
            this.setWidth(this.m_resizeHeader.element, resizeWidth);
            if (this.m_resizeHeader.contentElement) {
                const remainingWidth = resizeWidth - this.m_resizeHeader.constantWidth;
                if (remainingWidth > 0)
                    this.setWidth(this.m_resizeHeader.contentElement, remainingWidth);
                else {
                    this.m_loggerService.logError({
                        title: 'Cannot resize elemnt to less than zero pixels',
                        parameters: [
                            { title: 'Column', entry: this.getCellName(this.m_resizeHeader.element) },
                            { title: 'manualResizeWidth', entry: manualResizeWidth },
                            { title: 'minContentWidth', entry: minContentWidth },
                            { title: 'remainingWidth', entry: remainingWidth }
                        ],
                        context: this.getLogContextBuilder('saveUserSettings').get()
                    });
                }
            }
            this.m_resizeHeader.rowCells.forEach((cell) => this.setWidth(cell, resizeWidth));
        }
    }
    resetResize() {
        this.m_isPressed = false;
        if (this.m_resizeHeader) {
            this.renderer.removeClass(this.m_resizeHeader.element, this.RESIZING_CLASS);
            this.m_resizeHeader.rowCells.forEach((cell) => this.renderer.removeClass(cell, this.RESIZING_CLASS));
        }
        this.m_resizeHeader = null;
    }
    /* #endregion resize actions */
    /* #region userSettings */
    updateUserSettings() {
        this.headerCells.forEach((headerCell) => {
            let name = this.getCellName(headerCell);
            let colSettingsIndex = this.m_columnSettings.findIndex(settings => settings.colName == name);
            let widthInPixel = headerCell.style.width != '' ? Number(headerCell.style.width.split('px')[0]) : headerCell.scrollWidth;
            if (colSettingsIndex != -1)
                this.m_columnSettings[colSettingsIndex].width = widthInPixel;
            else
                this.m_columnSettings.push({ colName: name, width: widthInPixel, order: this.m_columnSettings?.length });
        });
        let tableSettings = this.m_userSettingsService.getTableSettings(this.m_userSettings, this.tableName);
        if (tableSettings)
            tableSettings.columnWidthType = this.m_widthType;
        this.saveUserSettings();
    }
    saveUserSettings() {
        if (this.m_userSettings) {
            this.m_userSettingsService.saveUserSettings(this.m_userSettings)
                .pipe(take(1))
                .subscribe({
                next: (res) => {
                    this.userSettingsChanged.emit(this.m_userSettings);
                },
                error: (err) => {
                    this.m_loggerService.logError({
                        parameters: [{ title: 'usersettings', entry: this.m_userSettings }],
                        entry: err,
                        context: this.getLogContextBuilder('saveUserSettings').get()
                    });
                }
            });
        }
    }
    /* #endregion userSettings */
    /* #region Convenience */
    /** Gibt die HeaderCells in einem Array zurück */
    get headerCells() {
        return this.getChildrenAsArray(this.m_headerRow);
    }
    /** Gibt die Rows der Tabelle als Array zurück */
    get rows() {
        return this.getChildrenAsArray(this.m_table);
    }
    getCells(p_row) {
        return this.getChildrenAsArray(p_row);
    }
    getChildrenAsArray(p_element) {
        return Array.from(p_element.children);
    }
    getCell(p_row, index) {
        return p_row.children[index];
    }
    isHeaderRow(p_row) {
        return p_row.className.includes(this.MAT_HEADER_ROW_CLASS);
    }
    isHeaderCell(p_row) {
        return p_row.className.includes(this.MAT_HEADER_CELL_CLASS);
    }
    isNotHeaderRow(p_row) {
        return p_row.className.includes(this.MAT_ROW_CLASS) || p_row.className.includes(this.MAT_FOOTER_ROW_CLASS);
    }
    hasHeaderCellMenuOrResizer(p_headerCell, p_type) {
        const nodeNameToSearch = (p_type === 'menu' ? this.EBO_MENU_NODE_NAME : this.EBO_RESIZER_NODE_NAME).toLowerCase();
        if (this.isHeaderCell(p_headerCell)) {
            return this.getCells(p_headerCell).some(headerChild => {
                return headerChild.nodeName?.toLowerCase() === nodeNameToSearch;
            });
        }
        return false;
    }
    checkCell(p_cell, p_name, p_isHeader) {
        let checkResult = p_cell != null; // prüft implizit auf != undefined
        if (p_name)
            checkResult &&= p_cell.className.includes(p_name);
        if (p_isHeader != undefined)
            checkResult &&= p_cell.className.includes(this.MAT_HEADER_CELL_CLASS);
        return checkResult;
    }
    getCellName(p_cell) {
        return p_cell.className.split(' ').find(cls => cls.includes('mat-column-'))?.split('mat-column-')[1];
    }
    changeWidthType(p_widthType) {
        this.m_widthType = p_widthType;
        if (this.m_tableContainsW100 == false) {
            // Diese Klasse nur anpassen, wenn sie nicht gewollt enthalten ist.
            if (p_widthType == 'evenly')
                this.m_table.classList.add(this.BOOTSTRAP_WIDTH_100_CLASS);
            else
                this.m_table.classList.remove(this.BOOTSTRAP_WIDTH_100_CLASS);
        }
    }
    get tableBorderWidth() {
        let totalBorderInPx = 0;
        if (this.m_table) {
            const computedStyles = window.getComputedStyle(this.m_table);
            const borderLeftPx = parseFloat(computedStyles.getPropertyValue('border-left-width')) ?? 0;
            const borderRightPx = parseFloat(computedStyles.getPropertyValue('border-right-width')) ?? 0;
            totalBorderInPx = borderLeftPx + borderRightPx;
        }
        else {
            this.m_loggerService.logError({
                title: 'Table not found',
                context: this.getLogContextBuilder('tableBorderWidth').get()
            });
        }
        return totalBorderInPx;
    }
    getLogContextBuilder(p_functionName) {
        return LogContextBuilder.getInstance('resize-column.directive.ts', 'ResizeColumnDirective', p_functionName);
    }
    static { this.ɵfac = function ResizeColumnDirective_Factory(t) { return new (t || ResizeColumnDirective)(i0.ɵɵdirectiveInject(UserSettingsService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i2$1.ContentObserver), i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(LoggerService), i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ResizeColumnDirective, selectors: [["", "resizeable", ""]], inputs: { resizable: ["resizeable", "resizable"], displayedColumns: "displayedColumns", tableName: "tableName", userSettings: "userSettings" }, outputs: { userSettingsChanged: "userSettingsChanged" } }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResizeColumnDirective, [{
        type: Directive,
        args: [{
                selector: "[resizeable]"
            }]
    }], function () { return [{ type: UserSettingsService }, { type: i0.Renderer2 }, { type: i0.ViewContainerRef }, { type: i2$1.ContentObserver }, { type: i1.MatDialog }, { type: LoggerService }, { type: i0.ElementRef }]; }, { resizable: [{
            type: Input,
            args: ["resizeable"]
        }], displayedColumns: [{
            type: Input
        }], tableName: [{
            type: Input
        }], userSettings: [{
            type: Input
        }], userSettingsChanged: [{
            type: Output
        }] }); })();

const STORAGE_CONFIG = new InjectionToken('STORAGE_CONFIG');

class StorageService {
    constructor(baseHref, storageConfig) {
        this.baseHref = baseHref;
        this.storageConfig = storageConfig;
        this.m_baseHref = this.baseHref.replace(/(\/(en|de)\/)/, '/');
    }
    setItem(p_storage, p_key, p_value) {
        const prfx = this.getPrefix();
        try {
            if (p_storage == 'local') {
                localStorage.setItem(`${this.m_baseHref}${prfx}${p_key}`, p_value);
            }
            else if (p_storage == 'session') {
                sessionStorage.setItem(`${this.m_baseHref}${prfx}${p_key}`, p_value);
            }
        }
        catch (err) {
            console.log(`Error encountered while trying to call setItem for ${p_storage}, key: ${p_key}, value: ${p_value}`);
            throw new Error(err);
        }
    }
    getItem(p_storage, p_key) {
        const prfx = this.getPrefix();
        if (p_storage == 'local') {
            return localStorage.getItem(`${this.m_baseHref}${prfx}${p_key}`);
        }
        else if (p_storage == 'session') {
            return sessionStorage.getItem(`${this.m_baseHref}${prfx}${p_key}`);
        }
    }
    removeItem(p_storage, p_key) {
        const prfx = this.getPrefix();
        if (p_storage == 'local') {
            return localStorage.removeItem(`${this.m_baseHref}${prfx}${p_key}`);
        }
        else if (p_storage == 'session') {
            return sessionStorage.removeItem(`${this.m_baseHref}${prfx}${p_key}`);
        }
    }
    clear(p_storage) {
        if (p_storage == 'local') {
            localStorage.clear();
        }
        else if (p_storage == 'session') {
            sessionStorage.clear();
        }
    }
    getPrefix() {
        let prfx = '';
        if (this.storageConfig.getPrefix() && this.storageConfig.getPrefix() != '') {
            prfx = this.storageConfig.getPrefix();
            if (!prfx.endsWith('/'))
                prfx += '/';
        }
        return prfx;
    }
    static { this.ɵfac = function StorageService_Factory(t) { return new (t || StorageService)(i0.ɵɵinject(APP_BASE_HREF), i0.ɵɵinject(STORAGE_CONFIG)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: StorageService, factory: StorageService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StorageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [APP_BASE_HREF]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [STORAGE_CONFIG]
            }] }]; }, null); })();

class UserSettingsDefaultDbService {
    constructor(storageService) {
        this.storageService = storageService;
    }
    get(p_ctx) {
        return new Observable((os) => {
            let jsonString = this.storageService.getItem('local', 'UserSettings/' + p_ctx);
            if (jsonString) {
                os.next(JSON.parse(jsonString));
                os.complete();
            }
            else {
                os.next(null);
                os.complete();
            }
        });
    }
    post(p_settings) {
        return new Observable((os) => {
            this.storageService.setItem('local', 'UserSettings/' + p_settings.id, JSON.stringify(p_settings));
            os.next('UserSettings/' + p_settings.id);
            os.complete();
        });
    }
    static { this.ɵfac = function UserSettingsDefaultDbService_Factory(t) { return new (t || UserSettingsDefaultDbService)(i0.ɵɵinject(StorageService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UserSettingsDefaultDbService, factory: UserSettingsDefaultDbService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserSettingsDefaultDbService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: StorageService }]; }, null); })();

/**
 * Standardimplementierung des ILoggerFormatService
 *
 * @class
 */
class LoggerFormatService {
    formatMessage(p_msg) {
        if (!p_msg || typeof (p_msg) === 'string') {
            // bei einem String machen wir aktuell nichts
            return p_msg;
        }
        else {
            // Kopie des Objekts erstellen und dem entsprechend "formatieren". Zum Beispiel Properties entfernen, Werte kürzen usw.
            // deep clone (langsam) evtl. structuredClone() Methode nutzen
            const clone = JSON.parse(JSON.stringify(p_msg));
            // Default formatierungen
            // Base64 String kürzen
            if (clone?.serviceParms?.tlob?.data) {
                clone.serviceParms.tlob.data = this.shortenBlobData(p_msg.serviceParms.tlob.data);
            }
            return JSON.stringify(clone); // String Ausgabe des Objekts
        }
    }
    formatTitle(p_title) {
        return p_title;
    }
    formatParameters(p_parameters) {
        return p_parameters;
    }
    /**
     * Gibt den Logeintrag als zusammengesetzten, formatierten String zurück.
     */
    formatLogEntry(p_logEntry) {
        let formatString = formatDate(p_logEntry.date, 'dd.MM.yyyy HH:mm', 'de-DE');
        let title = [];
        let details = [];
        if (p_logEntry.title)
            title.push(p_logEntry.title);
        if (LogContextHelper.hasValues(p_logEntry.context))
            details.push('Kontext: ' + LogContextHelper.contextToString(p_logEntry.context, true));
        if (p_logEntry.entry) {
            if (typeof p_logEntry.entry === 'string')
                title.push(p_logEntry.entry);
            else
                details.push('Entry: ' + p_logEntry.entry);
        }
        if (p_logEntry.parameters)
            details.push('Parameter: ' + JSON.stringify(p_logEntry.parameters));
        if (p_logEntry.stack)
            details.push('Stack: ' + p_logEntry.stack.join('||'));
        if (title.length > 0)
            formatString += ': ' + title.join(' - ');
        if (details.length > 0)
            formatString += ' [' + details.join('; ') + ']';
        return formatString;
    }
    /** Nur die ersten 15 Zeichen des Blobs anzeigen */
    shortenBlobData(p_data) {
        return `${p_data.slice(0, 15)}...`;
    }
    static { this.ɵfac = function LoggerFormatService_Factory(t) { return new (t || LoggerFormatService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoggerFormatService, factory: LoggerFormatService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoggerFormatService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

/**
 * Klasse mit Einstellungsmöglichkeiten für @see NetworkLogger
 *
 * Einbinding via Provider
 *
 * `
 * {
      provide: NetworkOnlineConfig,
      useExisting: MyNetworkOnlineConfig
    }`
 *
 * `@Injectable({
 * 		providedIn: 'root
 * })`
 * export class MyNetworkOnlineConfig extends NetworkOnlineConfig {
 * 	...
 * }
 */
class NetworkLoggerConfig {
    /*private*/ constructor() { }
    /**
     * Gibt an ob Netwerkrequests welche über einen HttpInterceptor ausgewertet werden, protokolliert werden sollen.
     * Default: nein
     * @returns ja/nein
     */
    protocolRequests() {
        return false;
    }
    // /**
    //  * Gibt an ob Netzwerk Statusänderungen festgehalten werden sollen.
    //  * Default: false
    //  * @returns ja/nein
    //  */
    // protocolConnectionChange(): boolean {
    // 	return false;
    // }
    // /**
    //  * Gibt die Menge an ConnectionChange Objekte an die maximal festgehalten werden können.
    //  * Ist die max. Menge erreicht, wird das erste Elemente entfernt sodass Platz für ein neues Element vorhanden ist.
    //  * Default: 50
    //  * @returns
    //  */
    // maxAmountOfNetworkStatusChangeEntries(): number {
    // 	return 50;
    // }
    /**
     * Gibt die Menge an NetworkLog's Objekten an, die maximal festgehalten werden können.
     * Ist die max. Menge erreicht, wird das erste Elemente entfernt sodass Platz für ein neues Element vorhanden ist.
     * Default: 100
     * @returns
     */
    maxAmountOfHttpRequestsEntries() {
        return 100;
    }
    static { this.ɵfac = function NetworkLoggerConfig_Factory(t) { return new (t || NetworkLoggerConfig)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NetworkLoggerConfig, factory: NetworkLoggerConfig.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NetworkLoggerConfig, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 *
 */
var NetworkLogLevel;
(function (NetworkLogLevel) {
    NetworkLogLevel["DEBUG"] = "DEBUG";
    NetworkLogLevel["ERROR"] = "ERROR";
    NetworkLogLevel["RESPONSE"] = "RESPONSE";
})(NetworkLogLevel || (NetworkLogLevel = {}));
/**
 * Dieser Service ermöglicht das Protokollieren von Netzwerkrequests.
 *
 * Um dies zu aktivieren ist eine eigene Implementation der @see NetworkLoggerConfig nötig.
 */
class NetworkLogger {
    constructor(networkConfig) {
        this.networkConfig = networkConfig;
    }
    /**
     * Lazy Initialisierung des Subjects und Observables, im Ctor eigentlich fehl am Platz, da die Protokollierung erst während der Laufzeit aktiviert werden könnte.
     * @returns Protokollierung aktiv?
     */
    protocolRequests() {
        const protolReqs = this.networkConfig.protocolRequests();
        if (!this.logsSubject && !this.logs$ && protolReqs) {
            this.logsSubject = new BehaviorSubject([]);
            this.logs$ = this.logsSubject.asObservable();
        }
        return protolReqs;
    }
    /**
     * Methode zur Protokollierung einer Netwerkzustands Änderung: Offline -> Online, Online -> Offline mit Timestamp
     * @param p_online
     */
    protocolNetworkStatusChange(p_online) {
        // if (this.networkConfig.protocolConnectionChange()) {
        // 	const currentStatus: ConnectionChange[] = this.networkStatusCSubject.value;
        // 	// wenn Länge gleich unser Config limit ist, Platz für einen Eintrag machen und ersten Eintrag rauswerfen
        // 	if (currentStatus.length === this.networkConfig.maxAmountOfNetworkStatusChangeEntries()) {
        // 		currentStatus.shift(); // FIFO - First in, first out
        // 	}
        // 	currentStatus.push({ date: new Date(), isOnline: p_online });
        // 	// neue gesamt Struktur ins Subject
        // 	this.networkStatusCSubject.next(currentStatus);
        // }
    }
    addRequest(p_requestUrlWithParams) {
        if (this.protocolRequests()) {
            const currentRequests = this.logsSubject.value;
            // wenn Länge gleich unser Config limit ist, Platz für einen Eintrag machen und ersten Eintrag rauswerfen
            if (currentRequests.length === this.networkConfig.maxAmountOfHttpRequestsEntries()) {
                currentRequests.shift(); // FIFO - First in, first out
            }
            currentRequests.push({
                requestUrl: p_requestUrlWithParams,
                timestamp: new Date(),
            });
            // neue gesamt Struktur ins Subject
            this.logsSubject.next(currentRequests);
        }
    }
    setResponse(p_requestUrl, p_response, p_logLevel) {
        if (this.protocolRequests()) {
            const currentRequests = this.logsSubject.value;
            const index = currentRequests.findIndex(entry => entry.requestUrl === p_requestUrl);
            if (index > -1) {
                currentRequests[index].response = p_response;
                currentRequests[index].logLevel = p_logLevel;
                this.logsSubject.next(currentRequests);
            }
        }
    }
    clear() {
        this.logsSubject.next([]);
    }
    static { this.ɵfac = function NetworkLogger_Factory(t) { return new (t || NetworkLogger)(i0.ɵɵinject(NetworkLoggerConfig)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NetworkLogger, factory: NetworkLogger.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NetworkLogger, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: NetworkLoggerConfig }]; }, null); })();

class ResponseDetailDlgIntl {
    constructor() {
        this.changes = new Subject();
        this.title = 'Http-Response Details';
        this.close = 'Schließen';
        this.timestamp = ' Zeitstempel';
    }
    static { this.ɵfac = function ResponseDetailDlgIntl_Factory(t) { return new (t || ResponseDetailDlgIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ResponseDetailDlgIntl, factory: ResponseDetailDlgIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResponseDetailDlgIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

class ResponseDetailDlgComponent {
    constructor(m_data, intl) {
        this.m_data = m_data;
        this.intl = intl;
        this.m_subscriptionsSubject = new Subject();
        this.m_logEntry = this.m_data[0];
        if (this.intl) {
            this.m_intl = intl;
        }
        else {
            this.m_intl = new ResponseDetailDlgIntl();
        }
    }
    ngOnInit() {
    }
    ngOnDestroy() {
        this.m_subscriptionsSubject.next();
        this.m_subscriptionsSubject.complete();
    }
    static { this.ɵfac = function ResponseDetailDlgComponent_Factory(t) { return new (t || ResponseDetailDlgComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(ResponseDetailDlgIntl, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ResponseDetailDlgComponent, selectors: [["app-response-detail-dlg"]], decls: 20, vars: 14, consts: [["mat-dialog-title", "", 1, "ebo-dialog-header"], [1, "ebo-dialog-title"], ["mat-icon-button", "", "type", "button", "mat-dialog-close", "", 3, "aria-label"], [1, "d-flex", "flex-fill", "flex-column"], [1, "overflow-auto"], [1, "ebo-dialog-actions"], ["mat-button", "", "type", "button", "mat-dialog-close", ""]], template: function ResponseDetailDlgComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0)(1, "span", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "button", 2)(4, "mat-icon");
            i0.ɵɵtext(5, "close");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(6, "mat-dialog-content", 3)(7, "p");
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "p");
            i0.ɵɵtext(10);
            i0.ɵɵpipe(11, "date");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "div");
            i0.ɵɵelement(13, "hr");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "pre", 4);
            i0.ɵɵtext(15);
            i0.ɵɵpipe(16, "json");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "mat-dialog-actions", 5)(18, "button", 6);
            i0.ɵɵtext(19);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.m_intl.title, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("aria-label", ctx.m_intl.close);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate3("", ctx.m_logEntry.requestUrl, " - ", ctx.m_logEntry == null ? null : ctx.m_logEntry.response == null ? null : ctx.m_logEntry.response.statusText, " (", ctx.m_logEntry == null ? null : ctx.m_logEntry.response == null ? null : ctx.m_logEntry.response.status, ")");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate2("", ctx.m_intl.timestamp, ": ", i0.ɵɵpipeBind2(11, 9, ctx.m_logEntry.timestamp, "dd.MM.yyyy - HH:mm"), "");
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 12, ctx.m_logEntry.response.body));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.m_intl.close);
        } }, dependencies: [i3.MatIcon, i3$2.MatButton, i3$2.MatIconButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, i1$1.JsonPipe, i1$1.DatePipe], styles: ["[_nghost-%COMP%]{width:100%;display:flex;flex-direction:column}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResponseDetailDlgComponent, [{
        type: Component,
        args: [{ selector: 'app-response-detail-dlg', template: "<h1 mat-dialog-title class=\"ebo-dialog-header\">\n  <span class=\"ebo-dialog-title\">\n    {{m_intl.title}}\n  </span>\n  <button mat-icon-button type=\"button\" aria-label=\"{{m_intl.close}}\" mat-dialog-close>\n    <mat-icon>close</mat-icon>\n  </button>\n  <!--Todo: Searchfield, das das JSON-Array durchsucht, ggf. die Stelle farblich hinterlegt und zu ihr scrollt-->\n</h1>\n<mat-dialog-content class=\"d-flex flex-fill flex-column\">\n  <p>{{m_logEntry.requestUrl}} - {{m_logEntry?.response?.statusText}} ({{m_logEntry?.response?.status}})</p>\n  <p>{{m_intl.timestamp}}: {{m_logEntry.timestamp | date: 'dd.MM.yyyy - HH:mm'}}</p>\n  <div>\n    <hr />\n  </div>\n  <pre class=\"overflow-auto\">{{m_logEntry.response.body|json}}</pre>\n</mat-dialog-content>\n<mat-dialog-actions class=\"ebo-dialog-actions\">\n  <button mat-button type=\"button\" mat-dialog-close>{{m_intl.close}}</button>\n</mat-dialog-actions>", styles: [":host{width:100%;display:flex;flex-direction:column}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: ResponseDetailDlgIntl, decorators: [{
                type: Optional
            }] }]; }, null); })();

class NetworkConsoleIntl {
    constructor() {
        this.changes = new Subject();
        this.debug = 'Allgemein';
        this.error = 'Fehlerhaft';
        this.success = 'Erfolgreich';
        this.entries = 'Einträge';
        this.entriesFailed = 'Fehlerhafte';
        this.entriesSuccessful = 'Erfolgreiche';
        this.filter = 'Filter';
        this.searchTerm = 'Suche';
        this.clear = 'Löschen';
        this.copyToClipboard = 'In Zwischenablage kopieren';
    }
    static { this.ɵfac = function NetworkConsoleIntl_Factory(t) { return new (t || NetworkConsoleIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NetworkConsoleIntl, factory: NetworkConsoleIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NetworkConsoleIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

class NetworkConsoleClassPipe {
    transform(p_level) {
        let className;
        switch (p_level) {
            case NetworkLogLevel.ERROR:
                className = 'error-text';
                break;
            case NetworkLogLevel.RESPONSE:
                className = 'success';
                break;
            case NetworkLogLevel.DEBUG:
            default:
                // keine besondere Class
                break;
        }
        return className;
    }
    static { this.ɵfac = function NetworkConsoleClassPipe_Factory(t) { return new (t || NetworkConsoleClassPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "networkLogClass", type: NetworkConsoleClassPipe, pure: true }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NetworkConsoleClassPipe, [{
        type: Pipe,
        args: [{
                name: 'networkLogClass',
                pure: true,
            }]
    }], null, null); })();

const _c0$2 = ["networkLogScrollViewer"];
function NetworkConsoleComponent_div_4_mat_option_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const logLevel_r9 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", logLevel_r9);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.getLogLevelTranslation(logLevel_r9), " ");
} }
function NetworkConsoleComponent_div_4_mat_icon_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 18);
} }
function NetworkConsoleComponent_div_4_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 19);
    i0.ɵɵlistener("click", function NetworkConsoleComponent_div_4_ng_template_14_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.clearSearchField_Click()); });
    i0.ɵɵtext(1, "close");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r8.m_intl.clear);
    i0.ɵɵproperty("hidden", !ctx_r8.m_networkLogSearchTermCtrl.value || ctx_r8.m_networkLogSearchTermCtrl.value == "");
    i0.ɵɵattribute("aria-label", ctx_r8.m_intl.clear);
} }
function NetworkConsoleComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 6)(2, "mat-form-field", 7)(3, "mat-label");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-select", 8);
    i0.ɵɵlistener("selectionChange", function NetworkConsoleComponent_div_4_Template_mat_select_selectionChange_5_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.filterLogs()); });
    i0.ɵɵtemplate(6, NetworkConsoleComponent_div_4_mat_option_6_Template, 2, 2, "mat-option", 9);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 6)(8, "mat-form-field", 7)(9, "mat-label");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "input", 10, 11);
    i0.ɵɵlistener("input", function NetworkConsoleComponent_div_4_Template_input_input_11_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.filterLogs()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, NetworkConsoleComponent_div_4_mat_icon_13_Template, 1, 0, "mat-icon", 12);
    i0.ɵɵtemplate(14, NetworkConsoleComponent_div_4_ng_template_14_Template, 2, 3, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 14)(17, "button", 15);
    i0.ɵɵlistener("click", function NetworkConsoleComponent_div_4_Template_button_click_17_listener() { i0.ɵɵrestoreView(_r13); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.clearNetworkLogs_Click()); });
    i0.ɵɵelementStart(18, "mat-icon", 16);
    i0.ɵɵtext(19, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r7 = i0.ɵɵreference(15);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.m_intl.filter);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControl", ctx_r0.m_logLevelFilterCtrl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.NETWORK_LOG_LEVELS);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.m_intl.searchTerm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControl", ctx_r0.m_networkLogSearchTermCtrl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.m_networkLogSearchTermCtrl.value || ctx_r0.m_networkLogSearchTermCtrl.value == "")("ngIfElse", _r7);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", !ctx_r0.m_networkLogs || ctx_r0.m_networkLogs.length <= 0);
    i0.ɵɵattribute("aria-label", ctx_r0.m_intl.clear);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.m_intl.clear, " ");
} }
function NetworkConsoleComponent_div_5_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25)(1, "div", 26);
    i0.ɵɵpipe(2, "networkLogClass");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 27);
    i0.ɵɵlistener("click", function NetworkConsoleComponent_div_5_div_7_Template_button_click_4_listener() { const restoredCtx = i0.ɵɵrestoreView(_r19); const logEntry_r17 = restoredCtx.$implicit; const ctx_r18 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r18.showResponseDetails_Click(logEntry_r17)); });
    i0.ɵɵpipe(5, "networkLogClass");
    i0.ɵɵelementStart(6, "mat-icon");
    i0.ɵɵtext(7, "open_in_new");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const logEntry_r17 = ctx.$implicit;
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(i0.ɵɵpipeBind1(2, 6, logEntry_r17.logLevel));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.getEntryString(logEntry_r17), " ");
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(i0.ɵɵpipeBind1(5, 8, logEntry_r17.logLevel));
    i0.ɵɵproperty("disabled", ctx_r16.m_isLoadingResponseDetails);
} }
function NetworkConsoleComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21)(2, "button", 22);
    i0.ɵɵlistener("click", function NetworkConsoleComponent_div_5_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.copyLogsToClipboard()); });
    i0.ɵɵelementStart(3, "mat-icon", 16);
    i0.ɵɵtext(4, "content_copy");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 23);
    i0.ɵɵtemplate(7, NetworkConsoleComponent_div_5_div_7_Template, 8, 10, "div", 24);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", ctx_r1.m_intl.clear);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.m_intl.copyToClipboard, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.m_filteredLogs);
} }
function NetworkConsoleComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ui-placeholder");
} }
class NetworkConsoleComponent {
    constructor(m_networkLogger, m_loggerService, m_filterBySearchStringPipe, m_changeDetector, m_dialog, m_clipboard, intl) {
        this.m_networkLogger = m_networkLogger;
        this.m_loggerService = m_loggerService;
        this.m_filterBySearchStringPipe = m_filterBySearchStringPipe;
        this.m_changeDetector = m_changeDetector;
        this.m_dialog = m_dialog;
        this.m_clipboard = m_clipboard;
        this.intl = intl;
        /** alle NetworkLogs */
        this.m_networkLogs = [];
        this.NETWORK_LOG_LEVELS = [NetworkLogLevel.DEBUG, NetworkLogLevel.ERROR, NetworkLogLevel.RESPONSE];
        this.m_logLevelFilterCtrl = new FormControl();
        this.m_networkLogSearchTermCtrl = new FormControl();
        this.m_isLoadingResponseDetails = false;
        this.m_subscriptionsSubject = new Subject();
        if (this.intl) {
            this.m_intl = intl;
        }
        else {
            this.m_intl = new NetworkConsoleIntl();
        }
    }
    ngOnInit() {
        this.m_logLevelFilterCtrl.patchValue([NetworkLogLevel.ERROR]);
        this.m_networkLogger.logs$
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe({
            next: (logs) => {
                this.m_networkLogs = logs;
                this.filterLogs();
            },
            error: (err) => {
                this.m_loggerService.logError({
                    title: 'networkConsole: Cannot get networkLogs from NetworkLoggerService',
                    entry: err,
                    context: this.getLogContextBuilder('ngOnInit').get()
                });
            }
        });
    }
    ngOnDestroy() {
        this.m_subscriptionsSubject.next();
        this.m_subscriptionsSubject.complete();
    }
    get headerTitel() {
        let countFailed = 0, countSuccess = 0;
        this.m_networkLogs.forEach(log => {
            if (log.logLevel === NetworkLogLevel.ERROR)
                countFailed++;
            else if (log.logLevel === NetworkLogLevel.RESPONSE)
                countSuccess++;
        });
        return `${this.m_networkLogs?.length ?? 0} ${this.m_intl.entries}, ${countFailed} ${this.m_intl.entriesFailed}, ${countSuccess} ${this.m_intl.entriesSuccessful}`;
    }
    getIsHttpResponse(p_logEntry) {
        return p_logEntry.response instanceof HttpResponse;
    }
    getIsHttpErrorResponse(p_logEntry) {
        return p_logEntry.response instanceof HttpErrorResponse;
    }
    getLogLevelTranslation(p_logLevel) {
        switch (p_logLevel) {
            case NetworkLogLevel.DEBUG:
                return this.m_intl.debug;
            case NetworkLogLevel.ERROR:
                return this.m_intl.error;
            case NetworkLogLevel.RESPONSE:
                return this.m_intl.success;
            default:
                throw new Error('unknown networkLogLevel');
        }
    }
    copyLogsToClipboard() {
        this.copyToClipboard(JSON.stringify(this.m_filteredLogs));
    }
    copyToClipboard(p_value) {
        const pending = this.m_clipboard.beginCopy(p_value);
        let remainingAttempts = 3;
        const attempt = () => {
            const result = pending.copy();
            if (!result && --remainingAttempts) {
                setTimeout(attempt);
            }
            else {
                pending.destroy();
            }
        };
        attempt();
    }
    filterLogs() {
        let logLevels = this.m_logLevelFilterCtrl ? this.m_logLevelFilterCtrl.value : [];
        let searchString = this.m_networkLogSearchTermCtrl ? this.m_networkLogSearchTermCtrl.value : null;
        let filteredLogs = this.m_networkLogs;
        if (logLevels?.length > 0) {
            filteredLogs = filteredLogs.filter(entry => logLevels.includes(entry.logLevel));
        }
        if (searchString) {
            filteredLogs = this.m_filterBySearchStringPipe.transform(filteredLogs, this.m_networkLogSearchTermCtrl?.value);
        }
        this.m_filteredLogs = filteredLogs;
    }
    onScrolled() {
        this.m_changeDetector.detectChanges();
    }
    scrollLogs_Click(p_scrollToTop) {
        let scrollIndex = p_scrollToTop ? 0 : this.m_filteredLogs?.length;
        this.m_logVirtualScroller.scrollToIndex(scrollIndex);
    }
    clearNetworkLogs_Click() {
        this.m_networkLogger.clear();
    }
    showResponseDetails_Click(p_logEntry) {
        this.m_isLoadingResponseDetails = true;
        let dlg = this.m_dialog.open(ResponseDetailDlgComponent, {
            hasBackdrop: true,
            panelClass: 'dialog-lg',
            disableClose: true,
            data: [p_logEntry]
        });
        dlg.afterClosed()
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe(() => this.m_isLoadingResponseDetails = false);
    }
    clearSearchField_Click() {
        this.m_networkLogSearchTermCtrl.reset();
    }
    getLogContextBuilder(p_functionName) {
        return LogContextBuilder.getInstance('network-console.component.ts', 'NetworkConsoleComponent', p_functionName);
    }
    getEntryString(p_logEntry) {
        let formatString = formatDate(p_logEntry.timestamp, 'dd.MM.yyyy HH:mm', 'de-DE');
        if (p_logEntry.logLevel != NetworkLogLevel.ERROR)
            formatString += ' ' + p_logEntry.requestUrl;
        if (p_logEntry.logLevel == NetworkLogLevel.ERROR && p_logEntry?.response?.error)
            formatString += ' ' + p_logEntry?.response?.error;
        if (p_logEntry.logLevel == NetworkLogLevel.RESPONSE) {
            if (p_logEntry?.response?.statusText)
                formatString += ' ' + p_logEntry?.response?.statusText;
            if (p_logEntry?.response?.status)
                formatString += ' ' + p_logEntry?.response?.status;
        }
        return formatString;
    }
    static { this.ɵfac = function NetworkConsoleComponent_Factory(t) { return new (t || NetworkConsoleComponent)(i0.ɵɵdirectiveInject(NetworkLogger), i0.ɵɵdirectiveInject(LoggerService), i0.ɵɵdirectiveInject(FilterBySearchStringPipe), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(i1$4.Clipboard), i0.ɵɵdirectiveInject(NetworkConsoleIntl, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NetworkConsoleComponent, selectors: [["ebootis-network-console"]], viewQuery: function NetworkConsoleComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$2, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.m_logVirtualScroller = _t.first);
        } }, decls: 8, vars: 4, consts: [[1, "container-fluid", "h-100", "d-flex", "flex-column"], [1, "row"], [1, "col", "ebo-tab-header"], ["class", "row", 4, "ngIf"], ["class", "d-flex flex-fill flex-column", 4, "ngIf", "ngIfElse"], ["placeholder", ""], [1, "col-12", "col-sm-6", "col-md-4", "col-lg-3"], ["appearance", "fill", 1, "w-100"], ["multiple", "", 3, "formControl", "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], ["matInput", "", 3, "formControl", "input"], ["logSearchStringCtrl", ""], ["matSuffix", "", 4, "ngIf", "ngIfElse"], ["clearSuffix", ""], [1, "col"], ["mat-button", "", "type", "button", "color", "warn", 1, "formfield-height", "float-end", 3, "disabled", "click"], [1, "pe-1"], [3, "value"], ["matSuffix", ""], ["tabindex", "-1", "matSuffix", "", 1, "clickable-icon", 3, "matTooltip", "hidden", "click"], [1, "d-flex", "flex-fill", "flex-column"], [1, "d-flex", "justify-content-between", "flex-wrap"], ["mat-button", "", "type", "button", 1, "mb-1", 3, "click"], [1, "flex-fill", "overflow-y-autos"], ["class", "d-flex align-items-center", 4, "ngFor", "ngForOf"], [1, "d-flex", "align-items-center"], [1, "flex-fill", "listItemContent"], ["mat-icon-button", "", 1, "ebo-sm-icon-button", "float-end", 3, "disabled", "click"]], template: function NetworkConsoleComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h2", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(4, NetworkConsoleComponent_div_4_Template, 21, 10, "div", 3);
            i0.ɵɵtemplate(5, NetworkConsoleComponent_div_5_Template, 8, 3, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, NetworkConsoleComponent_ng_template_6_Template, 1, 0, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r2 = i0.ɵɵreference(7);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.headerTitel, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.m_networkLogs);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.m_filteredLogs == null ? null : ctx.m_filteredLogs.length) > 0)("ngIfElse", _r2);
        } }, dependencies: [i1$1.NgForOf, i1$1.NgIf, i8$2.PlaceholderComponent, i3.MatIcon, i4.MatTooltip, i2.MatFormField, i2.MatLabel, i2.MatSuffix, i3$1.MatInput, i13.MatSelect, i8.MatOption, i6.DefaultValueAccessor, i6.NgControlStatus, i6.FormControlDirective, i3$2.MatButton, i3$2.MatIconButton, NetworkConsoleClassPipe], styles: [".small-height[_ngcontent-%COMP%]{height:36px}.listItemContent[_ngcontent-%COMP%]{display:inline-block;font-size:14px}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NetworkConsoleComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-network-console', template: "<div class=\"container-fluid h-100 d-flex flex-column\">\n  <div class=\"row\">\n    <h2 class=\"col ebo-tab-header\">\n      {{headerTitel}}\n    </h2>\n  </div>\n  <div class=\"row\" *ngIf=\"m_networkLogs\">\n    <div class=\"col-12 col-sm-6 col-md-4 col-lg-3\">\n      <mat-form-field appearance=\"fill\" class=\"w-100\">\n        <mat-label>{{m_intl.filter}}</mat-label>\n        <mat-select multiple [formControl]=\"m_logLevelFilterCtrl\" (selectionChange)=\"filterLogs()\">\n          <mat-option *ngFor=\"let logLevel of NETWORK_LOG_LEVELS\" [value]=\"logLevel\">\n            {{getLogLevelTranslation(logLevel)}}\n          </mat-option>\n        </mat-select>\n      </mat-form-field>\n    </div>\n    <div class=\"col-12 col-sm-6 col-md-4 col-lg-3\">\n      <mat-form-field appearance=\"fill\" class=\"w-100\">\n        <mat-label>{{m_intl.searchTerm}}</mat-label>\n        <input matInput #logSearchStringCtrl [formControl]=\"m_networkLogSearchTermCtrl\" (input)=\"filterLogs()\">\n        <mat-icon matSuffix\n                  *ngIf=\"!m_networkLogSearchTermCtrl.value || m_networkLogSearchTermCtrl.value==''; else clearSuffix\">\n        </mat-icon>\n        <ng-template #clearSuffix>\n          <mat-icon tabindex=\"-1\" matTooltip=\"{{m_intl.clear}}\"\n                    attr.aria-label=\"{{m_intl.clear}}\" matSuffix class=\"clickable-icon\"\n                    [hidden]=\"!m_networkLogSearchTermCtrl.value || m_networkLogSearchTermCtrl.value==''\"\n                    (click)=\"clearSearchField_Click()\">close</mat-icon>\n        </ng-template>\n      </mat-form-field>\n    </div>\n    <div class=\"col\">\n      <button mat-button type=\"button\" color=\"warn\" (click)=\"clearNetworkLogs_Click()\"\n              [disabled]=\"!m_networkLogs || m_networkLogs.length<=0\"\n              attr.aria-label=\"{{m_intl.clear}}\" class=\"formfield-height float-end\">\n        <mat-icon class=\"pe-1\">delete</mat-icon>\n        {{m_intl.clear}}\n      </button>\n    </div>\n  </div>\n  <div *ngIf=\"m_filteredLogs?.length>0; else placeholder\" class=\"d-flex flex-fill flex-column\">\n    <div class=\"d-flex justify-content-between flex-wrap\">\n      <button mat-button type=\"button\" (click)=\"copyLogsToClipboard()\"\n              attr.aria-label=\"{{m_intl.clear}}\" class=\"mb-1\">\n        <mat-icon class=\"pe-1\">content_copy</mat-icon> {{m_intl.copyToClipboard}}\n      </button>\n    </div>\n    <div class=\"flex-fill overflow-y-autos\">\n      <div *ngFor=\"let logEntry of m_filteredLogs\" class=\"d-flex align-items-center\">\n        <div class=\"flex-fill listItemContent\" [class]=\"logEntry.logLevel | networkLogClass\">\n          {{getEntryString(logEntry)}}\n        </div>\n        <button mat-icon-button [disabled]=\"m_isLoadingResponseDetails\" class=\"ebo-sm-icon-button float-end\"\n                [class]=\"logEntry.logLevel | networkLogClass\"\n                (click)=\"showResponseDetails_Click(logEntry)\">\n          <mat-icon>open_in_new</mat-icon>\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n<ng-template #placeholder>\n  <ui-placeholder></ui-placeholder>\n</ng-template>", styles: [".small-height{height:36px}.listItemContent{display:inline-block;font-size:14px}\n"] }]
    }], function () { return [{ type: NetworkLogger }, { type: LoggerService }, { type: FilterBySearchStringPipe }, { type: i0.ChangeDetectorRef }, { type: i1.MatDialog }, { type: i1$4.Clipboard }, { type: NetworkConsoleIntl, decorators: [{
                type: Optional
            }] }]; }, { m_logVirtualScroller: [{
            type: ViewChild,
            args: ['networkLogScrollViewer']
        }] }); })();

const ADMIN_CONSOLE_DATA = new InjectionToken('ADMIN_CONSOLE_DATA');

class AdminConsoleIntl {
    constructor() {
        this.changes = new Subject();
        // Strings für Tab "Allgemein"
        this.generalTabTitle = "Allgemein";
        this.softwareInfo = "Software-Info";
        this.revisionLabel = "Revision";
        this.databaseLabel = "Datenbank";
        // Strings für Tab "Ausstehende Nachrichten"
        this.pendingMessagesTabTitle = "Ausstehende Nachrichten";
        // Strings für Tab "Logs"
        this.logsTabTitle = "Logs";
        // Strings für Tab "Netzwerk"
        this.networkTabTitle = "Netzwerk";
        // Strings für Tab "Datenbank"
        this.databaseTabTitle = "Datenbank";
        // Strings für Tab "Speicher"
        this.storageTabTitle = 'Speicher';
        this.totalStorage = 'Gesamtspeicher';
        this.storageUsage = 'verwendeter Speicher';
        this.remainingStorage = 'freier Speicher';
        // Strings für Tab "ServiceWorker"
        this.serviceWorkerTabTitle = "ServiceWorker";
        this.serviceWorkerState = "Status";
        this.serviceWorkerNotAvailable = "ServiceWorker ist nicht verfügbar";
        // Allgemeine Strings
        this.copyToClipboard = "In zwischenablage kopieren";
        this.searchStringLabel = "Suchbegriff";
        this.passwordLabel = "Passwort";
    }
    static { this.ɵfac = function AdminConsoleIntl_Factory(t) { return new (t || AdminConsoleIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AdminConsoleIntl, factory: AdminConsoleIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AdminConsoleIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

class PendingMessagesIntl {
    constructor() {
        this.changes = new Subject();
        // Strings für Tab "Ausstehende Nachrichten"
        this.pendingMessagesHeader = "Ausstehende Nachrichten";
        this.uploadMessages = "Nachrichten hochladen";
        this.deleteAllMessages = "Alle Nachrichten löschen";
        this.noPendingMessages = "Keine ausstehenden Nachrichten";
        this.timeStampLabel = "Zeitstempel";
        this.lastTryLabel = "Letzter Versuch";
        this.stateLabel = "Status";
        this.parameterLabel = "Parameter";
        this.relationsLabel = "Relationen";
        this.deleteMessageLabel = "Nachricht löschen";
        this.messageStateNew = "Neu";
        this.messageStateFailed = "Fehlgeschlagen";
        this.messageStateDone = "Erfolgreich";
        this.wouldYouReallyLikeToPermanentlyDeleteAllPendingMessages = 'Möchten Sie wirklich alle ausstehenden Nachrichten unwiderruflich löschen?';
        this.deletePendingMessages = 'Ausstehende Nachrichten löschen';
        this.allMsgsCleared = 'Alle ausstehenden Nachrichten gelöscht';
        // Allgemeine Strings
        this.copyToClipboard = "In Zwischenablage kopieren";
        this.searchStringLabel = "Suchbegriff";
        this.passwordLabel = "Passwort";
    }
    static { this.ɵfac = function PendingMessagesIntl_Factory(t) { return new (t || PendingMessagesIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PendingMessagesIntl, factory: PendingMessagesIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PendingMessagesIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

var MessageState;
(function (MessageState) {
    MessageState["NEW"] = "NEW";
    MessageState["DONE"] = "DONE";
    MessageState["ALREADY_DONE"] = "ALREADY_DONE";
    MessageState["FAILED"] = "FAILED";
    MessageState["QUEUED"] = "QUEUED";
})(MessageState || (MessageState = {}));
class MessageQueue {
}

class NetworkOnlineService {
    constructor(networkLogger) {
        this.networkLogger = networkLogger;
        this.internalConnectionChanged = new BehaviorSubject(this.isOnline);
        this.networkOnline = this.internalConnectionChanged.asObservable();
        window.addEventListener('online', () => this.updateOnlineStatus());
        window.addEventListener('offline', () => this.updateOnlineStatus());
    }
    get isOnline() {
        return !!window.navigator.onLine;
    }
    updateOnlineStatus() {
        const onLine = window.navigator.onLine;
        this.internalConnectionChanged.next(onLine);
        this.networkLogger.protocolNetworkStatusChange(onLine);
    }
    static { this.ɵfac = function NetworkOnlineService_Factory(t) { return new (t || NetworkOnlineService)(i0.ɵɵinject(NetworkLogger)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NetworkOnlineService, factory: NetworkOnlineService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NetworkOnlineService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: NetworkLogger }]; }, null); })();

function PendingMessagesComponent_mat_icon_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, " outbox ");
    i0.ɵɵelementEnd();
} }
function PendingMessagesComponent_cdk_virtual_scroll_viewport_25_div_1_div_9_p_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const relation_r13 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", relation_r13, " ");
} }
function PendingMessagesComponent_cdk_virtual_scroll_viewport_25_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 24)(2, "h6", 20);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "pre", 25);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "json");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 24)(8, "h6", 20);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, PendingMessagesComponent_cdk_virtual_scroll_viewport_25_div_1_div_9_p_10_Template, 2, 1, "p", 26);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const msg_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r10.m_intl.parameterLabel, ":");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 4, ctx_r10.getServiceParms(msg_r8)));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", ctx_r10.m_intl.relationsLabel, ":");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", msg_r8.relations);
} }
function PendingMessagesComponent_cdk_virtual_scroll_viewport_25_div_1_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function PendingMessagesComponent_cdk_virtual_scroll_viewport_25_div_1_button_11_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r17); const msg_r8 = i0.ɵɵnextContext().$implicit; const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.deleteMessage_Click(msg_r8)); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r11.m_intl.deleteMessageLabel);
    i0.ɵɵattribute("aria-label", ctx_r11.m_intl.deleteMessageLabel);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.m_intl.deleteMessageLabel, " ");
} }
function PendingMessagesComponent_cdk_virtual_scroll_viewport_25_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "h6", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p", 20);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "date");
    i0.ɵɵpipe(6, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "mat-error", 20);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, PendingMessagesComponent_cdk_virtual_scroll_viewport_25_div_1_div_9_Template, 11, 6, "div", 21);
    i0.ɵɵelementStart(10, "div", 22);
    i0.ɵɵtemplate(11, PendingMessagesComponent_cdk_virtual_scroll_viewport_25_div_1_button_11_Template, 4, 3, "button", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "hr");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const msg_r8 = ctx.$implicit;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", msg_r8.serviceClass, ".", msg_r8.serviceMethod, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate6(" ", ctx_r7.m_intl.timeStampLabel, ": ", i0.ɵɵpipeBind2(5, 11, msg_r8.timestamp, "dd.MM.yyyy - HH:mm"), ", ", ctx_r7.m_intl.lastTryLabel, ": ", i0.ɵɵpipeBind2(6, 14, msg_r8.lastTry, "dd.MM.yyyy - HH:mm"), ", ", ctx_r7.m_intl.stateLabel, ": ", ctx_r7.getMessageStateText(msg_r8.messageState), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(msg_r8.errorMessage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.showDetails);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.isPasswordCorrect);
} }
function PendingMessagesComponent_cdk_virtual_scroll_viewport_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "cdk-virtual-scroll-viewport", 17);
    i0.ɵɵtemplate(1, PendingMessagesComponent_cdk_virtual_scroll_viewport_25_div_1_Template, 13, 17, "div", 18);
    i0.ɵɵpipe(2, "filterBySearchString");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(14);
    i0.ɵɵproperty("maxBufferPx", 1200)("minBufferPx", 1200);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("cdkVirtualForOf", i0.ɵɵpipeBind2(2, 4, ctx_r2.m_messages, _r0.value))("cdkVirtualForTemplateCacheSize", 0);
} }
function PendingMessagesComponent_ng_template_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ui-placeholder", 28);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerText", ctx_r4.m_intl.noPendingMessages);
} }
function PendingMessagesComponent_ng_template_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 29);
    i0.ɵɵtext(1, "\u00A0\n");
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 20);
} }
class PendingMessagesComponent {
    get passwordInput() {
        return this.passwordValue;
    }
    set passwordInput(p_value) {
        this.passwordValue = p_value;
    }
    constructor(m_offlineService, m_messageService, m_filterBySearchStringPipe, matDlg, m_loggerService, m_confirmationService, m_adminConsoleData, intl) {
        this.m_offlineService = m_offlineService;
        this.m_messageService = m_messageService;
        this.m_filterBySearchStringPipe = m_filterBySearchStringPipe;
        this.matDlg = matDlg;
        this.m_loggerService = m_loggerService;
        this.m_confirmationService = m_confirmationService;
        this.m_adminConsoleData = m_adminConsoleData;
        this.intl = intl;
        this.showDetails = true;
        this.passwordInputChanged = new EventEmitter();
        this.m_msgSearchStringCtrl = new FormControl();
        this.m_subscriptionsSubject = new Subject();
        this.m_logBaseCtx = { fileName: 'pending-messages.component.ts', className: 'PendingMessagesComponent' };
        if (this.intl) {
            this.m_intl = intl;
        }
        else {
            this.m_intl = new PendingMessagesIntl();
        }
    }
    ngOnInit() {
        this.m_offlineService.networkOnline
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe((isOnline) => { this.m_isOffline = !isOnline; });
        this.getMessages();
    }
    get isPasswordCorrect() {
        return this.passwordField?.isPasswordCorrect || false;
    }
    get filteredMessages() {
        return JSON.stringify(this.m_filterBySearchStringPipe.transform(this.m_messages, this.m_msgSearchStringCtrl.value));
    }
    refresh() {
        this.getMessages();
    }
    getMessages() {
        this.m_adminConsoleData.getPendingMessages()
            .pipe(take(1))
            .subscribe({
            next: (msgs) => {
                this.m_messages = msgs?.length > 0 ? [...msgs] : [];
            },
            error: (error) => {
                this.m_loggerService.logError({
                    entry: error,
                    context: { ...this.m_logBaseCtx, functionName: 'getMessages' }
                });
            }
        });
    }
    getServiceParms(p_msg) {
        if (p_msg.serviceParms?.tlob?.data) {
            p_msg.serviceParms.tlob.data = `${p_msg.serviceParms.tlob.data.slice(0, 15)}...`;
        }
        return p_msg.serviceParms;
    }
    getMessageStateText(p_msgState) {
        switch (p_msgState) {
            case MessageState.NEW:
                return this.m_intl.messageStateNew;
            case MessageState.FAILED:
                return this.m_intl.messageStateFailed;
            case MessageState.DONE:
                return this.m_intl.messageStateDone;
        }
        return '';
    }
    /* #region Events */
    workOnMessageQueue_Click() {
        this.m_adminConsoleData.workOnMessageQueue();
    }
    deleteAllMessages_Click() {
        this.m_confirmationService.openConfirmationDialog({
            message: this.m_intl.wouldYouReallyLikeToPermanentlyDeleteAllPendingMessages,
            title: this.m_intl.deletePendingMessages,
            isWarning: true
        })
            .pipe(switchMap((answer) => {
            if (answer)
                return this.m_adminConsoleData.deleteAllMessages()
                    .pipe(tap(() => this.m_messageService.showMessage(this.m_intl.allMsgsCleared, MessageType.success)));
            else
                return of(null);
        }))
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe({
            next: () => this.getMessages()
        });
    }
    deleteMessage_Click(p_msg) {
        this.m_adminConsoleData
            .deleteMessage(p_msg)
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe({
            next: () => this.getMessages()
        });
    }
    onPasswordValue_Change(p_newValue) {
        this.passwordValue = p_newValue;
        this.passwordInputChanged.emit(this.passwordValue);
    }
    static { this.ɵfac = function PendingMessagesComponent_Factory(t) { return new (t || PendingMessagesComponent)(i0.ɵɵdirectiveInject(NetworkOnlineService), i0.ɵɵdirectiveInject(MessageService), i0.ɵɵdirectiveInject(FilterBySearchStringPipe), i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(LoggerService), i0.ɵɵdirectiveInject(ConfirmationService), i0.ɵɵdirectiveInject(ADMIN_CONSOLE_DATA), i0.ɵɵdirectiveInject(PendingMessagesIntl, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PendingMessagesComponent, selectors: [["ebootis-pending-messages"]], viewQuery: function PendingMessagesComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(PasswordFieldContentComponent, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.passwordField = _t.first);
        } }, inputs: { isWorking: "isWorking", isLoading: "isLoading", showDetails: "showDetails", m_password: ["password", "m_password"], passwordInput: "passwordInput" }, outputs: { passwordInputChanged: "passwordInputChanged" }, decls: 30, vars: 20, consts: [[1, "container-fluid", "h-100", "d-flex", "flex-column"], [1, "row"], [1, "col", "ebo-tab-header"], [1, "headerSpan"], ["mat-icon-button", "", "type", "button", 3, "cdkCopyToClipboard", "matTooltip"], [1, "col-12", "col-sm-6", "col-md-4", "col-lg-3"], ["appearance", "fill", 1, "w-100"], ["matInput", "", 3, "formControl"], ["msgSearchStringCtrl", ""], [3, "password", "fieldLabel", "value", "valueChanged"], ["mat-button", "", "type", "button", "color", "warn", 1, "formfield-height", 3, "disabled", "click"], [1, "col"], ["mat-button", "", "type", "button", "color", "primary", 1, "formfield-height", "float-end", 3, "disabled", "click"], [4, "ngIf", "ngIfElse"], ["class", "d-flex flex-fill", "itemSize", "35", 3, "maxBufferPx", "minBufferPx", 4, "ngIf", "ngIfElse"], ["msgPlaceholder", ""], ["spinner", ""], ["itemSize", "35", 1, "d-flex", "flex-fill", 3, "maxBufferPx", "minBufferPx"], ["class", "mb-2", 4, "cdkVirtualFor", "cdkVirtualForOf", "cdkVirtualForTemplateCacheSize"], [1, "mb-2"], [1, "break"], ["class", "row", 4, "ngIf"], [1, "d-flex", "justify-content-between"], ["mat-button", "", "type", "button", "color", "warn", 3, "matTooltip", "click", 4, "ngIf"], [1, "col-12", "col-lg-6"], [1, "o-hidden", "break", "pre-wrap"], ["class", "break", 4, "ngFor", "ngForOf"], ["mat-button", "", "type", "button", "color", "warn", 3, "matTooltip", "click"], [1, "ms-3", 3, "innerText"], [1, "pe-1", 3, "diameter"]], template: function PendingMessagesComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h2", 2)(3, "span", 3);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "button", 4)(6, "mat-icon");
            i0.ɵɵtext(7, "content_copy");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(8, "div", 1)(9, "div", 5)(10, "mat-form-field", 6)(11, "mat-label");
            i0.ɵɵtext(12);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(13, "input", 7, 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(15, "div", 5)(16, "ebootis-password-field-content", 9);
            i0.ɵɵlistener("valueChanged", function PendingMessagesComponent_Template_ebootis_password_field_content_valueChanged_16_listener($event) { return ctx.onPasswordValue_Change($event); });
            i0.ɵɵelementStart(17, "button", 10);
            i0.ɵɵlistener("click", function PendingMessagesComponent_Template_button_click_17_listener() { return ctx.deleteAllMessages_Click(); });
            i0.ɵɵelementStart(18, "mat-icon");
            i0.ɵɵtext(19, "delete");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(20);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(21, "div", 11)(22, "button", 12);
            i0.ɵɵlistener("click", function PendingMessagesComponent_Template_button_click_22_listener() { return ctx.workOnMessageQueue_Click(); });
            i0.ɵɵtemplate(23, PendingMessagesComponent_mat_icon_23_Template, 2, 0, "mat-icon", 13);
            i0.ɵɵtext(24);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(25, PendingMessagesComponent_cdk_virtual_scroll_viewport_25_Template, 3, 7, "cdk-virtual-scroll-viewport", 14);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(26, PendingMessagesComponent_ng_template_26_Template, 1, 1, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(28, PendingMessagesComponent_ng_template_28_Template, 2, 1, "ng-template", null, 16, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r3 = i0.ɵɵreference(27);
            const _r5 = i0.ɵɵreference(29);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate2("", ctx.m_messages == null ? null : ctx.m_messages.length, " ", ctx.m_intl.pendingMessagesHeader, "");
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("matTooltip", ctx.m_intl.copyToClipboard);
            i0.ɵɵproperty("cdkCopyToClipboard", ctx.filteredMessages);
            i0.ɵɵattribute("aria-label", ctx.m_intl.copyToClipboard);
            i0.ɵɵadvance(7);
            i0.ɵɵtextInterpolate(ctx.m_intl.searchStringLabel);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControl", ctx.m_msgSearchStringCtrl);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("password", ctx.m_password)("fieldLabel", ctx.m_intl.passwordLabel)("value", ctx.passwordValue);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", ctx.isWorking || ctx.isLoading || (ctx.m_messages == null ? null : ctx.m_messages.length) <= 0);
            i0.ɵɵattribute("aria-label", ctx.m_intl.deleteAllMessages);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.m_intl.deleteAllMessages, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.m_isOffline || (ctx.m_messages == null ? null : ctx.m_messages.length) <= 0);
            i0.ɵɵattribute("aria-label", ctx.m_intl.uploadMessages);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.isWorking)("ngIfElse", _r5);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.m_intl.uploadMessages, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.m_messages == null ? null : ctx.m_messages.length) > 0)("ngIfElse", _r3);
        } }, dependencies: [i1$1.NgForOf, i1$1.NgIf, i8$2.PlaceholderComponent, i3.MatIcon, i4.MatTooltip, i2.MatFormField, i2.MatLabel, i2.MatError, i3$1.MatInput, i6.DefaultValueAccessor, i6.NgControlStatus, i6.FormControlDirective, i11.CdkFixedSizeVirtualScroll, i11.CdkVirtualForOf, i11.CdkVirtualScrollViewport, i1$4.CdkCopyToClipboard, i3$2.MatButton, i3$2.MatIconButton, i18.MatProgressSpinner, PasswordFieldContentComponent, i1$1.JsonPipe, i1$1.DatePipe, FilterBySearchStringPipe], styles: ["h2[_ngcontent-%COMP%] > .headerSpan[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;height:100%}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PendingMessagesComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-pending-messages', template: "<div class=\"container-fluid h-100 d-flex flex-column\">\n  <div class=\"row\">\n    <h2 class=\"col ebo-tab-header\">\n      <span class=\"headerSpan\">{{m_messages?.length}} {{m_intl.pendingMessagesHeader}}</span>\n      <button mat-icon-button type=\"button\" [cdkCopyToClipboard]=\"filteredMessages\"\n              matTooltip=\"{{m_intl.copyToClipboard}}\"\n              attr.aria-label=\"{{m_intl.copyToClipboard}}\">\n        <mat-icon>content_copy</mat-icon>\n      </button>\n    </h2>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-12 col-sm-6 col-md-4 col-lg-3\">\n      <mat-form-field appearance=\"fill\" class=\"w-100\">\n        <mat-label>{{m_intl.searchStringLabel}}</mat-label>\n        <input matInput #msgSearchStringCtrl [formControl]=\"m_msgSearchStringCtrl\">\n      </mat-form-field>\n    </div>\n    <div class=\"col-12 col-sm-6 col-md-4 col-lg-3\">\n      <ebootis-password-field-content [password]=\"m_password\" [fieldLabel]=\"m_intl.passwordLabel\" [value]=\"passwordValue\"\n                                      (valueChanged)=\"onPasswordValue_Change($event)\">\n        <button mat-button type=\"button\" color=\"warn\" class=\"formfield-height\"\n                attr.aria-label=\"{{m_intl.deleteAllMessages}}\"\n                (click)=\"deleteAllMessages_Click()\"\n                [disabled]=\"isWorking || isLoading || m_messages?.length<=0\">\n          <mat-icon>delete</mat-icon>\n          {{m_intl.deleteAllMessages}}\n        </button>\n      </ebootis-password-field-content>\n    </div>\n    <div class=\"col\">\n      <button mat-button type=\"button\" color=\"primary\" class=\"formfield-height float-end\"\n              attr.aria-label=\"{{m_intl.uploadMessages}}\"\n              [disabled]=\"m_isOffline || m_messages?.length <= 0\"\n              (click)=\"workOnMessageQueue_Click()\">\n        <mat-icon *ngIf=\"!isWorking;else spinner\">\n            outbox\n        </mat-icon>\n        {{m_intl.uploadMessages}}\n      </button>\n    </div>\n  </div>\n  <!--03.2022 Todo: einbauen, sobald verf\u00FCgbar: An autosize strategy that works on elements of differing sizes(!) \n          is currently being developed in @angular/cdk-experimental, but it is not ready for production use yet. \n          https://github.com/angular/components/issues/10113 -->\n  <cdk-virtual-scroll-viewport class=\"d-flex flex-fill\" itemSize=\"35\"\n                                *ngIf=\"m_messages?.length>0; else msgPlaceholder\" [maxBufferPx]=\"1200\" [minBufferPx]=\"1200\">\n    <div *cdkVirtualFor=\"let msg of m_messages | filterBySearchString: msgSearchStringCtrl.value; let i = index; templateCacheSize:0\"\n          class=\"mb-2\">\n      <h6 class=\"break\">{{msg.serviceClass}}.{{msg.serviceMethod}}</h6>\n      <p class=\"break\"> {{m_intl.timeStampLabel}}: {{msg.timestamp|\n        date:\n        'dd.MM.yyyy - HH:mm'}},\n        {{m_intl.lastTryLabel}}: {{msg.lastTry | date:\n        'dd.MM.yyyy - HH:mm'}}, {{m_intl.stateLabel}}:\n        {{getMessageStateText(msg.messageState)}}\n      </p>\n      <mat-error class=\"break\">{{msg.errorMessage}}</mat-error>\n      <div class=\"row\" *ngIf=\"showDetails\">\n        <div class=\"col-12 col-lg-6\">\n          <h6 class=\"break\">{{m_intl.parameterLabel}}:</h6>\n          <pre class=\"o-hidden break pre-wrap\">{{getServiceParms(msg)|json}}</pre>\n        </div>\n        <div class=\"col-12 col-lg-6\">\n          <h6 class=\"break\">{{m_intl.relationsLabel}}:</h6>\n          <p *ngFor=\"let relation of msg.relations\" class=\"break\">\n            {{relation}}\n          </p>\n        </div>\n      </div>\n      <div class=\"d-flex justify-content-between\">\n        <button mat-button type=\"button\" color=\"warn\" (click)=\"deleteMessage_Click(msg)\"\n                attr.aria-label=\"{{m_intl.deleteMessageLabel}}\"\n                *ngIf=\"isPasswordCorrect\"\n                matTooltip=\"{{m_intl.deleteMessageLabel}}\">\n          <mat-icon>delete</mat-icon>\n          {{m_intl.deleteMessageLabel}}\n        </button>\n      </div>\n      <hr>\n    </div>\n  </cdk-virtual-scroll-viewport>\n</div>\n\n<ng-template #msgPlaceholder>\n  <ui-placeholder class=\"ms-3\" [innerText]=\"m_intl.noPendingMessages\"></ui-placeholder>\n</ng-template>\n\n<ng-template #spinner>\n  <mat-spinner [diameter]=\"20\" class=\"pe-1\"></mat-spinner>&nbsp;\n</ng-template>", styles: ["h2>.headerSpan{display:inline-block;vertical-align:middle;height:100%}\n"] }]
    }], function () { return [{ type: NetworkOnlineService }, { type: MessageService }, { type: FilterBySearchStringPipe }, { type: i1.MatDialog }, { type: LoggerService }, { type: ConfirmationService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ADMIN_CONSOLE_DATA]
            }] }, { type: PendingMessagesIntl, decorators: [{
                type: Optional
            }] }]; }, { isWorking: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], showDetails: [{
            type: Input
        }], m_password: [{
            type: Input,
            args: ['password']
        }], passwordInput: [{
            type: Input
        }], passwordInputChanged: [{
            type: Output
        }], passwordField: [{
            type: ViewChild,
            args: [PasswordFieldContentComponent]
        }] }); })();

class ServiceWorkerIntl {
    constructor() {
        this.changes = new Subject();
        this.newUpdateMustBeInstalled = 'Neues Update muss installiert werden. Die Applikation wird neu geladen.';
    }
    static { this.ɵfac = function ServiceWorkerIntl_Factory(t) { return new (t || ServiceWorkerIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ServiceWorkerIntl, factory: ServiceWorkerIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ServiceWorkerIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

class ServiceWorkerService {
    constructor(appRef, updates, m_logger, m_serviceWorkerIntl) {
        this.appRef = appRef;
        this.updates = updates;
        this.m_logger = m_logger;
        this.m_serviceWorkerIntl = m_serviceWorkerIntl;
        this.m_forceUpdate = false;
        if (this.m_serviceWorkerIntl) {
            this.m_intl = m_serviceWorkerIntl;
        }
        else {
            this.m_intl = new ServiceWorkerIntl();
        }
        const logCtxBuilder = this.getLogContextBuilder('constructor');
        // Allow the app to stabilize first, before starting
        const appIsStable$ = this.appRef.isStable.pipe(first(isStable => isStable === true));
        const everySixHours$ = interval(60 * 1000 * 60 * 6);
        const everySixHoursOnceAppIsStable$ = appIsStable$.pipe(concatMap(() => everySixHours$));
        /** Poll for updates (every 6 hours)*/
        everySixHoursOnceAppIsStable$
            .subscribe(() => {
            if (this.updates.isEnabled) {
                this.m_forceUpdate = true;
                this.m_logger.logDebug({ title: 'Checking for App-update via interval', context: logCtxBuilder.get() });
                this.updates.checkForUpdate();
            }
        });
        this.updates.versionUpdates
            .subscribe((versionEvent) => {
            switch (versionEvent.type) {
                case 'VERSION_DETECTED':
                    this.updates.activateUpdate()
                        .then((updateAvailable) => {
                        if (updateAvailable) {
                            this.m_logger.logDebug({ title: `App update activated: (${versionEvent.version?.hash})`, context: logCtxBuilder.get() });
                        }
                        else {
                            this.m_logger.logDebug({ title: 'App is up to date', context: logCtxBuilder.get() });
                        }
                    });
                    break;
                case 'VERSION_READY':
                    if (this.m_forceUpdate) {
                        this.m_logger.logDebug({ title: `current version is ${versionEvent.currentVersion?.hash}, available version is ${versionEvent.latestVersion?.hash}`, context: logCtxBuilder.get() });
                        alert(this.m_intl.newUpdateMustBeInstalled);
                        document.location.reload();
                    }
                    break;
                case 'VERSION_INSTALLATION_FAILED':
                    this.m_logger.logError({ title: `sw.versionUpdates(): Version installation failed! ${versionEvent.error} at version ${versionEvent.version}`, context: logCtxBuilder.get() });
                    break;
            }
        });
        this.updates.unrecoverable.subscribe(event => {
            this.m_logger.logError({ entry: event, context: logCtxBuilder.get() });
            alert('An error occurred that we cannot recover from:\n' +
                event.reason +
                '\n\nPlease reload the page.');
        });
    }
    isEnabled() {
        return this.updates.isEnabled;
    }
    /**
     * returns swUpdates.checkForUpdate():
     * returns a promise for an update and waits until the new version is downloaded
     * from the server and ready for activation.
     * @returns true if a new version was found and is ready to be activated,
     * false if no new version was found
     * rejects if any error occurs
     */
    checkForUpdates() {
        this.m_forceUpdate = true;
        this.m_logger.logDebug({ context: this.getLogContextBuilder('checkForUpdates').get() });
        return this.updates.checkForUpdate();
    }
    getLogContextBuilder(p_functionName) {
        return LogContextBuilder.getInstance('service-worker.service.ts', 'ServiceWorkerService', p_functionName);
    }
    static { this.ɵfac = function ServiceWorkerService_Factory(t) { return new (t || ServiceWorkerService)(i0.ɵɵinject(i0.ApplicationRef), i0.ɵɵinject(i1$5.SwUpdate), i0.ɵɵinject(LoggerService), i0.ɵɵinject(ServiceWorkerIntl, 8)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ServiceWorkerService, factory: ServiceWorkerService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ServiceWorkerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i0.ApplicationRef }, { type: i1$5.SwUpdate }, { type: LoggerService }, { type: ServiceWorkerIntl, decorators: [{
                type: Optional
            }] }]; }, null); })();

function AdminConsoleComponent_mat_tab_1_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c0$1 = function (a0) { return { $implicit: a0 }; };
function AdminConsoleComponent_mat_tab_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-tab", 3)(1, "div", 4)(2, "div", 5)(3, "h2", 6)(4, "span", 7);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(6, "div", 5)(7, "div", 8);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 9);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 5)(12, "div", 8);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 9);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(16, AdminConsoleComponent_mat_tab_1_ng_container_16_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("label", ctx_r0.m_adminConsoleIntl.generalTabTitle);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.m_adminConsoleIntl.softwareInfo);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r0.m_adminConsoleIntl.revisionLabel, ":");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.m_revision);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r0.m_adminConsoleIntl.databaseLabel, ":");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.m_dataBaseInfo);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.generalTabTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(8, _c0$1, ctx_r0));
} }
function AdminConsoleComponent_mat_tab_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-tab", 3)(1, "ebootis-pending-messages", 11);
    i0.ɵɵlistener("passwordInputChanged", function AdminConsoleComponent_mat_tab_2_Template_ebootis_pending_messages_passwordInputChanged_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.onPasswordValue_Change($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("label", ctx_r1.m_pendingMessagesTabTitle);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isWorking", ctx_r1.isWorking)("isLoading", ctx_r1.isLoading)("password", ctx_r1.m_revision)("passwordInput", ctx_r1.passwordValue);
} }
function AdminConsoleComponent_mat_tab_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-tab", 12)(1, "ebootis-logs", 13);
    i0.ɵɵlistener("passwordInputChanged", function AdminConsoleComponent_mat_tab_3_Template_ebootis_logs_passwordInputChanged_1_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.onPasswordValue_Change($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("label", ctx_r2.m_logsTabTitle);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("password", ctx_r2.m_revision)("passwordInput", ctx_r2.passwordValue);
} }
function AdminConsoleComponent_mat_tab_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-tab", 12);
    i0.ɵɵelement(1, "ebootis-network-console");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("label", ctx_r3.m_adminConsoleIntl.networkTabTitle);
} }
function AdminConsoleComponent_mat_tab_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-tab", 3)(1, "div", 4)(2, "div", 5)(3, "h2", 6);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 5)(6, "div", 14);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 9);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 5)(11, "div", 14);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 9);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 5)(16, "div", 14);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 9);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("label", ctx_r4.m_adminConsoleIntl.storageTabTitle);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r4.m_adminConsoleIntl.storageTabTitle);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r4.m_adminConsoleIntl.totalStorage, ":");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.m_totalStorage);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r4.m_adminConsoleIntl.storageUsage, ":");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.m_storageUsage);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r4.m_adminConsoleIntl.remainingStorage, ":");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.m_remainingStorage);
} }
function AdminConsoleComponent_mat_tab_6_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-tab", 3)(1, "ebootis-db-viewer", 15);
    i0.ɵɵlistener("passwordInputChanged", function AdminConsoleComponent_mat_tab_6_Template_ebootis_db_viewer_passwordInputChanged_1_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.onPasswordValue_Change($event)); })("deleteDatabaseClicked", function AdminConsoleComponent_mat_tab_6_Template_ebootis_db_viewer_deleteDatabaseClicked_1_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.onDeleteDatabase_Clicked()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("label", ctx_r5.m_adminConsoleIntl.databaseTabTitle);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("password", ctx_r5.m_revision)("passwordInput", ctx_r5.passwordValue);
} }
function AdminConsoleComponent_mat_tab_7_iframe_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "iframe", 19);
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r15.m_serviceWorkerUrl, i0.ɵɵsanitizeResourceUrl);
} }
function AdminConsoleComponent_mat_tab_7_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r17.m_adminConsoleIntl.serviceWorkerNotAvailable);
} }
function AdminConsoleComponent_mat_tab_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-tab", 3)(1, "div", 16)(2, "div", 5)(3, "h2", 6);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, AdminConsoleComponent_mat_tab_7_iframe_5_Template, 1, 1, "iframe", 17);
    i0.ɵɵtemplate(6, AdminConsoleComponent_mat_tab_7_ng_template_6_Template, 2, 1, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r16 = i0.ɵɵreference(7);
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("label", ctx_r6.m_adminConsoleIntl.serviceWorkerTabTitle);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r6.m_adminConsoleIntl.serviceWorkerState);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.m_serviceWorkerUrl)("ngIfElse", _r16);
} }
// Entsprechen den Indizes (sofern keine Tabs ausgeblendet werden!) der TabPage, daher ist die Reihenfolge wichtig!
var TabPages;
(function (TabPages) {
    TabPages[TabPages["General"] = 0] = "General";
    TabPages[TabPages["PendingMessages"] = 1] = "PendingMessages";
    TabPages[TabPages["Logs"] = 2] = "Logs";
    TabPages[TabPages["Network"] = 3] = "Network";
    TabPages[TabPages["Database"] = 4] = "Database";
    TabPages[TabPages["ServiceWorker"] = 5] = "ServiceWorker";
    TabPages[TabPages["Storage"] = 6] = "Storage";
})(TabPages || (TabPages = {}));
class AdminConsoleComponent {
    constructor(m_serviceWorkerService, m_location, m_sanitizer, adminConsoleIntl, m_adminConsoleData, m_loggerService) {
        this.m_serviceWorkerService = m_serviceWorkerService;
        this.m_location = m_location;
        this.m_sanitizer = m_sanitizer;
        this.adminConsoleIntl = adminConsoleIntl;
        this.m_adminConsoleData = m_adminConsoleData;
        this.m_loggerService = m_loggerService;
        this.passwordInputChanged = new EventEmitter();
        /** Event welches getriggert wird, wenn in der DBViewer Component die Aktion die gesamte Datenbank zu löschen ausgeführt wird */
        this.deleteDatabaseClicked = new EventEmitter();
        this.TabPageEnum = TabPages;
        /** Verwendeter Speicher in MB */
        this.m_storageUsage = '-';
        /** Gesamtspeicher in MB*/
        this.m_totalStorage = '-';
        /** freier Speicher (nicht in Verwendung) in MB*/
        this.m_remainingStorage = '-';
        this.m_subscriptionsSubject = new Subject();
        if (this.adminConsoleIntl)
            this.m_adminConsoleIntl = this.adminConsoleIntl;
        else
            this.m_adminConsoleIntl = new AdminConsoleIntl();
        // Initialwerte, werden im ngOnInit mit Werten gesetzt
        this.m_logsTabTitle = this.m_adminConsoleIntl.logsTabTitle;
        this.m_pendingMessagesTabTitle = this.m_adminConsoleIntl.pendingMessagesTabTitle;
    }
    ngOnInit() {
        if (this.m_serviceWorkerService.isEnabled())
            this.m_serviceWorkerUrl = this.m_sanitizer.bypassSecurityTrustResourceUrl(this.m_location.prepareExternalUrl('ngsw/state'));
        this.m_revision = this.m_adminConsoleData.getRevision();
        this.m_dataBaseInfo = this.m_adminConsoleData.getDatabaseInfo();
        if (!this.excludeTabs?.includes(TabPages.Storage))
            this.storageEstimate();
        this.m_loggerService.logs$
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe({
            next: (logs) => {
                const numberOfLogs = logs.length;
                const numberOfFailedLogs = logs.filter((log) => log.level === LogLevel.ERROR).length;
                this.m_logsTabTitle = `${this.m_adminConsoleIntl.logsTabTitle} (${numberOfFailedLogs}/${numberOfLogs})`;
            },
            error: () => {
                this.m_logsTabTitle = this.m_adminConsoleIntl.logsTabTitle;
            }
        });
        this.m_adminConsoleData.getPendingMessages()
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe({
            next: (msgs) => {
                const numberOfPendingMessages = msgs.length;
                this.m_pendingMessagesTabTitle = `${this.m_adminConsoleIntl.pendingMessagesTabTitle} (${numberOfPendingMessages})`;
            },
            error: () => {
                this.m_pendingMessagesTabTitle = this.m_adminConsoleIntl.pendingMessagesTabTitle;
            }
        });
    }
    ngOnDestroy() {
        this.m_subscriptionsSubject.next();
        this.m_subscriptionsSubject.complete();
    }
    storageEstimate() {
        if (navigator.storage && navigator.storage.estimate) {
            navigator.storage.estimate().then(quota => {
                // quota.usage -> Number of bytes used.
                // quota.quota -> Maximum number of bytes available.
                this.m_totalStorage = `${(quota.quota / 1000000).toFixed(2)} MB`;
                this.m_storageUsage = `${(quota.usage / 1000000).toFixed(2)} MB`;
                this.m_remainingStorage = `${((quota.quota - quota.usage) / 1000000).toFixed(2)} MB`;
            });
        }
    }
    onPasswordValue_Change(p_newValue) {
        this.passwordValue = p_newValue;
        this.passwordInputChanged.emit(this.passwordValue);
    }
    onDeleteDatabase_Clicked() {
        this.deleteDatabaseClicked.emit();
    }
    get isPasswordCorrect() {
        return this.passwordValue == this.m_revision;
    }
    onTabChanged(p_tabEvent) {
        const tabIndex = p_tabEvent.index;
        if (this.excludeTabs.includes(TabPages.PendingMessages))
            return;
        if ((tabIndex == 0 && this.excludeTabs.includes(TabPages.General))
            || (tabIndex == 1 && !this.excludeTabs.includes(TabPages.General)))
            this.pendingMessagesComp.refresh();
    }
    static { this.ɵfac = function AdminConsoleComponent_Factory(t) { return new (t || AdminConsoleComponent)(i0.ɵɵdirectiveInject(ServiceWorkerService), i0.ɵɵdirectiveInject(i1$1.Location), i0.ɵɵdirectiveInject(i3$3.DomSanitizer), i0.ɵɵdirectiveInject(AdminConsoleIntl, 8), i0.ɵɵdirectiveInject(ADMIN_CONSOLE_DATA), i0.ɵɵdirectiveInject(LoggerService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AdminConsoleComponent, selectors: [["ebootis-admin-console"]], viewQuery: function AdminConsoleComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(PendingMessagesComponent, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pendingMessagesComp = _t.first);
        } }, inputs: { isWorking: "isWorking", isLoading: "isLoading", generalTabTemplate: "generalTabTemplate", excludeTabs: "excludeTabs" }, outputs: { passwordInputChanged: "passwordInputChanged", deleteDatabaseClicked: "deleteDatabaseClicked" }, features: [i0.ɵɵProvidersFeature([FilterBySearchStringPipe])], decls: 8, vars: 7, consts: [[1, "ebo-tab-100", 3, "selectedTabChange"], [3, "label", 4, "ngIf"], ["bodyClass", "no-overflow", 3, "label", 4, "ngIf"], [3, "label"], [1, "container-fluid"], [1, "row"], [1, "col", "ebo-tab-header"], [1, "headerSpan"], [1, "col-4", "col-sm-2", "col-xxl-1", "fw-bold"], [1, "col"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "isWorking", "isLoading", "password", "passwordInput", "passwordInputChanged"], ["bodyClass", "no-overflow", 3, "label"], [3, "password", "passwordInput", "passwordInputChanged"], [1, "col-6", "col-sm-4", "col-md-3", "col-xl-2", "fw-bold"], [3, "password", "passwordInput", "passwordInputChanged", "deleteDatabaseClicked"], [1, "container-fluid", "h-100", "d-flex", "flex-column"], ["frameborder", "0", "class", "flex-fill", 3, "src", 4, "ngIf", "ngIfElse"], ["swNotAvailable", ""], ["frameborder", "0", 1, "flex-fill", 3, "src"]], template: function AdminConsoleComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-tab-group", 0);
            i0.ɵɵlistener("selectedTabChange", function AdminConsoleComponent_Template_mat_tab_group_selectedTabChange_0_listener($event) { return ctx.onTabChanged($event); });
            i0.ɵɵtemplate(1, AdminConsoleComponent_mat_tab_1_Template, 17, 10, "mat-tab", 1);
            i0.ɵɵtemplate(2, AdminConsoleComponent_mat_tab_2_Template, 2, 5, "mat-tab", 1);
            i0.ɵɵtemplate(3, AdminConsoleComponent_mat_tab_3_Template, 2, 3, "mat-tab", 2);
            i0.ɵɵtemplate(4, AdminConsoleComponent_mat_tab_4_Template, 2, 1, "mat-tab", 2);
            i0.ɵɵtemplate(5, AdminConsoleComponent_mat_tab_5_Template, 20, 8, "mat-tab", 1);
            i0.ɵɵtemplate(6, AdminConsoleComponent_mat_tab_6_Template, 2, 3, "mat-tab", 1);
            i0.ɵɵtemplate(7, AdminConsoleComponent_mat_tab_7_Template, 8, 4, "mat-tab", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !(ctx.excludeTabs == null ? null : ctx.excludeTabs.includes(ctx.TabPageEnum.General)));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !(ctx.excludeTabs == null ? null : ctx.excludeTabs.includes(ctx.TabPageEnum.PendingMessages)));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !(ctx.excludeTabs == null ? null : ctx.excludeTabs.includes(ctx.TabPageEnum.Logs)));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !(ctx.excludeTabs == null ? null : ctx.excludeTabs.includes(ctx.TabPageEnum.Network)));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !(ctx.excludeTabs == null ? null : ctx.excludeTabs.includes(ctx.TabPageEnum.Storage)));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !(ctx.excludeTabs == null ? null : ctx.excludeTabs.includes(ctx.TabPageEnum.Database)));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !(ctx.excludeTabs == null ? null : ctx.excludeTabs.includes(ctx.TabPageEnum.ServiceWorker)));
        } }, dependencies: [i1$1.NgIf, i1$1.NgTemplateOutlet, i17.MatTab, i17.MatTabGroup, LogsComponent, DBViewerComponent, NetworkConsoleComponent, PendingMessagesComponent], styles: ["[_nghost-%COMP%]{display:block;height:100%}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AdminConsoleComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-admin-console', providers: [FilterBySearchStringPipe], template: "<mat-tab-group (selectedTabChange)=\"onTabChanged($event)\" class=\"ebo-tab-100\">\n  <!-- Tab - Allgemein -->\n  <mat-tab *ngIf=\"!excludeTabs?.includes(TabPageEnum.General)\" label=\"{{m_adminConsoleIntl.generalTabTitle}}\">\n    <div class=\"container-fluid\">\n      <div class=\"row\">\n        <h2 class=\"col ebo-tab-header\"><span class=\"headerSpan\">{{m_adminConsoleIntl.softwareInfo}}</span></h2>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-4 col-sm-2 col-xxl-1 fw-bold\">{{m_adminConsoleIntl.revisionLabel}}:</div>\n        <div class=\"col\">{{m_revision}}</div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-4 col-sm-2 col-xxl-1 fw-bold\">{{m_adminConsoleIntl.databaseLabel}}:</div>\n        <div class=\"col\">{{m_dataBaseInfo}}</div>\n      </div>\n      <ng-container *ngTemplateOutlet=\"generalTabTemplate; context: {$implicit: this};\"></ng-container>\n    </div>\n  </mat-tab>\n  <!-- Tab - Ausstehende Nachrichten -->\n  <mat-tab *ngIf=\"!excludeTabs?.includes(TabPageEnum.PendingMessages)\" label=\"{{m_pendingMessagesTabTitle}}\">\n    <ebootis-pending-messages [isWorking]=\"isWorking\" [isLoading]=\"isLoading\" [password]=\"m_revision\"\n      [passwordInput]=\"passwordValue\" (passwordInputChanged)=\"onPasswordValue_Change($event)\">\n    </ebootis-pending-messages>\n  </mat-tab>\n  <!-- Tab - Logs -->\n  <mat-tab *ngIf=\"!excludeTabs?.includes(TabPageEnum.Logs)\" label=\"{{m_logsTabTitle}}\" bodyClass=\"no-overflow\">\n    <ebootis-logs [password]=\"m_revision\" [passwordInput]=\"passwordValue\"\n      (passwordInputChanged)=\"onPasswordValue_Change($event)\">\n    </ebootis-logs>\n  </mat-tab>\n  <!-- Tab - Netzwerk -->\n  <mat-tab *ngIf=\"!excludeTabs?.includes(TabPageEnum.Network)\" label=\"{{m_adminConsoleIntl.networkTabTitle}}\" bodyClass=\"no-overflow\">\n    <ebootis-network-console>\n    </ebootis-network-console>\n  </mat-tab>\n  <!-- Tab Speicher -->\n  <mat-tab *ngIf=\"!excludeTabs?.includes(TabPageEnum.Storage)\" label=\"{{m_adminConsoleIntl.storageTabTitle}}\">\n    <div class=\"container-fluid\">\n      <div class=\"row\">\n        <h2 class=\"col ebo-tab-header\">{{m_adminConsoleIntl.storageTabTitle}}</h2>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-6 col-sm-4 col-md-3 col-xl-2 fw-bold\">{{m_adminConsoleIntl.totalStorage}}:</div>\n        <div class=\"col\">{{m_totalStorage}}</div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-6 col-sm-4 col-md-3 col-xl-2 fw-bold\">{{m_adminConsoleIntl.storageUsage}}:</div>\n        <div class=\"col\">{{m_storageUsage}}</div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-6 col-sm-4 col-md-3 col-xl-2 fw-bold\">{{m_adminConsoleIntl.remainingStorage}}:</div>\n        <div class=\"col\">{{m_remainingStorage}}</div>\n      </div>\n    </div>\n  </mat-tab>\n  <!-- Tab - Datenbank -->\n  <mat-tab *ngIf=\"!excludeTabs?.includes(TabPageEnum.Database)\" label=\"{{m_adminConsoleIntl.databaseTabTitle}}\">\n    <ebootis-db-viewer [password]=\"m_revision\" [passwordInput]=\"passwordValue\"\n      (passwordInputChanged)=\"onPasswordValue_Change($event)\" (deleteDatabaseClicked)=\"onDeleteDatabase_Clicked()\">\n    </ebootis-db-viewer>\n  </mat-tab>\n  <!-- Tab - ServiceWorker -->\n  <mat-tab *ngIf=\"!excludeTabs?.includes(TabPageEnum.ServiceWorker)\" label=\"{{m_adminConsoleIntl.serviceWorkerTabTitle}}\">\n    <div class=\"container-fluid h-100 d-flex flex-column\">\n      <div class=\"row\">\n        <h2 class=\"col ebo-tab-header\">{{m_adminConsoleIntl.serviceWorkerState}}</h2>\n      </div>\n      <iframe [src]=\"m_serviceWorkerUrl\" frameborder=\"0\" class=\"flex-fill\"\n        *ngIf=\"m_serviceWorkerUrl;else swNotAvailable\"></iframe>\n      <ng-template #swNotAvailable>\n        <p>{{m_adminConsoleIntl.serviceWorkerNotAvailable}}</p>\n      </ng-template>\n    </div>\n  </mat-tab>\n</mat-tab-group>", styles: [":host{display:block;height:100%}\n"] }]
    }], function () { return [{ type: ServiceWorkerService }, { type: i1$1.Location }, { type: i3$3.DomSanitizer }, { type: AdminConsoleIntl, decorators: [{
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [ADMIN_CONSOLE_DATA]
            }] }, { type: LoggerService }]; }, { isWorking: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], generalTabTemplate: [{
            type: Input
        }], excludeTabs: [{
            type: Input
        }], passwordInputChanged: [{
            type: Output
        }], deleteDatabaseClicked: [{
            type: Output
        }], pendingMessagesComp: [{
            type: ViewChild,
            args: [PendingMessagesComponent]
        }] }); })();

/**
 * Gilt sowohl für UpdateDataDialogComponent & UpdateDataOverviewComponent
 */
class UpdateDataOverviewIntl {
    constructor() {
        this.progress = 'Fortschritt';
        this.errorOccuredDuringDataSync = 'Beim Synchronisieren der Daten ist ein Fehler aufgetreten';
        this.automaticallyExpandExpansionPanel = 'automatisch ausklappen';
        this.automaticallyScrollToNewEntry = 'zu neuen Einträgen scrollen';
        this.dataSyncInProcess = 'Daten werden synchronisiert';
        this.close = 'Schließen';
    }
    static { this.ɵfac = function UpdateDataOverviewIntl_Factory(t) { return new (t || UpdateDataOverviewIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UpdateDataOverviewIntl, factory: UpdateDataOverviewIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdateDataOverviewIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

class UpdateDataProcessService {
    constructor(m_logger) {
        this.m_logger = m_logger;
        this.m_processList = new Map();
        this.m_processListBehavior = new BehaviorSubject([]);
        this.processListStream = this.m_processListBehavior.asObservable();
        this.m_updatedValue = new Subject();
        this.valueUpdates = this.m_updatedValue.asObservable();
    }
    /** Fügt der Liste einen neuen Hauptprozess hinzu */
    setProcess(p_process) {
        this.m_processList.set(p_process.id, p_process);
        this.m_processListBehavior.next(this.getProcessArray());
        this.m_updatedValue.next(p_process.id);
    }
    /** Löscht einen Hauptprozess aus der Liste */
    deleteProcess(p_processId) {
        this.m_processList.delete(p_processId);
    }
    /** Updatet Status und optional Text aller unfertigen Prozesse und Unterprozesse*/
    updateAllUnfinishedProcesses(p_icon, p_progressText) {
        let updateSubProcesses = (p_updated) => {
            p_updated.subProcesses?.forEach((subProcess) => {
                if (subProcess.icon != 'success' && subProcess.icon != 'error') {
                    subProcess.icon = p_updated.icon;
                    if (p_updated.progressText) {
                        subProcess.progressText = p_updated.progressText;
                    }
                    updateSubProcesses(subProcess);
                }
            });
        };
        this.m_processList.forEach((process) => {
            if (process.icon != 'success' && process.icon != 'error') {
                process.icon = p_icon;
                if (p_progressText) {
                    process.progressText = p_progressText;
                }
                updateSubProcesses(process);
            }
        });
    }
    /** Überschreibt die einzelnen Properties eines Prozess,
     * für die ein Wert mitgegeben wurde.
     * Achtung: Error-Icons werden nicht überschrieben
     */
    updateProcessData(p_current, p_updated) {
        /** Sucht einen Teilprozess und updatet diesen. Wenn nicht gefunden, wird ein neuer hinzugefügt. */
        let addOrUpdateSubprocess = (p_currentProcess, p_updated) => {
            let subProcess = this.getSubProcess(p_currentProcess.subProcesses, p_updated.id);
            if (subProcess) {
                subProcess = this.updateProcessData(subProcess, p_updated);
            }
            else {
                p_currentProcess.subProcesses.push(p_updated);
                subProcess = p_updated;
            }
            return subProcess;
        };
        let process = p_current;
        if (p_updated.icon) {
            if (p_current.icon != 'error') {
                p_current.icon = p_updated.icon;
            }
        }
        if (p_updated.title)
            p_current.title = p_updated.title;
        if (p_updated.processedAmount)
            p_current.processedAmount = p_updated.processedAmount;
        if (p_updated.totalAmount)
            p_current.totalAmount = p_updated.totalAmount;
        if (p_updated.subProcesses?.length > 0) {
            if (!p_current.subProcesses) {
                p_current.subProcesses = [];
            }
            for (let index = 0; index < p_updated.subProcesses.length; index++) {
                let subProcess = addOrUpdateSubprocess(p_current, p_updated.subProcesses[index]);
                if (subProcess) {
                    process = subProcess;
                    if (p_current.icon != 'error') {
                        if (subProcess.icon == 'error') {
                            p_current.icon = 'error';
                        }
                    }
                    break;
                }
            }
        }
        p_current.progressText = p_updated.progressText;
        return process;
    }
    /** Updatet einen Prozess. Sucht auch rekursiv in den Teilprozessen.
     * Gibt es den Prozess noch nicht, wird er hinzugefügt.*/
    updateProcess(p_processData) {
        let process = this.getProcess(p_processData.id);
        let existingProcess = process;
        if (process) {
            existingProcess = this.updateProcessData(process, p_processData);
        }
        this.m_processListBehavior.next(this.getProcessArray());
        this.m_updatedValue.next(existingProcess ? existingProcess.id : process.id);
    }
    /** Erhöht die bereits verarbeitete Menge um 1*/
    increaseProcessedAmount(p_id) {
        let process = this.getProcess(p_id);
        if (process) {
            process.processedAmount = process.processedAmount ? process.processedAmount + 1 : 1;
            this.m_processListBehavior.next(this.getProcessArray());
        }
        else {
            this.m_logger.logError({
                title: `UpdateDataProcessService.increaseProcessedAmount: could not find process with id ${p_id}`,
                context: this.getLogContextBuilder('increaseProcessedAmount').get()
            });
        }
    }
    /** Addiert eine mitgegebene Menge zur Gesamtmenge eines Prozesses hinzu */
    increaseTotalAmount(p_id, p_amount) {
        if (!p_amount) {
            this.m_logger.logError({
                title: `UpdateDataProcessService.increaseTotalAmount called for ${p_id}, but parameter p_amount was null`,
                context: this.getLogContextBuilder('increaseTotalAmount').get()
            });
            return;
        }
        let process = this.getProcess(p_id);
        if (process) {
            process.totalAmount = process.totalAmount ? process.totalAmount + p_amount : p_amount;
            this.m_processListBehavior.next(this.getProcessArray());
        }
        else {
            this.m_logger.logError({
                title: `UpdateDataProcessService.increaseTotalAmount: could not find process with id ${p_id}`,
                context: this.getLogContextBuilder('increaseTotalAmount').get()
            });
        }
    }
    /** Leert die Liste der Prozesse */
    reset() {
        this.m_processList.clear();
        this.m_processListBehavior.next([]);
    }
    /** Sucht einen (Unter-)Prozess anhand der ID und gibt ihn zurück */
    getProcess(p_id) {
        let process = this.m_processList.get(p_id);
        if (!process) {
            for (let index = 0; index < this.m_processList?.size; index++) {
                const listedProcess = this.getProcessArray()[index];
                if (listedProcess.id == p_id) {
                    process = listedProcess;
                }
                else if (listedProcess.subProcesses?.length > 0) {
                    process = this.getSubProcess(listedProcess.subProcesses, p_id);
                    if (process) {
                        break;
                    }
                }
            }
        }
        return process;
    }
    getProcessArray() {
        return Array.from(this.m_processList?.values());
    }
    /** Rekursive Methode, um einen Unterprozess zu finden und zurückgeben */
    getSubProcess(p_subprocesses, p_id) {
        let subprocess;
        if (p_subprocesses?.length > 0) {
            subprocess = p_subprocesses.find(process => process.id == p_id);
            if (subprocess) {
                return subprocess;
            }
            else {
                // Hier stand vorher eine ForEach. ForEach kann jedoch nicht unterbrochen werden (break, return, usw. werden ignoriert).
                // For-Schleife mit Break, sobald Prozess gefunden, ist dem entsprechend schneller
                for (let index = 0; index < p_subprocesses?.length; index++) {
                    let current = p_subprocesses[index];
                    subprocess = p_subprocesses.find(process => process.id == p_id);
                    if (subprocess) {
                        break;
                    }
                    else if (current.subProcesses?.length > 0) {
                        subprocess = this.getSubProcess(current.subProcesses, p_id);
                        if (subprocess) {
                            break;
                        }
                    }
                }
            }
        }
        return subprocess;
    }
    getLogContextBuilder(p_functionName) {
        return LogContextBuilder.getInstance('update-data-progress.service.ts', 'UpdateDataProgressService', p_functionName);
    }
    static { this.ɵfac = function UpdateDataProcessService_Factory(t) { return new (t || UpdateDataProcessService)(i0.ɵɵinject(LoggerService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UpdateDataProcessService, factory: UpdateDataProcessService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdateDataProcessService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: LoggerService }]; }, null); })();

function UpdateDataOverviewComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "mat-checkbox", 11);
    i0.ɵɵlistener("ngModelChange", function UpdateDataOverviewComponent_div_1_Template_mat_checkbox_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.m_automaticallyExpandExpansionPanels = $event); })("change", function UpdateDataOverviewComponent_div_1_Template_mat_checkbox_change_1_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.OnAutomaticallyExpandChanged($event.checked)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-checkbox", 12);
    i0.ɵɵlistener("ngModelChange", function UpdateDataOverviewComponent_div_1_Template_mat_checkbox_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.m_automaticallyScrollToChangedValue = $event); });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r0.m_automaticallyExpandExpansionPanels)("color", "primary");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.m_strings.automaticallyExpandExpansionPanel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r0.m_automaticallyScrollToChangedValue)("disabled", !ctx_r0.m_automaticallyExpandExpansionPanels)("color", "primary");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.m_strings.automaticallyScrollToNewEntry);
} }
function UpdateDataOverviewComponent_mat_header_cell_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.m_strings.progress, " ");
} }
function UpdateDataOverviewComponent_mat_cell_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c0 = function (a0) { return { process: a0 }; };
function UpdateDataOverviewComponent_mat_cell_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell");
    i0.ɵɵtemplate(1, UpdateDataOverviewComponent_mat_cell_5_ng_container_1_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const process_r15 = ctx.$implicit;
    i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(9);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0, process_r15));
} }
function UpdateDataOverviewComponent_mat_header_row_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-row");
} }
function UpdateDataOverviewComponent_mat_row_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-row", 14);
} }
function UpdateDataOverviewComponent_ng_template_8_ng_template_0_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function UpdateDataOverviewComponent_ng_template_8_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, UpdateDataOverviewComponent_ng_template_8_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 13);
} if (rf & 2) {
    const process_r18 = i0.ɵɵnextContext().process;
    i0.ɵɵnextContext();
    const _r7 = i0.ɵɵreference(11);
    i0.ɵɵproperty("ngTemplateOutlet", _r7)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0, process_r18));
} }
function UpdateDataOverviewComponent_ng_template_8_mat_accordion_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function UpdateDataOverviewComponent_ng_template_8_mat_accordion_2_div_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function UpdateDataOverviewComponent_ng_template_8_mat_accordion_2_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, UpdateDataOverviewComponent_ng_template_8_mat_accordion_2_div_5_ng_container_1_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const part_r26 = ctx.$implicit;
    i0.ɵɵnextContext(3);
    const _r5 = i0.ɵɵreference(9);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0, part_r26));
} }
function UpdateDataOverviewComponent_ng_template_8_mat_accordion_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-accordion", 17)(1, "mat-expansion-panel", 18)(2, "mat-expansion-panel-header", 19)(3, "mat-panel-title", 20);
    i0.ɵɵtemplate(4, UpdateDataOverviewComponent_ng_template_8_mat_accordion_2_ng_container_4_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, UpdateDataOverviewComponent_ng_template_8_mat_accordion_2_div_5_Template, 2, 4, "div", 21);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const process_r18 = i0.ɵɵnextContext().process;
    const ctx_r21 = i0.ɵɵnextContext();
    const _r7 = i0.ɵɵreference(11);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("expanded", ctx_r21.m_automaticallyExpandExpansionPanels);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", _r7)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c0, process_r18));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", process_r18.subProcesses);
} }
function UpdateDataOverviewComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, UpdateDataOverviewComponent_ng_template_8_ng_template_0_Template, 1, 4, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(2, UpdateDataOverviewComponent_ng_template_8_mat_accordion_2_Template, 6, 6, "mat-accordion", 16);
} if (rf & 2) {
    const process_r18 = ctx.process;
    const _r19 = i0.ɵɵreference(1);
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (process_r18.subProcesses == null ? null : process_r18.subProcesses.length) > 0 && ctx_r6.isDetailed)("ngIfElse", _r19);
} }
function UpdateDataOverviewComponent_ng_template_10_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function UpdateDataOverviewComponent_ng_template_10_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const process_r29 = i0.ɵɵnextContext().process;
    const ctx_r31 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\u00A0(", ctx_r31.getAmountText(process_r29), ")");
} }
function UpdateDataOverviewComponent_ng_template_10_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const process_r29 = i0.ɵɵnextContext().process;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\u00A0- ", process_r29.progressText, "");
} }
const _c1 = function (a0) { return { icon: a0 }; };
function UpdateDataOverviewComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, UpdateDataOverviewComponent_ng_template_10_ng_container_0_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementStart(1, "span", 22);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, UpdateDataOverviewComponent_ng_template_10_span_3_Template, 2, 1, "span", 1);
    i0.ɵɵtemplate(4, UpdateDataOverviewComponent_ng_template_10_span_4_Template, 2, 1, "span", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const process_r29 = ctx.process;
    const ctx_r8 = i0.ɵɵnextContext();
    const _r9 = i0.ɵɵreference(13);
    i0.ɵɵproperty("ngTemplateOutlet", _r9)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c1, process_r29.icon));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", process_r29.id);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", process_r29.title, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.getAmountText(process_r29));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", process_r29.progressText);
} }
function UpdateDataOverviewComponent_ng_template_12_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-icon", 28);
    i0.ɵɵtext(2, "done");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function UpdateDataOverviewComponent_ng_template_12_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-icon", 29);
    i0.ɵɵtext(2, " report_problem ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r37.m_strings.errorOccuredDuringDataSync);
} }
function UpdateDataOverviewComponent_ng_template_12_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "mat-spinner", 30);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("diameter", 20);
} }
function UpdateDataOverviewComponent_ng_template_12_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-icon", 28);
    i0.ɵɵtext(2, "more_horiz");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function UpdateDataOverviewComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 25);
    i0.ɵɵtemplate(1, UpdateDataOverviewComponent_ng_template_12_ng_container_1_Template, 3, 0, "ng-container", 26);
    i0.ɵɵtemplate(2, UpdateDataOverviewComponent_ng_template_12_ng_container_2_Template, 3, 1, "ng-container", 26);
    i0.ɵɵtemplate(3, UpdateDataOverviewComponent_ng_template_12_ng_container_3_Template, 2, 1, "ng-container", 26);
    i0.ɵɵtemplate(4, UpdateDataOverviewComponent_ng_template_12_ng_container_4_Template, 3, 0, "ng-container", 27);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const icon_r35 = ctx.icon;
    i0.ɵɵproperty("ngSwitch", icon_r35);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "success");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "error");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "loading");
} }
class UpdateDataOverviewComponent {
    constructor(processService, intl) {
        this.processService = processService;
        this.intl = intl;
        this.isDetailed = false;
        this.showFilters = false;
        this.m_columnsToDisplay = ['progress'];
        this.m_automaticallyExpandExpansionPanels = false;
        this.m_automaticallyScrollToChangedValue = false;
        this.m_subscriptionsSubject = new Subject();
        if (this.intl) {
            this.m_strings = intl;
        }
        else {
            this.m_strings = new UpdateDataOverviewIntl();
        }
        this.m_processData$ = this.processService.processListStream;
    }
    ngOnInit() {
        this.processService.valueUpdates
            .pipe(takeUntil(this.m_subscriptionsSubject))
            .subscribe({
            next: (id) => {
                if (this.m_automaticallyScrollToChangedValue) {
                    let element = document.getElementById(id);
                    if (element) {
                        element.scrollIntoView({ block: 'start' });
                    }
                }
            }
        });
    }
    ngOnDestroy() {
        this.m_subscriptionsSubject.next();
        this.m_subscriptionsSubject.complete();
    }
    getAmountText(p_process) {
        let text;
        if (p_process.processedAmount && p_process.totalAmount) {
            text = `${p_process.processedAmount} / ${p_process.totalAmount}`;
        }
        else if (p_process.totalAmount) {
            text = p_process.totalAmount;
        }
        else if (p_process.processedAmount) {
            text = p_process.processedAmount;
        }
        return text;
    }
    OnAutomaticallyExpandChanged(p_isChecked) {
        if (!p_isChecked) {
            this.m_automaticallyScrollToChangedValue = false;
        }
    }
    static { this.ɵfac = function UpdateDataOverviewComponent_Factory(t) { return new (t || UpdateDataOverviewComponent)(i0.ɵɵdirectiveInject(UpdateDataProcessService), i0.ɵɵdirectiveInject(UpdateDataOverviewIntl, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UpdateDataOverviewComponent, selectors: [["ebootis-update-data-overview"]], inputs: { isDetailed: "isDetailed", showFilters: "showFilters" }, decls: 14, vars: 4, consts: [[1, "w-100", "d-flex", "flex-fill", "flex-column"], [4, "ngIf"], [1, "w-100", "d-flex", "flex-fill", "flex-column", "ebo-not-striped", "ebo-no-hover", 3, "dataSource"], ["matColumnDef", "progress"], [4, "matHeaderCellDef"], [4, "matCellDef"], [4, "matHeaderRowDef"], ["class", "align-items-start", 4, "matRowDef", "matRowDefColumns"], ["processDetails", ""], ["headerText", ""], ["icon", ""], [1, "pe-5", 3, "ngModel", "color", "ngModelChange", "change"], [3, "ngModel", "disabled", "color", "ngModelChange"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "align-items-start"], ["plainText", ""], ["class", "d-flex flex-fill flex-column", 4, "ngIf", "ngIfElse"], [1, "d-flex", "flex-fill", "flex-column"], [1, "mat-elevation-z0", 3, "expanded"], [1, "p-0", "me-1", "d-flex", "flex-fill"], [1, "d-flex", "flex-fill"], ["class", "d-flex flex-fill", 4, "ngFor", "ngForOf"], [1, "d-flex", "flex-fill", 3, "id"], ["class", "linebreak-anywhere", 4, "ngIf"], [1, "linebreak-anywhere"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [1, "me-1"], [1, "me-1", 3, "matTooltip"], [1, "me-2", 3, "diameter"]], template: function UpdateDataOverviewComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, UpdateDataOverviewComponent_div_1_Template, 5, 7, "div", 1);
            i0.ɵɵelementStart(2, "mat-table", 2);
            i0.ɵɵelementContainerStart(3, 3);
            i0.ɵɵtemplate(4, UpdateDataOverviewComponent_mat_header_cell_4_Template, 2, 1, "mat-header-cell", 4);
            i0.ɵɵtemplate(5, UpdateDataOverviewComponent_mat_cell_5_Template, 2, 4, "mat-cell", 5);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵtemplate(6, UpdateDataOverviewComponent_mat_header_row_6_Template, 1, 0, "mat-header-row", 6);
            i0.ɵɵtemplate(7, UpdateDataOverviewComponent_mat_row_7_Template, 1, 0, "mat-row", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(8, UpdateDataOverviewComponent_ng_template_8_Template, 3, 2, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(10, UpdateDataOverviewComponent_ng_template_10_Template, 5, 8, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(12, UpdateDataOverviewComponent_ng_template_12_Template, 5, 4, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showFilters);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("dataSource", ctx.m_processData$);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("matHeaderRowDef", ctx.m_columnsToDisplay);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("matRowDefColumns", ctx.m_columnsToDisplay);
        } }, dependencies: [i1$1.NgForOf, i1$1.NgIf, i1$1.NgTemplateOutlet, i1$1.NgSwitch, i1$1.NgSwitchCase, i1$1.NgSwitchDefault, i3.MatIcon, i4.MatTooltip, i6.NgControlStatus, i6.NgModel, i18.MatProgressSpinner, i12.MatAccordion, i12.MatExpansionPanel, i12.MatExpansionPanelHeader, i12.MatExpansionPanelTitle, i8$1.MatCheckbox, i9.MatTable, i9.MatHeaderCellDef, i9.MatHeaderRowDef, i9.MatColumnDef, i9.MatCellDef, i9.MatRowDef, i9.MatHeaderCell, i9.MatCell, i9.MatHeaderRow, i9.MatRow], styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;flex:1 1 auto;height:100%}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdateDataOverviewComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-update-data-overview', template: "<div class=\"w-100 d-flex flex-fill flex-column\">\n    <div *ngIf=\"showFilters\">\n        <mat-checkbox class=\"pe-5\" [(ngModel)]=\"m_automaticallyExpandExpansionPanels\" (change)=\"OnAutomaticallyExpandChanged($event.checked)\"\n            [color]=\"'primary'\">{{m_strings.automaticallyExpandExpansionPanel}}</mat-checkbox>\n        <mat-checkbox [(ngModel)]=\"m_automaticallyScrollToChangedValue\" [disabled]=\"!m_automaticallyExpandExpansionPanels\"\n            [color]=\"'primary'\">{{m_strings.automaticallyScrollToNewEntry}}</mat-checkbox>\n    </div>\n    <mat-table [dataSource]=\"m_processData$\" class=\"w-100 d-flex flex-fill flex-column ebo-not-striped ebo-no-hover\">\n        <ng-container matColumnDef=\"progress\">\n            <mat-header-cell *matHeaderCellDef> {{m_strings.progress}} </mat-header-cell>\n            <mat-cell *matCellDef=\"let process\">\n                <ng-container *ngTemplateOutlet=\"processDetails; context:{process:process}\"></ng-container>\n            </mat-cell>\n        </ng-container>\n\n        <mat-header-row *matHeaderRowDef=\"m_columnsToDisplay\"></mat-header-row>\n        <mat-row *matRowDef=\"let row; columns: m_columnsToDisplay\" class=\"align-items-start\"></mat-row>\n    </mat-table>\n</div>\n\n<ng-template #processDetails let-process=\"process\">\n    <ng-template #plainText>\n        <ng-container *ngTemplateOutlet=\"headerText; context:{process:process}\"></ng-container>\n    </ng-template>\n    <mat-accordion *ngIf=\"process.subProcesses?.length > 0 && isDetailed; else plainText\"\n        class=\"d-flex flex-fill flex-column\">\n        <mat-expansion-panel class=\"mat-elevation-z0\" [expanded]=\"m_automaticallyExpandExpansionPanels\">\n            <mat-expansion-panel-header class=\"p-0 me-1 d-flex flex-fill\">\n                <mat-panel-title class=\"d-flex flex-fill\">\n                    <ng-container *ngTemplateOutlet=\"headerText; context:{process:process}\"></ng-container>\n                </mat-panel-title>\n            </mat-expansion-panel-header>\n            <div *ngFor=\"let part of process.subProcesses\" class=\"d-flex flex-fill\">\n                <ng-container *ngTemplateOutlet=\"processDetails; context:{process:part}\"></ng-container>\n            </div>\n        </mat-expansion-panel>\n    </mat-accordion>\n</ng-template>\n\n<ng-template #headerText let-process=\"process\">\n    <ng-container *ngTemplateOutlet=\"icon; context:{icon:process.icon}\"></ng-container>\n    <span [id]=\"process.id\" class=\"d-flex flex-fill\">{{process.title}}\n        <span *ngIf=\"getAmountText(process)\">&nbsp;({{getAmountText(process)}})</span>\n        <span *ngIf=\"process.progressText\" class=\"linebreak-anywhere\">&nbsp;- {{process.progressText}}</span>\n    </span>\n</ng-template>\n\n<ng-template #icon let-icon=\"icon\">\n    <ng-container [ngSwitch]=\"icon\">\n        <ng-container *ngSwitchCase=\"'success'\">\n            <mat-icon class=\"me-1\">done</mat-icon>\n        </ng-container>\n        <ng-container *ngSwitchCase=\"'error'\">\n            <mat-icon class=\"me-1\" matTooltip=\"{{m_strings.errorOccuredDuringDataSync}}\">\n                report_problem\n            </mat-icon>\n        </ng-container>\n        <ng-container *ngSwitchCase=\"'loading'\">\n            <mat-spinner [diameter]=\"20\" class=\"me-2\"></mat-spinner>\n        </ng-container>\n        <ng-container *ngSwitchDefault>\n            <mat-icon class=\"me-1\">more_horiz</mat-icon>\n        </ng-container>\n    </ng-container>\n</ng-template>", styles: [":host{display:flex;flex-direction:column;flex:1 1 auto;height:100%}\n"] }]
    }], function () { return [{ type: UpdateDataProcessService }, { type: UpdateDataOverviewIntl, decorators: [{
                type: Optional
            }] }]; }, { isDetailed: [{
            type: Input
        }], showFilters: [{
            type: Input
        }] }); })();

class UpdateDataDialogComponent {
    constructor(intl) {
        this.intl = intl;
        this.m_subscriptionsSubject = new Subject();
        if (this.intl) {
            this.m_strings = intl;
        }
        else {
            this.m_strings = new UpdateDataOverviewIntl();
        }
    }
    ngOnInit() {
    }
    ngOnDestroy() {
        this.m_subscriptionsSubject.next();
        this.m_subscriptionsSubject.complete();
    }
    static { this.ɵfac = function UpdateDataDialogComponent_Factory(t) { return new (t || UpdateDataDialogComponent)(i0.ɵɵdirectiveInject(UpdateDataOverviewIntl, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UpdateDataDialogComponent, selectors: [["app-update-data-dialog"]], decls: 8, vars: 2, consts: [["mat-dialog-title", "", 1, "ebo-dialog-header"], [1, "ebo-dialog-title"], [1, "ebo-dialog-actions"], ["mat-button", "", "type", "button", "mat-dialog-close", ""]], template: function UpdateDataDialogComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0)(1, "span", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(3, "mat-dialog-content");
            i0.ɵɵelement(4, "ebootis-update-data-overview");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "mat-dialog-actions", 2)(6, "button", 3);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.m_strings.dataSyncInProcess, " ");
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.m_strings.close);
        } }, dependencies: [i3$2.MatButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, UpdateDataOverviewComponent], styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;flex:1 1 auto;height:100%}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdateDataDialogComponent, [{
        type: Component,
        args: [{ selector: 'app-update-data-dialog', template: "<h1 mat-dialog-title class=\"ebo-dialog-header\">\n  <span class=\"ebo-dialog-title\">\n    {{m_strings.dataSyncInProcess}}\n  </span>\n</h1>\n<mat-dialog-content>\n  <ebootis-update-data-overview></ebootis-update-data-overview>\n</mat-dialog-content>\n<mat-dialog-actions class=\"ebo-dialog-actions\">\n  <button mat-button type=\"button\" mat-dialog-close>{{m_strings.close}}</button>\n</mat-dialog-actions>", styles: [":host{display:flex;flex-direction:column;flex:1 1 auto;height:100%}\n"] }]
    }], function () { return [{ type: UpdateDataOverviewIntl, decorators: [{
                type: Optional
            }] }]; }, null); })();

function ImgComponent_img_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 1);
    i0.ɵɵlistener("click", function ImgComponent_img_0_Template_img_click_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.openImage_Click($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.class);
    i0.ɵɵproperty("src", ctx_r0.m_imageLob, i0.ɵɵsanitizeUrl);
} }
var ImgAction;
(function (ImgAction) {
    ImgAction[ImgAction["UNKNOWN"] = 0] = "UNKNOWN";
    ImgAction[ImgAction["DELETE"] = 1] = "DELETE";
})(ImgAction || (ImgAction = {}));
class ImgComponent {
    get deleteable() {
        return this._deleteable;
    }
    /**
     * Flag um zu steuern ob ein Button im Vollbild Dialog zum löschen angezeigt wird
     * Default: false
     */
    set deleteable(p_value) {
        this._deleteable = coerceBooleanProperty(p_value);
    }
    get downloadable() {
        return this._downloadable;
    }
    /**
     * Flag um zu steuern ob ein Button im Vollbild Dialog zum löschen angezeigt wird
     * Default: false
     */
    set downloadable(p_value) {
        this._downloadable = coerceBooleanProperty(p_value);
    }
    get openable() {
        return this._openable;
    }
    /**
     * Flag um zu steuern ob das Bild in einem Vollbild Dialog zur Betrachtung geöffnet werden kann.
     * Default: false
     */
    set openable(p_value) {
        this._openable = coerceBooleanProperty(p_value);
    }
    /**
     * Bild (Tlob, B64 String oder sonstiges..)
     */
    set lob(p_file) {
        this.m_extFile = p_file;
        let fileURL = p_file;
        // Es kommt ein File oder eine ImageUrl an
        if (p_file.mimeType) {
            let mimeType, b64;
            mimeType = p_file.mimeType;
            b64 = p_file.data;
            fileURL = `data:${mimeType};base64,${b64}`;
        }
        this.m_imageLob = this.m_sanitizer.bypassSecurityTrustUrl(fileURL);
    }
    constructor(m_sanitizer, m_dialog) {
        this.m_sanitizer = m_sanitizer;
        this.m_dialog = m_dialog;
        this.onAction = new EventEmitter();
        this._deleteable = false;
        /**
         * Flag um zu steuern ob ein Button im Vollbild Dialog zum herunterladen angezeigt wird
         * Default: false
         */
        this._downloadable = false;
        this._openable = false;
        this.m_subscriptionsSubject = new Subject();
    }
    ngOnInit() {
    }
    ngOnDestroy() {
        this.m_subscriptionsSubject.next();
        this.m_subscriptionsSubject.complete();
    }
    openImage_Click(p_ev) {
        p_ev.stopPropagation();
        // soll nicht im Dialog geöffnen werden
        if (!this.openable)
            return;
        this.m_dialog.open(ImgFullSizeComponent, {
            data: {
                lob: this.m_imageLob,
                deleteable: this.deleteable,
                downloadable: this.downloadable,
                fileExtenstion: this.m_extFile?.fileExtension,
                fileMimeType: this.m_extFile?.mimeType || this.mimeType,
                fileName: this.m_extFile?.displayName,
                title: this.title,
            },
            panelClass: 'full-size-dialog',
            maxWidth: '100vw',
            maxHeight: '100vh',
            minHeight: '40vh',
            minWidth: '25vw',
            width: 'auto',
            height: 'auto',
        }).afterClosed()
            .pipe(take(1))
            .subscribe({
            next: (v) => {
                if (v && v === ImgAction.DELETE)
                    this.deleteImage();
            }
        });
    }
    emitAction(p_action) {
        if (!p_action === null)
            this.onAction.emit(p_action);
    }
    deleteImage() {
        if (this.deleteable)
            this.emitAction(ImgAction.DELETE);
    }
    static { this.ɵfac = function ImgComponent_Factory(t) { return new (t || ImgComponent)(i0.ɵɵdirectiveInject(i3$3.DomSanitizer), i0.ɵɵdirectiveInject(i1.MatDialog)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ImgComponent, selectors: [["ebootis-img"]], inputs: { deleteable: "deleteable", downloadable: "downloadable", class: "class", openable: "openable", title: "title", mimeType: "mimeType", lob: "lob" }, outputs: { onAction: "onAction" }, decls: 1, vars: 1, consts: [[3, "src", "class", "click", 4, "ngIf"], [3, "src", "click"]], template: function ImgComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ImgComponent_img_0_Template, 1, 3, "img", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.m_imageLob != null && ctx.m_imageLob != "");
        } }, dependencies: [i1$1.NgIf] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImgComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-img', template: "<img *ngIf=\"m_imageLob !=null && m_imageLob != ''\" [src]=\"m_imageLob\" [class]=\"class\" (click)=\"openImage_Click($event)\">" }]
    }], function () { return [{ type: i3$3.DomSanitizer }, { type: i1.MatDialog }]; }, { onAction: [{
            type: Output
        }], deleteable: [{
            type: Input
        }], downloadable: [{
            type: Input
        }], class: [{
            type: Input
        }], openable: [{
            type: Input
        }], title: [{
            type: Input
        }], mimeType: [{
            type: Input
        }], lob: [{
            type: Input,
            args: ['lob']
        }] }); })();

class ImgFullSizeIntl {
    constructor() {
        this.close = 'Schließen';
        this.delete = 'Entfernen';
        this.download = 'Herunterladen';
    }
    static { this.ɵfac = function ImgFullSizeIntl_Factory(t) { return new (t || ImgFullSizeIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ImgFullSizeIntl, factory: ImgFullSizeIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImgFullSizeIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

function ImgFullSizeComponent_mat_dialog_actions_9_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function ImgFullSizeComponent_mat_dialog_actions_9_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.deleteImage_Click()); });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r1.m_strings.delete);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.m_strings.delete, " ");
} }
function ImgFullSizeComponent_mat_dialog_actions_9_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 11)(1, "mat-icon");
    i0.ɵɵtext(2, "get_app");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r2.m_strings.download);
    i0.ɵɵproperty("download", ctx_r2.getDownloadName())("href", ctx_r2.m_lob, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.m_strings.download, " ");
} }
function ImgFullSizeComponent_mat_dialog_actions_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-dialog-actions", 7);
    i0.ɵɵtemplate(1, ImgFullSizeComponent_mat_dialog_actions_9_button_1_Template, 4, 2, "button", 8);
    i0.ɵɵtemplate(2, ImgFullSizeComponent_mat_dialog_actions_9_a_2_Template, 4, 4, "a", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.m_showDelete);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.m_showDownload);
} }
class ImgFullSizeComponent {
    constructor(m_dialogRef, m_data, m_intl) {
        this.m_dialogRef = m_dialogRef;
        this.m_data = m_data;
        this.m_intl = m_intl;
        this.m_showDelete = false;
        this.m_showDownload = false;
        if (this.m_intl) {
            this.m_strings = m_intl;
        }
        else {
            this.m_strings = new ImgFullSizeIntl();
        }
        this.m_lob = this.m_data.lob;
        this.m_showDelete = this.m_data.deleteable ?? false;
        this.m_showDownload = this.m_data.downloadable ?? false;
        // falls this.m_data.fileName == undefinded wird der String 'undefined' gesetzt
        // daher der fall mit || null
        this.m_fileName = this.m_data.fileName || null;
        this.m_fileExtension = this.m_data.fileExtenstion || null;
        this.m_fileMimeType = this.m_data.fileMimeType || null;
        this.m_title = this.m_data.title ?? this.m_fileName;
    }
    ngOnInit() {
    }
    deleteImage_Click() {
        if (this.m_showDelete)
            this.m_dialogRef.close(ImgAction.DELETE);
    }
    getDownloadName() {
        let name = this.m_fileName;
        if (!name)
            name = new Date().toLocaleString();
        let ext = this.m_fileExtension;
        if (!ext && this.m_fileMimeType)
            ext = this.m_fileMimeType.substring(this.m_fileMimeType.indexOf('/') + 1);
        if (ext && !name.includes(ext))
            name += '.' + ext;
        return name;
    }
    static { this.ɵfac = function ImgFullSizeComponent_Factory(t) { return new (t || ImgFullSizeComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(ImgFullSizeIntl, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ImgFullSizeComponent, selectors: [["app-img-full-size"]], decls: 10, vars: 4, consts: [["mat-dialog-title", "", 1, "ebo-dialog-header"], [1, "ebo-dialog-title"], ["mat-icon-button", "", "type", "button", "mat-dialog-close", "", 1, "close", 3, "aria-label"], [1, "flex-fill", "overflow-auto", "d-flex", "justify-content-center", "mh-100"], [1, "d-flex", "flex-column", "justify-content-center"], [3, "src"], ["class", "ebo-dialog-actions", 4, "ngIf"], [1, "ebo-dialog-actions"], ["mat-button", "", "color", "warn", 3, "matTooltip", "click", 4, "ngIf"], ["mat-button", "", "matPrefix", "", 3, "download", "href", "matTooltip", 4, "ngIf"], ["mat-button", "", "color", "warn", 3, "matTooltip", "click"], ["mat-button", "", "matPrefix", "", 3, "download", "href", "matTooltip"]], template: function ImgFullSizeComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0)(1, "span", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "button", 2)(4, "mat-icon");
            i0.ɵɵtext(5, "close");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(6, "mat-dialog-content", 3)(7, "div", 4);
            i0.ɵɵelement(8, "img", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(9, ImgFullSizeComponent_mat_dialog_actions_9_Template, 3, 2, "mat-dialog-actions", 6);
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.m_title, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("aria-label", ctx.m_strings.close);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("src", ctx.m_lob, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.m_showDelete || ctx.m_showDownload);
        } }, dependencies: [i1$1.NgIf, i3.MatIcon, i4.MatTooltip, i2.MatPrefix, i3$2.MatAnchor, i3$2.MatButton, i3$2.MatIconButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions], styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;height:100%}img[_ngcontent-%COMP%]{max-height:100%;max-width:100%;object-fit:contain}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImgFullSizeComponent, [{
        type: Component,
        args: [{ selector: 'app-img-full-size', template: "<h1 mat-dialog-title class=\"ebo-dialog-header\">\r\n  <span class=\"ebo-dialog-title\">\r\n    {{m_title}}\r\n  </span>\r\n  <button mat-icon-button type=\"button\" class=\"close\" aria-label=\"{{m_strings.close}}\" mat-dialog-close>\r\n    <mat-icon>close</mat-icon>\r\n  </button>\r\n</h1>\r\n<mat-dialog-content class=\"flex-fill overflow-auto d-flex justify-content-center mh-100\">\r\n  <div class=\"d-flex flex-column justify-content-center\">\r\n    <img [src]=\"m_lob\">\r\n  </div>\r\n</mat-dialog-content>\r\n<mat-dialog-actions class=\"ebo-dialog-actions\" *ngIf=\"m_showDelete || m_showDownload\">\r\n  <button mat-button color=\"warn\" *ngIf=\"m_showDelete\" (click)=\"deleteImage_Click()\" matTooltip=\"{{m_strings.delete}}\">\r\n    <mat-icon>delete</mat-icon>\r\n    {{m_strings.delete}}\r\n  </button>\r\n  <a mat-button matPrefix *ngIf=\"m_showDownload\" [download]=\"getDownloadName()\" [href]=\"m_lob\"\r\n     matTooltip=\"{{m_strings.download}}\">\r\n    <mat-icon>get_app</mat-icon>\r\n    {{m_strings.download}}\r\n  </a>\r\n</mat-dialog-actions>", styles: [":host{display:flex;flex-direction:column;height:100%}img{max-height:100%;max-width:100%;object-fit:contain}\n"] }]
    }], function () { return [{ type: i1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: ImgFullSizeIntl, decorators: [{
                type: Optional
            }] }]; }, null); })();

class UtilitiesModule {
    static forRoot() {
        return {
            ngModule: UtilitiesModule,
            providers: [
                IndexedDBService,
                {
                    provide: USER_SETTINGS_DB_SERVICE,
                    useClass: UserSettingsDefaultDbService
                },
                {
                    provide: LOGGER_FORMAT_SERVICE,
                    useClass: LoggerFormatService,
                }
            ]
        };
    }
    static { this.ɵfac = function UtilitiesModule_Factory(t) { return new (t || UtilitiesModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: UtilitiesModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            UiLibModule,
            MatSnackBarModule,
            MatIconModule,
            MatTooltipModule,
            MatFormFieldModule,
            MatInputModule,
            MatSelectModule,
            FormsModule,
            ReactiveFormsModule,
            CdkScrollableModule,
            ScrollingModule,
            ClipboardModule,
            MatButtonModule,
            MatDialogModule,
            MatProgressSpinnerModule,
            MatExpansionModule,
            MatListModule,
            MatAutocompleteModule,
            MatDatepickerModule,
            MatCheckboxModule,
            MatMenuModule,
            DragDropModule,
            MatSlideToggleModule,
            MatTableModule,
            MatCardModule,
            MatTabsModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UtilitiesModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MessageHandlerComponent,
                    NotificationHandlerComponent,
                    AlertComponent,
                    LogsComponent,
                    LogsDialogComponent,
                    LogScrollerComponent,
                    LogSettingsComponent,
                    FilterBySearchStringPipe,
                    FilterByLogLevelPipe,
                    ConfirmationDialogComponent,
                    DBViewerComponent,
                    DbviewerDialog,
                    ClassificationComponent,
                    AttributeFieldComponent,
                    ResizeColumnDirective,
                    TableMenuComponent,
                    ReorganizeColumnsDlgComponent,
                    ClassificationAssignNewComponent,
                    ColumnResizerComponent,
                    NetworkConsoleComponent,
                    NetworkConsoleClassPipe,
                    ResponseDetailDlgComponent,
                    AdminConsoleComponent,
                    LogEntryComponent,
                    FilterLogEntryPipe,
                    PendingMessagesComponent,
                    PasswordFieldContentComponent,
                    UpdateDataDialogComponent,
                    UpdateDataOverviewComponent,
                    ImgComponent,
                    ImgFullSizeComponent,
                    SnackbarComponent
                ],
                imports: [
                    CommonModule,
                    UiLibModule,
                    MatSnackBarModule,
                    MatIconModule,
                    MatTooltipModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatSelectModule,
                    FormsModule,
                    ReactiveFormsModule,
                    CdkScrollableModule,
                    ScrollingModule,
                    ClipboardModule,
                    MatButtonModule,
                    MatDialogModule,
                    MatProgressSpinnerModule,
                    MatExpansionModule,
                    MatListModule,
                    MatAutocompleteModule,
                    MatDatepickerModule,
                    MatCheckboxModule,
                    MatMenuModule,
                    DragDropModule,
                    MatSlideToggleModule,
                    MatTableModule,
                    MatCardModule,
                    MatTabsModule
                ],
                exports: [
                    MessageHandlerComponent,
                    NotificationHandlerComponent,
                    AlertComponent,
                    LogsComponent,
                    FilterBySearchStringPipe,
                    ConfirmationDialogComponent,
                    DBViewerComponent,
                    DbviewerDialog,
                    ClassificationComponent,
                    ResizeColumnDirective,
                    NetworkConsoleComponent,
                    ResponseDetailDlgComponent,
                    AdminConsoleComponent,
                    PasswordFieldContentComponent,
                    UpdateDataDialogComponent,
                    UpdateDataOverviewComponent,
                    ImgComponent,
                    ImgFullSizeComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(UtilitiesModule, { declarations: [MessageHandlerComponent,
        NotificationHandlerComponent,
        AlertComponent,
        LogsComponent,
        LogsDialogComponent,
        LogScrollerComponent,
        LogSettingsComponent,
        FilterBySearchStringPipe,
        FilterByLogLevelPipe,
        ConfirmationDialogComponent,
        DBViewerComponent,
        DbviewerDialog,
        ClassificationComponent,
        AttributeFieldComponent,
        ResizeColumnDirective,
        TableMenuComponent,
        ReorganizeColumnsDlgComponent,
        ClassificationAssignNewComponent,
        ColumnResizerComponent,
        NetworkConsoleComponent,
        NetworkConsoleClassPipe,
        ResponseDetailDlgComponent,
        AdminConsoleComponent,
        LogEntryComponent,
        FilterLogEntryPipe,
        PendingMessagesComponent,
        PasswordFieldContentComponent,
        UpdateDataDialogComponent,
        UpdateDataOverviewComponent,
        ImgComponent,
        ImgFullSizeComponent,
        SnackbarComponent], imports: [CommonModule,
        UiLibModule,
        MatSnackBarModule,
        MatIconModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        FormsModule,
        ReactiveFormsModule,
        CdkScrollableModule,
        ScrollingModule,
        ClipboardModule,
        MatButtonModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
        MatListModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatMenuModule,
        DragDropModule,
        MatSlideToggleModule,
        MatTableModule,
        MatCardModule,
        MatTabsModule], exports: [MessageHandlerComponent,
        NotificationHandlerComponent,
        AlertComponent,
        LogsComponent,
        FilterBySearchStringPipe,
        ConfirmationDialogComponent,
        DBViewerComponent,
        DbviewerDialog,
        ClassificationComponent,
        ResizeColumnDirective,
        NetworkConsoleComponent,
        ResponseDetailDlgComponent,
        AdminConsoleComponent,
        PasswordFieldContentComponent,
        UpdateDataDialogComponent,
        UpdateDataOverviewComponent,
        ImgComponent,
        ImgFullSizeComponent] }); })();

class GuidService {
    constructor() {
    }
    newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    static { this.ɵfac = function GuidService_Factory(t) { return new (t || GuidService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GuidService, factory: GuidService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const OFFLINE_DB_NAME = new InjectionToken('OFFLINE_DB_NAME', { providedIn: 'root', factory: () => null });

class OnlineOfflineService {
    constructor(storageService) {
        this.storageService = storageService;
        this.IS_OFFLINE = 'isOffline';
        this.isOffline = new BehaviorSubject(this.getState());
        this.m_isOfflineObservable = this.isOffline.asObservable();
    }
    get isOfflineObservable() {
        return this.m_isOfflineObservable;
    }
    /**
     * ändert den Offlinezustand und benachrichtigt Subscriber
     * @param p_isOffline der neue Zustand
     */
    setState(p_isOffline) {
        this.storageService.setItem('session', this.IS_OFFLINE, p_isOffline ? '1' : '0');
        this.isOffline.next(p_isOffline);
    }
    /**
     * liefert den Offlinezustand aus dem SessionStorage
     */
    getState() {
        return this.storageService.getItem('session', this.IS_OFFLINE) == '1';
    }
    static { this.ɵfac = function OnlineOfflineService_Factory(t) { return new (t || OnlineOfflineService)(i0.ɵɵinject(StorageService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: OnlineOfflineService, factory: OnlineOfflineService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OnlineOfflineService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: StorageService }]; }, null); })();

/**
 * Implementierung eines @interface ILoggerWriterService um Logeinträge in die IndexedDB zu persistieren.
 *
 * @class
 */
class LoggerIndexedDBWriter {
    constructor() {
    }
    /**
     * Speichert den übergebenen Logeeintrag in die Datenbank ab.
     * @param p_logEntry
     */
    writeMessage(p_logEntry) {
        if (this.m_database && p_logEntry.level === LogLevel.ERROR) {
            const tx = this.getTransaction('LOGS', 'readwrite');
            if (tx) {
                const putReq = tx.objectStore('LOGS').put(p_logEntry);
                putReq.onsuccess = () => {
                    // egal
                };
                putReq.onerror = () => {
                    // niemals den Logger nutzen - könnte zu Endschlosschleife hier führen!
                    console.log(putReq.error);
                };
            }
        }
    }
    /**
     * Methode um die Datenbank zu setzen.
     * @param p_database
     */
    setDatabase(p_database) {
        this.m_database = p_database;
    }
    getTransaction(p_objectStore, p_mode) {
        return this.m_database ? this.m_database.transaction(p_objectStore, p_mode) : null;
    }
}

/**
 * Implementierung eines @interface ILoggerWriterService um Logeinträge in den LocalStorage zu persistieren.
 *
 * @class
 */
class LoggerLocalStorageWriter {
    constructor(storageService) {
        this.storageService = storageService;
        // Da der LocalStorage nur begrent Speicher zulässt nutzen wir ein Limit wie viele Logeinträge wir speichern können
        this.LIMIT = 50;
    }
    /**
     * Speichert einen Logeintrag in den LocalStorage ab.
     * @param p_logEntry LogEntry
     */
    writeMessage(p_logEntry) {
        let entries = JSON.parse(this.storageService.getItem('local', 'logs'));
        if (entries.length === this.LIMIT) {
            entries.shift(); // FIFO - First in, first out
        }
        entries.push(p_logEntry);
        this.storageService.setItem('local', 'logs', JSON.stringify(entries));
    }
    static { this.ɵfac = function LoggerLocalStorageWriter_Factory(t) { return new (t || LoggerLocalStorageWriter)(i0.ɵɵinject(StorageService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoggerLocalStorageWriter, factory: LoggerLocalStorageWriter.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoggerLocalStorageWriter, [{
        type: Injectable
    }], function () { return [{ type: StorageService }]; }, null); })();

class LoggerServerWriter {
    constructor() { }
    /**
     *
     * @param p_logEntry LogEntry
     */
    writeMessage(p_logEntry) {
    }
}

/**
 * Hilfsklasse für Tabellen
 *
 * @TODO wenn TypeScript irgendwann ein final/sealed Modifier implementiert, diesen dieser Klasse hinzufügen :)
 */
class TableUtility {
    // nicht instanziierbar
    constructor() { }
    static sortList(list, sort) {
        if (!list?.length || !sort?.direction)
            return list ?? [];
        const sortFaktor = sort.direction === 'asc' ? 1 : -1;
        const fields = sort.active.split('.');
        return list.sort((a, b) => {
            let sortValue = 0;
            const valueA = fields.reduce(this.sortFieldReducer, a);
            const valueB = fields.reduce(this.sortFieldReducer, b);
            if (valueA != null && valueB != null) {
                if (typeof valueA == 'string' && valueA.toLocaleLowerCase() != valueB.toLocaleLowerCase())
                    sortValue = valueA.toLocaleLowerCase() < valueB.toLocaleLowerCase() ? -1 : 1;
                else if (typeof valueA != 'string' && valueA != valueB)
                    sortValue = valueA < valueB ? -1 : 1;
            }
            else if (valueA != null)
                sortValue = 1;
            else if (valueB != null)
                sortValue = -1;
            return sortValue * sortFaktor;
        });
    }
    static sortFieldReducer(obj, subField) {
        if (obj === null || obj === undefined)
            return null;
        return subField in obj ? obj[subField] : null;
    }
}

const ADMIN_CONSOLE_INTL = new InjectionToken('ADMIN_CONSOLE_INTL');

const PENDING_MESSAGES_INTL = new InjectionToken('PENDING_MESSAGES_INTL');

const THEME_PROVIDER_SERVICE = new InjectionToken('THEME_PROVIDER_SERVICE');

class ThemeProviderService {
    constructor() {
        this.DEFAULT_THEME = {
            name: 'Light-Theme',
            cssClass: 'light-theme'
            /* themeId: ThemeId.default */
        };
        this.DARK_THEME = {
            name: 'Dark-Theme',
            cssClass: 'dark-theme'
            /* themeId: ThemeId.dark */
        };
        this.availableThemes = [this.DEFAULT_THEME, this.DARK_THEME];
    }
    getAvailableThemes() {
        return this.availableThemes;
    }
    getDefaultTheme() {
        return this.DEFAULT_THEME;
    }
    static { this.ɵfac = function ThemeProviderService_Factory(t) { return new (t || ThemeProviderService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ThemeProviderService, factory: ThemeProviderService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ThemeProviderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ThemingService {
    constructor(rendererFactory, document, themeProviderService) {
        this.rendererFactory = rendererFactory;
        this.document = document;
        this.themeProviderService = themeProviderService;
        this.renderer = rendererFactory.createRenderer(null, null);
        this.currentTheme = this.themeProviderService.getDefaultTheme();
    }
    changeTheme(p_theme) {
        this.renderer.removeClass(this.document.body, this.currentTheme.cssClass);
        this.currentTheme = p_theme;
        this.renderer.addClass(this.document.body, this.currentTheme.cssClass);
    }
    getAllThemes() {
        return this.themeProviderService.getAvailableThemes();
    }
    getCurrentTheme() {
        return this.currentTheme;
    }
    static { this.ɵfac = function ThemingService_Factory(t) { return new (t || ThemingService)(i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(THEME_PROVIDER_SERVICE)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ThemingService, factory: ThemingService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ThemingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i0.RendererFactory2 }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [THEME_PROVIDER_SERVICE]
            }] }]; }, null); })();

/*
 * Public API Surface of utilities-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ADMIN_CONSOLE_DATA, ADMIN_CONSOLE_INTL, ATTRIBUTE_FIELD_TRANSLATE, AdminConsoleComponent, AdminConsoleIntl, AlertComponent, ClassificationAssignNewIntl, ClassificationComponent, ClassificationIntl, ClassificationUtility, ConfirmationDialogComponent, ConfirmationDlgIntl, ConfirmationIntl, ConfirmationService, DBViewerComponent, DBViewerIntl, DB_VIEWER_DB_SERVICE, DateUtility, DbviewerDialog, FilterBySearchStringPipe, GuidService, ImgAction, ImgComponent, ImgFullSizeComponent, IndexedDBService, LOGGER_CATEGORY_PROVIDER, LOGGER_FORMAT_SERVICE, LOGGER_WRITER_SERVICE, LOG_LEVEL_ARRAY, LogContextBuilder, LogContextHelper, LogLevel, LogSettingsHelper, LoggerFormatService, LoggerIndexedDBWriter, LoggerLocalStorageWriter, LoggerServerWriter, LoggerService, LogsComponent, LogsIntl, MessageHandlerComponent, MessageHandlerIntl, MessageQueue, MessageService, MessageState, MessageType, NetworkConsoleComponent, NetworkConsoleIntl, NetworkLogLevel, NetworkLogger, NetworkLoggerConfig, NetworkOnlineService, NotificationHandlerComponent, NotificationHandlerIntl, OFFLINE_DB_NAME, ObjectStoreValue, ObjectUtility, OnlineOfflineService, PENDING_MESSAGES_INTL, PasswordFieldContentComponent, PendingMessagesComponent, PendingMessagesIntl, ReorganizeColumnsDlgComponent, ResizeColumnDirective, ResponseDetailDlgComponent, STORAGE_CONFIG, ServiceWorkerIntl, ServiceWorkerService, StorageService, THEME_PROVIDER_SERVICE, TabPages, TableIntl, TableUtility, ThemeProviderService, ThemingService, USER_SETTINGS_DB_SERVICE, UpdateDataDialogComponent, UpdateDataOverviewComponent, UpdateDataOverviewIntl, UpdateDataProcessService, UserSettingsService, UtilitiesModule, params };
